import type { FolderTree } from '~/graphql/scalars';
import type { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: number; output: number; }
  /** Big numbers as numbers instead of as strings */
  BigIntNumber: { input: number; output: number; }
  /** Sorted tree of folders including id, name, and children */
  FolderTree: { input: FolderTree; output: FolderTree; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** An ISO 8601-encoded duration */
  ISO8601Duration: { input: string; output: string; }
  /** IP address */
  InternetAddress: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: {} | null; output: {} | null; }
}

export interface AiChatMessageInput {
  readonly content: Scalars['String']['input'];
  readonly role: AiChatRole;
}

export const AiChatRole = {
  Assistant: 'ASSISTANT',
  User: 'USER'
} as const;

export type AiChatRole = typeof AiChatRole[keyof typeof AiChatRole];
/** Autogenerated input type of ActivateDevice */
export interface ActivateDeviceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly code: Scalars['String']['input'];
  readonly deviceId?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of ActivateDevice. */
export interface ActivateDevicePayload {
  readonly __typename: 'ActivateDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly device: Device;
  readonly network: Network;
}

export interface ActiveShow {
  readonly __typename: 'ActiveShow';
  readonly description: Scalars['String']['output'];
  readonly event?: Maybe<Event>;
  readonly reason: Scalars['String']['output'];
  readonly show: Show;
}

/** Autogenerated input type of AddChannelsToChannelGuide */
export interface AddChannelsToChannelGuideInput {
  readonly channelGuideId: Scalars['Int']['input'];
  readonly channelIds: ReadonlyArray<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of AddChannelsToChannelGuide. */
export interface AddChannelsToChannelGuidePayload {
  readonly __typename: 'AddChannelsToChannelGuidePayload';
  readonly addedIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly channelGuide: ChannelGuide;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of AddContentFoldersToPlaylist */
export interface AddContentFoldersToPlaylistInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly folderIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly index?: InputMaybe<Scalars['Int']['input']>;
  readonly playlistId: Scalars['Int']['input'];
}

/** Autogenerated return type of AddContentFoldersToPlaylist. */
export interface AddContentFoldersToPlaylistPayload {
  readonly __typename: 'AddContentFoldersToPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly playlist: Playlist;
  readonly playlistItems: ReadonlyArray<PlaylistItem>;
}

/** Autogenerated input type of AddContentToPlaylist */
export interface AddContentToPlaylistInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentItemIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly mediaItemIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly playlistId: Scalars['Int']['input'];
  readonly showId?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of AddContentToPlaylist. */
export interface AddContentToPlaylistPayload {
  readonly __typename: 'AddContentToPlaylistPayload';
  readonly addedIds: ReadonlyArray<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly playlist: Playlist;
}

/** Autogenerated input type of AddContentToShow */
export interface AddContentToShowInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentItemIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly mediaItemIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly showId: Scalars['Int']['input'];
  readonly viewZoneId: Scalars['Int']['input'];
}

/** Autogenerated return type of AddContentToShow. */
export interface AddContentToShowPayload {
  readonly __typename: 'AddContentToShowPayload';
  readonly addedIds: ReadonlyArray<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly playlist: Playlist;
  readonly viewZone: ViewZone;
}

/** Autogenerated input type of AddDevicesToDeviceGroup */
export interface AddDevicesToDeviceGroupInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceGroupId: Scalars['Int']['input'];
  readonly deviceIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of AddDevicesToDeviceGroup. */
export interface AddDevicesToDeviceGroupPayload {
  readonly __typename: 'AddDevicesToDeviceGroupPayload';
  readonly addedIds: ReadonlyArray<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceGroup: DeviceGroupNew;
  readonly network: Network;
}

/** Autogenerated input type of AddToRole */
export interface AddToRoleInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentFolderRules?: InputMaybe<ReadonlyArray<RoleContentFolderInput>>;
  readonly dataSourceRules?: InputMaybe<ReadonlyArray<RoleDataSourceInput>>;
  readonly designFolderRules?: InputMaybe<ReadonlyArray<RoleDesignFolderInput>>;
  readonly deviceGroupRules?: InputMaybe<ReadonlyArray<RoleDeviceGroupInput>>;
  readonly deviceRules?: InputMaybe<ReadonlyArray<RoleDeviceInput>>;
  readonly eventTypeRules?: InputMaybe<ReadonlyArray<RoleEventTypeInput>>;
  readonly id: Scalars['Int']['input'];
  readonly playlistFolderRules?: InputMaybe<ReadonlyArray<RolePlaylistFolderInput>>;
  readonly showFolderRules?: InputMaybe<ReadonlyArray<RoleShowFolderInput>>;
  readonly userRoles?: InputMaybe<ReadonlyArray<RoleUserInput>>;
}

/** Autogenerated return type of AddToRole. */
export interface AddToRolePayload {
  readonly __typename: 'AddToRolePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly role: Role;
}

/** Autogenerated input type of AiChatSendMessage */
export interface AiChatSendMessageInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly messages: ReadonlyArray<AiChatMessageInput>;
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of AiChatSendMessage. */
export interface AiChatSendMessagePayload {
  readonly __typename: 'AiChatSendMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly message: Scalars['String']['output'];
}

export interface Announcement {
  readonly __typename: 'Announcement';
  readonly body: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly publishedAt: Scalars['ISO8601DateTime']['output'];
  readonly read: Scalars['Boolean']['output'];
  readonly severity: AnnouncementSeverity;
  readonly sticky: Scalars['Boolean']['output'];
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
}

export const AnnouncementCategory = {
  Billing: 'BILLING',
  CmsRelease: 'CMS_RELEASE',
  Content: 'CONTENT',
  DeviceSoftware: 'DEVICE_SOFTWARE',
  Maintenance: 'MAINTENANCE'
} as const;

export type AnnouncementCategory = typeof AnnouncementCategory[keyof typeof AnnouncementCategory];
export interface AnnouncementFilters {
  readonly __typename: 'AnnouncementFilters';
  readonly categories: ReadonlyArray<FilterCount>;
  readonly read: ReadonlyArray<FilterCount>;
  readonly severities: ReadonlyArray<FilterCount>;
  readonly tags: ReadonlyArray<FilterCount>;
}

export const AnnouncementOrdering = {
  SeverityAsc: 'SEVERITY_ASC',
  SeverityDesc: 'SEVERITY_DESC'
} as const;

export type AnnouncementOrdering = typeof AnnouncementOrdering[keyof typeof AnnouncementOrdering];
export interface AnnouncementPage {
  readonly __typename: 'AnnouncementPage';
  readonly nodes: ReadonlyArray<Announcement>;
  readonly pageInfo: PaginationInfo;
}

export const AnnouncementSeverity = {
  Critical: 'CRITICAL',
  Info: 'INFO',
  Warn: 'WARN'
} as const;

export type AnnouncementSeverity = typeof AnnouncementSeverity[keyof typeof AnnouncementSeverity];
export interface AnnouncementUnreadCount {
  readonly __typename: 'AnnouncementUnreadCount';
  readonly count: Scalars['Int']['output'];
  readonly severity: AnnouncementSeverity;
}

export interface AuditLog {
  readonly __typename: 'AuditLog';
  readonly action: Scalars['String']['output'];
  readonly actionName: Scalars['String']['output'];
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly network?: Maybe<Network>;
  readonly payload: Scalars['JSON']['output'];
  readonly records: AuditLogRecordPage;
  readonly recordsCount: Scalars['Int']['output'];
  readonly userName: Scalars['String']['output'];
}


export interface AuditLogRecordsArgs {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}

/** Input type for filtering audit logs during export */
export interface AuditLogExportFilterInput {
  /** End date for filtering audit logs */
  readonly endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Filter by record types */
  readonly recordTypes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Search query string */
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Start date for filtering audit logs */
  readonly startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Filter by user IDs */
  readonly userIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface AuditLogPage {
  readonly __typename: 'AuditLogPage';
  readonly nodes: ReadonlyArray<AuditLog>;
  readonly pageInfo: PaginationInfo;
}

/** Represents a record associated with an audit log entry */
export interface AuditLogRecord {
  readonly __typename: 'AuditLogRecord';
  /** The unique ID of this audit log record */
  readonly id: Scalars['Int']['output'];
  /** The ID of the associated record */
  readonly recordId?: Maybe<Scalars['Int']['output']>;
  /** The name of the associated record */
  readonly recordName?: Maybe<Scalars['String']['output']>;
  /** The type of the associated record */
  readonly recordType: Scalars['String']['output'];
}

export interface AuditLogRecordPage {
  readonly __typename: 'AuditLogRecordPage';
  readonly nodes: ReadonlyArray<AuditLogRecord>;
  readonly pageInfo: PaginationInfo;
}

export interface AuditLogsFilters {
  readonly __typename: 'AuditLogsFilters';
  readonly maxYear?: Maybe<Scalars['Int']['output']>;
  readonly minYear?: Maybe<Scalars['Int']['output']>;
  readonly recordTypes: ReadonlyArray<FilterCount>;
  readonly userIds: ReadonlyArray<FilterCount>;
}

export interface Authorizable {
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly id: Scalars['Int']['output'];
}

export interface AuthorizableInput {
  readonly id: Scalars['Int']['input'];
  readonly type: AuthorizableType;
}

export const AuthorizableType = {
  ContentFolder: 'CONTENT_FOLDER',
  ContentItem: 'CONTENT_ITEM',
  MediaItem: 'MEDIA_ITEM'
} as const;

export type AuthorizableType = typeof AuthorizableType[keyof typeof AuthorizableType];
export interface AuthorizationResult {
  readonly __typename: 'AuthorizationResult';
  /** Human-readable error message */
  readonly message?: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  readonly reasons?: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  readonly value: Scalars['Boolean']['output'];
}

/** Autogenerated input type of BulkTag */
export interface BulkTagInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly items: ReadonlyArray<BulkTagInputType>;
  readonly tag: Scalars['String']['input'];
}

export interface BulkTagInputType {
  readonly taggableId: Scalars['Int']['input'];
  readonly taggableType: TaggableType;
}

/** Autogenerated return type of BulkTag. */
export interface BulkTagPayload {
  readonly __typename: 'BulkTagPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly taggables: ReadonlyArray<Taggable>;
}

/** Autogenerated input type of BulkUpdateDevices */
export interface BulkUpdateDevicesInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: DeviceBulkPatch;
  readonly selected: DeviceBulkSelectionInput;
}

/** Autogenerated return type of BulkUpdateDevices. */
export interface BulkUpdateDevicesPayload {
  readonly __typename: 'BulkUpdateDevicesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly devices: ReadonlyArray<Device>;
  readonly networks: ReadonlyArray<Network>;
  readonly result: BulkUpdateResult;
}

export interface BulkUpdateResult {
  readonly __typename: 'BulkUpdateResult';
  readonly errored: Scalars['Int']['output'];
  readonly succeeded: Scalars['Int']['output'];
  readonly unauthed: Scalars['Int']['output'];
}

/** Autogenerated input type of CancelDeviceSignal */
export interface CancelDeviceSignalInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of CancelDeviceSignal. */
export interface CancelDeviceSignalPayload {
  readonly __typename: 'CancelDeviceSignalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceSignal: DeviceSignal;
}

/** Autogenerated input type of ChangeDataSourceAlcoholVisibility */
export interface ChangeDataSourceAlcoholVisibilityInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly show: Scalars['Boolean']['input'];
}

/** Autogenerated return type of ChangeDataSourceAlcoholVisibility. */
export interface ChangeDataSourceAlcoholVisibilityPayload {
  readonly __typename: 'ChangeDataSourceAlcoholVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataSource: DataSource;
}

export interface Channel {
  readonly __typename: 'Channel';
  readonly backgroundColor: Scalars['String']['output'];
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly channelGuideCount: Scalars['Int']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly enabledForLiveStreaming: Scalars['Boolean']['output'];
  readonly encryption: ChannelEncryptionKind;
  readonly id: Scalars['Int']['output'];
  readonly jpegxsEnabled: Scalars['Boolean']['output'];
  readonly metadata?: Maybe<ChannelMetadata>;
  readonly name: Scalars['String']['output'];
  readonly number: Scalars['String']['output'];
  readonly outputUrl?: Maybe<Scalars['String']['output']>;
  readonly outputUrls?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly source?: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
  readonly thumbnailFile: File;
  /** @deprecated Use `thumbnailFile.id` instead */
  readonly thumbnailFileId: Scalars['Int']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly url: Scalars['String']['output'];
  readonly urls: ReadonlyArray<Scalars['String']['output']>;
}

export interface ChannelAudioStream {
  readonly __typename: 'ChannelAudioStream';
  readonly bitRate?: Maybe<Scalars['String']['output']>;
  readonly channelLayout?: Maybe<Scalars['String']['output']>;
  readonly channels?: Maybe<Scalars['Int']['output']>;
  readonly codecLongName?: Maybe<Scalars['String']['output']>;
  readonly codecName?: Maybe<Scalars['String']['output']>;
  readonly sampleRate?: Maybe<Scalars['String']['output']>;
}

export interface ChannelCondition {
  readonly enabledForLiveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export const ChannelEncryptionKind = {
  /** AES 128-bit encryption */
  Aes_128: 'AES_128',
  /** No encryption */
  None: 'NONE',
  /** Passthrough stream, no encryption */
  Passthrough: 'PASSTHROUGH',
  /** Pro-Idiom encryption */
  ProIdiom: 'PRO_IDIOM'
} as const;

export type ChannelEncryptionKind = typeof ChannelEncryptionKind[keyof typeof ChannelEncryptionKind];
export interface ChannelGuide {
  readonly __typename: 'ChannelGuide';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly channelCount: Scalars['Int']['output'];
  readonly channels: ReadonlyArray<Channel>;
  /** @deprecated Will be removed */
  readonly contentItemId: Scalars['Int']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly defaultChannel?: Maybe<Channel>;
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly showCount: Scalars['Int']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface ChannelGuidePage {
  readonly __typename: 'ChannelGuidePage';
  readonly nodes: ReadonlyArray<ChannelGuide>;
  readonly pageInfo: PaginationInfo;
}

export interface ChannelGuidePatch {
  readonly channelIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly defaultChannelId?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
}

export const ChannelGuidesOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type ChannelGuidesOrderBy = typeof ChannelGuidesOrderBy[keyof typeof ChannelGuidesOrderBy];
export interface ChannelMetadata {
  readonly __typename: 'ChannelMetadata';
  readonly audioStream?: Maybe<ChannelAudioStream>;
  readonly timestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly videoStream?: Maybe<ChannelVideoStream>;
}

export interface ChannelPage {
  readonly __typename: 'ChannelPage';
  readonly nodes: ReadonlyArray<Channel>;
  readonly pageInfo: PaginationInfo;
}

export interface ChannelPatch {
  readonly backgroundColor?: InputMaybe<Scalars['String']['input']>;
  readonly enabledForLiveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  readonly encryption?: InputMaybe<ChannelEncryptionKind>;
  readonly jpegxsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly metadata?: InputMaybe<Scalars['JSON']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly number?: InputMaybe<Scalars['String']['input']>;
  readonly outputUrl?: InputMaybe<Scalars['String']['input']>;
  readonly outputUrls?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly thumbnailUri?: InputMaybe<Scalars['String']['input']>;
  readonly url?: InputMaybe<Scalars['String']['input']>;
  readonly urls?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface ChannelVideoStream {
  readonly __typename: 'ChannelVideoStream';
  readonly codecLongName?: Maybe<Scalars['String']['output']>;
  readonly codecName?: Maybe<Scalars['String']['output']>;
  readonly colorSpace?: Maybe<Scalars['String']['output']>;
  readonly displayAspectRatio?: Maybe<Scalars['String']['output']>;
  readonly fieldOrder?: Maybe<Scalars['String']['output']>;
  readonly frameRate?: Maybe<Scalars['String']['output']>;
  readonly pixFmt?: Maybe<Scalars['String']['output']>;
  readonly resolution: Scalars['String']['output'];
}

/** Autogenerated input type of CleanupTemplateVersions */
export interface CleanupTemplateVersionsInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly templateIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of CleanupTemplateVersions. */
export interface CleanupTemplateVersionsPayload {
  readonly __typename: 'CleanupTemplateVersionsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly templates: ReadonlyArray<Template>;
}

/** Autogenerated input type of ClearDeviceCache */
export interface ClearDeviceCacheInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceId: Scalars['Int']['input'];
}

/** Autogenerated return type of ClearDeviceCache. */
export interface ClearDeviceCachePayload {
  readonly __typename: 'ClearDeviceCachePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly device: Device;
}

/** An object contained in a folder which may be a ContentItem or a MediaItem */
export type Content = ContentItem | MediaItem;

export interface ContentCondition {
  /** Aspect ratio as a decimal. Example: 16/9 ~= 1.77 */
  readonly aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Apps to leave out, e.g. the one being edited */
  readonly excludeContentItemIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly kind?: InputMaybe<ReadonlyArray<ContentKind>>;
  readonly search?: InputMaybe<Scalars['String']['input']>;
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface ContentFilters {
  readonly __typename: 'ContentFilters';
  readonly kind: ReadonlyArray<FilterCount>;
  readonly tags: ReadonlyArray<FilterCount>;
}

export interface ContentFolder extends Authorizable {
  readonly __typename: 'ContentFolder';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  /** Child folders that can be accessed and their ancestors. */
  readonly children: ReadonlyArray<ContentFolder>;
  readonly childrenCount: Scalars['Int']['output'];
  readonly content: ContentPage;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['Int']['output'];
  readonly itemCount: Scalars['Int']['output'];
  /** Will return items if the current user has access to this folder */
  readonly mediaItems: ReadonlyArray<MediaItem>;
  readonly name: Scalars['String']['output'];
  readonly network: Network;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}


export interface ContentFolderChildrenArgs {
  condition?: InputMaybe<ContentCondition>;
}


export interface ContentFolderChildrenCountArgs {
  condition?: InputMaybe<ContentCondition>;
}


export interface ContentFolderContentArgs {
  condition?: InputMaybe<ContentCondition>;
  orderBy?: InputMaybe<ContentOrderBy>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}


export interface ContentFolderItemCountArgs {
  condition?: InputMaybe<ContentCondition>;
}


export interface ContentFolderMediaItemsArgs {
  condition?: InputMaybe<MediaItemCondition>;
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface ContentFolderPatch {
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly parentId?: InputMaybe<Scalars['Int']['input']>;
}

export interface ContentFolderRule {
  readonly __typename: 'ContentFolderRule';
  readonly contentFolder: ContentFolder;
  readonly id: Scalars['Int']['output'];
}

export interface ContentItem extends Authorizable {
  readonly __typename: 'ContentItem';
  readonly canDestroy: AuthorizationResult;
  readonly canShow: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly canUpgrade: AuthorizationResult;
  readonly contentFolder: ContentFolder;
  readonly contentFolderId?: Maybe<Scalars['Int']['output']>;
  readonly contentOptions: ReadonlyArray<ContentOption>;
  /** When this entity was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly defaultDuration?: Maybe<Interval>;
  readonly description: Scalars['String']['output'];
  readonly design?: Maybe<Design>;
  readonly durationReadonly: Scalars['Boolean']['output'];
  readonly file: File;
  readonly fileId: Scalars['Int']['output'];
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly overlay?: Maybe<Overlay>;
  readonly source?: Maybe<ContentSource>;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  readonly template: Template;
  readonly templateUri: Scalars['String']['output'];
  readonly templateVersion: TemplateVersion;
  /** @deprecated Use `templateVersion.id` */
  readonly templateVersionId: Scalars['Int']['output'];
  readonly thumbnailFile?: Maybe<File>;
  /** A public URL for the (smallest) thumbnail available, else `null` */
  readonly thumbnailUri?: Maybe<Scalars['String']['output']>;
  /** When this entity was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly usages: UsagePage;
}


export interface ContentItemUsagesArgs {
  orderBy?: InputMaybe<ReadonlyArray<ContentOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}

/** The connection type for ContentItem. */
export interface ContentItemConnection {
  readonly __typename: 'ContentItemConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ContentItemEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<ContentItem>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ContentItemEdge {
  readonly __typename: 'ContentItemEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ContentItem>;
}

/** Autogenerated input type of CreateContentItem */
export interface ContentItemInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ContentFolder` where this `ContentItem` exists */
  readonly contentFolderId?: InputMaybe<Scalars['Int']['input']>;
  /** Options for the new `ContentItem`; must match the parameters of the related `TemplateVersion` */
  readonly contentOptions: ReadonlyArray<ContentOptionInput>;
  /**
   * Override `TemplateVersion`'s default duration; not applicable if `TemplateVersion's duration is readonly
   * **TODO:** validate this constraint
   */
  readonly defaultDuration?: InputMaybe<IntervalInput>;
  /**
   * Lock this `ContentItem`'s default duration; not applicable if `TemplateVersion's duration is readonly
   * **TODO:** validate this constraint
   */
  readonly durationReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  /** A name to designate the new `ContentItem` */
  readonly name: Scalars['String']['input'];
  /** ID of the `Network` in which the `ContentItem` will be created */
  readonly networkId: Scalars['Int']['input'];
  /** ID of the `TemplateVersion` from which to create a `ContentItem` */
  readonly templateVersionId: Scalars['Int']['input'];
}

export interface ContentItemPage {
  readonly __typename: 'ContentItemPage';
  readonly nodes: ReadonlyArray<ContentItem>;
  readonly pageInfo: PaginationInfo;
}

export interface ContentItemPatch {
  /** Must include all of the options to update; `TemplateParam` IDs must match the `TemplateVersion` */
  readonly contentOptions?: InputMaybe<ReadonlyArray<ContentOptionInput>>;
  /**
   * Override `TemplateVersion`'s default duration; not applicable if `TemplateVersion's duration is readonly
   * **TODO:** validate this constraint
   */
  readonly defaultDuration?: InputMaybe<IntervalInput>;
  /** Description of the content item */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Lock this `ContentItem`'s default duration; not applicable if `TemplateVersion's duration is readonly
   * **TODO:** validate this constraint
   */
  readonly durationReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  /** A name for this content item; defaults to the name of the associated `Template` or `MediaItem` */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly thumbnailUri?: InputMaybe<Scalars['String']['input']>;
}

export const ContentKind = {
  /** App */
  App: 'APP',
  /** Image */
  Image: 'IMAGE',
  /** Overlay */
  Overlay: 'OVERLAY',
  /** Pdf */
  Pdf: 'PDF',
  /** PowerPoint */
  Powerpoint: 'POWERPOINT',
  /** Video */
  Video: 'VIDEO'
} as const;

export type ContentKind = typeof ContentKind[keyof typeof ContentKind];
export interface ContentOption {
  readonly __typename: 'ContentOption';
  readonly array: Scalars['Boolean']['output'];
  readonly configValue?: Maybe<Scalars['JSON']['output']>;
  readonly contentItemId: Scalars['Int']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly dataItem?: Maybe<DataItem>;
  readonly defaultValue?: Maybe<Scalars['JSON']['output']>;
  readonly description: Scalars['String']['output'];
  /** @deprecated Use media_item instead for this info */
  readonly file?: Maybe<File>;
  /** @deprecated Use media_item instead for this info */
  readonly fileId?: Maybe<Scalars['Int']['output']>;
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly kind: TemplateParamKind;
  readonly label: Scalars['String']['output'];
  readonly mediaItem?: Maybe<MediaItem>;
  readonly name: Scalars['String']['output'];
  readonly nullable: Scalars['Boolean']['output'];
  readonly templateParam: TemplateParam;
  readonly templateParamId: Scalars['Int']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly value?: Maybe<Scalars['JSON']['output']>;
}


export interface ContentOptionFileIdArgs {
  deviceId?: InputMaybe<Scalars['Int']['input']>;
}


export interface ContentOptionValueArgs {
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ContentOptionInput {
  /** JSON value to set for the option */
  readonly configValue?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of this `ContentOption`'s related `TemplateParam` */
  readonly templateParamId: Scalars['Int']['input'];
}

export const ContentOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type ContentOrderBy = typeof ContentOrderBy[keyof typeof ContentOrderBy];
export interface ContentPage {
  readonly __typename: 'ContentPage';
  readonly nodes: ReadonlyArray<Content>;
  readonly pageInfo: PaginationInfo;
}

/** The Media Item or Design which was used to dynamically create this content item. */
export type ContentSource = Design | MediaItem;

export interface ContentTag {
  readonly __typename: 'ContentTag';
  readonly name: Scalars['String']['output'];
  readonly uses: Scalars['Int']['output'];
}

export interface ContentableInput {
  readonly contentableId: Scalars['Int']['input'];
  readonly contentableType: ContentableType;
}

export const ContentableType = {
  /** Content item contentable type */
  App: 'APP',
  /** Media item contentable type */
  Media: 'MEDIA'
} as const;

export type ContentableType = typeof ContentableType[keyof typeof ContentableType];
/** Autogenerated input type of CopyContentItem */
export interface CopyContentItemInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentItemId: Scalars['Int']['input'];
}

/** Autogenerated return type of CopyContentItem. */
export interface CopyContentItemPayload {
  readonly __typename: 'CopyContentItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contentItem?: Maybe<ContentItem>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly network?: Maybe<Network>;
}

/** Autogenerated input type of CopyDesign */
export interface CopyDesignInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly designId: Scalars['Int']['input'];
}

/** Autogenerated return type of CopyDesign. */
export interface CopyDesignPayload {
  readonly __typename: 'CopyDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly design: Design;
  readonly network: Network;
}

/** Autogenerated input type of CopyShow */
export interface CopyShowInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly showId: Scalars['Int']['input'];
}

/** Autogenerated return type of CopyShow. */
export interface CopyShowPayload {
  readonly __typename: 'CopyShowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly show: Show;
}

/** Autogenerated input type of CopyView */
export interface CopyViewInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly viewId: Scalars['Int']['input'];
}

/** Autogenerated return type of CopyView. */
export interface CopyViewPayload {
  readonly __typename: 'CopyViewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly show?: Maybe<Show>;
  readonly view?: Maybe<View>;
}

/** Autogenerated input type of CreateAwsCredentials */
export interface CreateAwsCredentialsInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateAwsCredentials. */
export interface CreateAwsCredentialsPayload {
  readonly __typename: 'CreateAwsCredentialsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly credentials?: Maybe<UploadCredentials>;
  readonly region?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of CreateChannelGuide */
export interface CreateChannelGuideInput {
  readonly channelIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateChannelGuide. */
export interface CreateChannelGuidePayload {
  readonly __typename: 'CreateChannelGuidePayload';
  readonly channelGuide: ChannelGuide;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
}

/** Autogenerated input type of CreateChannel */
export interface CreateChannelInput {
  readonly backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly enabledForLiveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  readonly encryption: ChannelEncryptionKind;
  readonly jpegxsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
  readonly number?: InputMaybe<Scalars['String']['input']>;
  readonly outputUrl?: InputMaybe<Scalars['String']['input']>;
  readonly outputUrls?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly thumbnailUri: Scalars['String']['input'];
  readonly url: Scalars['String']['input'];
  readonly urls: ReadonlyArray<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateChannel. */
export interface CreateChannelPayload {
  readonly __typename: 'CreateChannelPayload';
  readonly channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
}

/** Autogenerated input type of CreateContentFolder */
export interface CreateContentFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly parentId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateContentFolder. */
export interface CreateContentFolderPayload {
  readonly __typename: 'CreateContentFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contentFolder: ContentFolder;
  readonly network: Network;
  readonly parent: ContentFolder;
}

/** Autogenerated return type of CreateContentItem. */
export interface CreateContentItemPayload {
  readonly __typename: 'CreateContentItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contentItem?: Maybe<ContentItem>;
  readonly network?: Maybe<Network>;
}

/** Autogenerated input type of CreateDesignFolder */
export interface CreateDesignFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly parentId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateDesignFolder. */
export interface CreateDesignFolderPayload {
  readonly __typename: 'CreateDesignFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly designFolder: DesignFolder;
  readonly network: Network;
  readonly parent: DesignFolder;
}

/** Autogenerated input type of CreateDesign */
export interface CreateDesignInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly designFolderId?: InputMaybe<Scalars['Int']['input']>;
  readonly height: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
  readonly width: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateDesign. */
export interface CreateDesignPayload {
  readonly __typename: 'CreateDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly design: Design;
}

/** Autogenerated input type of CreateDeviceCollection */
export interface CreateDeviceCollectionInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conditions: DeviceCondition;
  readonly name: Scalars['String']['input'];
  readonly source?: InputMaybe<DeviceDynamicCollectionSource>;
}

/** Autogenerated return type of CreateDeviceCollection. */
export interface CreateDeviceCollectionPayload {
  readonly __typename: 'CreateDeviceCollectionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceCollection: DeviceDynamicCollection;
  readonly network: Network;
}

/** Autogenerated input type of CreateDeviceGroup */
export interface CreateDeviceGroupInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateDeviceGroup. */
export interface CreateDeviceGroupPayload {
  readonly __typename: 'CreateDeviceGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceGroup: DeviceGroupNew;
  readonly network: Network;
}

/** Autogenerated input type of CreateDeviceSignal */
export interface CreateDeviceSignalInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly payload: DeviceSignalInput;
}

/** Autogenerated return type of CreateDeviceSignal. */
export interface CreateDeviceSignalPayload {
  readonly __typename: 'CreateDeviceSignalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceSignal: DeviceSignal;
}

/** Autogenerated input type of CreateEvent */
export interface CreateEventInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly eventTypeId: Scalars['Int']['input'];
  readonly includeInPlayoutReporting?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly sponsorStartTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly sponsorStopTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly start: Scalars['ISO8601DateTime']['input'];
  readonly stop: Scalars['ISO8601DateTime']['input'];
}

/** Autogenerated return type of CreateEvent. */
export interface CreateEventPayload {
  readonly __typename: 'CreateEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event: Event;
  readonly eventType: EventType;
  readonly network: Network;
}

/** Autogenerated input type of CreateEventType */
export interface CreateEventTypeInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly contentStartTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly contentStopTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly fcLeagueId?: InputMaybe<Scalars['Int']['input']>;
  readonly fcTeamId?: InputMaybe<Scalars['Int']['input']>;
  readonly iconUri: Scalars['String']['input'];
  readonly manageDisplay: Scalars['Boolean']['input'];
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
  readonly sponsorStartTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly sponsorStopTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly syncFcAdmin: Scalars['Boolean']['input'];
}

/** Autogenerated return type of CreateEventType. */
export interface CreateEventTypePayload {
  readonly __typename: 'CreateEventTypePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly eventType: EventType;
  readonly network: Network;
}

/** Autogenerated input type of CreateFont */
export interface CreateFontInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly fileUri: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateFont. */
export interface CreateFontPayload {
  readonly __typename: 'CreateFontPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly font: Font;
  readonly network: Network;
}

/** Autogenerated input type of CreateLayout */
export interface CreateLayoutInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly height: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
  readonly width: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateLayout. */
export interface CreateLayoutPayload {
  readonly __typename: 'CreateLayoutPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly layout?: Maybe<Layout>;
}

/** Autogenerated input type of CreateOverlay */
export interface CreateOverlayInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly item: OverlayInput;
}

/** Autogenerated return type of CreateOverlay. */
export interface CreateOverlayPayload {
  readonly __typename: 'CreateOverlayPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly overlay: Overlay;
}

/** Autogenerated input type of CreatePlaylistFolder */
export interface CreatePlaylistFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly parentId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreatePlaylistFolder. */
export interface CreatePlaylistFolderPayload {
  readonly __typename: 'CreatePlaylistFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly parent: PlaylistFolder;
  readonly playlistFolder: PlaylistFolder;
}

/** Autogenerated input type of CreatePlaylist */
export interface CreatePlaylistInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly kind?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
  readonly playlistFolderId?: InputMaybe<Scalars['Int']['input']>;
  readonly reusable?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreatePlaylist. */
export interface CreatePlaylistPayload {
  readonly __typename: 'CreatePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly playlist?: Maybe<Playlist>;
}

/** Autogenerated input type of CreateRemoteCredentials */
export interface CreateRemoteCredentialsInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateRemoteCredentials. */
export interface CreateRemoteCredentialsPayload {
  readonly __typename: 'CreateRemoteCredentialsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly credentials: RemoteCredentials;
}

/** Autogenerated input type of CreateRole */
export interface CreateRoleInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateRole. */
export interface CreateRolePayload {
  readonly __typename: 'CreateRolePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly role: Role;
}

/** Autogenerated input type of CreateSeason */
export interface CreateSeasonInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly endsOn: Scalars['ISO8601Date']['input'];
  readonly eventTypeId: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
  readonly startsOn: Scalars['ISO8601Date']['input'];
}

/** Autogenerated return type of CreateSeason. */
export interface CreateSeasonPayload {
  readonly __typename: 'CreateSeasonPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly eventType: EventType;
  readonly season: Season;
}

/** Autogenerated input type of CreateShowFolder */
export interface CreateShowFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly parentId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateShowFolder. */
export interface CreateShowFolderPayload {
  readonly __typename: 'CreateShowFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly parent: ShowFolder;
  readonly showFolder: ShowFolder;
}

/** Autogenerated input type of CreateShow */
export interface CreateShowInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly layoutId: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
  readonly showFolderId?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated input type of CreateShowInstance */
export interface CreateShowInstanceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceGroupId: Scalars['Int']['input'];
  readonly eventId: Scalars['Int']['input'];
  readonly showId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateShowInstance. */
export interface CreateShowInstancePayload {
  readonly __typename: 'CreateShowInstancePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceGroup?: Maybe<DeviceGroupNew>;
  readonly event?: Maybe<Event>;
  readonly show?: Maybe<Show>;
}

/** Autogenerated return type of CreateShow. */
export interface CreateShowPayload {
  readonly __typename: 'CreateShowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly show: Show;
}

/** Autogenerated input type of CreateTVBrand */
export interface CreateTvBrandInput {
  readonly baudRate?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly input1?: InputMaybe<Scalars['String']['input']>;
  readonly input2?: InputMaybe<Scalars['String']['input']>;
  readonly input3?: InputMaybe<Scalars['String']['input']>;
  readonly mute?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
  readonly powerOff?: InputMaybe<Scalars['String']['input']>;
  readonly powerOn?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly unmute?: InputMaybe<Scalars['String']['input']>;
  readonly volumeDown?: InputMaybe<Scalars['String']['input']>;
  readonly volumeUp?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateTVBrand. */
export interface CreateTvBrandPayload {
  readonly __typename: 'CreateTVBrandPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tvBrand: TvBrand;
}

/** Autogenerated input type of CreateTemplate */
export interface CreateTemplateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dataUrl: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
  readonly templateCategoryId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateTemplate. */
export interface CreateTemplatePayload {
  readonly __typename: 'CreateTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly template?: Maybe<Template>;
}

/** Autogenerated input type of CreateTemplateVersion */
export interface CreateTemplateVersionInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dataUrl: Scalars['String']['input'];
  readonly templateId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateTemplateVersion. */
export interface CreateTemplateVersionPayload {
  readonly __typename: 'CreateTemplateVersionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly template?: Maybe<Template>;
}

/** Autogenerated input type of CreateUploadConfig */
export interface CreateUploadConfigInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateUploadConfig. */
export interface CreateUploadConfigPayload {
  readonly __typename: 'CreateUploadConfigPayload';
  readonly bucket: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly credentials: UploadCredentials;
  readonly metadata: UploadMetadata;
  readonly region: Scalars['String']['output'];
}

/** Autogenerated input type of CreateUser */
export interface CreateUserInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly networkId?: InputMaybe<Scalars['Int']['input']>;
  readonly owner?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sysadmin?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateUser. */
export interface CreateUserPayload {
  readonly __typename: 'CreateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly user?: Maybe<User>;
}

/** Autogenerated input type of CreateView */
export interface CreateViewInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly layoutId: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
  readonly showId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateView. */
export interface CreateViewPayload {
  readonly __typename: 'CreateViewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly show?: Maybe<Show>;
  readonly view?: Maybe<View>;
}

/** Autogenerated input type of CreateViewZonePlaylist */
export interface CreateViewZonePlaylistInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly playlistId: Scalars['Int']['input'];
  readonly viewZoneId: Scalars['Int']['input'];
}

/** Autogenerated return type of CreateViewZonePlaylist. */
export interface CreateViewZonePlaylistPayload {
  readonly __typename: 'CreateViewZonePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly viewZone: ViewZone;
}

/** Autogenerated input type of CreateZone */
export interface CreateZoneInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly layoutId: Scalars['Int']['input'];
  readonly patch: ZonePatch;
}

/** Autogenerated return type of CreateZone. */
export interface CreateZonePayload {
  readonly __typename: 'CreateZonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly layout?: Maybe<Layout>;
  readonly zone?: Maybe<Zone>;
}

export interface Credentials {
  readonly __typename: 'Credentials';
  readonly keySecret: Scalars['String']['output'];
  readonly verificationToken: Scalars['String']['output'];
  readonly verificationUrl: Scalars['String']['output'];
}

/** Autogenerated return type of CurrentUserUpdated. */
export interface CurrentUserUpdatedPayload {
  readonly __typename: 'CurrentUserUpdatedPayload';
  readonly event: Scalars['String']['output'];
  readonly user: User;
}

export interface DataItem {
  readonly __typename: 'DataItem';
  readonly alcohol: Scalars['Boolean']['output'];
  readonly canDestroy: AuthorizationResult;
  readonly data: Scalars['JSON']['output'];
  readonly enabled: Scalars['Boolean']['output'];
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly source: DataSource;
}

/** Autogenerated input type of DataItemCreate */
export interface DataItemCreateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly data: Scalars['JSON']['input'];
  readonly dataSourceId: Scalars['BigInt']['input'];
}

/** Autogenerated return type of DataItemCreate. */
export interface DataItemCreatePayload {
  readonly __typename: 'DataItemCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataItem: DataItem;
  readonly dataSource: DataSource;
}

/** Autogenerated input type of DataItemDelete */
export interface DataItemDeleteInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['BigInt']['input'];
}

/** Autogenerated return type of DataItemDelete. */
export interface DataItemDeletePayload {
  readonly __typename: 'DataItemDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataSource: DataSource;
}

export interface DataItemPage {
  readonly __typename: 'DataItemPage';
  readonly nodes: ReadonlyArray<DataItem>;
  readonly pageInfo: PaginationInfo;
}

/** Autogenerated input type of DataItemUpdate */
export interface DataItemUpdateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly data: Scalars['JSON']['input'];
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of DataItemUpdate. */
export interface DataItemUpdatePayload {
  readonly __typename: 'DataItemUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataItem: DataItem;
  readonly dataSource: DataSource;
}

export interface DataSource {
  readonly __typename: 'DataSource';
  readonly alcoholDisabled: Scalars['Boolean']['output'];
  readonly canDestroy: AuthorizationResult;
  readonly canSync: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly canUpdateItems: AuthorizationResult;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly creator?: Maybe<User>;
  readonly deviceKey?: Maybe<Scalars['String']['output']>;
  readonly foreignIdName?: Maybe<Scalars['String']['output']>;
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly includesAlcohol: Scalars['Boolean']['output'];
  readonly itemCount: Scalars['Int']['output'];
  readonly items: DataItemPage;
  readonly keys: ReadonlyArray<Scalars['String']['output']>;
  readonly kind: DataSourceKind;
  readonly name: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}


export interface DataSourceItemsArgs {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderFirst?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}

export const DataSourceKind = {
  /** Originally a comma separated file type */
  Csv: 'CSV',
  /** Readonly data source updated by an integration */
  Integration: 'INTEGRATION',
  /** Originally an Excel spreadsheet */
  Xlsx: 'XLSX'
} as const;

export type DataSourceKind = typeof DataSourceKind[keyof typeof DataSourceKind];
export interface DataSourcePage {
  readonly __typename: 'DataSourcePage';
  readonly nodes: ReadonlyArray<DataSource>;
  readonly pageInfo: PaginationInfo;
}

export interface DataSourceRule {
  readonly __typename: 'DataSourceRule';
  readonly dataSource: DataSource;
  readonly id: Scalars['Int']['output'];
}

export const DataSourcesOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type DataSourcesOrderBy = typeof DataSourcesOrderBy[keyof typeof DataSourcesOrderBy];
/** Autogenerated input type of DeleteChannelGuide */
export interface DeleteChannelGuideInput {
  readonly channelGuideIds: ReadonlyArray<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of DeleteChannelGuide. */
export interface DeleteChannelGuidePayload {
  readonly __typename: 'DeleteChannelGuidePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of DeleteChannel */
export interface DeleteChannelInput {
  readonly channelIds: ReadonlyArray<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of DeleteChannel. */
export interface DeleteChannelPayload {
  readonly __typename: 'DeleteChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of DeleteContentFolder */
export interface DeleteContentFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentFolderId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteContentFolder. */
export interface DeleteContentFolderPayload {
  readonly __typename: 'DeleteContentFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly parent: ContentFolder;
}

/** Autogenerated input type of DeleteContent */
export interface DeleteContentInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly items: ReadonlyArray<ContentableInput>;
}

/** Autogenerated return type of DeleteContent. */
export interface DeleteContentPayload {
  readonly __typename: 'DeleteContentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedItems: ReadonlyArray<Content>;
}

/** Autogenerated input type of DeleteDataSource */
export interface DeleteDataSourceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteDataSource. */
export interface DeleteDataSourcePayload {
  readonly __typename: 'DeleteDataSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataSource: DataSource;
}

/** Autogenerated input type of DeleteDesignFolder */
export interface DeleteDesignFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly designFolderId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteDesignFolder. */
export interface DeleteDesignFolderPayload {
  readonly __typename: 'DeleteDesignFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly parent: DesignFolder;
}

/** Autogenerated input type of DeleteDesign */
export interface DeleteDesignInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly designIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of DeleteDesign. */
export interface DeleteDesignPayload {
  readonly __typename: 'DeleteDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of DeleteDeviceCollection */
export interface DeleteDeviceCollectionInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteDeviceCollection. */
export interface DeleteDeviceCollectionPayload {
  readonly __typename: 'DeleteDeviceCollectionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
}

/** Autogenerated input type of DeleteDeviceGroup */
export interface DeleteDeviceGroupInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceGroupIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of DeleteDeviceGroup. */
export interface DeleteDeviceGroupPayload {
  readonly __typename: 'DeleteDeviceGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of DeleteDevice */
export interface DeleteDeviceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteDevice. */
export interface DeleteDevicePayload {
  readonly __typename: 'DeleteDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly device: Device;
}

/** Autogenerated input type of DeleteDeviceSignal */
export interface DeleteDeviceSignalInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly signalIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of DeleteDeviceSignal. */
export interface DeleteDeviceSignalPayload {
  readonly __typename: 'DeleteDeviceSignalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of DeleteEvent */
export interface DeleteEventInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ids: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of DeleteEvent. */
export interface DeleteEventPayload {
  readonly __typename: 'DeleteEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of DeleteEventType */
export interface DeleteEventTypeInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteEventType. */
export interface DeleteEventTypePayload {
  readonly __typename: 'DeleteEventTypePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly eventType: EventType;
  readonly network: Network;
}

/** Autogenerated input type of DeleteFont */
export interface DeleteFontInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteFont. */
export interface DeleteFontPayload {
  readonly __typename: 'DeleteFontPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly font: Font;
}

/** Autogenerated input type of DeleteLayout */
export interface DeleteLayoutInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly layoutId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteLayout. */
export interface DeleteLayoutPayload {
  readonly __typename: 'DeleteLayoutPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly layout: Layout;
}

/** Autogenerated input type of DeleteOverlay */
export interface DeleteOverlayInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly overlayId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteOverlay. */
export interface DeleteOverlayPayload {
  readonly __typename: 'DeleteOverlayPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly overlay: Overlay;
}

/** Autogenerated input type of DeletePlaylistFolder */
export interface DeletePlaylistFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly playlistFolderId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeletePlaylistFolder. */
export interface DeletePlaylistFolderPayload {
  readonly __typename: 'DeletePlaylistFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly parent: PlaylistFolder;
}

/** Autogenerated input type of DeletePlaylist */
export interface DeletePlaylistInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly playlistIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated input type of DeletePlaylistItem */
export interface DeletePlaylistItemInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly playlistId: Scalars['Int']['input'];
  readonly playlistItemIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of DeletePlaylistItem. */
export interface DeletePlaylistItemPayload {
  readonly __typename: 'DeletePlaylistItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly playlist: Playlist;
  readonly removedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated return type of DeletePlaylist. */
export interface DeletePlaylistPayload {
  readonly __typename: 'DeletePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of DeleteRoles */
export interface DeleteRolesInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly networkId: Scalars['Int']['input'];
  readonly roleIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of DeleteRoles. */
export interface DeleteRolesPayload {
  readonly __typename: 'DeleteRolesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly network: Network;
}

/** Autogenerated input type of DeleteSeason */
export interface DeleteSeasonInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteSeason. */
export interface DeleteSeasonPayload {
  readonly __typename: 'DeleteSeasonPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly eventType: EventType;
  readonly season: Season;
}

/** Autogenerated input type of DeleteShowFolder */
export interface DeleteShowFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly showFolderId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteShowFolder. */
export interface DeleteShowFolderPayload {
  readonly __typename: 'DeleteShowFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly parent: ShowFolder;
}

/** Autogenerated input type of DeleteShow */
export interface DeleteShowInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly showIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of DeleteShow. */
export interface DeleteShowPayload {
  readonly __typename: 'DeleteShowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of DeleteTVBrand */
export interface DeleteTvBrandInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteTVBrand. */
export interface DeleteTvBrandPayload {
  readonly __typename: 'DeleteTVBrandPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly tvBrand: TvBrand;
}

/** Autogenerated input type of DeleteTag */
export interface DeleteTagInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly networkId: Scalars['Int']['input'];
  readonly tag: Scalars['String']['input'];
  readonly taggableTypes: ReadonlyArray<TaggableType>;
}

/** Autogenerated return type of DeleteTag. */
export interface DeleteTagPayload {
  readonly __typename: 'DeleteTagPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
}

/** Autogenerated input type of DeleteTemplate */
export interface DeleteTemplateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly templateId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteTemplate. */
export interface DeleteTemplatePayload {
  readonly __typename: 'DeleteTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly template: Template;
}

/** Autogenerated input type of DeleteUser */
export interface DeleteUserInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly networkId?: InputMaybe<Scalars['Int']['input']>;
  readonly userId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteUser. */
export interface DeleteUserPayload {
  readonly __typename: 'DeleteUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user: User;
}

/** Autogenerated input type of DeleteView */
export interface DeleteViewInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly viewId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteView. */
export interface DeleteViewPayload {
  readonly __typename: 'DeleteViewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly show: Show;
  readonly view: View;
}

/** Autogenerated input type of DeleteViewZonePlaylist */
export interface DeleteViewZonePlaylistInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly viewZonePlaylistId: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteViewZonePlaylist. */
export interface DeleteViewZonePlaylistPayload {
  readonly __typename: 'DeleteViewZonePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly viewZone: ViewZone;
  readonly viewZonePlaylist: ViewZonePlaylist;
}

/** Autogenerated input type of DeleteZone */
export interface DeleteZoneInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of DeleteZone. */
export interface DeleteZonePayload {
  readonly __typename: 'DeleteZonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly zone: Zone;
}

export interface Design {
  readonly __typename: 'Design';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly data: Scalars['JSON']['output'];
  readonly dataItems: ReadonlyArray<DataItem>;
  readonly designFolder: DesignFolder;
  readonly designFolderId: Scalars['Int']['output'];
  readonly fonts: ReadonlyArray<Font>;
  readonly height: Scalars['Int']['output'];
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly mediaItems: ReadonlyArray<MediaItem>;
  readonly name: Scalars['String']['output'];
  readonly publishedApp?: Maybe<ContentItem>;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  /** A public URL for the (smallest) thumbnail available, else `null` */
  readonly thumbnailUri?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly width: Scalars['Int']['output'];
}

export interface DesignFilters {
  readonly __typename: 'DesignFilters';
  readonly published: ReadonlyArray<FilterCount>;
  readonly tags: ReadonlyArray<FilterCount>;
}

export interface DesignFolder {
  readonly __typename: 'DesignFolder';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  /** Child folders that can be accessed and their ancestors. */
  readonly children: ReadonlyArray<DesignFolder>;
  readonly childrenCount: Scalars['Int']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly designs: DesignPage;
  readonly id: Scalars['Int']['output'];
  readonly itemCount: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}


export interface DesignFolderChildrenArgs {
  condition?: InputMaybe<DesignFolderCondition>;
}


export interface DesignFolderChildrenCountArgs {
  condition?: InputMaybe<DesignFolderCondition>;
}


export interface DesignFolderDesignsArgs {
  orderBy?: InputMaybe<ReadonlyArray<DesignsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  published?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface DesignFolderItemCountArgs {
  published?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface DesignFolderCondition {
  readonly parentId?: InputMaybe<Scalars['Int']['input']>;
  readonly published?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly search?: InputMaybe<Scalars['String']['input']>;
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface DesignFolderPatch {
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly parentId?: InputMaybe<Scalars['Int']['input']>;
}

export interface DesignFolderRule {
  readonly __typename: 'DesignFolderRule';
  readonly designFolder: DesignFolder;
  readonly id: Scalars['Int']['output'];
}

export interface DesignPage {
  readonly __typename: 'DesignPage';
  readonly nodes: ReadonlyArray<Design>;
  readonly pageInfo: PaginationInfo;
}

export interface DesignPatch {
  readonly data?: InputMaybe<Scalars['JSON']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly thumbnailUri?: InputMaybe<Scalars['String']['input']>;
}

export interface DesignTag {
  readonly __typename: 'DesignTag';
  readonly name: Scalars['String']['output'];
  readonly uses: Scalars['Int']['output'];
}

export const DesignsOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type DesignsOrderBy = typeof DesignsOrderBy[keyof typeof DesignsOrderBy];
export interface Device {
  readonly __typename: 'Device';
  readonly activationChangedAt: Scalars['ISO8601DateTime']['output'];
  readonly active: Scalars['Boolean']['output'];
  readonly activeShow?: Maybe<ActiveShow>;
  readonly api: Scalars['Boolean']['output'];
  readonly arch: Scalars['String']['output'];
  readonly cacheContent: Scalars['Boolean']['output'];
  readonly cacheServer: Scalars['Boolean']['output'];
  readonly canSchedule: AuthorizationResult;
  readonly canSendCommand: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly canUpdateSoftware: AuthorizationResult;
  readonly closedCaptioning: Scalars['Boolean']['output'];
  readonly command?: Maybe<Scalars['JSON']['output']>;
  readonly cpuPercentage?: Maybe<Scalars['Int']['output']>;
  readonly cpuTemperature?: Maybe<Scalars['Int']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly currentChannel?: Maybe<Channel>;
  readonly currentScheduledShow?: Maybe<ScheduledShow>;
  readonly currentView?: Maybe<View>;
  readonly defaultChannel?: Maybe<Channel>;
  readonly demo: Scalars['Boolean']['output'];
  readonly deviceCommands: DeviceCommandPage;
  /** @deprecated This data is fake. Only leaving for players that access location through the group. Use `group` instead. */
  readonly deviceGroup: DeviceGroup;
  readonly diskAvailable?: Maybe<Scalars['BigInt']['output']>;
  readonly diskTotal?: Maybe<Scalars['BigInt']['output']>;
  readonly displayOn?: Maybe<Scalars['Boolean']['output']>;
  readonly displayServer?: Maybe<Scalars['String']['output']>;
  readonly dynamicCollections: ReadonlyArray<DeviceDynamicCollection>;
  readonly edgeServer: Scalars['Boolean']['output'];
  readonly encryptionServer: Scalars['Boolean']['output'];
  readonly environments: ReadonlyArray<Scalars['String']['output']>;
  readonly eventStream: Scalars['Boolean']['output'];
  readonly gameEventConsoleType?: Maybe<DeviceGameEventConsoleType>;
  readonly gameEventSerialServerHost?: Maybe<Scalars['String']['output']>;
  readonly gameEventSport?: Maybe<DeviceGameEventSport>;
  readonly gameEvents: Scalars['Boolean']['output'];
  /** Manifest grab interval in seconds */
  readonly grabInterval: Scalars['Int']['output'];
  /** @deprecated In the future a device will belong to many device groups, we should start replacing with `deviceGroups`, even though for now it will have zero or one members */
  readonly group?: Maybe<DeviceGroupNew>;
  readonly groups: ReadonlyArray<DeviceGroupNew>;
  readonly id: Scalars['Int']['output'];
  readonly inactiveEnvironments: ReadonlyArray<Scalars['String']['output']>;
  readonly internal: Scalars['Boolean']['output'];
  /** @deprecated Use `networking.ipAddress` instead. */
  readonly ipAddress: Scalars['InternetAddress']['output'];
  readonly jpegxsEncoder: Scalars['Boolean']['output'];
  readonly jpegxsEncoderBpp: Scalars['Float']['output'];
  readonly jpegxsEncoderTtl: Scalars['Int']['output'];
  readonly jpegxsEncoderUrl?: Maybe<Scalars['String']['output']>;
  readonly jpegxsLicense?: Maybe<DeviceJpegxsLicense>;
  readonly keyId: Scalars['String']['output'];
  readonly keyIdDescription: Scalars['String']['output'];
  readonly kind: DeviceKind;
  readonly libraryVersion?: Maybe<Scalars['String']['output']>;
  /** @deprecated This data is fake. Only leaving for players that access network through the location. */
  readonly location: Location;
  readonly logUri?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `networking.macAddress` instead. */
  readonly macAddress: Scalars['String']['output'];
  readonly manifest?: Maybe<Manifest>;
  readonly memoryAvailable?: Maybe<Scalars['BigInt']['output']>;
  readonly memoryTotal?: Maybe<Scalars['BigInt']['output']>;
  readonly messagingBackend: DeviceMessagingBackend;
  readonly messagingProxy: Scalars['Boolean']['output'];
  readonly metadata: Scalars['JSON']['output'];
  readonly model?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly network: Network;
  readonly networking?: Maybe<DeviceNetworking>;
  readonly nightlyBehavior: DeviceNightlyBehavior;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly ntpServer: Scalars['Boolean']['output'];
  readonly osUptime?: Maybe<Scalars['BigInt']['output']>;
  readonly overscan?: Maybe<Scalars['Float']['output']>;
  readonly playerVersion?: Maybe<Scalars['String']['output']>;
  readonly preload: Scalars['Boolean']['output'];
  readonly processUptime?: Maybe<Scalars['BigInt']['output']>;
  readonly properties: ReadonlyArray<ManifestProperty>;
  readonly propertyGroups: ReadonlyArray<PropertyGroupOwner>;
  readonly ptpService?: Maybe<DevicePtpService>;
  readonly publisher: Scalars['Boolean']['output'];
  readonly realtime: Scalars['Boolean']['output'];
  readonly remoteTargets: ReadonlyArray<Device>;
  readonly samsungFirmwares: ReadonlyArray<SamsungFirmware>;
  readonly scheduledShows: ScheduledShowPage;
  readonly scoreServer: Scalars['Boolean']['output'];
  readonly screenshotInterval?: Maybe<Scalars['ISO8601Duration']['output']>;
  /** @deprecated Players now upload screenshots directly to S3 using device credentials. */
  readonly screenshotUploadUri: Scalars['String']['output'];
  readonly screenshotUri?: Maybe<Scalars['String']['output']>;
  readonly serialDataSource?: Maybe<DeviceSerialDataSource>;
  readonly serialNetworkUrl?: Maybe<Scalars['String']['output']>;
  readonly serialPortSpeed: Scalars['Int']['output'];
  readonly serialServer: Scalars['Boolean']['output'];
  readonly silence: Scalars['Boolean']['output'];
  readonly snmpService: Scalars['Boolean']['output'];
  readonly softwareVersion?: Maybe<SoftwareVersion>;
  readonly sshService: Scalars['Boolean']['output'];
  readonly status: DeviceStatus;
  /** Device status update interval in seconds */
  readonly statusInterval: Scalars['Int']['output'];
  readonly statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly streamAnalysis: Scalars['Boolean']['output'];
  /** Whether mute/unmute can reach this device */
  readonly supportsMute: Scalars['Boolean']['output'];
  /** Whether relative volume stepping can reach this device's audio */
  readonly supportsVolume: Scalars['Boolean']['output'];
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  readonly timeSinceUpdate?: Maybe<Interval>;
  readonly timeZone: Scalars['String']['output'];
  readonly transcodeServer: Scalars['Boolean']['output'];
  readonly tvBrand?: Maybe<TvBrand>;
  readonly type: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly usesLatestVersion: Scalars['Boolean']['output'];
  readonly wasCommanded: Scalars['Boolean']['output'];
  readonly webosFirmwares: ReadonlyArray<WebosFirmware>;
}


export interface DeviceDeviceCommandsArgs {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}


export interface DeviceScheduledShowsArgs {
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<ScheduledShowsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface DeviceWasCommandedArgs {
  commandType: DeviceRestartCommand;
  hours: Scalars['Int']['input'];
}

export const DeviceArch = {
  Arm: 'ARM',
  Arm64: 'ARM64',
  Ia32: 'IA32',
  Mips: 'MIPS',
  Mipsel: 'MIPSEL',
  Ppc: 'PPC',
  Ppc64: 'PPC64',
  S390: 'S390',
  S390X: 'S390X',
  X64: 'X64'
} as const;

export type DeviceArch = typeof DeviceArch[keyof typeof DeviceArch];
export interface DeviceBulkPatch {
  readonly api?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cacheContent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly closedCaptioning?: InputMaybe<Scalars['Boolean']['input']>;
  readonly defaultChannelId?: InputMaybe<Scalars['Int']['input']>;
  readonly demo?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deviceGroupId?: InputMaybe<Scalars['Int']['input']>;
  readonly eventStream?: InputMaybe<Scalars['Boolean']['input']>;
  readonly internal?: InputMaybe<Scalars['Boolean']['input']>;
  readonly messagingBackend?: InputMaybe<DeviceMessagingBackend>;
  readonly nightlyBehavior?: InputMaybe<DeviceNightlyBehavior>;
  readonly overscan?: InputMaybe<Scalars['Float']['input']>;
  readonly preload?: InputMaybe<Scalars['Boolean']['input']>;
  readonly realtime?: InputMaybe<Scalars['Boolean']['input']>;
  readonly screenshotInterval?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly silence?: InputMaybe<Scalars['Boolean']['input']>;
  readonly snmpService?: InputMaybe<Scalars['Boolean']['input']>;
  readonly tag?: InputMaybe<Scalars['String']['input']>;
  readonly tvBrandId?: InputMaybe<Scalars['Int']['input']>;
}

export type DeviceBulkSelectionInput =
  { readonly condition: DeviceCondition; readonly ids?: never; }
  |  { readonly condition?: never; readonly ids: ReadonlyArray<Scalars['Int']['input']>; };

export interface DeviceCommand {
  readonly __typename: 'DeviceCommand';
  readonly command: Scalars['JSON']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly device: Device;
  readonly expiresAt: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly status: Scalars['String']['output'];
}

export const DeviceCommandKind = {
  /** Analyze IPTV channel streams */
  AnalyzeChannels: 'ANALYZE_CHANNELS',
  /** Send arbitrary command */
  Arbitrary: 'ARBITRARY',
  /** Set brightness 0-100 (Samsung only) */
  Brightness: 'BRIGHTNESS',
  /** Switch environments */
  Environment: 'ENVIRONMENT',
  /** Zip up device logs and upload to S3 */
  Logs: 'LOGS',
  /** Remotely play an overlay */
  PlayOverlay: 'PLAY_OVERLAY',
  /** Delete all cached files from device */
  Purge: 'PURGE',
  /** Reboot the device */
  Reboot: 'REBOOT',
  /** Starts an SSH server and reverse tunnel connection to remote.fanconnect.tv on port 80 */
  Remote: 'REMOTE',
  /**
   * Send a remote-control button press (up/down/left/right/ok/back/home). Volume
   * is not a button press — see VOLUME_UP/VOLUME_DOWN.
   */
  RemoteControl: 'REMOTE_CONTROL',
  /** Restart the player software */
  Restart: 'RESTART',
  /** Install firmware on Samsung */
  SamsungFirmware: 'SAMSUNG_FIRMWARE',
  /** Take a screenshot and upload it to S3 */
  Screenshot: 'SCREENSHOT',
  /** Remotely stop an overlay */
  StopOverlay: 'STOP_OVERLAY',
  /** Remotely trigger a view */
  TriggerView: 'TRIGGER_VIEW',
  /** Remotely tune to a channel */
  TuneChannel: 'TUNE_CHANNEL',
  /** Install the latest version of the player software */
  Update: 'UPDATE',
  /** Set volume 0-100 */
  Volume: 'VOLUME',
  /** Decrease volume one step */
  VolumeDown: 'VOLUME_DOWN',
  /** Increase volume one step */
  VolumeUp: 'VOLUME_UP',
  /** Install firmware on webOS */
  WebosFirmware: 'WEBOS_FIRMWARE'
} as const;

export type DeviceCommandKind = typeof DeviceCommandKind[keyof typeof DeviceCommandKind];
export interface DeviceCommandPage {
  readonly __typename: 'DeviceCommandPage';
  readonly nodes: ReadonlyArray<DeviceCommand>;
  readonly pageInfo: PaginationInfo;
}

export interface DeviceCondition {
  readonly arch?: InputMaybe<ReadonlyArray<DeviceArch>>;
  readonly demo?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly displayOn?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly displayServers?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly groups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']['input']>>>;
  readonly internal?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly kind?: InputMaybe<ReadonlyArray<DeviceKind>>;
  readonly models?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly networkId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by hardware reboot within N hours */
  readonly osUptimeBelow?: InputMaybe<Scalars['Int']['input']>;
  readonly playerVersions?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Filter by software restart within N hours */
  readonly processUptimeBelow?: InputMaybe<Scalars['Int']['input']>;
  readonly search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by devices with any of these services enabled */
  readonly services?: InputMaybe<ReadonlyArray<DeviceService>>;
  readonly silence?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  readonly status?: InputMaybe<ReadonlyArray<DeviceStatus>>;
  /** Filter by available storage percentage below threshold */
  readonly storageBelow?: InputMaybe<Scalars['Int']['input']>;
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Filter by CPU temperature above threshold in Celsius */
  readonly temperatureAbove?: InputMaybe<Scalars['Int']['input']>;
  readonly tvBrands?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** Filter by uptime below threshold in hours */
  readonly uptimeBelow?: InputMaybe<Scalars['Int']['input']>;
}

export interface DeviceDynamicCollection {
  readonly __typename: 'DeviceDynamicCollection';
  readonly canDestroy: AuthorizationResult;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly deviceCount: Scalars['Int']['output'];
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly query: Scalars['String']['output'];
  readonly source: DeviceDynamicCollectionSource;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}

export const DeviceDynamicCollectionSource = {
  Manual: 'MANUAL',
  SavedFilter: 'SAVED_FILTER'
} as const;

export type DeviceDynamicCollectionSource = typeof DeviceDynamicCollectionSource[keyof typeof DeviceDynamicCollectionSource];
export interface DeviceFilters {
  readonly __typename: 'DeviceFilters';
  readonly arch: ReadonlyArray<FilterCount>;
  readonly demo: ReadonlyArray<FilterCount>;
  readonly displayOn: ReadonlyArray<FilterCount>;
  readonly displayServers: ReadonlyArray<FilterCount>;
  readonly groups: ReadonlyArray<FilterCount>;
  readonly internal: ReadonlyArray<FilterCount>;
  readonly kind: ReadonlyArray<FilterCount>;
  readonly models: ReadonlyArray<FilterCount>;
  readonly playerVersions: ReadonlyArray<FilterCount>;
  readonly services: ReadonlyArray<FilterCount>;
  readonly silence: ReadonlyArray<FilterCount>;
  readonly status: ReadonlyArray<FilterCount>;
  readonly storageBelow: ReadonlyArray<FilterCount>;
  readonly tags: ReadonlyArray<FilterCount>;
  readonly temperatureAbove: ReadonlyArray<FilterCount>;
  readonly tvBrands: ReadonlyArray<FilterCount>;
  readonly uptimeBelow: ReadonlyArray<FilterCount>;
}

export const DeviceGameEventConsoleType = {
  DaktronicsAllSport5000: 'DAKTRONICS_ALL_SPORT5000',
  DaktronicsDsti: 'DAKTRONICS_DSTI',
  Oes: 'OES',
  ScorePad: 'SCORE_PAD'
} as const;

export type DeviceGameEventConsoleType = typeof DeviceGameEventConsoleType[keyof typeof DeviceGameEventConsoleType];
export const DeviceGameEventSport = {
  Baseball: 'BASEBALL',
  Basketball: 'BASKETBALL',
  Football: 'FOOTBALL',
  Hockey: 'HOCKEY',
  Soccer: 'SOCCER'
} as const;

export type DeviceGameEventSport = typeof DeviceGameEventSport[keyof typeof DeviceGameEventSport];
export interface DeviceGroup {
  readonly __typename: 'DeviceGroup';
  /**
   * The primary key of this entity
   * @deprecated This data is fake. Only leaving for players that access location through the group.
   */
  readonly id: Scalars['Int']['output'];
  /** @deprecated Please access location directly from device. */
  readonly location: Location;
  /** @deprecated This data is fake. Only leaving for players that access location through the group. */
  readonly name: Scalars['String']['output'];
}

export interface DeviceGroupNew {
  readonly __typename: 'DeviceGroupNew';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly defaultShow?: Maybe<Show>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly deviceCount: Scalars['Int']['output'];
  readonly deviceStats: DeviceStats;
  readonly devices: DevicePage;
  readonly enableReporting: Scalars['Boolean']['output'];
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly thumbnailFile?: Maybe<File>;
  readonly updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
}


export interface DeviceGroupNewDevicesArgs {
  orderBy?: InputMaybe<ReadonlyArray<DevicesOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface DeviceGroupNewPage {
  readonly __typename: 'DeviceGroupNewPage';
  readonly nodes: ReadonlyArray<DeviceGroupNew>;
  readonly pageInfo: PaginationInfo;
}

export interface DeviceGroupPatch {
  readonly defaultShowId?: InputMaybe<Scalars['Int']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly enableReporting?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly thumbnailUri?: InputMaybe<Scalars['String']['input']>;
}

export interface DeviceGroupRule {
  readonly __typename: 'DeviceGroupRule';
  readonly access: RuleAccess;
  readonly deviceGroup: DeviceGroupNew;
  readonly id: Scalars['Int']['output'];
}

export const DeviceGroupsOrderBy = {
  CreatedAtAsc: 'CREATED_AT_ASC',
  CreatedAtDesc: 'CREATED_AT_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type DeviceGroupsOrderBy = typeof DeviceGroupsOrderBy[keyof typeof DeviceGroupsOrderBy];
export const DeviceJpegxsLicense = {
  Jpegxs: 'JPEGXS',
  Jpegxs_4K: 'JPEGXS_4K',
  JpegxsF: 'JPEGXS_F',
  JpegxsF_4K: 'JPEGXS_F_4K'
} as const;

export type DeviceJpegxsLicense = typeof DeviceJpegxsLicense[keyof typeof DeviceJpegxsLicense];
export const DeviceKind = {
  /** Android Device */
  Android: 'ANDROID',
  /** BrightSign Device */
  Brightsign: 'BRIGHTSIGN',
  /** Linux Device */
  Linux: 'LINUX',
  /** Samsung Device */
  Samsung: 'SAMSUNG',
  /** Web Player */
  Web: 'WEB',
  /** WebOS Player */
  Webos: 'WEBOS'
} as const;

export type DeviceKind = typeof DeviceKind[keyof typeof DeviceKind];
export const DeviceMessagingBackend = {
  AwsIot: 'AWS_IOT',
  Mqtt: 'MQTT',
  Pubnub: 'PUBNUB'
} as const;

export type DeviceMessagingBackend = typeof DeviceMessagingBackend[keyof typeof DeviceMessagingBackend];
export interface DeviceNetworking {
  readonly __typename: 'DeviceNetworking';
  readonly ipAddress?: Maybe<Scalars['InternetAddress']['output']>;
  readonly macAddress?: Maybe<Scalars['String']['output']>;
  readonly switch?: Maybe<DeviceNetworkingSwitch>;
}

export interface DeviceNetworkingPort {
  readonly __typename: 'DeviceNetworkingPort';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly speed?: Maybe<Scalars['String']['output']>;
}

export const DeviceNetworkingProvider = {
  Cisco: 'CISCO',
  Extreme: 'EXTREME',
  Other: 'OTHER'
} as const;

export type DeviceNetworkingProvider = typeof DeviceNetworkingProvider[keyof typeof DeviceNetworkingProvider];
export interface DeviceNetworkingSwitch {
  readonly __typename: 'DeviceNetworkingSwitch';
  readonly model?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly port: DeviceNetworkingPort;
  readonly provider: DeviceNetworkingProvider;
}

export const DeviceNightlyBehavior = {
  None: 'NONE',
  Reboot: 'REBOOT',
  Restart: 'RESTART'
} as const;

export type DeviceNightlyBehavior = typeof DeviceNightlyBehavior[keyof typeof DeviceNightlyBehavior];
export interface DevicePage {
  readonly __typename: 'DevicePage';
  readonly nodes: ReadonlyArray<Device>;
  readonly pageInfo: PaginationInfo;
}

export interface DevicePatch {
  readonly api?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cacheContent?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cacheServer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly closedCaptioning?: InputMaybe<Scalars['Boolean']['input']>;
  readonly defaultChannelId?: InputMaybe<Scalars['Int']['input']>;
  readonly demo?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deviceGroupId?: InputMaybe<Scalars['Int']['input']>;
  readonly edgeServer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly encryptionServer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly eventStream?: InputMaybe<Scalars['Boolean']['input']>;
  readonly gameEventConsoleType?: InputMaybe<DeviceGameEventConsoleType>;
  readonly gameEventSerialServerHost?: InputMaybe<Scalars['String']['input']>;
  readonly gameEventSport?: InputMaybe<DeviceGameEventSport>;
  readonly gameEvents?: InputMaybe<Scalars['Boolean']['input']>;
  readonly internal?: InputMaybe<Scalars['Boolean']['input']>;
  readonly jpegxsEncoder?: InputMaybe<Scalars['Boolean']['input']>;
  readonly jpegxsEncoderBpp?: InputMaybe<Scalars['Float']['input']>;
  readonly jpegxsEncoderTtl?: InputMaybe<Scalars['Int']['input']>;
  readonly jpegxsEncoderUrl?: InputMaybe<Scalars['String']['input']>;
  readonly jpegxsLicense?: InputMaybe<DeviceJpegxsLicense>;
  readonly messagingBackend?: InputMaybe<DeviceMessagingBackend>;
  readonly messagingProxy?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly nightlyBehavior?: InputMaybe<DeviceNightlyBehavior>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly ntpServer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly overscan?: InputMaybe<Scalars['Float']['input']>;
  readonly preload?: InputMaybe<Scalars['Boolean']['input']>;
  readonly propertyValuesAttributes?: InputMaybe<ReadonlyArray<PropertyValuePatch>>;
  readonly ptpService?: InputMaybe<DevicePtpService>;
  readonly publisher?: InputMaybe<Scalars['Boolean']['input']>;
  readonly realtime?: InputMaybe<Scalars['Boolean']['input']>;
  readonly remoteTargetIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly scoreServer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly screenshotInterval?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly serialDataSource?: InputMaybe<DeviceSerialDataSource>;
  readonly serialNetworkUrl?: InputMaybe<Scalars['String']['input']>;
  readonly serialPortSpeed?: InputMaybe<Scalars['Int']['input']>;
  readonly serialServer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly silence?: InputMaybe<Scalars['Boolean']['input']>;
  readonly snmpService?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sshService?: InputMaybe<Scalars['Boolean']['input']>;
  readonly streamAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  readonly transcodeServer?: InputMaybe<Scalars['Boolean']['input']>;
  readonly tvBrandId?: InputMaybe<Scalars['Int']['input']>;
}

export const DevicePtpService = {
  Follower: 'FOLLOWER',
  Leader: 'LEADER'
} as const;

export type DevicePtpService = typeof DevicePtpService[keyof typeof DevicePtpService];
export interface DeviceRegistration {
  readonly __typename: 'DeviceRegistration';
  readonly keyId: Scalars['String']['output'];
  readonly keyIdDescription: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
}

export const DeviceRestartCommand = {
  /** Reboot the device */
  Reboot: 'REBOOT',
  /** Restart the player software */
  Restart: 'RESTART'
} as const;

export type DeviceRestartCommand = typeof DeviceRestartCommand[keyof typeof DeviceRestartCommand];
export interface DeviceRule {
  readonly __typename: 'DeviceRule';
  readonly access: RuleAccess;
  readonly device: Device;
  readonly id: Scalars['Int']['output'];
}

export const DeviceSerialDataSource = {
  Embedded: 'EMBEDDED',
  Network: 'NETWORK',
  Usb: 'USB'
} as const;

export type DeviceSerialDataSource = typeof DeviceSerialDataSource[keyof typeof DeviceSerialDataSource];
export const DeviceService = {
  Api: 'API',
  CacheServer: 'CACHE_SERVER',
  EncryptionServer: 'ENCRYPTION_SERVER',
  GameEvents: 'GAME_EVENTS',
  JpegxsEncoder: 'JPEGXS_ENCODER',
  MessagingProxy: 'MESSAGING_PROXY',
  NtpServer: 'NTP_SERVER',
  PtpFollower: 'PTP_FOLLOWER',
  PtpLeader: 'PTP_LEADER',
  Publisher: 'PUBLISHER',
  ScoreServer: 'SCORE_SERVER',
  SerialServer: 'SERIAL_SERVER',
  SnmpService: 'SNMP_SERVICE',
  SshService: 'SSH_SERVICE',
  StreamAnalysis: 'STREAM_ANALYSIS',
  TranscodeServer: 'TRANSCODE_SERVER'
} as const;

export type DeviceService = typeof DeviceService[keyof typeof DeviceService];
export interface DeviceSignal {
  readonly __typename: 'DeviceSignal';
  readonly action: SignalAction;
  readonly allDevices: Scalars['Boolean']['output'];
  readonly canCancel: AuthorizationResult;
  readonly canDestroy: AuthorizationResult;
  readonly canRun: AuthorizationResult;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly deviceCount: Scalars['Int']['output'];
  readonly deviceDynamicCollection?: Maybe<DeviceDynamicCollection>;
  readonly deviceGroup?: Maybe<DeviceGroupNew>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly event: Scalars['JSON']['output'];
  readonly eventType?: Maybe<EventType>;
  readonly id: Scalars['Int']['output'];
  readonly kind: DeviceSignalKind;
  readonly name: Scalars['String']['output'];
  readonly running: Scalars['Boolean']['output'];
  readonly schedule?: Maybe<DeviceSignalSchedule>;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}

export const DeviceSignalActionCommand = {
  PlayOverlay: 'PLAY_OVERLAY',
  PlayShow: 'PLAY_SHOW',
  StopOverlay: 'STOP_OVERLAY',
  TriggerView: 'TRIGGER_VIEW',
  TuneChannel: 'TUNE_CHANNEL',
  TvOff: 'TV_OFF',
  TvOn: 'TV_ON'
} as const;

export type DeviceSignalActionCommand = typeof DeviceSignalActionCommand[keyof typeof DeviceSignalActionCommand];
export interface DeviceSignalCondition {
  readonly action?: InputMaybe<ReadonlyArray<DeviceSignalActionCommand>>;
  readonly eventType?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly kind?: InputMaybe<ReadonlyArray<DeviceSignalKind>>;
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export const DeviceSignalEvent = {
  ChlEndGame: 'CHL_END_GAME',
  ChlGoal: 'CHL_GOAL',
  ChlHomeTeamLoss: 'CHL_HOME_TEAM_LOSS',
  ChlHomeTeamWin: 'CHL_HOME_TEAM_WIN',
  ChlOvertime: 'CHL_OVERTIME',
  ChlStart_1StIntermission: 'CHL_START_1ST_INTERMISSION',
  ChlStart_2NdIntermission: 'CHL_START_2ND_INTERMISSION',
  ChlStartPeriod_2: 'CHL_START_PERIOD_2',
  ChlStartPeriod_3: 'CHL_START_PERIOD_3',
  CommonStartTime: 'COMMON_START_TIME',
  Milb_1StInningEnd: 'MILB_1ST_INNING_END',
  Milb_1StInningMiddle: 'MILB_1ST_INNING_MIDDLE',
  Milb_1StInningStart: 'MILB_1ST_INNING_START',
  Milb_2NdInningEnd: 'MILB_2ND_INNING_END',
  Milb_2NdInningMiddle: 'MILB_2ND_INNING_MIDDLE',
  Milb_2NdInningStart: 'MILB_2ND_INNING_START',
  Milb_3RdInningEnd: 'MILB_3RD_INNING_END',
  Milb_3RdInningMiddle: 'MILB_3RD_INNING_MIDDLE',
  Milb_3RdInningStart: 'MILB_3RD_INNING_START',
  Milb_4ThInningEnd: 'MILB_4TH_INNING_END',
  Milb_4ThInningMiddle: 'MILB_4TH_INNING_MIDDLE',
  Milb_4ThInningStart: 'MILB_4TH_INNING_START',
  Milb_5ThInningEnd: 'MILB_5TH_INNING_END',
  Milb_5ThInningMiddle: 'MILB_5TH_INNING_MIDDLE',
  Milb_5ThInningStart: 'MILB_5TH_INNING_START',
  Milb_6ThInningEnd: 'MILB_6TH_INNING_END',
  Milb_6ThInningMiddle: 'MILB_6TH_INNING_MIDDLE',
  Milb_6ThInningStart: 'MILB_6TH_INNING_START',
  Milb_7ThInningEnd: 'MILB_7TH_INNING_END',
  Milb_7ThInningMiddle: 'MILB_7TH_INNING_MIDDLE',
  Milb_7ThInningStart: 'MILB_7TH_INNING_START',
  Milb_8ThInningEnd: 'MILB_8TH_INNING_END',
  Milb_8ThInningMiddle: 'MILB_8TH_INNING_MIDDLE',
  Milb_8ThInningStart: 'MILB_8TH_INNING_START',
  Milb_9ThInningEnd: 'MILB_9TH_INNING_END',
  Milb_9ThInningMiddle: 'MILB_9TH_INNING_MIDDLE',
  Milb_9ThInningStart: 'MILB_9TH_INNING_START',
  MilbEndGame: 'MILB_END_GAME',
  MilbHomeRun: 'MILB_HOME_RUN',
  MilbHomeTeamLoss: 'MILB_HOME_TEAM_LOSS',
  MilbHomeTeamWin: 'MILB_HOME_TEAM_WIN',
  Mlb_1StInningEnd: 'MLB_1ST_INNING_END',
  Mlb_1StInningMiddle: 'MLB_1ST_INNING_MIDDLE',
  Mlb_1StInningStart: 'MLB_1ST_INNING_START',
  Mlb_2NdInningEnd: 'MLB_2ND_INNING_END',
  Mlb_2NdInningMiddle: 'MLB_2ND_INNING_MIDDLE',
  Mlb_2NdInningStart: 'MLB_2ND_INNING_START',
  Mlb_3RdInningEnd: 'MLB_3RD_INNING_END',
  Mlb_3RdInningMiddle: 'MLB_3RD_INNING_MIDDLE',
  Mlb_3RdInningStart: 'MLB_3RD_INNING_START',
  Mlb_4ThInningEnd: 'MLB_4TH_INNING_END',
  Mlb_4ThInningMiddle: 'MLB_4TH_INNING_MIDDLE',
  Mlb_4ThInningStart: 'MLB_4TH_INNING_START',
  Mlb_5ThInningEnd: 'MLB_5TH_INNING_END',
  Mlb_5ThInningMiddle: 'MLB_5TH_INNING_MIDDLE',
  Mlb_5ThInningStart: 'MLB_5TH_INNING_START',
  Mlb_6ThInningEnd: 'MLB_6TH_INNING_END',
  Mlb_6ThInningMiddle: 'MLB_6TH_INNING_MIDDLE',
  Mlb_6ThInningStart: 'MLB_6TH_INNING_START',
  Mlb_7ThInningEnd: 'MLB_7TH_INNING_END',
  Mlb_7ThInningMiddle: 'MLB_7TH_INNING_MIDDLE',
  Mlb_7ThInningStart: 'MLB_7TH_INNING_START',
  Mlb_8ThInningEnd: 'MLB_8TH_INNING_END',
  Mlb_8ThInningMiddle: 'MLB_8TH_INNING_MIDDLE',
  Mlb_8ThInningStart: 'MLB_8TH_INNING_START',
  Mlb_9ThInningEnd: 'MLB_9TH_INNING_END',
  Mlb_9ThInningMiddle: 'MLB_9TH_INNING_MIDDLE',
  Mlb_9ThInningStart: 'MLB_9TH_INNING_START',
  MlbEndGame: 'MLB_END_GAME',
  MlbHomeRun: 'MLB_HOME_RUN',
  MlbHomeTeamLoss: 'MLB_HOME_TEAM_LOSS',
  MlbHomeTeamWin: 'MLB_HOME_TEAM_WIN',
  MlsEndGame: 'MLS_END_GAME',
  MlsHomeTeamGoal: 'MLS_HOME_TEAM_GOAL',
  MlsHomeTeamLoss: 'MLS_HOME_TEAM_LOSS',
  MlsHomeTeamWin: 'MLS_HOME_TEAM_WIN',
  MlsStart_2NdHalf: 'MLS_START_2ND_HALF',
  MlsStartHalftime: 'MLS_START_HALFTIME',
  NbaEndGame: 'NBA_END_GAME',
  NbaEndQuarter_1: 'NBA_END_QUARTER_1',
  NbaEndQuarter_3: 'NBA_END_QUARTER_3',
  NbaHomeTeamLoss: 'NBA_HOME_TEAM_LOSS',
  NbaHomeTeamWin: 'NBA_HOME_TEAM_WIN',
  NbaStartHalftime: 'NBA_START_HALFTIME',
  NbaStartQuarter_2: 'NBA_START_QUARTER_2',
  NbaStartQuarter_3: 'NBA_START_QUARTER_3',
  NbaStartQuarter_4: 'NBA_START_QUARTER_4',
  NcaafEndQuarter_1: 'NCAAF_END_QUARTER_1',
  NcaafEndQuarter_3: 'NCAAF_END_QUARTER_3',
  NcaafEndTime: 'NCAAF_END_TIME',
  NcaafFieldGoal: 'NCAAF_FIELD_GOAL',
  NcaafHomeTeamLoss: 'NCAAF_HOME_TEAM_LOSS',
  NcaafHomeTeamWin: 'NCAAF_HOME_TEAM_WIN',
  NcaafStartHalftime: 'NCAAF_START_HALFTIME',
  NcaafStartQuarter_2: 'NCAAF_START_QUARTER_2',
  NcaafStartQuarter_3: 'NCAAF_START_QUARTER_3',
  NcaafStartQuarter_4: 'NCAAF_START_QUARTER_4',
  NcaafTouchdown: 'NCAAF_TOUCHDOWN',
  NflEndQuarter_1: 'NFL_END_QUARTER_1',
  NflEndQuarter_3: 'NFL_END_QUARTER_3',
  NflEndTime: 'NFL_END_TIME',
  NflFieldGoal: 'NFL_FIELD_GOAL',
  NflHomeTeamLoss: 'NFL_HOME_TEAM_LOSS',
  NflHomeTeamWin: 'NFL_HOME_TEAM_WIN',
  NflOvertime: 'NFL_OVERTIME',
  NflStartHalftime: 'NFL_START_HALFTIME',
  NflStartQuarter_2: 'NFL_START_QUARTER_2',
  NflStartQuarter_3: 'NFL_START_QUARTER_3',
  NflStartQuarter_4: 'NFL_START_QUARTER_4',
  NflTouchdown: 'NFL_TOUCHDOWN',
  NhlEndGame: 'NHL_END_GAME',
  NhlGoal: 'NHL_GOAL',
  NhlHomeTeamLoss: 'NHL_HOME_TEAM_LOSS',
  NhlHomeTeamWin: 'NHL_HOME_TEAM_WIN',
  NhlOvertime: 'NHL_OVERTIME',
  NhlStart_1StIntermission: 'NHL_START_1ST_INTERMISSION',
  NhlStart_2NdIntermission: 'NHL_START_2ND_INTERMISSION',
  NhlStartPeriod_2: 'NHL_START_PERIOD_2',
  NhlStartPeriod_3: 'NHL_START_PERIOD_3',
  NwslEndGame: 'NWSL_END_GAME',
  NwslHomeTeamGoal: 'NWSL_HOME_TEAM_GOAL',
  NwslHomeTeamLoss: 'NWSL_HOME_TEAM_LOSS',
  NwslHomeTeamWin: 'NWSL_HOME_TEAM_WIN',
  NwslStart_2NdHalf: 'NWSL_START_2ND_HALF',
  NwslStartHalftime: 'NWSL_START_HALFTIME'
} as const;

export type DeviceSignalEvent = typeof DeviceSignalEvent[keyof typeof DeviceSignalEvent];
export interface DeviceSignalFilters {
  readonly __typename: 'DeviceSignalFilters';
  readonly action: ReadonlyArray<FilterCount>;
  readonly eventType: ReadonlyArray<FilterCount>;
  readonly kind: ReadonlyArray<FilterCount>;
  readonly tags: ReadonlyArray<FilterCount>;
}

export const DeviceSignalFrequency = {
  Daily: 'DAILY',
  Once: 'ONCE',
  Weekly: 'WEEKLY'
} as const;

export type DeviceSignalFrequency = typeof DeviceSignalFrequency[keyof typeof DeviceSignalFrequency];
export interface DeviceSignalInput {
  readonly action: Scalars['JSON']['input'];
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly event?: InputMaybe<Scalars['JSON']['input']>;
  readonly eventTypeId?: InputMaybe<Scalars['Int']['input']>;
  readonly kind: DeviceSignalKind;
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
  readonly schedule?: InputMaybe<DeviceSignalScheduleInput>;
  readonly target: DeviceSignalTarget;
}

export const DeviceSignalKind = {
  Event: 'EVENT',
  Manual: 'MANUAL'
} as const;

export type DeviceSignalKind = typeof DeviceSignalKind[keyof typeof DeviceSignalKind];
export interface DeviceSignalPage {
  readonly __typename: 'DeviceSignalPage';
  readonly nodes: ReadonlyArray<DeviceSignal>;
  readonly pageInfo: PaginationInfo;
}

export interface DeviceSignalPatch {
  readonly action?: InputMaybe<Scalars['JSON']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly event?: InputMaybe<Scalars['JSON']['input']>;
  readonly eventTypeId?: InputMaybe<Scalars['Int']['input']>;
  readonly kind?: InputMaybe<DeviceSignalKind>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly schedule?: InputMaybe<DeviceSignalScheduleInput>;
  readonly target?: InputMaybe<DeviceSignalTarget>;
}

export interface DeviceSignalSchedule {
  readonly __typename: 'DeviceSignalSchedule';
  readonly endsOn?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly frequency: DeviceSignalFrequency;
  readonly startTime: Scalars['String']['output'];
  readonly startsOn: Scalars['ISO8601Date']['output'];
  readonly weekdays?: Maybe<ReadonlyArray<Scalars['Int']['output']>>;
}

export interface DeviceSignalScheduleInput {
  readonly endsOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly frequency: DeviceSignalFrequency;
  readonly startTime: Scalars['String']['input'];
  readonly startsOn: Scalars['ISO8601Date']['input'];
  readonly weekdays?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface DeviceSignalTag {
  readonly __typename: 'DeviceSignalTag';
  readonly name: Scalars['String']['output'];
  readonly uses: Scalars['Int']['output'];
}

export type DeviceSignalTarget =
  { readonly allDevices: Scalars['Boolean']['input']; readonly deviceDynamicCollectionId?: never; readonly deviceGroupId?: never; }
  |  { readonly allDevices?: never; readonly deviceDynamicCollectionId: Scalars['Int']['input']; readonly deviceGroupId?: never; }
  |  { readonly allDevices?: never; readonly deviceDynamicCollectionId?: never; readonly deviceGroupId: Scalars['Int']['input']; };

export const DeviceSignalsOrderBy = {
  KindAsc: 'KIND_ASC',
  KindDesc: 'KIND_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type DeviceSignalsOrderBy = typeof DeviceSignalsOrderBy[keyof typeof DeviceSignalsOrderBy];
export interface DeviceStats {
  readonly __typename: 'DeviceStats';
  readonly activeCount: Scalars['Int']['output'];
  readonly displayOffCount: Scalars['Int']['output'];
  readonly displayOnCount: Scalars['Int']['output'];
  readonly errorCount: Scalars['Int']['output'];
  readonly healthyCount: Scalars['Int']['output'];
  readonly silenceCount: Scalars['Int']['output'];
  readonly warnCount: Scalars['Int']['output'];
}

export const DeviceStatus = {
  Error: 'ERROR',
  Healthy: 'HEALTHY',
  Warn: 'WARN'
} as const;

export type DeviceStatus = typeof DeviceStatus[keyof typeof DeviceStatus];
export interface DeviceStatusInput {
  readonly currentChannelId?: InputMaybe<Scalars['BigInt']['input']>;
  readonly currentViewId?: InputMaybe<Scalars['BigInt']['input']>;
  readonly displayOn?: InputMaybe<Scalars['Boolean']['input']>;
  readonly environments: ReadonlyArray<Scalars['String']['input']>;
  readonly ipAddress: Scalars['InternetAddress']['input'];
  readonly libraryVersion: SemverInput;
  readonly macAddress?: InputMaybe<Scalars['String']['input']>;
  readonly metadata?: InputMaybe<Scalars['JSON']['input']>;
  readonly playerVersion: SemverInput;
  readonly systemInfo?: InputMaybe<SystemInfoInput>;
}

export interface DeviceTag {
  readonly __typename: 'DeviceTag';
  readonly name: Scalars['String']['output'];
  readonly uses: Scalars['Int']['output'];
}

export const DevicesOrderBy = {
  ActiveAsc: 'ACTIVE_ASC',
  ActiveDesc: 'ACTIVE_DESC',
  ActiveShowAsc: 'ACTIVE_SHOW_ASC',
  ActiveShowDesc: 'ACTIVE_SHOW_DESC',
  ConnectedAsc: 'CONNECTED_ASC',
  ConnectedDesc: 'CONNECTED_DESC',
  CpuPercentageAsc: 'CPU_PERCENTAGE_ASC',
  CpuPercentageDesc: 'CPU_PERCENTAGE_DESC',
  CpuTemperatureAsc: 'CPU_TEMPERATURE_ASC',
  CpuTemperatureDesc: 'CPU_TEMPERATURE_DESC',
  DiskUsageAsc: 'DISK_USAGE_ASC',
  DiskUsageDesc: 'DISK_USAGE_DESC',
  DisplayServerAsc: 'DISPLAY_SERVER_ASC',
  DisplayServerDesc: 'DISPLAY_SERVER_DESC',
  IdAsc: 'ID_ASC',
  IdDesc: 'ID_DESC',
  IpAddressAsc: 'IP_ADDRESS_ASC',
  IpAddressDesc: 'IP_ADDRESS_DESC',
  MacAddressAsc: 'MAC_ADDRESS_ASC',
  MacAddressDesc: 'MAC_ADDRESS_DESC',
  MemoryUsageAsc: 'MEMORY_USAGE_ASC',
  MemoryUsageDesc: 'MEMORY_USAGE_DESC',
  ModelAsc: 'MODEL_ASC',
  ModelDesc: 'MODEL_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC',
  NetworkAsc: 'NETWORK_ASC',
  NetworkDesc: 'NETWORK_DESC',
  OsUptimeAsc: 'OS_UPTIME_ASC',
  OsUptimeDesc: 'OS_UPTIME_DESC',
  PlayerVersionAsc: 'PLAYER_VERSION_ASC',
  PlayerVersionDesc: 'PLAYER_VERSION_DESC',
  ProcessUptimeAsc: 'PROCESS_UPTIME_ASC',
  ProcessUptimeDesc: 'PROCESS_UPTIME_DESC',
  StoragePercentAsc: 'STORAGE_PERCENT_ASC',
  StoragePercentDesc: 'STORAGE_PERCENT_DESC'
} as const;

export type DevicesOrderBy = typeof DevicesOrderBy[keyof typeof DevicesOrderBy];
/** Autogenerated input type of DuplicateDeviceSignal */
export interface DuplicateDeviceSignalInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceSignalId: Scalars['Int']['input'];
}

/** Autogenerated return type of DuplicateDeviceSignal. */
export interface DuplicateDeviceSignalPayload {
  readonly __typename: 'DuplicateDeviceSignalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceSignal: DeviceSignal;
}

/** Autogenerated input type of DuplicateTVBrand */
export interface DuplicateTvBrandInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly networkId: Scalars['Int']['input'];
  readonly tvBrandId: Scalars['Int']['input'];
}

/** Autogenerated return type of DuplicateTVBrand. */
export interface DuplicateTvBrandPayload {
  readonly __typename: 'DuplicateTVBrandPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tvBrand: TvBrand;
}

export interface Event {
  readonly __typename: 'Event';
  readonly actualStop?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly canDestroy: AuthorizationResult;
  readonly canOverride: AuthorizationResult;
  readonly canRerunRollups: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly contentBuffer: Scalars['Boolean']['output'];
  readonly contentStart: Scalars['ISO8601DateTime']['output'];
  readonly contentStop: Scalars['ISO8601DateTime']['output'];
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly eventType: EventType;
  readonly fcEventId?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly includeInPlayoutReporting: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly overrideCount: Scalars['Int']['output'];
  readonly rollupRequested: Scalars['Boolean']['output'];
  readonly season?: Maybe<Season>;
  readonly showDeviceGroups?: Maybe<ReadonlyArray<ShowEventDeviceGroup>>;
  readonly sponsorStartTime?: Maybe<Scalars['ISO8601Duration']['output']>;
  readonly sponsorStopTime?: Maybe<Scalars['ISO8601Duration']['output']>;
  readonly start: Scalars['ISO8601DateTime']['output'];
  readonly stop: Scalars['ISO8601DateTime']['output'];
  readonly syncingFromAdmin: Scalars['Boolean']['output'];
  readonly updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
}

export type EventIdentifier =
  { readonly fcEventId: Scalars['Int']['input']; readonly id?: never; }
  |  { readonly fcEventId?: never; readonly id: Scalars['Int']['input']; };

export interface EventPatch {
  readonly actualStop?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly includeInPlayoutReporting?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly sponsorStartTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly sponsorStopTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly stop?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}

export interface EventType {
  readonly __typename: 'EventType';
  readonly canDestroy: AuthorizationResult;
  readonly canShow: AuthorizationResult;
  readonly canSync: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly color?: Maybe<Scalars['String']['output']>;
  readonly contentStartTime: Scalars['ISO8601Duration']['output'];
  readonly contentStopTime: Scalars['ISO8601Duration']['output'];
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly event: Event;
  readonly eventCount: Scalars['Int']['output'];
  readonly eventIdsWithRollups: ReadonlyArray<Scalars['Int']['output']>;
  readonly events: ReadonlyArray<Event>;
  readonly fcLeagueId?: Maybe<Scalars['Int']['output']>;
  readonly fcTeamId?: Maybe<Scalars['Int']['output']>;
  readonly iconFile?: Maybe<File>;
  readonly id: Scalars['Int']['output'];
  readonly manageDisplay: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly seasons: ReadonlyArray<Season>;
  readonly showDeviceGroups?: Maybe<ReadonlyArray<ShowEventTypeDeviceGroup>>;
  readonly signalType: Scalars['String']['output'];
  readonly sponsorStartTime: Scalars['ISO8601Duration']['output'];
  readonly sponsorStopTime: Scalars['ISO8601Duration']['output'];
  readonly syncFcAdmin: Scalars['Boolean']['output'];
  readonly updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
}


export interface EventTypeEventArgs {
  id: Scalars['Int']['input'];
}


export interface EventTypeEventCountArgs {
  includeInPlayoutReporting?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface EventTypeEventsArgs {
  includeInPlayoutReporting?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface EventTypePage {
  readonly __typename: 'EventTypePage';
  readonly nodes: ReadonlyArray<EventType>;
  readonly pageInfo: PaginationInfo;
}

export interface EventTypePatch {
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly contentStartTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly contentStopTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly fcLeagueId?: InputMaybe<Scalars['Int']['input']>;
  readonly fcTeamId?: InputMaybe<Scalars['Int']['input']>;
  readonly iconUri?: InputMaybe<Scalars['String']['input']>;
  readonly manageDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly sponsorStartTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly sponsorStopTime?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly syncFcAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface EventTypeRule {
  readonly __typename: 'EventTypeRule';
  readonly eventType: EventType;
  readonly id: Scalars['Int']['output'];
}

export interface EventTypeShowsDeviceGroupsPatch {
  readonly showsDeviceGroups: ReadonlyArray<ShowsDeviceGroupsInput>;
}

export const EventTypesOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type EventTypesOrderBy = typeof EventTypesOrderBy[keyof typeof EventTypesOrderBy];
/** Autogenerated input type of ExportAuditLogs */
export interface ExportAuditLogsInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly filters?: InputMaybe<AuditLogExportFilterInput>;
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of ExportAuditLogs. */
export interface ExportAuditLogsPayload {
  readonly __typename: 'ExportAuditLogsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
}

/** Autogenerated input type of ExportDataSource */
export interface ExportDataSourceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of ExportDataSource. */
export interface ExportDataSourcePayload {
  readonly __typename: 'ExportDataSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
}

/** Autogenerated input type of ExportDevices */
export interface ExportDevicesInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly condition?: InputMaybe<DeviceCondition>;
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of ExportDevices. */
export interface ExportDevicesPayload {
  readonly __typename: 'ExportDevicesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
}

export interface FailureReasons {
  readonly __typename: 'FailureReasons';
  /** JSON-encoded map of reasons */
  readonly details: Scalars['String']['output'];
  /** Human-readable errors */
  readonly fullMessages: ReadonlyArray<Scalars['String']['output']>;
}

export interface FanconnectConfig {
  readonly __typename: 'FanconnectConfig';
  readonly apiKey: Scalars['String']['output'];
  readonly autoschedule: Scalars['Boolean']['output'];
  readonly domain: Scalars['String']['output'];
  readonly leagueName: Scalars['String']['output'];
  readonly subdomain: Scalars['String']['output'];
}

export interface FanconnectConfigInput {
  readonly apiKey: Scalars['String']['input'];
  readonly autoschedule: Scalars['Boolean']['input'];
  readonly domain: Scalars['String']['input'];
  readonly leagueName: Scalars['String']['input'];
  readonly subdomain: Scalars['String']['input'];
}

export interface File {
  readonly __typename: 'File';
  readonly bucket: Scalars['String']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly downloadUri: Scalars['String']['output'];
  readonly filename: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly ipAddress?: Maybe<Scalars['InternetAddress']['output']>;
  readonly kind: FileKind;
  readonly md5Sum: Scalars['String']['output'];
  readonly mimeType: Scalars['String']['output'];
  readonly network: Network;
  readonly networkId: Scalars['Int']['output'];
  readonly objectKey: Scalars['String']['output'];
  readonly originalFilename: Scalars['String']['output'];
  readonly size: Scalars['BigIntNumber']['output'];
  readonly source: Scalars['String']['output'];
  readonly uncompressedSize?: Maybe<Scalars['BigIntNumber']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly uri: Scalars['String']['output'];
}


export interface FileDownloadUriArgs {
  expires?: InputMaybe<Scalars['Int']['input']>;
}


export interface FileUriArgs {
  expires?: InputMaybe<Scalars['Int']['input']>;
}

export const FileKind = {
  /** Generic file */
  File: 'FILE',
  /** ZIP archive */
  Zip: 'ZIP'
} as const;

export type FileKind = typeof FileKind[keyof typeof FileKind];
export interface FilterCount {
  readonly __typename: 'FilterCount';
  readonly count: Scalars['Int']['output'];
  readonly filter: Scalars['String']['output'];
}

export interface Font {
  readonly __typename: 'Font';
  readonly canDelete: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly file: File;
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface FontPage {
  readonly __typename: 'FontPage';
  readonly nodes: ReadonlyArray<Font>;
  readonly pageInfo: PaginationInfo;
}

export const FontsOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type FontsOrderBy = typeof FontsOrderBy[keyof typeof FontsOrderBy];
/** Autogenerated input type of ForgotPassword */
export interface ForgotPasswordInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
}

/** Autogenerated return type of ForgotPassword. */
export interface ForgotPasswordPayload {
  readonly __typename: 'ForgotPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of GeneratePlayoutDetailPdf */
export interface GeneratePlayoutDetailPdfInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly combineByName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deviceGroupIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly eventIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly eventTypeId: Scalars['Int']['input'];
  readonly from: Scalars['ISO8601DateTime']['input'];
  readonly identifier: PlayoutReportPdfIdentifier;
  readonly sections: ReadonlyArray<PlayoutReportPdfSection>;
  readonly to: Scalars['ISO8601DateTime']['input'];
}

/** Autogenerated return type of GeneratePlayoutDetailPdf. */
export interface GeneratePlayoutDetailPdfPayload {
  readonly __typename: 'GeneratePlayoutDetailPdfPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
}

/** Autogenerated input type of GenerateReport */
export interface GenerateReportInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceGroupIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly eventIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly eventTypeId: Scalars['Int']['input'];
  readonly from: Scalars['ISO8601DateTime']['input'];
  readonly to: Scalars['ISO8601DateTime']['input'];
}

/** Autogenerated return type of GenerateReport. */
export interface GenerateReportPayload {
  readonly __typename: 'GenerateReportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
}

/** Autogenerated input type of GetDeviceCommand */
export interface GetDeviceCommandInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of GetDeviceCommand. */
export interface GetDeviceCommandPayload {
  readonly __typename: 'GetDeviceCommandPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly command?: Maybe<Scalars['JSON']['output']>;
}

export interface GroupedTemplateParams {
  readonly __typename: 'GroupedTemplateParams';
  readonly paramGroup?: Maybe<TemplateParamGroup>;
  readonly params: ReadonlyArray<TemplateParam>;
}

/** Autogenerated input type of Impersonate */
export interface ImpersonateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of Impersonate. */
export interface ImpersonatePayload {
  readonly __typename: 'ImpersonatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user: User;
}

/** An interval of time that has passed where the smallest distinct unit is a second. */
export interface Interval {
  readonly __typename: 'Interval';
  /** A quantity of days. */
  readonly days: Scalars['Int']['output'];
  /** A quantity of hours. */
  readonly hours: Scalars['Int']['output'];
  /** A quantity of minutes. */
  readonly minutes: Scalars['Int']['output'];
  /** A quantity of months. */
  readonly months: Scalars['Int']['output'];
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  readonly seconds: Scalars['Float']['output'];
  /** A quantity of years. */
  readonly years: Scalars['Int']['output'];
}

export interface IntervalInput {
  /** A quantity of days. */
  readonly days?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of hours. */
  readonly hours?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of minutes. */
  readonly minutes?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of months. */
  readonly months?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other fields will dump their "\
   *              "overflow into a smaller unit of time. Intervals don’t have a smaller unit than seconds.
   */
  readonly seconds?: InputMaybe<Scalars['Float']['input']>;
  /** A quantity of years. */
  readonly years?: InputMaybe<Scalars['Int']['input']>;
}

export interface Layout {
  readonly __typename: 'Layout';
  readonly canAddZone: AuthorizationResult;
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly height: Scalars['Float']['output'];
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly network: Network;
  readonly networkId: Scalars['Int']['output'];
  readonly orientation: Orientation;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly width: Scalars['Float']['output'];
  readonly zoneIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly zones: ReadonlyArray<Zone>;
}

export interface LayoutPage {
  readonly __typename: 'LayoutPage';
  readonly nodes: ReadonlyArray<Layout>;
  readonly pageInfo: PaginationInfo;
}

export interface LayoutPatch {
  readonly childIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
}

export const LayoutsOrderBy = {
  HeightAsc: 'HEIGHT_ASC',
  HeightDesc: 'HEIGHT_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC',
  WidthAsc: 'WIDTH_ASC',
  WidthDesc: 'WIDTH_DESC'
} as const;

export type LayoutsOrderBy = typeof LayoutsOrderBy[keyof typeof LayoutsOrderBy];
export interface League {
  readonly __typename: 'League';
  readonly id: Scalars['Int']['output'];
  readonly logoUrl?: Maybe<Scalars['String']['output']>;
  readonly longName?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly shortName?: Maybe<Scalars['String']['output']>;
}

export interface Location {
  readonly __typename: 'Location';
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly network: Network;
}

/** Autogenerated input type of Login */
export interface LoginInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly password: Scalars['String']['input'];
}

/** Autogenerated return type of Login. */
export interface LoginPayload {
  readonly __typename: 'LoginPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<Query>;
}

/** Autogenerated input type of Logout */
export interface LogoutInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of Logout. */
export interface LogoutPayload {
  readonly __typename: 'LogoutPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
}

export interface Manifest {
  readonly __typename: 'Manifest';
  /** `ContentItem`s used by this device */
  readonly contentItems: ReadonlyArray<ContentItem>;
  readonly device: Device;
  readonly event?: Maybe<Event>;
  readonly files: ReadonlyArray<File>;
  readonly layouts: ReadonlyArray<Layout>;
  readonly overlays: ReadonlyArray<Overlay>;
  readonly playlists: ReadonlyArray<Playlist>;
  readonly shows: ReadonlyArray<Show>;
}

export interface ManifestProperty {
  readonly __typename: 'ManifestProperty';
  readonly kind: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly propertyGroupName: Scalars['String']['output'];
  readonly value?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of MarkAnnouncementsRead */
export interface MarkAnnouncementsReadInput {
  readonly announcementIds: ReadonlyArray<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly read: Scalars['Boolean']['input'];
}

/** Autogenerated return type of MarkAnnouncementsRead. */
export interface MarkAnnouncementsReadPayload {
  readonly __typename: 'MarkAnnouncementsReadPayload';
  readonly announcements: ReadonlyArray<Announcement>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user: User;
}

export interface MediaItem extends Authorizable {
  readonly __typename: 'MediaItem';
  readonly canDestroy: AuthorizationResult;
  readonly canShow: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly contentFolderId: Scalars['Int']['output'];
  readonly contentItem: ContentItem;
  readonly contentItemCount: Scalars['Int']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly defaultDuration?: Maybe<Interval>;
  readonly designCount: Scalars['Int']['output'];
  /**
   * The file from the appropriate rendition for the device specified by `device_id`. \
   *            This should only be null if there are no renditions.
   */
  readonly file?: Maybe<File>;
  readonly folder: ContentFolder;
  readonly format?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly kind: MediaKind;
  readonly name: Scalars['String']['output'];
  readonly originalFile: File;
  readonly originalMetadata?: Maybe<Scalars['JSON']['output']>;
  readonly overlay?: Maybe<Overlay>;
  readonly playlistCount: Scalars['Int']['output'];
  readonly public: Scalars['Boolean']['output'];
  readonly renditions: ReadonlyArray<Rendition>;
  readonly status: MediaStatus;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  /** A public URL for the (smallest) thumbnail available, else `null` */
  readonly thumbnailUri?: Maybe<Scalars['String']['output']>;
  readonly thumbnails: ReadonlyArray<Thumbnail>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly usages: UsagePage;
  readonly useOriginal: Scalars['Boolean']['output'];
}


export interface MediaItemFileArgs {
  deviceId?: InputMaybe<Scalars['Int']['input']>;
}


export interface MediaItemUsagesArgs {
  orderBy?: InputMaybe<ReadonlyArray<ContentOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface MediaItemCondition {
  /** Aspect ratio as a decimal. Example: 16/9 ~= 1.77 */
  readonly aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  readonly folderId?: InputMaybe<Scalars['Int']['input']>;
  readonly kind?: InputMaybe<ReadonlyArray<MediaKind>>;
}

export interface MediaItemPatch {
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly useOriginal?: InputMaybe<Scalars['Boolean']['input']>;
}

export const MediaKind = {
  /** Image */
  Image: 'IMAGE',
  /** Pdf */
  Pdf: 'PDF',
  /** PowerPoint */
  Powerpoint: 'POWERPOINT',
  /** Studio */
  Studio: 'STUDIO',
  /** Video */
  Video: 'VIDEO'
} as const;

export type MediaKind = typeof MediaKind[keyof typeof MediaKind];
export const MediaStatus = {
  /** Processing underway */
  InProgress: 'IN_PROGRESS',
  /** Processing has not started yet */
  Pending: 'PENDING',
  /** Processing complete */
  Ready: 'READY'
} as const;

export type MediaStatus = typeof MediaStatus[keyof typeof MediaStatus];
/** Autogenerated input type of MoveContent */
export interface MoveContentInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentFolderId: Scalars['Int']['input'];
  readonly items: ReadonlyArray<ContentableInput>;
}

/** Autogenerated return type of MoveContent. */
export interface MoveContentPayload {
  readonly __typename: 'MoveContentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contentFolders: ReadonlyArray<ContentFolder>;
}

/** Autogenerated input type of MoveDesign */
export interface MoveDesignInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly designFolderId: Scalars['Int']['input'];
  readonly designIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of MoveDesign. */
export interface MoveDesignPayload {
  readonly __typename: 'MoveDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly designFolders: ReadonlyArray<DesignFolder>;
  readonly designs: ReadonlyArray<Design>;
}

/** Autogenerated input type of MovePlaylist */
export interface MovePlaylistInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly playlistFolderId: Scalars['Int']['input'];
  readonly playlistIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of MovePlaylist. */
export interface MovePlaylistPayload {
  readonly __typename: 'MovePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly playlistFolders: ReadonlyArray<PlaylistFolder>;
  readonly playlists: ReadonlyArray<Playlist>;
}

/** Autogenerated input type of MoveShow */
export interface MoveShowInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly showFolderId: Scalars['Int']['input'];
  readonly showIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of MoveShow. */
export interface MoveShowPayload {
  readonly __typename: 'MoveShowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly showFolders: ReadonlyArray<ShowFolder>;
  readonly shows: ReadonlyArray<Show>;
}

export interface Mutation {
  readonly __typename: 'Mutation';
  readonly activateDevice?: Maybe<ActivateDevicePayload>;
  /** Adds one or more `Channel`s to a `ChannelGuide` */
  readonly addChannelsToChannelGuide?: Maybe<AddChannelsToChannelGuidePayload>;
  readonly addContentFoldersToPlaylist?: Maybe<AddContentFoldersToPlaylistPayload>;
  /** Adds content to a `Playlist` */
  readonly addContentToPlaylist?: Maybe<AddContentToPlaylistPayload>;
  /** Adds content to a `Show` */
  readonly addContentToShow?: Maybe<AddContentToShowPayload>;
  /** Adds one or more `Device`s to a `DeviceGroup` */
  readonly addDevicesToDeviceGroup?: Maybe<AddDevicesToDeviceGroupPayload>;
  /** Adds users and entities to a `Role` */
  readonly addToRole?: Maybe<AddToRolePayload>;
  readonly aiChatSendMessage?: Maybe<AiChatSendMessagePayload>;
  readonly assignPropertyGroup?: Maybe<PropertyGroupAssignPayload>;
  readonly bulkTag?: Maybe<BulkTagPayload>;
  readonly bulkUpdateDevices?: Maybe<BulkUpdateDevicesPayload>;
  readonly cancelDeviceSignal?: Maybe<CancelDeviceSignalPayload>;
  readonly changeDataSourceAlcoholVisibility?: Maybe<ChangeDataSourceAlcoholVisibilityPayload>;
  readonly cleanupTemplateVersions?: Maybe<CleanupTemplateVersionsPayload>;
  readonly clearDeviceCache?: Maybe<ClearDeviceCachePayload>;
  readonly copyContentItem?: Maybe<CopyContentItemPayload>;
  readonly copyDesign?: Maybe<CopyDesignPayload>;
  readonly copyShow?: Maybe<CopyShowPayload>;
  readonly copyView?: Maybe<CopyViewPayload>;
  readonly createAwsCredentials?: Maybe<CreateAwsCredentialsPayload>;
  readonly createChannel?: Maybe<CreateChannelPayload>;
  /** Creates a new `ChannelGuide` */
  readonly createChannelGuide?: Maybe<CreateChannelGuidePayload>;
  readonly createContentFolder?: Maybe<CreateContentFolderPayload>;
  readonly createContentItem?: Maybe<CreateContentItemPayload>;
  readonly createDataItem?: Maybe<DataItemCreatePayload>;
  readonly createDesign?: Maybe<CreateDesignPayload>;
  readonly createDesignFolder?: Maybe<CreateDesignFolderPayload>;
  readonly createDeviceCollection?: Maybe<CreateDeviceCollectionPayload>;
  readonly createDeviceGroup?: Maybe<CreateDeviceGroupPayload>;
  readonly createDeviceSignal?: Maybe<CreateDeviceSignalPayload>;
  /** Creates an `Event for an `EventType` */
  readonly createEvent?: Maybe<CreateEventPayload>;
  /** Creates an `EventType` for a `Network` */
  readonly createEventType?: Maybe<CreateEventTypePayload>;
  /** Creates a `Font` for a `Network` */
  readonly createFont?: Maybe<CreateFontPayload>;
  /** Creates a `Layout` for a `Network` */
  readonly createLayout?: Maybe<CreateLayoutPayload>;
  readonly createOverlay?: Maybe<CreateOverlayPayload>;
  readonly createPlaylist?: Maybe<CreatePlaylistPayload>;
  readonly createPlaylistFolder?: Maybe<CreatePlaylistFolderPayload>;
  readonly createRemoteCredentials?: Maybe<CreateRemoteCredentialsPayload>;
  /** Creates a new `Role` in a `Network` */
  readonly createRole?: Maybe<CreateRolePayload>;
  readonly createScheduledShow?: Maybe<ScheduledShowMutationsCreatePayload>;
  /** Creates a `Season` for an `EventType` */
  readonly createSeason?: Maybe<CreateSeasonPayload>;
  readonly createShow?: Maybe<CreateShowPayload>;
  readonly createShowFolder?: Maybe<CreateShowFolderPayload>;
  /** Creates a `Show` instance for the provided origin `Show` */
  readonly createShowInstance?: Maybe<CreateShowInstancePayload>;
  readonly createTemplate?: Maybe<CreateTemplatePayload>;
  readonly createTemplateVersion?: Maybe<CreateTemplateVersionPayload>;
  readonly createTvBrand?: Maybe<CreateTvBrandPayload>;
  readonly createUploadConfig?: Maybe<CreateUploadConfigPayload>;
  readonly createUser?: Maybe<CreateUserPayload>;
  readonly createView?: Maybe<CreateViewPayload>;
  readonly createViewZonePlaylist?: Maybe<CreateViewZonePlaylistPayload>;
  /** Creates a `Zone` for a `Layout` */
  readonly createZone?: Maybe<CreateZonePayload>;
  /** Deletes `Channel`s by ID from a `Network` */
  readonly deleteChannel?: Maybe<DeleteChannelPayload>;
  /** Deletes `ChannelGuide`s from a `Network` */
  readonly deleteChannelGuide?: Maybe<DeleteChannelGuidePayload>;
  readonly deleteContent?: Maybe<DeleteContentPayload>;
  readonly deleteContentFolder?: Maybe<DeleteContentFolderPayload>;
  readonly deleteDataItem?: Maybe<DataItemDeletePayload>;
  readonly deleteDataSource?: Maybe<DeleteDataSourcePayload>;
  readonly deleteDesign?: Maybe<DeleteDesignPayload>;
  readonly deleteDesignFolder?: Maybe<DeleteDesignFolderPayload>;
  readonly deleteDevice?: Maybe<DeleteDevicePayload>;
  readonly deleteDeviceCollection?: Maybe<DeleteDeviceCollectionPayload>;
  readonly deleteDeviceGroup?: Maybe<DeleteDeviceGroupPayload>;
  readonly deleteDeviceSignal?: Maybe<DeleteDeviceSignalPayload>;
  readonly deleteEvent?: Maybe<DeleteEventPayload>;
  readonly deleteEventType?: Maybe<DeleteEventTypePayload>;
  /** Deletes a `Font` */
  readonly deleteFont?: Maybe<DeleteFontPayload>;
  readonly deleteLayout?: Maybe<DeleteLayoutPayload>;
  readonly deleteOverlay?: Maybe<DeleteOverlayPayload>;
  readonly deletePlaylist?: Maybe<DeletePlaylistPayload>;
  readonly deletePlaylistFolder?: Maybe<DeletePlaylistFolderPayload>;
  readonly deletePlaylistItem?: Maybe<DeletePlaylistItemPayload>;
  /** Deletes `Role`s from a `Network` */
  readonly deleteRoles?: Maybe<DeleteRolesPayload>;
  readonly deleteScheduledShow?: Maybe<ScheduledShowMutationsDeletePayload>;
  readonly deleteSeason?: Maybe<DeleteSeasonPayload>;
  readonly deleteShow?: Maybe<DeleteShowPayload>;
  readonly deleteShowFolder?: Maybe<DeleteShowFolderPayload>;
  readonly deleteTag?: Maybe<DeleteTagPayload>;
  readonly deleteTemplate?: Maybe<DeleteTemplatePayload>;
  readonly deleteTvBrand?: Maybe<DeleteTvBrandPayload>;
  readonly deleteUser?: Maybe<DeleteUserPayload>;
  readonly deleteView?: Maybe<DeleteViewPayload>;
  readonly deleteViewZonePlaylist?: Maybe<DeleteViewZonePlaylistPayload>;
  readonly deleteZone?: Maybe<DeleteZonePayload>;
  readonly duplicateDeviceSignal?: Maybe<DuplicateDeviceSignalPayload>;
  readonly duplicateTvBrand?: Maybe<DuplicateTvBrandPayload>;
  /** Exports audit logs to a CSV file */
  readonly exportAuditLogs?: Maybe<ExportAuditLogsPayload>;
  readonly exportDataSource?: Maybe<ExportDataSourcePayload>;
  /** Exports devices to a CSV file */
  readonly exportDevices?: Maybe<ExportDevicesPayload>;
  readonly forgotPassword?: Maybe<ForgotPasswordPayload>;
  /** Generates a PDF report for a playout report asset or sponsor detail page */
  readonly generatePlayoutDetailPdf?: Maybe<GeneratePlayoutDetailPdfPayload>;
  /** Generates a sponsor playback report */
  readonly generateReport?: Maybe<GenerateReportPayload>;
  readonly getDeviceCommand?: Maybe<GetDeviceCommandPayload>;
  readonly impersonate?: Maybe<ImpersonatePayload>;
  readonly login?: Maybe<LoginPayload>;
  readonly logout?: Maybe<LogoutPayload>;
  readonly markAnnouncementsRead?: Maybe<MarkAnnouncementsReadPayload>;
  readonly moveContent?: Maybe<MoveContentPayload>;
  readonly moveDesign?: Maybe<MoveDesignPayload>;
  readonly movePlaylist?: Maybe<MovePlaylistPayload>;
  readonly moveShow?: Maybe<MoveShowPayload>;
  /** Plays selected content on devices via an all-day-every-day scheduled show */
  readonly playContentOnDevices?: Maybe<PlayContentOnDevicesPayload>;
  readonly publishDesign?: Maybe<PublishDesignPayload>;
  readonly registerDevice?: Maybe<RegisterDevicePayload>;
  /** Removes one or more `Device`s from a `DeviceGroup` */
  readonly removeDevicesFromDeviceGroup?: Maybe<RemoveDevicesFromDeviceGroupPayload>;
  /** Removes one or more `Device`s from a `ScheduledShow` */
  readonly removeDevicesFromScheduledShow?: Maybe<RemoveDevicesFromScheduledShowPayload>;
  /** Removes users and entities from a `Role` */
  readonly removeFromRole?: Maybe<RemoveFromRolePayload>;
  readonly removePropertyGroup?: Maybe<PropertyGroupRemovePayload>;
  readonly renameTag?: Maybe<RenameTagPayload>;
  readonly rerunEventRollups?: Maybe<RerunEventRollupsPayload>;
  readonly resendConfirmation?: Maybe<ResendConfirmationPayload>;
  readonly resetPassword?: Maybe<ResetPasswordPayload>;
  readonly runDeviceSignal?: Maybe<RunDeviceSignalPayload>;
  readonly runSignalByEventName?: Maybe<RunSignalByEventNamePayload>;
  readonly sendDeviceCommand?: Maybe<SendDeviceCommandPayload>;
  readonly sendRemoteCommand?: Maybe<SendRemoteCommandPayload>;
  readonly setPassword?: Maybe<SetPasswordPayload>;
  readonly shufflePlaylist?: Maybe<ShufflePlaylistPayload>;
  readonly stopImpersonate?: Maybe<StopImpersonatePayload>;
  readonly syncDataSource?: Maybe<SyncDataSourcePayload>;
  /** Syncs events from FanConnect Sports Information Service */
  readonly syncEvents?: Maybe<SyncEventsPayload>;
  readonly transferDevice?: Maybe<TransferDevicePayload>;
  readonly tuneRemoteChannel?: Maybe<TuneRemoteChannelPayload>;
  /** Updates a channel by id */
  readonly updateChannel?: Maybe<UpdateChannelPayload>;
  /** Updates a `ChannelGuide` by id */
  readonly updateChannelGuide?: Maybe<UpdateChannelGuidePayload>;
  readonly updateContentFolder?: Maybe<UpdateContentFolderPayload>;
  readonly updateContentItem?: Maybe<UpdateContentItemPayload>;
  readonly updateDataItem?: Maybe<DataItemUpdatePayload>;
  readonly updateDataSource?: Maybe<UpdateDataSourcePayload>;
  readonly updateDesign?: Maybe<UpdateDesignPayload>;
  readonly updateDesignFolder?: Maybe<UpdateDesignFolderPayload>;
  readonly updateDevice?: Maybe<UpdateDevicePayload>;
  readonly updateDeviceGroup?: Maybe<UpdateDeviceGroupPayload>;
  readonly updateDeviceSignal?: Maybe<UpdateDeviceSignalPayload>;
  /** @deprecated Switch to `updateDeviceStatusV3` */
  readonly updateDeviceStatusV2?: Maybe<UpdateDeviceStatusPayload>;
  readonly updateDeviceStatusV3?: Maybe<UpdateDeviceStatusV3Payload>;
  readonly updateEvent?: Maybe<UpdateEventPayload>;
  readonly updateEventType?: Maybe<UpdateEventTypePayload>;
  readonly updateEventTypeShowsDeviceGroups?: Maybe<UpdateEventTypeShowsDeviceGroupsPayload>;
  /** Updates a `Font` */
  readonly updateFont?: Maybe<UpdateFontPayload>;
  readonly updateLayout?: Maybe<UpdateLayoutPayload>;
  readonly updateMediaItem?: Maybe<UpdateMediaItemPayload>;
  readonly updateNetwork?: Maybe<UpdateNetworkPayload>;
  readonly updateOverlay?: Maybe<UpdateOverlayPayload>;
  readonly updatePlaylist?: Maybe<UpdatePlaylistPayload>;
  readonly updatePlaylistFolder?: Maybe<UpdatePlaylistFolderPayload>;
  readonly updatePlaylistItem?: Maybe<UpdatePlaylistItemPayload>;
  readonly updatePropertyValue?: Maybe<PropertyValueUpdatePayload>;
  /** Updates a `Role` by id */
  readonly updateRole?: Maybe<UpdateRolePayload>;
  readonly updateScheduledShow?: Maybe<ScheduledShowMutationsUpdatePayload>;
  readonly updateSeason?: Maybe<UpdateSeasonPayload>;
  readonly updateShow?: Maybe<UpdateShowPayload>;
  readonly updateShowFolder?: Maybe<UpdateShowFolderPayload>;
  readonly updateTags?: Maybe<UpdateTagsPayload>;
  readonly updateTemplate?: Maybe<UpdateTemplatePayload>;
  readonly updateTvBrand?: Maybe<UpdateTvBrandPayload>;
  readonly updateUser?: Maybe<UpdateUserPayload>;
  readonly updateView?: Maybe<UpdateViewPayload>;
  readonly updateViewZone?: Maybe<UpdateViewZonePayload>;
  readonly updateZone?: Maybe<UpdateZonePayload>;
  readonly upgradeAllContentItems?: Maybe<UpgradeAllContentItemsPayload>;
  readonly upgradeContentItem?: Maybe<UpgradeContentItemPayload>;
  readonly uploadDataSource?: Maybe<UploadDataSourcePayload>;
}


export interface MutationActivateDeviceArgs {
  input: ActivateDeviceInput;
}


export interface MutationAddChannelsToChannelGuideArgs {
  input: AddChannelsToChannelGuideInput;
}


export interface MutationAddContentFoldersToPlaylistArgs {
  input: AddContentFoldersToPlaylistInput;
}


export interface MutationAddContentToPlaylistArgs {
  input: AddContentToPlaylistInput;
}


export interface MutationAddContentToShowArgs {
  input: AddContentToShowInput;
}


export interface MutationAddDevicesToDeviceGroupArgs {
  input: AddDevicesToDeviceGroupInput;
}


export interface MutationAddToRoleArgs {
  input: AddToRoleInput;
}


export interface MutationAiChatSendMessageArgs {
  input: AiChatSendMessageInput;
}


export interface MutationAssignPropertyGroupArgs {
  input: PropertyGroupAssignInput;
}


export interface MutationBulkTagArgs {
  input: BulkTagInput;
}


export interface MutationBulkUpdateDevicesArgs {
  input: BulkUpdateDevicesInput;
}


export interface MutationCancelDeviceSignalArgs {
  input: CancelDeviceSignalInput;
}


export interface MutationChangeDataSourceAlcoholVisibilityArgs {
  input: ChangeDataSourceAlcoholVisibilityInput;
}


export interface MutationCleanupTemplateVersionsArgs {
  input: CleanupTemplateVersionsInput;
}


export interface MutationClearDeviceCacheArgs {
  input: ClearDeviceCacheInput;
}


export interface MutationCopyContentItemArgs {
  input: CopyContentItemInput;
}


export interface MutationCopyDesignArgs {
  input: CopyDesignInput;
}


export interface MutationCopyShowArgs {
  input: CopyShowInput;
}


export interface MutationCopyViewArgs {
  input: CopyViewInput;
}


export interface MutationCreateAwsCredentialsArgs {
  input: CreateAwsCredentialsInput;
}


export interface MutationCreateChannelArgs {
  input: CreateChannelInput;
}


export interface MutationCreateChannelGuideArgs {
  input: CreateChannelGuideInput;
}


export interface MutationCreateContentFolderArgs {
  input: CreateContentFolderInput;
}


export interface MutationCreateContentItemArgs {
  input: ContentItemInput;
}


export interface MutationCreateDataItemArgs {
  input: DataItemCreateInput;
}


export interface MutationCreateDesignArgs {
  input: CreateDesignInput;
}


export interface MutationCreateDesignFolderArgs {
  input: CreateDesignFolderInput;
}


export interface MutationCreateDeviceCollectionArgs {
  input: CreateDeviceCollectionInput;
}


export interface MutationCreateDeviceGroupArgs {
  input: CreateDeviceGroupInput;
}


export interface MutationCreateDeviceSignalArgs {
  input: CreateDeviceSignalInput;
}


export interface MutationCreateEventArgs {
  input: CreateEventInput;
}


export interface MutationCreateEventTypeArgs {
  input: CreateEventTypeInput;
}


export interface MutationCreateFontArgs {
  input: CreateFontInput;
}


export interface MutationCreateLayoutArgs {
  input: CreateLayoutInput;
}


export interface MutationCreateOverlayArgs {
  input: CreateOverlayInput;
}


export interface MutationCreatePlaylistArgs {
  input: CreatePlaylistInput;
}


export interface MutationCreatePlaylistFolderArgs {
  input: CreatePlaylistFolderInput;
}


export interface MutationCreateRemoteCredentialsArgs {
  input: CreateRemoteCredentialsInput;
}


export interface MutationCreateRoleArgs {
  input: CreateRoleInput;
}


export interface MutationCreateScheduledShowArgs {
  input: ScheduledShowMutationsCreateInput;
}


export interface MutationCreateSeasonArgs {
  input: CreateSeasonInput;
}


export interface MutationCreateShowArgs {
  input: CreateShowInput;
}


export interface MutationCreateShowFolderArgs {
  input: CreateShowFolderInput;
}


export interface MutationCreateShowInstanceArgs {
  input: CreateShowInstanceInput;
}


export interface MutationCreateTemplateArgs {
  input: CreateTemplateInput;
}


export interface MutationCreateTemplateVersionArgs {
  input: CreateTemplateVersionInput;
}


export interface MutationCreateTvBrandArgs {
  input: CreateTvBrandInput;
}


export interface MutationCreateUploadConfigArgs {
  input: CreateUploadConfigInput;
}


export interface MutationCreateUserArgs {
  input: CreateUserInput;
}


export interface MutationCreateViewArgs {
  input: CreateViewInput;
}


export interface MutationCreateViewZonePlaylistArgs {
  input: CreateViewZonePlaylistInput;
}


export interface MutationCreateZoneArgs {
  input: CreateZoneInput;
}


export interface MutationDeleteChannelArgs {
  input: DeleteChannelInput;
}


export interface MutationDeleteChannelGuideArgs {
  input: DeleteChannelGuideInput;
}


export interface MutationDeleteContentArgs {
  input: DeleteContentInput;
}


export interface MutationDeleteContentFolderArgs {
  input: DeleteContentFolderInput;
}


export interface MutationDeleteDataItemArgs {
  input: DataItemDeleteInput;
}


export interface MutationDeleteDataSourceArgs {
  input: DeleteDataSourceInput;
}


export interface MutationDeleteDesignArgs {
  input: DeleteDesignInput;
}


export interface MutationDeleteDesignFolderArgs {
  input: DeleteDesignFolderInput;
}


export interface MutationDeleteDeviceArgs {
  input: DeleteDeviceInput;
}


export interface MutationDeleteDeviceCollectionArgs {
  input: DeleteDeviceCollectionInput;
}


export interface MutationDeleteDeviceGroupArgs {
  input: DeleteDeviceGroupInput;
}


export interface MutationDeleteDeviceSignalArgs {
  input: DeleteDeviceSignalInput;
}


export interface MutationDeleteEventArgs {
  input: DeleteEventInput;
}


export interface MutationDeleteEventTypeArgs {
  input: DeleteEventTypeInput;
}


export interface MutationDeleteFontArgs {
  input: DeleteFontInput;
}


export interface MutationDeleteLayoutArgs {
  input: DeleteLayoutInput;
}


export interface MutationDeleteOverlayArgs {
  input: DeleteOverlayInput;
}


export interface MutationDeletePlaylistArgs {
  input: DeletePlaylistInput;
}


export interface MutationDeletePlaylistFolderArgs {
  input: DeletePlaylistFolderInput;
}


export interface MutationDeletePlaylistItemArgs {
  input: DeletePlaylistItemInput;
}


export interface MutationDeleteRolesArgs {
  input: DeleteRolesInput;
}


export interface MutationDeleteScheduledShowArgs {
  input: ScheduledShowMutationsDeleteInput;
}


export interface MutationDeleteSeasonArgs {
  input: DeleteSeasonInput;
}


export interface MutationDeleteShowArgs {
  input: DeleteShowInput;
}


export interface MutationDeleteShowFolderArgs {
  input: DeleteShowFolderInput;
}


export interface MutationDeleteTagArgs {
  input: DeleteTagInput;
}


export interface MutationDeleteTemplateArgs {
  input: DeleteTemplateInput;
}


export interface MutationDeleteTvBrandArgs {
  input: DeleteTvBrandInput;
}


export interface MutationDeleteUserArgs {
  input: DeleteUserInput;
}


export interface MutationDeleteViewArgs {
  input: DeleteViewInput;
}


export interface MutationDeleteViewZonePlaylistArgs {
  input: DeleteViewZonePlaylistInput;
}


export interface MutationDeleteZoneArgs {
  input: DeleteZoneInput;
}


export interface MutationDuplicateDeviceSignalArgs {
  input: DuplicateDeviceSignalInput;
}


export interface MutationDuplicateTvBrandArgs {
  input: DuplicateTvBrandInput;
}


export interface MutationExportAuditLogsArgs {
  input: ExportAuditLogsInput;
}


export interface MutationExportDataSourceArgs {
  input: ExportDataSourceInput;
}


export interface MutationExportDevicesArgs {
  input: ExportDevicesInput;
}


export interface MutationForgotPasswordArgs {
  input: ForgotPasswordInput;
}


export interface MutationGeneratePlayoutDetailPdfArgs {
  input: GeneratePlayoutDetailPdfInput;
}


export interface MutationGenerateReportArgs {
  input: GenerateReportInput;
}


export interface MutationGetDeviceCommandArgs {
  input: GetDeviceCommandInput;
}


export interface MutationImpersonateArgs {
  input: ImpersonateInput;
}


export interface MutationLoginArgs {
  input: LoginInput;
}


export interface MutationLogoutArgs {
  input: LogoutInput;
}


export interface MutationMarkAnnouncementsReadArgs {
  input: MarkAnnouncementsReadInput;
}


export interface MutationMoveContentArgs {
  input: MoveContentInput;
}


export interface MutationMoveDesignArgs {
  input: MoveDesignInput;
}


export interface MutationMovePlaylistArgs {
  input: MovePlaylistInput;
}


export interface MutationMoveShowArgs {
  input: MoveShowInput;
}


export interface MutationPlayContentOnDevicesArgs {
  input: PlayContentOnDevicesInput;
}


export interface MutationPublishDesignArgs {
  input: PublishDesignInput;
}


export interface MutationRegisterDeviceArgs {
  input: RegisterDeviceInput;
}


export interface MutationRemoveDevicesFromDeviceGroupArgs {
  input: RemoveDevicesFromDeviceGroupInput;
}


export interface MutationRemoveDevicesFromScheduledShowArgs {
  input: RemoveDevicesFromScheduledShowInput;
}


export interface MutationRemoveFromRoleArgs {
  input: RemoveFromRoleInput;
}


export interface MutationRemovePropertyGroupArgs {
  input: PropertyGroupRemoveInput;
}


export interface MutationRenameTagArgs {
  input: RenameTagInput;
}


export interface MutationRerunEventRollupsArgs {
  input: RerunEventRollupsInput;
}


export interface MutationResendConfirmationArgs {
  input: ResendConfirmationInput;
}


export interface MutationResetPasswordArgs {
  input: ResetPasswordInput;
}


export interface MutationRunDeviceSignalArgs {
  input: RunDeviceSignalInput;
}


export interface MutationRunSignalByEventNameArgs {
  input: RunSignalByEventNameInput;
}


export interface MutationSendDeviceCommandArgs {
  input: SendDeviceCommandInput;
}


export interface MutationSendRemoteCommandArgs {
  input: SendRemoteCommandInput;
}


export interface MutationSetPasswordArgs {
  input: SetPasswordInput;
}


export interface MutationShufflePlaylistArgs {
  input: ShufflePlaylistInput;
}


export interface MutationStopImpersonateArgs {
  input: StopImpersonateInput;
}


export interface MutationSyncDataSourceArgs {
  input: SyncDataSourceInput;
}


export interface MutationSyncEventsArgs {
  input: SyncEventsInput;
}


export interface MutationTransferDeviceArgs {
  input: TransferDeviceInput;
}


export interface MutationTuneRemoteChannelArgs {
  input: TuneRemoteChannelInput;
}


export interface MutationUpdateChannelArgs {
  input: UpdateChannelInput;
}


export interface MutationUpdateChannelGuideArgs {
  input: UpdateChannelGuideInput;
}


export interface MutationUpdateContentFolderArgs {
  input: UpdateContentFolderInput;
}


export interface MutationUpdateContentItemArgs {
  input: UpdateContentItemInput;
}


export interface MutationUpdateDataItemArgs {
  input: DataItemUpdateInput;
}


export interface MutationUpdateDataSourceArgs {
  input: UpdateDataSourceInput;
}


export interface MutationUpdateDesignArgs {
  input: UpdateDesignInput;
}


export interface MutationUpdateDesignFolderArgs {
  input: UpdateDesignFolderInput;
}


export interface MutationUpdateDeviceArgs {
  input: UpdateDeviceInput;
}


export interface MutationUpdateDeviceGroupArgs {
  input: UpdateDeviceGroupInput;
}


export interface MutationUpdateDeviceSignalArgs {
  input: UpdateDeviceSignalInput;
}


export interface MutationUpdateDeviceStatusV2Args {
  input: UpdateDeviceStatusInput;
}


export interface MutationUpdateDeviceStatusV3Args {
  input: UpdateDeviceStatusV3Input;
}


export interface MutationUpdateEventArgs {
  input: UpdateEventInput;
}


export interface MutationUpdateEventTypeArgs {
  input: UpdateEventTypeInput;
}


export interface MutationUpdateEventTypeShowsDeviceGroupsArgs {
  input: UpdateEventTypeShowsDeviceGroupsInput;
}


export interface MutationUpdateFontArgs {
  input: UpdateFontInput;
}


export interface MutationUpdateLayoutArgs {
  input: UpdateLayoutInput;
}


export interface MutationUpdateMediaItemArgs {
  input: UpdateMediaItemInput;
}


export interface MutationUpdateNetworkArgs {
  input: UpdateNetworkInput;
}


export interface MutationUpdateOverlayArgs {
  input: UpdateOverlayInput;
}


export interface MutationUpdatePlaylistArgs {
  input: UpdatePlaylistInput;
}


export interface MutationUpdatePlaylistFolderArgs {
  input: UpdatePlaylistFolderInput;
}


export interface MutationUpdatePlaylistItemArgs {
  input: UpdatePlaylistItemInput;
}


export interface MutationUpdatePropertyValueArgs {
  input: PropertyValueUpdateInput;
}


export interface MutationUpdateRoleArgs {
  input: UpdateRoleInput;
}


export interface MutationUpdateScheduledShowArgs {
  input: ScheduledShowMutationsUpdateInput;
}


export interface MutationUpdateSeasonArgs {
  input: UpdateSeasonInput;
}


export interface MutationUpdateShowArgs {
  input: UpdateShowInput;
}


export interface MutationUpdateShowFolderArgs {
  input: UpdateShowFolderInput;
}


export interface MutationUpdateTagsArgs {
  input: UpdateTagsInput;
}


export interface MutationUpdateTemplateArgs {
  input: UpdateTemplateInput;
}


export interface MutationUpdateTvBrandArgs {
  input: UpdateTvBrandInput;
}


export interface MutationUpdateUserArgs {
  input: UpdateUserInput;
}


export interface MutationUpdateViewArgs {
  input: UpdateViewInput;
}


export interface MutationUpdateViewZoneArgs {
  input: UpdateViewZoneInput;
}


export interface MutationUpdateZoneArgs {
  input: UpdateZoneInput;
}


export interface MutationUpgradeAllContentItemsArgs {
  input: UpgradeAllContentItemsInput;
}


export interface MutationUpgradeContentItemArgs {
  input: UpgradeContentItemInput;
}


export interface MutationUploadDataSourceArgs {
  input: UploadDataSourceInput;
}

export interface Network {
  readonly __typename: 'Network';
  readonly allChannelGuides: ReadonlyArray<ChannelGuide>;
  readonly allChannels: ReadonlyArray<Channel>;
  readonly allDataSources: ReadonlyArray<DataSource>;
  readonly allDeviceGroups: ReadonlyArray<DeviceGroupNew>;
  readonly allDevices: ReadonlyArray<Device>;
  readonly allEventTypes: ReadonlyArray<EventType>;
  readonly allFonts: ReadonlyArray<Font>;
  readonly allLayouts: ReadonlyArray<Layout>;
  readonly allPlaylists: ReadonlyArray<Playlist>;
  readonly allShows: ReadonlyArray<Show>;
  readonly allTvBrands: ReadonlyArray<TvBrand>;
  readonly auditLog: AuditLog;
  readonly auditLogs: AuditLogPage;
  readonly auditLogsFilterInfo: AuditLogsFilters;
  readonly authorizable: ReadonlyArray<Authorizable>;
  readonly cacheServers: ReadonlyArray<Device>;
  readonly canAccessContent: AuthorizationResult;
  readonly canAccessDataSources: AuthorizationResult;
  readonly canAccessDevices: AuthorizationResult;
  readonly canAccessFcAdminLeagues: AuthorizationResult;
  readonly canAccessFonts: AuthorizationResult;
  readonly canAccessLiveChannelStreams: AuthorizationResult;
  readonly canAccessPlaylists: AuthorizationResult;
  readonly canAccessReporting: AuthorizationResult;
  readonly canAccessScheduler: AuthorizationResult;
  readonly canAccessShows: AuthorizationResult;
  readonly canAccessStudio: AuthorizationResult;
  readonly canAccessTemplates: AuthorizationResult;
  readonly canActivateDevices: AuthorizationResult;
  readonly canCreateDataSources: AuthorizationResult;
  readonly canCreateEvents: AuthorizationResult;
  readonly canCreatePlaylists: AuthorizationResult;
  readonly canCreateScheduledShows: AuthorizationResult;
  readonly canCreateShows: AuthorizationResult;
  readonly canCreateTemplate: AuthorizationResult;
  readonly canCreateUser: AuthorizationResult;
  readonly canDestroy: AuthorizationResult;
  readonly canManage: AuthorizationResult;
  readonly canManagePropertyGroups: AuthorizationResult;
  readonly canManageViews: AuthorizationResult;
  readonly canShow: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly channel: Channel;
  readonly channelCount: Scalars['Int']['output'];
  readonly channelGuide: ChannelGuide;
  readonly channelGuides: ChannelGuidePage;
  readonly channelPages: ChannelPage;
  /** @deprecated Use allChannels instead */
  readonly channels: ReadonlyArray<Channel>;
  readonly content: ContentPage;
  readonly contentFilterInfo: ContentFilters;
  readonly contentFolder: ContentFolder;
  readonly contentFolderTree: Scalars['FolderTree']['output'];
  /** All folders in the network the current user has access to. */
  readonly contentFolders: ReadonlyArray<ContentFolder>;
  readonly contentItem?: Maybe<ContentItem>;
  readonly contentItems: ReadonlyArray<ContentItem>;
  readonly contentTags: ReadonlyArray<ContentTag>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly dataSource: DataSource;
  readonly dataSources: DataSourcePage;
  readonly description: Scalars['String']['output'];
  readonly design: Design;
  readonly designFilterInfo: DesignFilters;
  readonly designFolder: DesignFolder;
  readonly designFolderTree: Scalars['FolderTree']['output'];
  /** All folders in the network the current user has access to. */
  readonly designFolders: ReadonlyArray<DesignFolder>;
  readonly designTags: ReadonlyArray<DesignTag>;
  readonly designs: DesignPage;
  readonly deviceCount: Scalars['Int']['output'];
  readonly deviceDynamicCollections: ReadonlyArray<DeviceDynamicCollection>;
  readonly deviceFilterInfo: DeviceFilters;
  readonly deviceGroup: DeviceGroupNew;
  readonly deviceGroups: DeviceGroupNewPage;
  readonly deviceLicenses?: Maybe<Scalars['Int']['output']>;
  readonly deviceLicensesAvailable?: Maybe<Scalars['Int']['output']>;
  readonly deviceLicensesUsed?: Maybe<Scalars['Int']['output']>;
  readonly deviceSignal: DeviceSignal;
  readonly deviceSignalFilterInfo: DeviceSignalFilters;
  readonly deviceSignalTags: ReadonlyArray<DeviceSignalTag>;
  readonly deviceSignals: DeviceSignalPage;
  readonly deviceStats: DeviceStats;
  readonly deviceTags: ReadonlyArray<DeviceTag>;
  readonly devices: DevicePage;
  readonly displayServers: ReadonlyArray<Scalars['String']['output']>;
  readonly enableApi: Scalars['Boolean']['output'];
  readonly enableSnmp: Scalars['Boolean']['output'];
  readonly encryptionKey?: Maybe<Scalars['String']['output']>;
  readonly event: Event;
  readonly eventType: EventType;
  readonly eventTypes: EventTypePage;
  readonly events: ReadonlyArray<Event>;
  readonly font?: Maybe<Font>;
  readonly fonts: FontPage;
  readonly id: Scalars['Int']['output'];
  readonly layout?: Maybe<Layout>;
  readonly layouts: LayoutPage;
  readonly leagues: ReadonlyArray<League>;
  readonly logoUrl?: Maybe<Scalars['String']['output']>;
  readonly mediaItem?: Maybe<MediaItem>;
  readonly mediaItems: ReadonlyArray<MediaItem>;
  readonly models: ReadonlyArray<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly networkMembership?: Maybe<NetworkMembership>;
  readonly networkMemberships: NetworkMembershipPage;
  readonly overlays: ReadonlyArray<Overlay>;
  readonly playerVersions: ReadonlyArray<Scalars['String']['output']>;
  readonly playlist?: Maybe<Playlist>;
  readonly playlistFilterInfo: PlaylistFilters;
  readonly playlistFolder: PlaylistFolder;
  readonly playlistFolderTree: Scalars['FolderTree']['output'];
  /** All folders in the network the current user has access to. */
  readonly playlistFolders: ReadonlyArray<PlaylistFolder>;
  readonly playlistTags: ReadonlyArray<PlaylistTag>;
  readonly playlists: PlaylistPage;
  readonly playoutReport: PlayoutReport;
  readonly public: Scalars['Boolean']['output'];
  readonly role: Role;
  readonly roles: RolePage;
  readonly scheduledShow?: Maybe<ScheduledShow>;
  readonly scheduledShows: ScheduledShowPage;
  readonly settings: NetworkSettings;
  readonly show?: Maybe<Show>;
  readonly showFilterInfo: ShowFilters;
  readonly showFolder: ShowFolder;
  readonly showFolderTree: Scalars['FolderTree']['output'];
  /** All folders in the network the current user has access to. */
  readonly showFolders: ReadonlyArray<ShowFolder>;
  readonly showTags: ReadonlyArray<ShowTag>;
  readonly shows: ShowPage;
  /** Required while SNMP is on (players never use "public"); null for viewers who may not read it */
  readonly snmpCommunity?: Maybe<Scalars['String']['output']>;
  /** Whether the network has an SNMP community, so devices can run the SNMP service */
  readonly snmpConfigured: Scalars['Boolean']['output'];
  readonly softwareUpdateInfo: SoftwareUpdateInfo;
  readonly teams: ReadonlyArray<Team>;
  readonly timeZone: Scalars['String']['output'];
  readonly tvBrand?: Maybe<TvBrand>;
  readonly tvBrands: TvBrandPage;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly userCount: Scalars['Int']['output'];
  readonly userIds: UserConnection;
  readonly views: ReadonlyArray<View>;
}


export interface NetworkAllChannelsArgs {
  channelGuideId?: InputMaybe<Scalars['Int']['input']>;
  condition?: InputMaybe<ChannelCondition>;
}


export interface NetworkAllDataSourcesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkAllDeviceGroupsArgs {
  reportingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface NetworkAllDevicesArgs {
  condition?: InputMaybe<DeviceCondition>;
}


export interface NetworkAllEventTypesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkAllFontsArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkAllLayoutsArgs {
  search?: InputMaybe<Scalars['String']['input']>;
  withZones?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface NetworkAuditLogArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkAuditLogsArgs {
  channelGuideId?: InputMaybe<Scalars['Int']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  contentItemId?: InputMaybe<Scalars['Int']['input']>;
  dataSourceId?: InputMaybe<Scalars['Int']['input']>;
  deviceGroupId?: InputMaybe<Scalars['Int']['input']>;
  deviceId?: InputMaybe<Scalars['Int']['input']>;
  deviceSignalId?: InputMaybe<Scalars['Int']['input']>;
  eventTypeId?: InputMaybe<Scalars['Int']['input']>;
  excludeSystem?: InputMaybe<Scalars['Boolean']['input']>;
  fontId?: InputMaybe<Scalars['Int']['input']>;
  layoutId?: InputMaybe<Scalars['Int']['input']>;
  mediaItemId?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  playlistId?: InputMaybe<Scalars['Int']['input']>;
  recordTypes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showId?: InputMaybe<Scalars['Int']['input']>;
  tvBrandId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}


export interface NetworkAuditLogsFilterInfoArgs {
  recordTypes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}


export interface NetworkAuthorizableArgs {
  items: ReadonlyArray<AuthorizableInput>;
}


export interface NetworkChannelArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkChannelGuideArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkChannelGuidesArgs {
  orderBy?: InputMaybe<ReadonlyArray<ChannelGuidesOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkChannelPagesArgs {
  condition?: InputMaybe<ChannelCondition>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkChannelsArgs {
  condition?: InputMaybe<ChannelCondition>;
}


export interface NetworkContentArgs {
  condition?: InputMaybe<ContentCondition>;
  orderBy?: InputMaybe<ContentOrderBy>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}


export interface NetworkContentFilterInfoArgs {
  condition?: InputMaybe<ContentCondition>;
  contentFolderId?: InputMaybe<Scalars['Int']['input']>;
}


export interface NetworkContentFolderArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkContentItemArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkContentItemsArgs {
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkDataSourceArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkDataSourcesArgs {
  orderBy?: InputMaybe<ReadonlyArray<DataSourcesOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkDesignArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkDesignFilterInfoArgs {
  designFolderId?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface NetworkDesignFolderArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkDesignsArgs {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  published?: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface NetworkDeviceDynamicCollectionsArgs {
  source?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkDeviceFilterInfoArgs {
  condition?: InputMaybe<DeviceCondition>;
}


export interface NetworkDeviceGroupArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkDeviceGroupsArgs {
  orderBy?: InputMaybe<ReadonlyArray<DeviceGroupsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkDeviceSignalArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkDeviceSignalFilterInfoArgs {
  condition?: InputMaybe<DeviceSignalCondition>;
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkDeviceSignalsArgs {
  condition?: InputMaybe<DeviceSignalCondition>;
  orderBy?: InputMaybe<ReadonlyArray<DeviceSignalsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkDevicesArgs {
  condition?: InputMaybe<DeviceCondition>;
  orderBy?: InputMaybe<ReadonlyArray<DevicesOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}


export interface NetworkEventArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkEventTypeArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkEventTypesArgs {
  orderBy?: InputMaybe<ReadonlyArray<EventTypesOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkEventsArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkFontArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkFontsArgs {
  orderBy?: InputMaybe<ReadonlyArray<FontsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkLayoutArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkLayoutsArgs {
  orderBy?: InputMaybe<ReadonlyArray<LayoutsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  withZones?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface NetworkMediaItemArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkMediaItemsArgs {
  ids: ReadonlyArray<Scalars['Int']['input']>;
}


export interface NetworkNetworkMembershipArgs {
  userId: Scalars['Int']['input'];
}


export interface NetworkNetworkMembershipsArgs {
  orderBy?: InputMaybe<ReadonlyArray<NetworkMembershipsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkPlaylistArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkPlaylistFilterInfoArgs {
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface NetworkPlaylistFolderArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkPlaylistsArgs {
  orderBy?: InputMaybe<ReadonlyArray<PlaylistsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface NetworkPlayoutReportArgs {
  combineByName?: InputMaybe<Scalars['Boolean']['input']>;
  deviceGroupIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  eventIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  eventTypeId: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


export interface NetworkRoleArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkRolesArgs {
  orderBy?: InputMaybe<ReadonlyArray<RolesOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkScheduledShowArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkScheduledShowsArgs {
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<ScheduledShowsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkShowArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkShowFilterInfoArgs {
  search?: InputMaybe<Scalars['String']['input']>;
  showFolderId?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface NetworkShowFolderArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkShowsArgs {
  orderBy?: InputMaybe<ReadonlyArray<ShowsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface NetworkSoftwareUpdateInfoArgs {
  selected: DeviceBulkSelectionInput;
}


export interface NetworkTeamsArgs {
  leagueId: Scalars['String']['input'];
}


export interface NetworkTvBrandArgs {
  id: Scalars['Int']['input'];
}


export interface NetworkTvBrandsArgs {
  orderBy?: InputMaybe<ReadonlyArray<TvBrandsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface NetworkUserIdsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrdering>>;
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface NetworkCondition {
  readonly public?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for Network. */
export interface NetworkConnection {
  readonly __typename: 'NetworkConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<NetworkEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Network>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface NetworkEdge {
  readonly __typename: 'NetworkEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Network>;
}

export interface NetworkMembership {
  readonly __typename: 'NetworkMembership';
  readonly canDestroyUser: AuthorizationResult;
  readonly canImpersonateUser: AuthorizationResult;
  readonly id: Scalars['Int']['output'];
  readonly network: Network;
  readonly owner: Scalars['Boolean']['output'];
  readonly user: User;
}

export interface NetworkMembershipPage {
  readonly __typename: 'NetworkMembershipPage';
  readonly nodes: ReadonlyArray<NetworkMembership>;
  readonly pageInfo: PaginationInfo;
}

export const NetworkMembershipsOrderBy = {
  EmailAsc: 'EMAIL_ASC',
  EmailDesc: 'EMAIL_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type NetworkMembershipsOrderBy = typeof NetworkMembershipsOrderBy[keyof typeof NetworkMembershipsOrderBy];
export interface NetworkPatch {
  readonly defaultShowId?: InputMaybe<Scalars['Int']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly enableApi?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enableSnmp?: InputMaybe<Scalars['Boolean']['input']>;
  readonly encryptionKey?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly settings?: InputMaybe<NetworkSettingsInput>;
  readonly snmpCommunity?: InputMaybe<Scalars['String']['input']>;
  readonly timeZone?: InputMaybe<Scalars['String']['input']>;
}

/** Settings for a Network */
export interface NetworkSettings {
  readonly __typename: 'NetworkSettings';
  readonly accessFcAdminLeagues: Scalars['Boolean']['output'];
  readonly defaultImageDuration: Scalars['ISO8601Duration']['output'];
  readonly enableLanguageSelection: Scalars['Boolean']['output'];
  readonly enableLiveChannelStreaming: Scalars['Boolean']['output'];
  readonly enableWebpRendition: Scalars['Boolean']['output'];
  readonly managePropertyGroups: Scalars['Boolean']['output'];
  readonly manageViews: Scalars['Boolean']['output'];
  readonly pptSlideDuration: Scalars['Int']['output'];
  readonly pptTransition: PptTransition;
  readonly showTimestampOnScreenshots: Scalars['Boolean']['output'];
  readonly transcodeServerHost?: Maybe<Scalars['String']['output']>;
}

export interface NetworkSettingsInput {
  readonly accessFcAdminLeagues?: InputMaybe<Scalars['Boolean']['input']>;
  readonly defaultImageDuration?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly enableLanguageSelection?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enableLiveChannelStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enableWebpRendition?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managePropertyGroups?: InputMaybe<Scalars['Boolean']['input']>;
  readonly manageViews?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pptSlideDuration?: InputMaybe<Scalars['Int']['input']>;
  readonly pptTransition?: InputMaybe<PptTransition>;
  readonly showTimestampOnScreenshots?: InputMaybe<Scalars['Boolean']['input']>;
  readonly transcodeServerHost?: InputMaybe<Scalars['String']['input']>;
}

export const NetworksOrderBy = {
  CreatedAsc: 'CREATED_ASC',
  CreatedDesc: 'CREATED_DESC',
  DevicesAsc: 'DEVICES_ASC',
  DevicesDesc: 'DEVICES_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC',
  UsersAsc: 'USERS_ASC',
  UsersDesc: 'USERS_DESC'
} as const;

export type NetworksOrderBy = typeof NetworksOrderBy[keyof typeof NetworksOrderBy];
export const Orientation = {
  /** W > H */
  Landscape: 'LANDSCAPE',
  /** W < H */
  Portrait: 'PORTRAIT',
  /** W = H */
  Square: 'SQUARE'
} as const;

export type Orientation = typeof Orientation[keyof typeof Orientation];
export interface Overlay {
  readonly __typename: 'Overlay';
  readonly canDestroy: AuthorizationResult;
  readonly contentItem: ContentItem;
  readonly duration: Scalars['ISO8601Duration']['output'];
  readonly id: Scalars['Int']['output'];
  readonly mediaItem?: Maybe<MediaItem>;
  readonly name: Scalars['String']['output'];
}

export type OverlayInput =
  { readonly contentItemId: Scalars['Int']['input']; readonly mediaItemId?: never; }
  |  { readonly contentItemId?: never; readonly mediaItemId: Scalars['Int']['input']; };

export interface OverlayPatch {
  readonly duration?: InputMaybe<Scalars['ISO8601Duration']['input']>;
}

/** Information about pagination in a connection. */
export interface PageInfo {
  readonly __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
}

export interface PaginationInfo {
  readonly __typename: 'PaginationInfo';
  readonly currentPage: Scalars['Int']['output'];
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  readonly nodesCount: Scalars['Int']['output'];
  readonly pagesCount: Scalars['Int']['output'];
  readonly perPage: Scalars['Int']['output'];
}

/** Autogenerated input type of PlayContentOnDevices */
export interface PlayContentOnDevicesInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentItemIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly mediaItemIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly name: Scalars['String']['input'];
  readonly orientation: Orientation;
  readonly selected: DeviceBulkSelectionInput;
  readonly showFolderId: Scalars['Int']['input'];
}

/** Autogenerated return type of PlayContentOnDevices. */
export interface PlayContentOnDevicesPayload {
  readonly __typename: 'PlayContentOnDevicesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly devices: ReadonlyArray<Device>;
}

export interface Playlist {
  readonly __typename: 'Playlist';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  /** When this entity was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly defaultImageDuration?: Maybe<Scalars['ISO8601Duration']['output']>;
  readonly description: Scalars['String']['output'];
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly kind?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly playlistFolder: PlaylistFolder;
  readonly playlistFolderId: Scalars['Int']['output'];
  readonly playlistItems: ReadonlyArray<PlaylistItem>;
  readonly playlistItemsCount: Scalars['Int']['output'];
  readonly reusable: Scalars['Boolean']['output'];
  /** The total runtime of this `Playlist` */
  readonly runtime: Interval;
  readonly showCount: Scalars['Int']['output'];
  readonly shows: ShowPage;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  /** When this entity was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}


export interface PlaylistPlaylistItemsArgs {
  active?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface PlaylistShowsArgs {
  orderBy?: InputMaybe<ReadonlyArray<PlaylistShowsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface PlaylistFilters {
  readonly __typename: 'PlaylistFilters';
  readonly tags: ReadonlyArray<FilterCount>;
}

export interface PlaylistFolder {
  readonly __typename: 'PlaylistFolder';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  /** Child folders that can be accessed and their ancestors. */
  readonly children: ReadonlyArray<PlaylistFolder>;
  readonly childrenCount: Scalars['Int']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['Int']['output'];
  readonly itemCount: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly playlists: PlaylistPage;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}


export interface PlaylistFolderChildrenArgs {
  condition?: InputMaybe<PlaylistFolderCondition>;
}


export interface PlaylistFolderChildrenCountArgs {
  condition?: InputMaybe<PlaylistFolderCondition>;
}


export interface PlaylistFolderItemCountArgs {
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface PlaylistFolderPlaylistsArgs {
  orderBy?: InputMaybe<ReadonlyArray<PlaylistsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface PlaylistFolderCondition {
  readonly parentId?: InputMaybe<Scalars['Int']['input']>;
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface PlaylistFolderPatch {
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly parentId?: InputMaybe<Scalars['Int']['input']>;
}

export interface PlaylistFolderRule {
  readonly __typename: 'PlaylistFolderRule';
  readonly id: Scalars['Int']['output'];
  readonly playlistFolder: PlaylistFolder;
}

export interface PlaylistItem {
  readonly __typename: 'PlaylistItem';
  readonly contentItem: ContentItem;
  readonly contentItemId: Scalars['Int']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly duration?: Maybe<Interval>;
  readonly durationDefaulted: Scalars['Boolean']['output'];
  readonly durationReadonly: Scalars['Boolean']['output'];
  readonly endsAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly playlistId: Scalars['Int']['output'];
  /** @deprecated Will be removed */
  readonly schedule?: Maybe<Schedule>;
  readonly startsAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface PlaylistItemPatch {
  /** A fixed duration for playback or null */
  readonly duration?: InputMaybe<IntervalInput>;
  readonly endsAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly startsAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

export interface PlaylistPage {
  readonly __typename: 'PlaylistPage';
  readonly nodes: ReadonlyArray<Playlist>;
  readonly pageInfo: PaginationInfo;
}

export interface PlaylistPatch {
  readonly defaultImageDuration?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly playlistItemIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export const PlaylistShowsOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC',
  ShowFolderAsc: 'SHOW_FOLDER_ASC',
  ShowFolderDesc: 'SHOW_FOLDER_DESC'
} as const;

export type PlaylistShowsOrderBy = typeof PlaylistShowsOrderBy[keyof typeof PlaylistShowsOrderBy];
export interface PlaylistTag {
  readonly __typename: 'PlaylistTag';
  readonly name: Scalars['String']['output'];
  readonly uses: Scalars['Int']['output'];
}

export const PlaylistsOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type PlaylistsOrderBy = typeof PlaylistsOrderBy[keyof typeof PlaylistsOrderBy];
export interface PlayoutReport {
  readonly __typename: 'PlayoutReport';
  readonly assetDetail: PlayoutReportAssetDetail;
  readonly byAsset: ReadonlyArray<PlayoutReportAssetAggregate>;
  readonly byAssetSummary: ReadonlyArray<PlayoutReportAssetSummary>;
  readonly byDeviceGroup: ReadonlyArray<PlayoutReportDeviceGroupAggregate>;
  readonly byEvent: ReadonlyArray<PlayoutReportEventAggregate>;
  readonly bySponsor: ReadonlyArray<PlayoutReportSponsorAggregate>;
  readonly bySponsorSummary: ReadonlyArray<PlayoutReportSponsorSummary>;
  readonly byZone: ReadonlyArray<PlayoutReportZoneAggregate>;
  readonly sponsorDetail: PlayoutReportSponsorDetail;
  readonly stats: PlayoutReportStats;
  readonly topAssets: ReadonlyArray<PlayoutReportTopAsset>;
}


export interface PlayoutReportAssetDetailArgs {
  assetId: Scalars['Int']['input'];
  kind: Scalars['String']['input'];
}


export interface PlayoutReportByAssetArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PlayoutReportsOrderBy>;
}


export interface PlayoutReportByDeviceGroupArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface PlayoutReportBySponsorArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PlayoutReportsOrderBy>;
}


export interface PlayoutReportSponsorDetailArgs {
  sponsorId: Scalars['Int']['input'];
}


export interface PlayoutReportTopAssetsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PlayoutReportsOrderBy>;
}

export interface PlayoutReportAssetAggregate {
  readonly __typename: 'PlayoutReportAssetAggregate';
  readonly asset: Scalars['String']['output'];
  readonly assetId?: Maybe<Scalars['Int']['output']>;
  readonly durationMs: Scalars['BigIntNumber']['output'];
  readonly kind: Scalars['String']['output'];
  readonly plays: Scalars['Int']['output'];
  readonly sponsor?: Maybe<Scalars['String']['output']>;
}

export interface PlayoutReportAssetDetail {
  readonly __typename: 'PlayoutReportAssetDetail';
  readonly assetName?: Maybe<Scalars['String']['output']>;
  readonly associatedSponsors: ReadonlyArray<PlayoutReportSponsorSummary>;
  readonly byDeviceGroup: ReadonlyArray<PlayoutReportDeviceGroupAggregate>;
  readonly byEvent: ReadonlyArray<PlayoutReportEventAggregate>;
  readonly byZone: ReadonlyArray<PlayoutReportZoneAggregate>;
  readonly contentFolderId?: Maybe<Scalars['Int']['output']>;
  readonly stats: PlayoutReportStats;
  readonly thumbnailUri?: Maybe<Scalars['String']['output']>;
}


export interface PlayoutReportAssetDetailByDeviceGroupArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface PlayoutReportAssetSummary {
  readonly __typename: 'PlayoutReportAssetSummary';
  readonly asset: Scalars['String']['output'];
  readonly assetId?: Maybe<Scalars['Int']['output']>;
  readonly avgDurationMsPerEvent: Scalars['BigIntNumber']['output'];
  readonly avgDurationMsPerEventPerDevice: Scalars['BigIntNumber']['output'];
  readonly avgPlaysPerEvent: Scalars['Float']['output'];
  readonly avgPlaysPerEventPerDevice: Scalars['Float']['output'];
  readonly contentFolderId?: Maybe<Scalars['Int']['output']>;
  readonly contentItemId?: Maybe<Scalars['Int']['output']>;
  readonly deviceCount: Scalars['Int']['output'];
  readonly durationMs: Scalars['BigIntNumber']['output'];
  readonly eventCount: Scalars['Int']['output'];
  readonly kind: Scalars['String']['output'];
  readonly mediaItemId?: Maybe<Scalars['Int']['output']>;
  readonly plays: Scalars['Int']['output'];
  readonly zones: ReadonlyArray<Scalars['String']['output']>;
}

export interface PlayoutReportDeviceGroupAggregate {
  readonly __typename: 'PlayoutReportDeviceGroupAggregate';
  readonly deviceGroup: Scalars['String']['output'];
  readonly deviceGroupId?: Maybe<Scalars['Int']['output']>;
  readonly durationMs: Scalars['BigIntNumber']['output'];
  readonly otherCount?: Maybe<Scalars['Int']['output']>;
}

export interface PlayoutReportEventAggregate {
  readonly __typename: 'PlayoutReportEventAggregate';
  readonly durationMs: Scalars['BigIntNumber']['output'];
  readonly event: Scalars['String']['output'];
  readonly eventId: Scalars['Int']['output'];
  readonly eventStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly plays: Scalars['Int']['output'];
}

export interface PlayoutReportPdfAssetIdentifier {
  readonly assetId: Scalars['Int']['input'];
  readonly kind: Scalars['String']['input'];
}

export type PlayoutReportPdfIdentifier =
  { readonly asset: PlayoutReportPdfAssetIdentifier; readonly sponsorId?: never; }
  |  { readonly asset?: never; readonly sponsorId: Scalars['Int']['input']; };

export const PlayoutReportPdfSection = {
  /** Sponsor detail only */
  AssetSummary: 'ASSET_SUMMARY',
  /** Asset detail only */
  AssociatedSponsors: 'ASSOCIATED_SPONSORS',
  ByDeviceGroup: 'BY_DEVICE_GROUP',
  ByZone: 'BY_ZONE',
  DevicesReached: 'DEVICES_REACHED',
  DurationByEvent: 'DURATION_BY_EVENT',
  EventsCount: 'EVENTS_COUNT',
  EventBreakdown: 'EVENT_BREAKDOWN',
  PlaysByEvent: 'PLAYS_BY_EVENT',
  /** Asset detail only */
  Thumbnail: 'THUMBNAIL',
  TotalAirtime: 'TOTAL_AIRTIME',
  TotalPlays: 'TOTAL_PLAYS'
} as const;

export type PlayoutReportPdfSection = typeof PlayoutReportPdfSection[keyof typeof PlayoutReportPdfSection];
export interface PlayoutReportSponsorAggregate {
  readonly __typename: 'PlayoutReportSponsorAggregate';
  readonly durationMs: Scalars['BigIntNumber']['output'];
  readonly plays: Scalars['Int']['output'];
  readonly sponsor: Scalars['String']['output'];
  readonly sponsorId?: Maybe<Scalars['Int']['output']>;
}

export interface PlayoutReportSponsorDetail {
  readonly __typename: 'PlayoutReportSponsorDetail';
  readonly byAssetSummary: ReadonlyArray<PlayoutReportAssetSummary>;
  readonly byDeviceGroup: ReadonlyArray<PlayoutReportDeviceGroupAggregate>;
  readonly byEvent: ReadonlyArray<PlayoutReportEventAggregate>;
  readonly byZone: ReadonlyArray<PlayoutReportZoneAggregate>;
  readonly contentFolderId?: Maybe<Scalars['Int']['output']>;
  readonly sponsorName?: Maybe<Scalars['String']['output']>;
  readonly stats: PlayoutReportStats;
}


export interface PlayoutReportSponsorDetailByDeviceGroupArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface PlayoutReportSponsorSummary {
  readonly __typename: 'PlayoutReportSponsorSummary';
  readonly avgDurationMsPerEvent: Scalars['BigIntNumber']['output'];
  readonly avgDurationMsPerEventPerDevice: Scalars['BigIntNumber']['output'];
  readonly avgPlaysPerEvent: Scalars['Float']['output'];
  readonly avgPlaysPerEventPerDevice: Scalars['Float']['output'];
  readonly contentFolderId?: Maybe<Scalars['Int']['output']>;
  readonly deviceCount: Scalars['Int']['output'];
  readonly durationMs: Scalars['BigIntNumber']['output'];
  readonly eventCount: Scalars['Int']['output'];
  readonly plays: Scalars['Int']['output'];
  readonly sponsor: Scalars['String']['output'];
  readonly sponsorId: Scalars['Int']['output'];
}

export interface PlayoutReportStats {
  readonly __typename: 'PlayoutReportStats';
  readonly eventCount: Scalars['Int']['output'];
  readonly totalDurationMs: Scalars['BigIntNumber']['output'];
  readonly totalPlays: Scalars['Int']['output'];
  readonly uniqueAssets: Scalars['Int']['output'];
  readonly uniqueDeviceGroups: Scalars['Int']['output'];
  readonly uniqueDevices: Scalars['Int']['output'];
}

export interface PlayoutReportTopAsset {
  readonly __typename: 'PlayoutReportTopAsset';
  readonly asset: Scalars['String']['output'];
  readonly assetId?: Maybe<Scalars['Int']['output']>;
  readonly avgDurationMsPerEvent: Scalars['BigIntNumber']['output'];
  readonly avgDurationMsPerEventPerDevice: Scalars['BigIntNumber']['output'];
  readonly avgPlaysPerEvent: Scalars['Float']['output'];
  readonly avgPlaysPerEventPerDevice: Scalars['Float']['output'];
  readonly contentFolderId?: Maybe<Scalars['Int']['output']>;
  readonly contentItemId?: Maybe<Scalars['Int']['output']>;
  readonly deviceCount: Scalars['Int']['output'];
  readonly durationMs: Scalars['BigIntNumber']['output'];
  readonly eventCount: Scalars['Int']['output'];
  readonly kind: Scalars['String']['output'];
  readonly mediaItemId?: Maybe<Scalars['Int']['output']>;
  readonly plays: Scalars['Int']['output'];
  readonly sponsor: Scalars['String']['output'];
  readonly sponsorId?: Maybe<Scalars['Int']['output']>;
  readonly zones: ReadonlyArray<Scalars['String']['output']>;
}

export interface PlayoutReportZoneAggregate {
  readonly __typename: 'PlayoutReportZoneAggregate';
  readonly durationMs: Scalars['BigIntNumber']['output'];
  readonly zone: Scalars['String']['output'];
}

export const PlayoutReportsOrderBy = {
  Duration: 'DURATION',
  Plays: 'PLAYS'
} as const;

export type PlayoutReportsOrderBy = typeof PlayoutReportsOrderBy[keyof typeof PlayoutReportsOrderBy];
/** Transition applied between slides when converting PowerPoint files to video */
export const PptTransition = {
  /** circleclose */
  Circleclose: 'CIRCLECLOSE',
  /** circleopen */
  Circleopen: 'CIRCLEOPEN',
  /** dissolve */
  Dissolve: 'DISSOLVE',
  /** fade */
  Fade: 'FADE',
  /** fadeblack */
  Fadeblack: 'FADEBLACK',
  /** fadewhite */
  Fadewhite: 'FADEWHITE',
  /** none */
  None: 'NONE',
  /** slideleft */
  Slideleft: 'SLIDELEFT',
  /** slideright */
  Slideright: 'SLIDERIGHT',
  /** wipedown */
  Wipedown: 'WIPEDOWN',
  /** wipeleft */
  Wipeleft: 'WIPELEFT',
  /** wiperight */
  Wiperight: 'WIPERIGHT',
  /** wipeup */
  Wipeup: 'WIPEUP'
} as const;

export type PptTransition = typeof PptTransition[keyof typeof PptTransition];
export interface PropertyDefinition {
  readonly __typename: 'PropertyDefinition';
  readonly allowedValues?: Maybe<ReadonlyArray<PropertyDefinitionAllowedValuesType>>;
  readonly defaultValue?: Maybe<Scalars['String']['output']>;
  readonly description: Scalars['String']['output'];
  readonly helpText: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly kind: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
}

export interface PropertyDefinitionAllowedValuesType {
  readonly __typename: 'PropertyDefinitionAllowedValuesType';
  readonly label: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
}

export interface PropertyGroup {
  readonly __typename: 'PropertyGroup';
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
}

/** Autogenerated input type of PropertyGroupAssign */
export interface PropertyGroupAssignInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ownerId: Scalars['Int']['input'];
  readonly ownerType: PropertyOwnerType;
  readonly propertyGroupId: Scalars['Int']['input'];
}

/** Autogenerated return type of PropertyGroupAssign. */
export interface PropertyGroupAssignPayload {
  readonly __typename: 'PropertyGroupAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly owner: PropertyOwner;
  readonly propertyGroupOwner?: Maybe<PropertyGroupOwner>;
}

export interface PropertyGroupOwner {
  readonly __typename: 'PropertyGroupOwner';
  readonly canDestroy: AuthorizationResult;
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly propertyGroupId: Scalars['Int']['output'];
  readonly propertyValues: ReadonlyArray<PropertyValue>;
}

/** Autogenerated input type of PropertyGroupRemove */
export interface PropertyGroupRemoveInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ownerId: Scalars['Int']['input'];
  readonly ownerType: PropertyOwnerType;
  readonly propertyGroupId: Scalars['Int']['input'];
}

/** Autogenerated return type of PropertyGroupRemove. */
export interface PropertyGroupRemovePayload {
  readonly __typename: 'PropertyGroupRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly owner: PropertyOwner;
  readonly propertyGroupOwner?: Maybe<PropertyGroupOwner>;
}

/** An object which may have property groups assigned to it */
export type PropertyOwner = Device | Show;

export const PropertyOwnerType = {
  Device: 'DEVICE',
  Show: 'SHOW'
} as const;

export type PropertyOwnerType = typeof PropertyOwnerType[keyof typeof PropertyOwnerType];
export interface PropertyValue {
  readonly __typename: 'PropertyValue';
  readonly id: Scalars['Int']['output'];
  readonly propertyDefinition: PropertyDefinition;
  readonly value?: Maybe<Scalars['String']['output']>;
}

export interface PropertyValuePatch {
  readonly id: Scalars['Int']['input'];
  readonly value?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of PropertyValueUpdate */
export interface PropertyValueUpdateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ownerId: Scalars['Int']['input'];
  readonly ownerType: PropertyOwnerType;
  readonly patch: ReadonlyArray<PropertyValuePatch>;
}

/** Autogenerated return type of PropertyValueUpdate. */
export interface PropertyValueUpdatePayload {
  readonly __typename: 'PropertyValueUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly owner: PropertyOwner;
}

/** Autogenerated input type of PublishDesign */
export interface PublishDesignInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentFolderId: Scalars['Int']['input'];
  readonly id: Scalars['Int']['input'];
  readonly thumbnailUri: Scalars['String']['input'];
}

/** Autogenerated return type of PublishDesign. */
export interface PublishDesignPayload {
  readonly __typename: 'PublishDesignPayload';
  readonly app: ContentItem;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly design: Design;
}

export interface Query {
  readonly __typename: 'Query';
  readonly announcement?: Maybe<Announcement>;
  readonly announcementFilterInfo: AnnouncementFilters;
  readonly announcements: AnnouncementPage;
  /** @deprecated Use `network.contentItem` (when it's added) */
  readonly contentItem?: Maybe<ContentItem>;
  /** @deprecated Use `network.contentItems` */
  readonly contentItems?: Maybe<ContentItemConnection>;
  readonly currentUser?: Maybe<User>;
  readonly device?: Maybe<Device>;
  readonly deviceManifest?: Maybe<Manifest>;
  readonly deviceRegistration?: Maybe<DeviceRegistration>;
  readonly devices: ReadonlyArray<Device>;
  readonly emailByToken?: Maybe<Scalars['String']['output']>;
  /** The current environment (staging, production, etc.) */
  readonly env: Scalars['String']['output'];
  readonly file?: Maybe<File>;
  readonly network?: Maybe<Network>;
  readonly networks: NetworkConnection;
  readonly newApp?: Maybe<ContentItem>;
  readonly propertyGroups: ReadonlyArray<PropertyGroup>;
  /** The remote-control session for the api key in the `x-api-key` header */
  readonly remote?: Maybe<Remote>;
  readonly template?: Maybe<Template>;
  readonly templateCategories: ReadonlyArray<TemplateCategory>;
  readonly templateVersionPreview?: Maybe<TemplateVersionPreviewType>;
  /**
   * Reports what is wrong with a template zip without creating anything, so the
   * upload UI can show problems before the user commits.
   */
  readonly templateZipValidation: TemplateZipValidation;
  readonly templates: TemplateConnection;
  readonly timeZones: ReadonlyArray<TimeZone>;
  readonly trueUser?: Maybe<User>;
  readonly user?: Maybe<User>;
  readonly users: UserConnection;
}


export interface QueryAnnouncementArgs {
  id: Scalars['Int']['input'];
}


export interface QueryAnnouncementFilterInfoArgs {
  categories?: InputMaybe<ReadonlyArray<AnnouncementCategory>>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  severities?: InputMaybe<ReadonlyArray<AnnouncementSeverity>>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface QueryAnnouncementsArgs {
  categories?: InputMaybe<ReadonlyArray<AnnouncementCategory>>;
  orderBy?: InputMaybe<ReadonlyArray<AnnouncementOrdering>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  severities?: InputMaybe<ReadonlyArray<AnnouncementSeverity>>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface QueryContentItemArgs {
  id: Scalars['Int']['input'];
}


export interface QueryContentItemsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryDeviceArgs {
  deviceId?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryDeviceRegistrationArgs {
  code: Scalars['String']['input'];
}


export interface QueryDevicesArgs {
  deviceIds: ReadonlyArray<Scalars['Int']['input']>;
}


export interface QueryEmailByTokenArgs {
  token: Scalars['String']['input'];
}


export interface QueryFileArgs {
  fileId: Scalars['Int']['input'];
}


export interface QueryNetworkArgs {
  id?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryNetworksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<NetworkCondition>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<NetworksOrderBy>>;
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryNewAppArgs {
  templateId: Scalars['Int']['input'];
}


export interface QueryTemplateArgs {
  id: Scalars['Int']['input'];
}


export interface QueryTemplateCategoriesArgs {
  orderBy?: InputMaybe<ReadonlyArray<TemplateCategoryOrdering>>;
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryTemplateVersionPreviewArgs {
  contentOptions: ReadonlyArray<ContentOptionInput>;
  templateVersionId: Scalars['Int']['input'];
}


export interface QueryTemplateZipValidationArgs {
  dataUrl: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
}


export interface QueryTemplatesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withVersions?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryUserArgs {
  id: Scalars['Int']['input'];
}


export interface QueryUsersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currentNetworkId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrdering>>;
  search?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of RegisterDevice */
export interface RegisterDeviceInput {
  readonly arch?: InputMaybe<Scalars['String']['input']>;
  readonly buildDescriptor?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ipAddress: Scalars['InternetAddress']['input'];
  readonly keyId: Scalars['String']['input'];
  readonly kind: Scalars['String']['input'];
  readonly macAddress: Scalars['String']['input'];
}

/** Autogenerated return type of RegisterDevice. */
export interface RegisterDevicePayload {
  readonly __typename: 'RegisterDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly credentials: Credentials;
}

export interface Remote {
  readonly __typename: 'Remote';
  /**
   * The channels a fan can tune, from the channel guide of the show every online
   * remote target (or the device itself, when it has none) is currently running.
   */
  readonly channels: ReadonlyArray<RemoteChannel>;
  readonly deviceName: Scalars['String']['output'];
  /**
   * Whether a command can currently be delivered. False when every remote target
   * (or the device itself, when it has none) is offline.
   */
  readonly realtime: Scalars['Boolean']['output'];
  /** Whether the mute keys should be offered. True when any target can act on them. */
  readonly supportsMute: Scalars['Boolean']['output'];
  /** Whether the volume keys should be offered. True when any target can act on them. */
  readonly supportsVolume: Scalars['Boolean']['output'];
}

export const RemoteButton = {
  /** Go back */
  Back: 'BACK',
  /** Navigate down */
  Down: 'DOWN',
  /** Go to the home screen */
  Home: 'HOME',
  /** Navigate left */
  Left: 'LEFT',
  /** Open the menu */
  Menu: 'MENU',
  /** Mute the device */
  Mute: 'MUTE',
  /** Confirm the current selection */
  Ok: 'OK',
  /** Navigate right */
  Right: 'RIGHT',
  /** Unmute the device */
  Unmute: 'UNMUTE',
  /** Navigate up */
  Up: 'UP',
  /** Lower the device volume */
  VolumeDown: 'VOLUME_DOWN',
  /** Raise the device volume */
  VolumeUp: 'VOLUME_UP'
} as const;

export type RemoteButton = typeof RemoteButton[keyof typeof RemoteButton];
export interface RemoteChannel {
  readonly __typename: 'RemoteChannel';
  readonly backgroundColor: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly number: Scalars['String']['output'];
  readonly thumbnailUri: Scalars['String']['output'];
}

export interface RemoteCredentials {
  readonly __typename: 'RemoteCredentials';
  readonly apiKey: Scalars['String']['output'];
  readonly expiresAt: Scalars['ISO8601DateTime']['output'];
}

/** Autogenerated input type of RemoveDevicesFromDeviceGroup */
export interface RemoveDevicesFromDeviceGroupInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceGroupId: Scalars['Int']['input'];
  readonly deviceIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of RemoveDevicesFromDeviceGroup. */
export interface RemoveDevicesFromDeviceGroupPayload {
  readonly __typename: 'RemoveDevicesFromDeviceGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceGroup: DeviceGroupNew;
  readonly network: Network;
  readonly removedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of RemoveDevicesFromScheduledShow */
export interface RemoveDevicesFromScheduledShowInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly scheduledShowId: Scalars['Int']['input'];
}

/** Autogenerated return type of RemoveDevicesFromScheduledShow. */
export interface RemoveDevicesFromScheduledShowPayload {
  readonly __typename: 'RemoveDevicesFromScheduledShowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly devices: ReadonlyArray<Device>;
  readonly scheduledShow: ScheduledShow;
}

/** Autogenerated input type of RemoveFromRole */
export interface RemoveFromRoleInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentFolderRuleIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly dataSourceRuleIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly designFolderRuleIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly deviceGroupRuleIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly deviceRuleIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly eventTypeRuleIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly id: Scalars['Int']['input'];
  readonly playlistFolderRuleIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly showFolderRuleIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly userIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

/** Autogenerated return type of RemoveFromRole. */
export interface RemoveFromRolePayload {
  readonly __typename: 'RemoveFromRolePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly role: Role;
}

/** Autogenerated input type of RenameTag */
export interface RenameTagInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly networkId: Scalars['Int']['input'];
  readonly renameTo: Scalars['String']['input'];
  readonly tag: Scalars['String']['input'];
  readonly taggableTypes: ReadonlyArray<TaggableType>;
}

/** Autogenerated return type of RenameTag. */
export interface RenameTagPayload {
  readonly __typename: 'RenameTagPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
}

export interface Rendition {
  readonly __typename: 'Rendition';
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly height?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly size?: Maybe<Scalars['BigIntNumber']['output']>;
  readonly status: MediaStatus;
  readonly uri?: Maybe<Scalars['String']['output']>;
  readonly variant?: Maybe<RenditionVariant>;
  readonly width?: Maybe<Scalars['Int']['output']>;
}

export const RenditionVariant = {
  /** MP4 video transcode */
  Mp4: 'MP4',
  /** VP9 + alpha WebM video rendition */
  Webm: 'WEBM',
  /** WebP image rendition */
  Webp: 'WEBP'
} as const;

export type RenditionVariant = typeof RenditionVariant[keyof typeof RenditionVariant];
/** Autogenerated input type of RerunEventRollups */
export interface RerunEventRollupsInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['Int']['input'];
}

/** Autogenerated return type of RerunEventRollups. */
export interface RerunEventRollupsPayload {
  readonly __typename: 'RerunEventRollupsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event: Event;
}

/** Autogenerated input type of ResendConfirmation */
export interface ResendConfirmationInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly userId: Scalars['Int']['input'];
}

/** Autogenerated return type of ResendConfirmation. */
export interface ResendConfirmationPayload {
  readonly __typename: 'ResendConfirmationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
}

/** Autogenerated input type of ResetPassword */
export interface ResetPasswordInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly password: Scalars['String']['input'];
  readonly token: Scalars['String']['input'];
}

/** Autogenerated return type of ResetPassword. */
export interface ResetPasswordPayload {
  readonly __typename: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
}

export interface Role {
  readonly __typename: 'Role';
  readonly accessDevices: Scalars['Boolean']['output'];
  readonly accessFonts: Scalars['Boolean']['output'];
  readonly accessLiveChannelStreams: Scalars['Boolean']['output'];
  readonly accessReporting: Scalars['Boolean']['output'];
  readonly accessScheduler: Scalars['Boolean']['output'];
  readonly accessStudio: Scalars['Boolean']['output'];
  readonly accessTemplates: Scalars['Boolean']['output'];
  readonly activateDevices: Scalars['Boolean']['output'];
  readonly contentFolderCount: Scalars['Int']['output'];
  readonly contentFolderRules: ReadonlyArray<ContentFolderRule>;
  readonly createDataSources: Scalars['Boolean']['output'];
  readonly createEvents: Scalars['Boolean']['output'];
  readonly createPlaylists: Scalars['Boolean']['output'];
  readonly createScheduledShows: Scalars['Boolean']['output'];
  readonly createShows: Scalars['Boolean']['output'];
  readonly createTemplates: Scalars['Boolean']['output'];
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly dataSourceCount: Scalars['Int']['output'];
  readonly dataSourceRules: ReadonlyArray<DataSourceRule>;
  readonly description: Scalars['String']['output'];
  readonly designFolderCount: Scalars['Int']['output'];
  readonly designFolderRules: ReadonlyArray<DesignFolderRule>;
  readonly deviceCount: Scalars['Int']['output'];
  readonly deviceGroupRules: ReadonlyArray<DeviceGroupRule>;
  readonly deviceRules: ReadonlyArray<DeviceRule>;
  readonly eventTypeCount: Scalars['Int']['output'];
  readonly eventTypeRules: ReadonlyArray<EventTypeRule>;
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly playlistFolderCount: Scalars['Int']['output'];
  readonly playlistFolderRules: ReadonlyArray<PlaylistFolderRule>;
  readonly showFolderCount: Scalars['Int']['output'];
  readonly showFolderRules: ReadonlyArray<ShowFolderRule>;
  readonly updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCount: Scalars['Int']['output'];
  readonly users: ReadonlyArray<User>;
}


export interface RoleContentFolderRulesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface RoleDataSourceRulesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface RoleDesignFolderRulesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface RoleDeviceGroupRulesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface RoleDeviceRulesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface RoleEventTypeRulesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface RolePlaylistFolderRulesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface RoleShowFolderRulesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface RoleUsersArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface RoleContentFolderInput {
  readonly contentFolderId: Scalars['Int']['input'];
}

export interface RoleDataSourceInput {
  readonly dataSourceId: Scalars['Int']['input'];
}

export interface RoleDesignFolderInput {
  readonly designFolderId: Scalars['Int']['input'];
}

export interface RoleDeviceGroupInput {
  readonly access: RuleAccess;
  readonly deviceGroupId: Scalars['Int']['input'];
}

export interface RoleDeviceInput {
  readonly access: RuleAccess;
  readonly deviceId: Scalars['Int']['input'];
}

export interface RoleEventTypeInput {
  readonly eventTypeId: Scalars['Int']['input'];
}

export interface RolePage {
  readonly __typename: 'RolePage';
  readonly nodes: ReadonlyArray<Role>;
  readonly pageInfo: PaginationInfo;
}

export interface RolePatch {
  readonly accessDevices?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accessFonts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accessLiveChannelStreams?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accessReporting?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accessScheduler?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accessStudio?: InputMaybe<Scalars['Boolean']['input']>;
  readonly accessTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  readonly activateDevices?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createDataSources?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createEvents?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createPlaylists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createScheduledShows?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createShows?: InputMaybe<Scalars['Boolean']['input']>;
  readonly createTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
}

export interface RolePlaylistFolderInput {
  readonly playlistFolderId: Scalars['Int']['input'];
}

export interface RoleShowFolderInput {
  readonly showFolderId: Scalars['Int']['input'];
}

export interface RoleUserInput {
  readonly userId: Scalars['Int']['input'];
}

export const RolesOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type RolesOrderBy = typeof RolesOrderBy[keyof typeof RolesOrderBy];
export const RuleAccess = {
  Read: 'READ',
  Write: 'WRITE'
} as const;

export type RuleAccess = typeof RuleAccess[keyof typeof RuleAccess];
/** Autogenerated input type of RunDeviceSignal */
export interface RunDeviceSignalInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of RunDeviceSignal. */
export interface RunDeviceSignalPayload {
  readonly __typename: 'RunDeviceSignalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceSignal: DeviceSignal;
}

/** Autogenerated input type of RunSignalByEventName */
export interface RunSignalByEventNameInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly signalEventName: DeviceSignalEvent;
}

/** Autogenerated return type of RunSignalByEventName. */
export interface RunSignalByEventNamePayload {
  readonly __typename: 'RunSignalByEventNamePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
}

export interface SamsungFirmware {
  readonly __typename: 'SamsungFirmware';
  readonly id: Scalars['Int']['output'];
  readonly version: Scalars['String']['output'];
}

export interface Schedule {
  readonly __typename: 'Schedule';
  readonly allDay: Scalars['Boolean']['output'];
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly endTime?: Maybe<Scalars['String']['output']>;
  readonly rrule?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['String']['output']>;
  readonly startTime?: Maybe<Scalars['String']['output']>;
}

export interface ScheduleInput {
  readonly endTime?: InputMaybe<Scalars['String']['input']>;
  readonly rrule: Scalars['String']['input'];
  readonly startTime?: InputMaybe<Scalars['String']['input']>;
}

export interface ScheduledShow {
  readonly __typename: 'ScheduledShow';
  readonly canUpdate: AuthorizationResult;
  /** When this entity was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly deviceCount: Scalars['Int']['output'];
  readonly devices: ReadonlyArray<Device>;
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly schedule?: Maybe<Schedule>;
  readonly show: Show;
  /** When this entity was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** Autogenerated input type of ScheduledShowMutationsCreate */
export interface ScheduledShowMutationsCreateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly schedule: ScheduleInput;
  readonly selected: DeviceBulkSelectionInput;
  readonly showId: Scalars['Int']['input'];
}

/** Autogenerated return type of ScheduledShowMutationsCreate. */
export interface ScheduledShowMutationsCreatePayload {
  readonly __typename: 'ScheduledShowMutationsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly devices: ReadonlyArray<Device>;
  readonly scheduledShow?: Maybe<ScheduledShow>;
  readonly show: Show;
}

/** Autogenerated input type of ScheduledShowMutationsDelete */
export interface ScheduledShowMutationsDeleteInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly scheduledShowIds: ReadonlyArray<Scalars['Int']['input']>;
}

/** Autogenerated return type of ScheduledShowMutationsDelete. */
export interface ScheduledShowMutationsDeletePayload {
  readonly __typename: 'ScheduledShowMutationsDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedIds: ReadonlyArray<Scalars['Int']['output']>;
}

/** Autogenerated input type of ScheduledShowMutationsUpdate */
export interface ScheduledShowMutationsUpdateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: ScheduledShowPatch;
}

/** Autogenerated return type of ScheduledShowMutationsUpdate. */
export interface ScheduledShowMutationsUpdatePayload {
  readonly __typename: 'ScheduledShowMutationsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly scheduledShow?: Maybe<ScheduledShow>;
}

export interface ScheduledShowPage {
  readonly __typename: 'ScheduledShowPage';
  readonly nodes: ReadonlyArray<ScheduledShow>;
  readonly pageInfo: PaginationInfo;
}

export interface ScheduledShowPatch {
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly schedule?: InputMaybe<ScheduleInput>;
  readonly showId?: InputMaybe<Scalars['Int']['input']>;
}

export const ScheduledShowsOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type ScheduledShowsOrderBy = typeof ScheduledShowsOrderBy[keyof typeof ScheduledShowsOrderBy];
export interface Season {
  readonly __typename: 'Season';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly endsOn: Scalars['ISO8601Date']['output'];
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly startsOn: Scalars['ISO8601Date']['output'];
}

export interface SeasonPatch {
  readonly endsOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly startsOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

export interface SemverInput {
  /** Changes to this field indicate breaking changes */
  readonly major: Scalars['Int']['input'];
  /** Changes to this field indicate backwards-compatible feature additions */
  readonly minor: Scalars['Int']['input'];
  /** Changes to this field indicate changes (i.e. bug fixes) that do not change the public interface */
  readonly patch: Scalars['Int']['input'];
  readonly prerelease?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of SendDeviceCommand */
export interface SendDeviceCommandInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly command: DeviceCommandKind;
  readonly payload: Scalars['JSON']['input'];
  readonly selected: DeviceBulkSelectionInput;
}

/** Autogenerated return type of SendDeviceCommand. */
export interface SendDeviceCommandPayload {
  readonly __typename: 'SendDeviceCommandPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly devices?: Maybe<ReadonlyArray<Device>>;
  readonly error?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of SendRemoteCommand */
export interface SendRemoteCommandInput {
  readonly button: RemoteButton;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of SendRemoteCommand. */
export interface SendRemoteCommandPayload {
  readonly __typename: 'SendRemoteCommandPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly remote: Remote;
}

/** Autogenerated input type of SetPassword */
export interface SetPasswordInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly password: Scalars['String']['input'];
  readonly token: Scalars['String']['input'];
}

/** Autogenerated return type of SetPassword. */
export interface SetPasswordPayload {
  readonly __typename: 'SetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
}

export interface Show {
  readonly __typename: 'Show';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly channelGuide?: Maybe<ChannelGuide>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly defaultForDeviceGroups?: Maybe<ReadonlyArray<DeviceGroupNew>>;
  readonly defaultImageDuration?: Maybe<Scalars['ISO8601Duration']['output']>;
  readonly defaultView: View;
  /** @deprecated Use default_view instead for this info, saved for player */
  readonly defaultViewId: Scalars['Int']['output'];
  readonly eventDeviceGroups: ReadonlyArray<ShowEventDeviceGroup>;
  readonly fanconnect?: Maybe<FanconnectConfig>;
  readonly homeView?: Maybe<View>;
  readonly id: Scalars['Int']['output'];
  readonly instances?: Maybe<ReadonlyArray<Show>>;
  readonly name: Scalars['String']['output'];
  readonly origin?: Maybe<Show>;
  readonly originId?: Maybe<Scalars['Int']['output']>;
  readonly properties: ReadonlyArray<ManifestProperty>;
  readonly propertyGroups: ReadonlyArray<PropertyGroupOwner>;
  readonly scheduledShows: ReadonlyArray<ScheduledShow>;
  readonly serviceIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly services: ReadonlyArray<ContentItem>;
  readonly showFolder: ShowFolder;
  readonly showFolderId: Scalars['Int']['output'];
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly viewCount: Scalars['Int']['output'];
  readonly viewIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly views: ReadonlyArray<View>;
}

export interface ShowEventDeviceGroup {
  readonly __typename: 'ShowEventDeviceGroup';
  readonly deviceGroup: DeviceGroupNew;
  readonly event: Event;
  readonly id: Scalars['Int']['output'];
  readonly show: Show;
}

export interface ShowEventTypeDeviceGroup {
  readonly __typename: 'ShowEventTypeDeviceGroup';
  readonly deviceGroup: DeviceGroupNew;
  readonly eventType: EventType;
  readonly id: Scalars['Int']['output'];
  readonly show: Show;
}

export interface ShowFilters {
  readonly __typename: 'ShowFilters';
  readonly tags: ReadonlyArray<FilterCount>;
}

export interface ShowFolder {
  readonly __typename: 'ShowFolder';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  /** Child folders that can be accessed and their ancestors. */
  readonly children: ReadonlyArray<ShowFolder>;
  readonly childrenCount: Scalars['Int']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['Int']['output'];
  readonly itemCount: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly shows: ShowPage;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}


export interface ShowFolderChildrenArgs {
  condition?: InputMaybe<ShowFolderCondition>;
}


export interface ShowFolderChildrenCountArgs {
  condition?: InputMaybe<ShowFolderCondition>;
}


export interface ShowFolderItemCountArgs {
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}


export interface ShowFolderShowsArgs {
  orderBy?: InputMaybe<ReadonlyArray<ShowsOrderBy>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface ShowFolderCondition {
  readonly parentId?: InputMaybe<Scalars['Int']['input']>;
  readonly search?: InputMaybe<Scalars['String']['input']>;
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

export interface ShowFolderPatch {
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly parentId?: InputMaybe<Scalars['Int']['input']>;
}

export interface ShowFolderRule {
  readonly __typename: 'ShowFolderRule';
  readonly id: Scalars['Int']['output'];
  readonly showFolder: ShowFolder;
}

export interface ShowPage {
  readonly __typename: 'ShowPage';
  readonly nodes: ReadonlyArray<Show>;
  readonly pageInfo: PaginationInfo;
}

export interface ShowPatch {
  readonly channelGuideId?: InputMaybe<Scalars['Int']['input']>;
  readonly defaultImageDuration?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  readonly defaultViewId?: InputMaybe<Scalars['Int']['input']>;
  readonly fanconnect?: InputMaybe<FanconnectConfigInput>;
  readonly homeViewId?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly propertyValues?: InputMaybe<ReadonlyArray<PropertyValuePatch>>;
}

export interface ShowTag {
  readonly __typename: 'ShowTag';
  readonly name: Scalars['String']['output'];
  readonly uses: Scalars['Int']['output'];
}

export interface ShowsDeviceGroupsInput {
  readonly deviceGroupId: Scalars['Int']['input'];
  readonly showId: Scalars['Int']['input'];
}

export const ShowsOrderBy = {
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type ShowsOrderBy = typeof ShowsOrderBy[keyof typeof ShowsOrderBy];
/** Autogenerated input type of ShufflePlaylist */
export interface ShufflePlaylistInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly playlistId: Scalars['Int']['input'];
}

/** Autogenerated return type of ShufflePlaylist. */
export interface ShufflePlaylistPayload {
  readonly __typename: 'ShufflePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly playlist: Playlist;
}

export type SignalAction = SignalActionArbitrary | SignalActionPlayOverlay | SignalActionPlayShow | SignalActionReboot | SignalActionStopOverlay | SignalActionTriggerView | SignalActionTuneChannel;

export interface SignalActionArbitrary {
  readonly __typename: 'SignalActionArbitrary';
  readonly arbitrary: Scalars['String']['output'];
  readonly command: Scalars['String']['output'];
}

export interface SignalActionPlayOverlay {
  readonly __typename: 'SignalActionPlayOverlay';
  readonly command: Scalars['String']['output'];
  readonly overlay?: Maybe<Overlay>;
}

export interface SignalActionPlayShow {
  readonly __typename: 'SignalActionPlayShow';
  readonly command: Scalars['String']['output'];
  readonly show?: Maybe<Show>;
}

export interface SignalActionReboot {
  readonly __typename: 'SignalActionReboot';
  readonly command: Scalars['String']['output'];
}

export interface SignalActionStopOverlay {
  readonly __typename: 'SignalActionStopOverlay';
  readonly command: Scalars['String']['output'];
}

export interface SignalActionTriggerView {
  readonly __typename: 'SignalActionTriggerView';
  readonly command: Scalars['String']['output'];
  readonly view?: Maybe<View>;
}

export interface SignalActionTuneChannel {
  readonly __typename: 'SignalActionTuneChannel';
  readonly channel?: Maybe<Channel>;
  readonly command: Scalars['String']['output'];
}

export interface SoftwareUpdateInfo {
  readonly __typename: 'SoftwareUpdateInfo';
  readonly currentVersion?: Maybe<Scalars['String']['output']>;
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly versions: ReadonlyArray<SoftwareVersion>;
}

export interface SoftwareVersion {
  readonly __typename: 'SoftwareVersion';
  readonly approved: Scalars['Boolean']['output'];
  readonly current: Scalars['Boolean']['output'];
  readonly eoledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly version: Scalars['String']['output'];
}

/** Autogenerated input type of StopImpersonate */
export interface StopImpersonateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of StopImpersonate. */
export interface StopImpersonatePayload {
  readonly __typename: 'StopImpersonatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user: User;
}

export interface Subscription {
  readonly __typename: 'Subscription';
  readonly currentUserUpdated: CurrentUserUpdatedPayload;
}

/** Autogenerated input type of SyncDataSource */
export interface SyncDataSourceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
}

/** Autogenerated return type of SyncDataSource. */
export interface SyncDataSourcePayload {
  readonly __typename: 'SyncDataSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataSource: DataSource;
}

/** Autogenerated input type of SyncEvents */
export interface SyncEventsInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventTypeId: Scalars['Int']['input'];
}

/** Autogenerated return type of SyncEvents. */
export interface SyncEventsPayload {
  readonly __typename: 'SyncEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly eventType: EventType;
}

export interface SystemInfoCpuInput {
  readonly model: Scalars['String']['input'];
  /** @deprecated Use `speed_v2` instead in case big integers */
  readonly speed?: InputMaybe<Scalars['Int']['input']>;
  readonly speedV2?: InputMaybe<Scalars['BigInt']['input']>;
  /** @deprecated Use `times_v2` instead in case big integers */
  readonly times?: InputMaybe<SystemInfoCpuTimeInput>;
  readonly timesV2?: InputMaybe<SystemInfoCpuTimeV2Input>;
}

export interface SystemInfoCpuTempInput {
  readonly chipset?: InputMaybe<Scalars['Float']['input']>;
  readonly cores?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
  readonly main?: InputMaybe<Scalars['Float']['input']>;
  readonly max?: InputMaybe<Scalars['Float']['input']>;
  readonly socket?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
}

export interface SystemInfoCpuTimeInput {
  readonly idle: Scalars['Int']['input'];
  readonly irq: Scalars['Int']['input'];
  readonly nice: Scalars['Int']['input'];
  readonly sys: Scalars['Int']['input'];
  readonly user: Scalars['Int']['input'];
}

export interface SystemInfoCpuTimeV2Input {
  readonly idle: Scalars['BigInt']['input'];
  readonly irq: Scalars['BigInt']['input'];
  readonly nice: Scalars['BigInt']['input'];
  readonly sys: Scalars['BigInt']['input'];
  readonly user: Scalars['BigInt']['input'];
}

export interface SystemInfoCpuUsageInput {
  readonly system: Scalars['BigInt']['input'];
  readonly user: Scalars['BigInt']['input'];
}

export interface SystemInfoInput {
  readonly cpuTemp?: InputMaybe<SystemInfoCpuTempInput>;
  readonly cpuUsage?: InputMaybe<SystemInfoCpuUsageInput>;
  readonly cpuUsageCalculated?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated This is unused as of player version 1.18.4 */
  readonly cpus?: InputMaybe<ReadonlyArray<SystemInfoCpuInput>>;
  readonly diskSpace?: InputMaybe<SystemInfoSpaceInput>;
  readonly loadAverage?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
  readonly memory?: InputMaybe<SystemInfoSpaceInput>;
  readonly uptime?: InputMaybe<SystemInfoUptimeInput>;
}

export interface SystemInfoSpaceInput {
  readonly available?: InputMaybe<Scalars['BigInt']['input']>;
  readonly total?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface SystemInfoUptimeInput {
  readonly os: Scalars['Float']['input'];
  readonly process: Scalars['Float']['input'];
}

export interface TvBrand {
  readonly __typename: 'TVBrand';
  readonly baudRate: Scalars['Int']['output'];
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly deviceCount: Scalars['Int']['output'];
  readonly id: Scalars['Int']['output'];
  readonly input1: Scalars['String']['output'];
  readonly input2: Scalars['String']['output'];
  readonly input3: Scalars['String']['output'];
  readonly mute: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly network: Network;
  readonly powerOff: Scalars['String']['output'];
  readonly powerOn: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
  readonly unmute: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly volumeDown: Scalars['String']['output'];
  readonly volumeUp: Scalars['String']['output'];
}


export interface TvBrandDeviceCountArgs {
  networkId: Scalars['Int']['input'];
}

export interface TvBrandPage {
  readonly __typename: 'TVBrandPage';
  readonly nodes: ReadonlyArray<TvBrand>;
  readonly pageInfo: PaginationInfo;
}

export const TvBrandsOrderBy = {
  CreatedAtAsc: 'CREATED_AT_ASC',
  CreatedAtDesc: 'CREATED_AT_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC'
} as const;

export type TvBrandsOrderBy = typeof TvBrandsOrderBy[keyof typeof TvBrandsOrderBy];
/** An object which may have tags assigned to it */
export type Taggable = ContentItem | Design | Device | DeviceSignal | MediaItem | Playlist | Show;

export const TaggableType = {
  /** Content item taggable type */
  App: 'APP',
  /** Design taggable type */
  Design: 'DESIGN',
  /** Device taggable type */
  Device: 'DEVICE',
  /** Device signal taggable type */
  DeviceSignal: 'DEVICE_SIGNAL',
  /** Media item taggable type */
  Media: 'MEDIA',
  /** Playlist taggable type */
  Playlist: 'PLAYLIST',
  /** Show taggable type */
  Show: 'SHOW'
} as const;

export type TaggableType = typeof TaggableType[keyof typeof TaggableType];
export interface Team {
  readonly __typename: 'Team';
  readonly abbreviation?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly location?: Maybe<Scalars['String']['output']>;
  readonly logoUrl?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly primaryColor?: Maybe<Scalars['String']['output']>;
}

export interface Template {
  readonly __typename: 'Template';
  readonly adKind?: Maybe<TemplateAdKind>;
  readonly canCleanup: AuthorizationResult;
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly canUpgradeAll: AuthorizationResult;
  readonly contentItems: ContentItemPage;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['Int']['output'];
  readonly latestVersion?: Maybe<TemplateVersion>;
  readonly mediaKind?: Maybe<MediaKind>;
  readonly name: Scalars['String']['output'];
  readonly templateCategory: TemplateCategory;
  readonly templateVersions: TemplateVersionConnection;
  /** A public URL for the (smallest) thumbnail available, else `null` */
  readonly thumbnailUri?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}


export interface TemplateContentItemsArgs {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}


export interface TemplateTemplateVersionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export const TemplateAdKind = {
  /** Fullscreen Ad */
  Fullscreen: 'FULLSCREEN',
  /** Panel Ad */
  Panel: 'PANEL'
} as const;

export type TemplateAdKind = typeof TemplateAdKind[keyof typeof TemplateAdKind];
export interface TemplateCategory {
  readonly __typename: 'TemplateCategory';
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly templates: ReadonlyArray<Template>;
}


export interface TemplateCategoryTemplatesArgs {
  search?: InputMaybe<Scalars['String']['input']>;
}

export const TemplateCategoryOrdering = {
  CreatedAsc: 'CREATED_ASC',
  CreatedDesc: 'CREATED_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC',
  UpdatedAsc: 'UPDATED_ASC',
  UpdatedDesc: 'UPDATED_DESC'
} as const;

export type TemplateCategoryOrdering = typeof TemplateCategoryOrdering[keyof typeof TemplateCategoryOrdering];
/** The connection type for Template. */
export interface TemplateConnection {
  readonly __typename: 'TemplateConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TemplateEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Template>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface TemplateEdge {
  readonly __typename: 'TemplateEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Template>;
}

export interface TemplateParam {
  readonly __typename: 'TemplateParam';
  readonly array: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly defaultValue?: Maybe<Scalars['JSON']['output']>;
  readonly description: Scalars['String']['output'];
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly kind: TemplateParamKind;
  readonly label: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly nullable: Scalars['Boolean']['output'];
  readonly options?: Maybe<ReadonlyArray<TemplateParamOption>>;
  readonly templateVersionId: Scalars['Int']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface TemplateParamGroup {
  readonly __typename: 'TemplateParamGroup';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly label: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
}

export const TemplateParamKind = {
  /** App (content item) ID */
  App: 'APP',
  /** `true` or `false` */
  Boolean: 'BOOLEAN',
  /** CSS Color */
  Color: 'COLOR',
  /** Item data from Data Source */
  Data: 'DATA',
  /** Item from Data Source */
  DataItem: 'DATA_ITEM',
  /** Entire Data Source as JSON */
  DataSource: 'DATA_SOURCE',
  /** Design data from studio as JSON */
  Design: 'DESIGN',
  /** The playing device's row from each Data Source, matched on the source's device key */
  DeviceDataSource: 'DEVICE_DATA_SOURCE',
  /** Floating-point number */
  Float: 'FLOAT',
  /** Font */
  Font: 'FONT',
  /** Image media item */
  Image: 'IMAGE',
  /** Whole number */
  Integer: 'INTEGER',
  /** Image or video media item */
  Media: 'MEDIA',
  /** Pdf media item */
  Pdf: 'PDF',
  /** PowerPoint media item */
  Powerpoint: 'POWERPOINT',
  /** Generic text */
  String: 'STRING',
  /** Generic text, only more so */
  Text: 'TEXT',
  /** Video media item */
  Video: 'VIDEO'
} as const;

export type TemplateParamKind = typeof TemplateParamKind[keyof typeof TemplateParamKind];
export interface TemplateParamOption {
  readonly __typename: 'TemplateParamOption';
  readonly name: Scalars['String']['output'];
  readonly value: Scalars['JSON']['output'];
}

export interface TemplatePatch {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly templateCategoryId?: InputMaybe<Scalars['Int']['input']>;
  readonly thumbnailUri?: InputMaybe<Scalars['String']['input']>;
}

export interface TemplateVersion {
  readonly __typename: 'TemplateVersion';
  readonly aspectRatio?: Maybe<Scalars['String']['output']>;
  readonly canDestroy: AuthorizationResult;
  readonly checksum: Scalars['String']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly defaultDuration?: Maybe<Interval>;
  readonly durationReadonly: Scalars['Boolean']['output'];
  readonly fileId: Scalars['Int']['output'];
  readonly groupedParams: ReadonlyArray<GroupedTemplateParams>;
  readonly id: Scalars['Int']['output'];
  readonly templateId: Scalars['Int']['output'];
  /** @deprecated Use `groupedParams` insead */
  readonly templateParams: ReadonlyArray<TemplateParam>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly uri: Scalars['String']['output'];
  readonly uses: Scalars['Int']['output'];
  readonly version: Scalars['String']['output'];
}


export interface TemplateVersionUriArgs {
  expires?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for TemplateVersion. */
export interface TemplateVersionConnection {
  readonly __typename: 'TemplateVersionConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TemplateVersionEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<TemplateVersion>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface TemplateVersionEdge {
  readonly __typename: 'TemplateVersionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<TemplateVersion>;
}

export interface TemplateVersionPreviewType {
  readonly __typename: 'TemplateVersionPreviewType';
  readonly aspectRatio?: Maybe<Scalars['String']['output']>;
  readonly contentItem: ContentItem;
}

export interface TemplateZipValidation {
  readonly __typename: 'TemplateZipValidation';
  /** Empty when the zip is usable. */
  readonly errors: ReadonlyArray<TemplateZipValidationError>;
}

export interface TemplateZipValidationError {
  readonly __typename: 'TemplateZipValidationError';
  /** Human-readable descriptions of what is wrong. */
  readonly explanation: ReadonlyArray<Scalars['String']['output']>;
  /** Segments locating the problem in config.json, e.g. ["params", "0", "kind"]. Empty when the problem is with the zip itself. */
  readonly path: ReadonlyArray<Scalars['String']['output']>;
}

export interface Thumbnail {
  readonly __typename: 'Thumbnail';
  readonly boundsHeight: Scalars['Int']['output'];
  readonly boundsWidth: Scalars['Int']['output'];
  readonly uri: Scalars['String']['output'];
}

export interface TimeZone {
  readonly __typename: 'TimeZone';
  readonly id: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
}

/** Autogenerated input type of TransferDevice */
export interface TransferDeviceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceId: Scalars['Int']['input'];
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of TransferDevice. */
export interface TransferDevicePayload {
  readonly __typename: 'TransferDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly device?: Maybe<Device>;
}

/** Autogenerated input type of TuneRemoteChannel */
export interface TuneRemoteChannelInput {
  readonly channelId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of TuneRemoteChannel. */
export interface TuneRemoteChannelPayload {
  readonly __typename: 'TuneRemoteChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly remote: Remote;
}

export interface TvBrandPatch {
  readonly baudRate?: InputMaybe<Scalars['Int']['input']>;
  readonly input1?: InputMaybe<Scalars['String']['input']>;
  readonly input2?: InputMaybe<Scalars['String']['input']>;
  readonly input3?: InputMaybe<Scalars['String']['input']>;
  readonly mute?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly powerOff?: InputMaybe<Scalars['String']['input']>;
  readonly powerOn?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly unmute?: InputMaybe<Scalars['String']['input']>;
  readonly volumeDown?: InputMaybe<Scalars['String']['input']>;
  readonly volumeUp?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of UpdateChannelGuide */
export interface UpdateChannelGuideInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: ChannelGuidePatch;
}

/** Autogenerated return type of UpdateChannelGuide. */
export interface UpdateChannelGuidePayload {
  readonly __typename: 'UpdateChannelGuidePayload';
  readonly channelGuide: ChannelGuide;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of UpdateChannel */
export interface UpdateChannelInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: ChannelPatch;
}

/** Autogenerated return type of UpdateChannel. */
export interface UpdateChannelPayload {
  readonly __typename: 'UpdateChannelPayload';
  readonly channel: Channel;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
}

/** Autogenerated input type of UpdateContentFolder */
export interface UpdateContentFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentFolderId: Scalars['Int']['input'];
  readonly patch: ContentFolderPatch;
}

/** Autogenerated return type of UpdateContentFolder. */
export interface UpdateContentFolderPayload {
  readonly __typename: 'UpdateContentFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contentFolder: ContentFolder;
  readonly network: Network;
  readonly oldParent?: Maybe<ContentFolder>;
  readonly parent: ContentFolder;
}

/** Autogenerated input type of UpdateContentItem */
export interface UpdateContentItemInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentItemId: Scalars['Int']['input'];
  readonly patch: ContentItemPatch;
}

/** Autogenerated return type of UpdateContentItem. */
export interface UpdateContentItemPayload {
  readonly __typename: 'UpdateContentItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contentItem: ContentItem;
}

/** Autogenerated input type of UpdateDataSource */
export interface UpdateDataSourceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceKey?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateDataSource. */
export interface UpdateDataSourcePayload {
  readonly __typename: 'UpdateDataSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataSource: DataSource;
}

/** Autogenerated input type of UpdateDesignFolder */
export interface UpdateDesignFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly designFolderId: Scalars['Int']['input'];
  readonly patch: DesignFolderPatch;
}

/** Autogenerated return type of UpdateDesignFolder. */
export interface UpdateDesignFolderPayload {
  readonly __typename: 'UpdateDesignFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly designFolder: DesignFolder;
  readonly network: Network;
  readonly oldParent?: Maybe<DesignFolder>;
  readonly parent: DesignFolder;
}

/** Autogenerated input type of UpdateDesign */
export interface UpdateDesignInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: DesignPatch;
}

/** Autogenerated return type of UpdateDesign. */
export interface UpdateDesignPayload {
  readonly __typename: 'UpdateDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly design: Design;
  readonly network: Network;
}

/** Autogenerated input type of UpdateDeviceGroup */
export interface UpdateDeviceGroupInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: DeviceGroupPatch;
}

/** Autogenerated return type of UpdateDeviceGroup. */
export interface UpdateDeviceGroupPayload {
  readonly __typename: 'UpdateDeviceGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceGroup: DeviceGroupNew;
  readonly network: Network;
}

/** Autogenerated input type of UpdateDevice */
export interface UpdateDeviceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceId: Scalars['Int']['input'];
  readonly patch: DevicePatch;
}

/** Autogenerated return type of UpdateDevice. */
export interface UpdateDevicePayload {
  readonly __typename: 'UpdateDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly device?: Maybe<Device>;
}

/** Autogenerated input type of UpdateDeviceSignal */
export interface UpdateDeviceSignalInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: DeviceSignalPatch;
}

/** Autogenerated return type of UpdateDeviceSignal. */
export interface UpdateDeviceSignalPayload {
  readonly __typename: 'UpdateDeviceSignalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceSignal: DeviceSignal;
  readonly network: Network;
}

/** Autogenerated input type of UpdateDeviceStatus */
export interface UpdateDeviceStatusInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly status: DeviceStatusInput;
}

/** Autogenerated return type of UpdateDeviceStatus. */
export interface UpdateDeviceStatusPayload {
  readonly __typename: 'UpdateDeviceStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly device?: Maybe<Device>;
}

/** Autogenerated input type of UpdateDeviceStatusV3 */
export interface UpdateDeviceStatusV3Input {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly status: DeviceStatusInput;
}

/** Autogenerated return type of UpdateDeviceStatusV3. */
export interface UpdateDeviceStatusV3Payload {
  readonly __typename: 'UpdateDeviceStatusV3Payload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly device?: Maybe<Device>;
}

/** Autogenerated input type of UpdateEvent */
export interface UpdateEventInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly identifier: EventIdentifier;
  readonly patch: EventPatch;
}

/** Autogenerated return type of UpdateEvent. */
export interface UpdateEventPayload {
  readonly __typename: 'UpdateEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event: Event;
}

/** Autogenerated input type of UpdateEventType */
export interface UpdateEventTypeInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: EventTypePatch;
}

/** Autogenerated return type of UpdateEventType. */
export interface UpdateEventTypePayload {
  readonly __typename: 'UpdateEventTypePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly eventType: EventType;
  readonly network: Network;
}

/** Autogenerated input type of UpdateEventTypeShowsDeviceGroups */
export interface UpdateEventTypeShowsDeviceGroupsInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: EventTypeShowsDeviceGroupsPatch;
}

/** Autogenerated return type of UpdateEventTypeShowsDeviceGroups. */
export interface UpdateEventTypeShowsDeviceGroupsPayload {
  readonly __typename: 'UpdateEventTypeShowsDeviceGroupsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly eventType: EventType;
}

/** Autogenerated input type of UpdateFont */
export interface UpdateFontInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly fileUri?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateFont. */
export interface UpdateFontPayload {
  readonly __typename: 'UpdateFontPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly font: Font;
}

/** Autogenerated input type of UpdateLayout */
export interface UpdateLayoutInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly layoutId: Scalars['Int']['input'];
  readonly patch: LayoutPatch;
}

/** Autogenerated return type of UpdateLayout. */
export interface UpdateLayoutPayload {
  readonly __typename: 'UpdateLayoutPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly layout: Layout;
}

/** Autogenerated input type of UpdateMediaItem */
export interface UpdateMediaItemInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly mediaItemId: Scalars['Int']['input'];
  readonly patch: MediaItemPatch;
}

/** Autogenerated return type of UpdateMediaItem. */
export interface UpdateMediaItemPayload {
  readonly __typename: 'UpdateMediaItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly mediaItem?: Maybe<MediaItem>;
}

/** Autogenerated input type of UpdateNetwork */
export interface UpdateNetworkInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly networkId: Scalars['Int']['input'];
  readonly patch: NetworkPatch;
}

/** Autogenerated return type of UpdateNetwork. */
export interface UpdateNetworkPayload {
  readonly __typename: 'UpdateNetworkPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network?: Maybe<Network>;
}

/** Autogenerated input type of UpdateOverlay */
export interface UpdateOverlayInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: OverlayPatch;
}

/** Autogenerated return type of UpdateOverlay. */
export interface UpdateOverlayPayload {
  readonly __typename: 'UpdateOverlayPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly overlay: Overlay;
}

/** Autogenerated input type of UpdatePlaylistFolder */
export interface UpdatePlaylistFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: PlaylistFolderPatch;
  readonly playlistFolderId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpdatePlaylistFolder. */
export interface UpdatePlaylistFolderPayload {
  readonly __typename: 'UpdatePlaylistFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly oldParent?: Maybe<PlaylistFolder>;
  readonly parent: PlaylistFolder;
  readonly playlistFolder: PlaylistFolder;
}

/** Autogenerated input type of UpdatePlaylist */
export interface UpdatePlaylistInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: PlaylistPatch;
  readonly playlistId: Scalars['Int']['input'];
}

/** Autogenerated input type of UpdatePlaylistItem */
export interface UpdatePlaylistItemInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: PlaylistItemPatch;
  readonly playlistItemId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpdatePlaylistItem. */
export interface UpdatePlaylistItemPayload {
  readonly __typename: 'UpdatePlaylistItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly playlist: Playlist;
  readonly playlistItem: PlaylistItem;
}

/** Autogenerated return type of UpdatePlaylist. */
export interface UpdatePlaylistPayload {
  readonly __typename: 'UpdatePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly playlist?: Maybe<Playlist>;
}

/** Autogenerated input type of UpdateRole */
export interface UpdateRoleInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: RolePatch;
}

/** Autogenerated return type of UpdateRole. */
export interface UpdateRolePayload {
  readonly __typename: 'UpdateRolePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly role: Role;
}

/** Autogenerated input type of UpdateSeason */
export interface UpdateSeasonInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: SeasonPatch;
}

/** Autogenerated return type of UpdateSeason. */
export interface UpdateSeasonPayload {
  readonly __typename: 'UpdateSeasonPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly eventType: EventType;
  readonly season: Season;
}

/** Autogenerated input type of UpdateShowFolder */
export interface UpdateShowFolderInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: ShowFolderPatch;
  readonly showFolderId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpdateShowFolder. */
export interface UpdateShowFolderPayload {
  readonly __typename: 'UpdateShowFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly oldParent?: Maybe<ShowFolder>;
  readonly parent: ShowFolder;
  readonly showFolder: ShowFolder;
}

/** Autogenerated input type of UpdateShow */
export interface UpdateShowInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: ShowPatch;
  readonly showId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpdateShow. */
export interface UpdateShowPayload {
  readonly __typename: 'UpdateShowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly show: Show;
}

/** Autogenerated input type of UpdateTVBrand */
export interface UpdateTvBrandInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: TvBrandPatch;
}

/** Autogenerated return type of UpdateTVBrand. */
export interface UpdateTvBrandPayload {
  readonly __typename: 'UpdateTVBrandPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tvBrand: TvBrand;
}

/** Autogenerated input type of UpdateTags */
export interface UpdateTagsInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taggableId: Scalars['Int']['input'];
  readonly taggableType: TaggableType;
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
}

/** Autogenerated return type of UpdateTags. */
export interface UpdateTagsPayload {
  readonly __typename: 'UpdateTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly network: Network;
  readonly taggable: Taggable;
}

/** Autogenerated input type of UpdateTemplate */
export interface UpdateTemplateInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: TemplatePatch;
  readonly templateId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpdateTemplate. */
export interface UpdateTemplatePayload {
  readonly __typename: 'UpdateTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly template: Template;
}

/** Autogenerated input type of UpdateUser */
export interface UpdateUserInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: UserPatch;
  readonly userId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpdateUser. */
export interface UpdateUserPayload {
  readonly __typename: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<User>;
}

/** Autogenerated input type of UpdateView */
export interface UpdateViewInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: ViewPatch;
  readonly viewId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpdateView. */
export interface UpdateViewPayload {
  readonly __typename: 'UpdateViewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly view?: Maybe<View>;
}

/** Autogenerated input type of UpdateViewZone */
export interface UpdateViewZoneInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly patch: ViewZonePatch;
  readonly viewZoneId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpdateViewZone. */
export interface UpdateViewZonePayload {
  readonly __typename: 'UpdateViewZonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly viewZone?: Maybe<ViewZone>;
}

/** Autogenerated input type of UpdateZone */
export interface UpdateZoneInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['Int']['input'];
  readonly patch: ZonePatch;
}

/** Autogenerated return type of UpdateZone. */
export interface UpdateZonePayload {
  readonly __typename: 'UpdateZonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly layout: Layout;
  readonly zone: Zone;
}

/** Autogenerated input type of UpgradeAllContentItems */
export interface UpgradeAllContentItemsInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly templateId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpgradeAllContentItems. */
export interface UpgradeAllContentItemsPayload {
  readonly __typename: 'UpgradeAllContentItemsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly template?: Maybe<Template>;
}

/** Autogenerated input type of UpgradeContentItem */
export interface UpgradeContentItemInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contentItemId: Scalars['Int']['input'];
}

/** Autogenerated return type of UpgradeContentItem. */
export interface UpgradeContentItemPayload {
  readonly __typename: 'UpgradeContentItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contentItem?: Maybe<ContentItem>;
}

export interface UploadCredentials {
  readonly __typename: 'UploadCredentials';
  readonly accessKeyId: Scalars['String']['output'];
  readonly expiration: Scalars['ISO8601DateTime']['output'];
  readonly secretAccessKey: Scalars['String']['output'];
  readonly sessionToken: Scalars['String']['output'];
}

/** Autogenerated input type of UploadDataSource */
export interface UploadDataSourceInput {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dataSourceId?: InputMaybe<Scalars['Int']['input']>;
  readonly dataUri: Scalars['String']['input'];
  readonly foreignIdName?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly networkId: Scalars['Int']['input'];
}

/** Autogenerated return type of UploadDataSource. */
export interface UploadDataSourcePayload {
  readonly __typename: 'UploadDataSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataSource: DataSource;
}

export interface UploadMetadata {
  readonly __typename: 'UploadMetadata';
  readonly networkId: Scalars['String']['output'];
  readonly userId: Scalars['String']['output'];
}

/** A place where content is used: a saved App, an unpublished Design, a reusable Playlist, or a Show */
export type Usage = ContentItem | Design | Playlist | Show;

export interface UsagePage {
  readonly __typename: 'UsagePage';
  readonly nodes: ReadonlyArray<Usage>;
  readonly pageInfo: PaginationInfo;
}

export interface User {
  readonly __typename: 'User';
  readonly admin: Scalars['Boolean']['output'];
  readonly authStrategy?: Maybe<UserAuthStrategy>;
  readonly autoRefresh: Scalars['Boolean']['output'];
  readonly canCreateNetwork: AuthorizationResult;
  readonly canDestroy: AuthorizationResult;
  readonly canManageNetwork: AuthorizationResult;
  readonly canShow: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly currentSignInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly currentSignInIp?: Maybe<Scalars['String']['output']>;
  readonly defaultNetworkId?: Maybe<Scalars['Int']['output']>;
  readonly devicePreviewAutoplay?: Maybe<Scalars['Boolean']['output']>;
  readonly email: Scalars['String']['output'];
  readonly hideDashboard: Scalars['Boolean']['output'];
  readonly id: Scalars['Int']['output'];
  readonly lastSignInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly lastSignInIp?: Maybe<Scalars['String']['output']>;
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly networkMembership?: Maybe<NetworkMembership>;
  readonly networkMemberships: ReadonlyArray<NetworkMembership>;
  readonly networks: ReadonlyArray<Network>;
  readonly roles: ReadonlyArray<Role>;
  readonly signInCount: Scalars['Int']['output'];
  readonly status: Scalars['String']['output'];
  readonly unreadAnnouncementCount: Scalars['Int']['output'];
  readonly unreadAnnouncementsBySeverity: ReadonlyArray<AnnouncementUnreadCount>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
}


export interface UserNetworkMembershipArgs {
  networkId: Scalars['Int']['input'];
}


export interface UserNetworksArgs {
  condition?: InputMaybe<NetworkCondition>;
  orderBy?: InputMaybe<ReadonlyArray<NetworksOrderBy>>;
  search?: InputMaybe<Scalars['String']['input']>;
}

export const UserAuthStrategy = {
  /** FanConnect */
  Fanconnect: 'FANCONNECT',
  /** SAML */
  Saml: 'SAML'
} as const;

export type UserAuthStrategy = typeof UserAuthStrategy[keyof typeof UserAuthStrategy];
/** The connection type for User. */
export interface UserConnection {
  readonly __typename: 'UserConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<User>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserEdge {
  readonly __typename: 'UserEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<User>;
}

export const UserOrdering = {
  EmailAsc: 'EMAIL_ASC',
  EmailDesc: 'EMAIL_DESC',
  LastLoginAsc: 'LAST_LOGIN_ASC',
  LastLoginDesc: 'LAST_LOGIN_DESC',
  NameAsc: 'NAME_ASC',
  NameDesc: 'NAME_DESC',
  StatusAsc: 'STATUS_ASC',
  StatusDesc: 'STATUS_DESC'
} as const;

export type UserOrdering = typeof UserOrdering[keyof typeof UserOrdering];
export interface UserPatch {
  readonly autoRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  readonly defaultNetworkId?: InputMaybe<Scalars['Int']['input']>;
  readonly devicePreviewAutoplay?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hideDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  readonly locale?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly newPassword?: InputMaybe<Scalars['String']['input']>;
  readonly oldPassword?: InputMaybe<Scalars['String']['input']>;
}

export interface View {
  readonly __typename: 'View';
  readonly canDestroy: AuthorizationResult;
  /** When this entity was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The primary key of this entity */
  readonly id: Scalars['Int']['output'];
  readonly layout: Layout;
  readonly layoutId: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly show: Show;
  readonly showId: Scalars['Int']['output'];
  readonly thumbnailFileId?: Maybe<Scalars['Int']['output']>;
  /** A public URL for the (smallest) thumbnail available, else `null` */
  readonly thumbnailUri?: Maybe<Scalars['String']['output']>;
  /** When this entity was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly viewZones: ReadonlyArray<ViewZone>;
}


export interface ViewViewZonesArgs {
  orderBy?: InputMaybe<ViewZoneOrder>;
}

export interface ViewPatch {
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly thumbnailUri?: InputMaybe<Scalars['String']['input']>;
}

export interface ViewZone {
  readonly __typename: 'ViewZone';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['Int']['output'];
  readonly layoutId: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  /** If `true`, generate playback events for each app in this zone */
  readonly reportPlayback: Scalars['Boolean']['output'];
  readonly sync: Scalars['Boolean']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly viewZonePlaylistIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly viewZonePlaylists: ReadonlyArray<ViewZonePlaylist>;
  readonly zoneId: Scalars['Int']['output'];
}

export const ViewZoneOrder = {
  LayoutAsc: 'LAYOUT_ASC',
  LayoutDesc: 'LAYOUT_DESC'
} as const;

export type ViewZoneOrder = typeof ViewZoneOrder[keyof typeof ViewZoneOrder];
export interface ViewZonePatch {
  readonly reportPlayback?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sync?: InputMaybe<Scalars['Boolean']['input']>;
  readonly viewZonePlaylistIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
}

export interface ViewZonePlaylist {
  readonly __typename: 'ViewZonePlaylist';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['Int']['output'];
  readonly playlist: Playlist;
  readonly playlistId: Scalars['Int']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly viewZone: ViewZone;
}

export interface WebosFirmware {
  readonly __typename: 'WebosFirmware';
  readonly id: Scalars['Int']['output'];
  readonly version: Scalars['String']['output'];
}

export interface Zone {
  readonly __typename: 'Zone';
  readonly canDestroy: AuthorizationResult;
  readonly canUpdate: AuthorizationResult;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly height: Scalars['Float']['output'];
  readonly id: Scalars['Int']['output'];
  readonly layoutId: Scalars['Int']['output'];
  readonly left: Scalars['Float']['output'];
  readonly name: Scalars['String']['output'];
  readonly top: Scalars['Float']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly width: Scalars['Float']['output'];
}

export interface ZonePatch {
  readonly height?: InputMaybe<Scalars['Int']['input']>;
  readonly left?: InputMaybe<Scalars['Int']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly top?: InputMaybe<Scalars['Int']['input']>;
  readonly width?: InputMaybe<Scalars['Int']['input']>;
}

export type ActivateDevicePayloadKeySpecifier = ('clientMutationId' | 'device' | 'network' | ActivateDevicePayloadKeySpecifier)[];
export type ActivateDevicePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActiveShowKeySpecifier = ('description' | 'event' | 'reason' | 'show' | ActiveShowKeySpecifier)[];
export type ActiveShowFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddChannelsToChannelGuidePayloadKeySpecifier = ('addedIds' | 'channelGuide' | 'clientMutationId' | AddChannelsToChannelGuidePayloadKeySpecifier)[];
export type AddChannelsToChannelGuidePayloadFieldPolicy = {
	addedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	channelGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddContentFoldersToPlaylistPayloadKeySpecifier = ('clientMutationId' | 'playlist' | 'playlistItems' | AddContentFoldersToPlaylistPayloadKeySpecifier)[];
export type AddContentFoldersToPlaylistPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddContentToPlaylistPayloadKeySpecifier = ('addedIds' | 'clientMutationId' | 'playlist' | AddContentToPlaylistPayloadKeySpecifier)[];
export type AddContentToPlaylistPayloadFieldPolicy = {
	addedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddContentToShowPayloadKeySpecifier = ('addedIds' | 'clientMutationId' | 'playlist' | 'viewZone' | AddContentToShowPayloadKeySpecifier)[];
export type AddContentToShowPayloadFieldPolicy = {
	addedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>,
	viewZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddDevicesToDeviceGroupPayloadKeySpecifier = ('addedIds' | 'clientMutationId' | 'deviceGroup' | 'network' | AddDevicesToDeviceGroupPayloadKeySpecifier)[];
export type AddDevicesToDeviceGroupPayloadFieldPolicy = {
	addedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddToRolePayloadKeySpecifier = ('clientMutationId' | 'role' | AddToRolePayloadKeySpecifier)[];
export type AddToRolePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AiChatSendMessagePayloadKeySpecifier = ('clientMutationId' | 'message' | AiChatSendMessagePayloadKeySpecifier)[];
export type AiChatSendMessagePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnnouncementKeySpecifier = ('body' | 'id' | 'publishedAt' | 'read' | 'severity' | 'sticky' | 'tags' | 'title' | AnnouncementKeySpecifier)[];
export type AnnouncementFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	severity?: FieldPolicy<any> | FieldReadFunction<any>,
	sticky?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnnouncementFiltersKeySpecifier = ('categories' | 'read' | 'severities' | 'tags' | AnnouncementFiltersKeySpecifier)[];
export type AnnouncementFiltersFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	severities?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnnouncementPageKeySpecifier = ('nodes' | 'pageInfo' | AnnouncementPageKeySpecifier)[];
export type AnnouncementPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AnnouncementUnreadCountKeySpecifier = ('count' | 'severity' | AnnouncementUnreadCountKeySpecifier)[];
export type AnnouncementUnreadCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	severity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditLogKeySpecifier = ('action' | 'actionName' | 'createdAt' | 'id' | 'network' | 'payload' | 'records' | 'recordsCount' | 'userName' | AuditLogKeySpecifier)[];
export type AuditLogFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	actionName?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	payload?: FieldPolicy<any> | FieldReadFunction<any>,
	records?: FieldPolicy<any> | FieldReadFunction<any>,
	recordsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	userName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditLogPageKeySpecifier = ('nodes' | 'pageInfo' | AuditLogPageKeySpecifier)[];
export type AuditLogPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditLogRecordKeySpecifier = ('id' | 'recordId' | 'recordName' | 'recordType' | AuditLogRecordKeySpecifier)[];
export type AuditLogRecordFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	recordId?: FieldPolicy<any> | FieldReadFunction<any>,
	recordName?: FieldPolicy<any> | FieldReadFunction<any>,
	recordType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditLogRecordPageKeySpecifier = ('nodes' | 'pageInfo' | AuditLogRecordPageKeySpecifier)[];
export type AuditLogRecordPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuditLogsFiltersKeySpecifier = ('maxYear' | 'minYear' | 'recordTypes' | 'userIds' | AuditLogsFiltersKeySpecifier)[];
export type AuditLogsFiltersFieldPolicy = {
	maxYear?: FieldPolicy<any> | FieldReadFunction<any>,
	minYear?: FieldPolicy<any> | FieldReadFunction<any>,
	recordTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	userIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuthorizableKeySpecifier = ('canDestroy' | 'canUpdate' | 'id' | AuthorizableKeySpecifier)[];
export type AuthorizableFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AuthorizationResultKeySpecifier = ('message' | 'reasons' | 'value' | AuthorizationResultKeySpecifier)[];
export type AuthorizationResultFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	reasons?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkTagPayloadKeySpecifier = ('clientMutationId' | 'network' | 'taggables' | BulkTagPayloadKeySpecifier)[];
export type BulkTagPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	taggables?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkUpdateDevicesPayloadKeySpecifier = ('clientMutationId' | 'devices' | 'networks' | 'result' | BulkUpdateDevicesPayloadKeySpecifier)[];
export type BulkUpdateDevicesPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	networks?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkUpdateResultKeySpecifier = ('errored' | 'succeeded' | 'unauthed' | BulkUpdateResultKeySpecifier)[];
export type BulkUpdateResultFieldPolicy = {
	errored?: FieldPolicy<any> | FieldReadFunction<any>,
	succeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	unauthed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CancelDeviceSignalPayloadKeySpecifier = ('clientMutationId' | 'deviceSignal' | CancelDeviceSignalPayloadKeySpecifier)[];
export type CancelDeviceSignalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceSignal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChangeDataSourceAlcoholVisibilityPayloadKeySpecifier = ('clientMutationId' | 'dataSource' | ChangeDataSourceAlcoholVisibilityPayloadKeySpecifier)[];
export type ChangeDataSourceAlcoholVisibilityPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelKeySpecifier = ('backgroundColor' | 'canDestroy' | 'canUpdate' | 'channelGuideCount' | 'createdAt' | 'enabledForLiveStreaming' | 'encryption' | 'id' | 'jpegxsEnabled' | 'metadata' | 'name' | 'number' | 'outputUrl' | 'outputUrls' | 'source' | 'status' | 'thumbnailFile' | 'thumbnailFileId' | 'updatedAt' | 'url' | 'urls' | ChannelKeySpecifier)[];
export type ChannelFieldPolicy = {
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	channelGuideCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	enabledForLiveStreaming?: FieldPolicy<any> | FieldReadFunction<any>,
	encryption?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	jpegxsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	outputUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	outputUrls?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailFile?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailFileId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	urls?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelAudioStreamKeySpecifier = ('bitRate' | 'channelLayout' | 'channels' | 'codecLongName' | 'codecName' | 'sampleRate' | ChannelAudioStreamKeySpecifier)[];
export type ChannelAudioStreamFieldPolicy = {
	bitRate?: FieldPolicy<any> | FieldReadFunction<any>,
	channelLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	codecLongName?: FieldPolicy<any> | FieldReadFunction<any>,
	codecName?: FieldPolicy<any> | FieldReadFunction<any>,
	sampleRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelGuideKeySpecifier = ('canDestroy' | 'canUpdate' | 'channelCount' | 'channels' | 'contentItemId' | 'createdAt' | 'defaultChannel' | 'id' | 'name' | 'showCount' | 'updatedAt' | ChannelGuideKeySpecifier)[];
export type ChannelGuideFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	channelCount?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	showCount?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelGuidePageKeySpecifier = ('nodes' | 'pageInfo' | ChannelGuidePageKeySpecifier)[];
export type ChannelGuidePageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelMetadataKeySpecifier = ('audioStream' | 'timestamp' | 'videoStream' | ChannelMetadataKeySpecifier)[];
export type ChannelMetadataFieldPolicy = {
	audioStream?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	videoStream?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelPageKeySpecifier = ('nodes' | 'pageInfo' | ChannelPageKeySpecifier)[];
export type ChannelPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelVideoStreamKeySpecifier = ('codecLongName' | 'codecName' | 'colorSpace' | 'displayAspectRatio' | 'fieldOrder' | 'frameRate' | 'pixFmt' | 'resolution' | ChannelVideoStreamKeySpecifier)[];
export type ChannelVideoStreamFieldPolicy = {
	codecLongName?: FieldPolicy<any> | FieldReadFunction<any>,
	codecName?: FieldPolicy<any> | FieldReadFunction<any>,
	colorSpace?: FieldPolicy<any> | FieldReadFunction<any>,
	displayAspectRatio?: FieldPolicy<any> | FieldReadFunction<any>,
	fieldOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	frameRate?: FieldPolicy<any> | FieldReadFunction<any>,
	pixFmt?: FieldPolicy<any> | FieldReadFunction<any>,
	resolution?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CleanupTemplateVersionsPayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | 'templates' | CleanupTemplateVersionsPayloadKeySpecifier)[];
export type CleanupTemplateVersionsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	templates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClearDeviceCachePayloadKeySpecifier = ('clientMutationId' | 'device' | ClearDeviceCachePayloadKeySpecifier)[];
export type ClearDeviceCachePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentFiltersKeySpecifier = ('kind' | 'tags' | ContentFiltersKeySpecifier)[];
export type ContentFiltersFieldPolicy = {
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentFolderKeySpecifier = ('canDestroy' | 'canUpdate' | 'children' | 'childrenCount' | 'content' | 'createdAt' | 'id' | 'itemCount' | 'mediaItems' | 'name' | 'network' | 'updatedAt' | ContentFolderKeySpecifier)[];
export type ContentFolderFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	childrenCount?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaItems?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentFolderRuleKeySpecifier = ('contentFolder' | 'id' | ContentFolderRuleKeySpecifier)[];
export type ContentFolderRuleFieldPolicy = {
	contentFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentItemKeySpecifier = ('canDestroy' | 'canShow' | 'canUpdate' | 'canUpgrade' | 'contentFolder' | 'contentFolderId' | 'contentOptions' | 'createdAt' | 'defaultDuration' | 'description' | 'design' | 'durationReadonly' | 'file' | 'fileId' | 'id' | 'name' | 'overlay' | 'source' | 'tags' | 'template' | 'templateUri' | 'templateVersion' | 'templateVersionId' | 'thumbnailFile' | 'thumbnailUri' | 'updatedAt' | 'usages' | ContentItemKeySpecifier)[];
export type ContentItemFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canShow?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpgrade?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	design?: FieldPolicy<any> | FieldReadFunction<any>,
	durationReadonly?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	overlay?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>,
	templateUri?: FieldPolicy<any> | FieldReadFunction<any>,
	templateVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	templateVersionId?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailFile?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUri?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	usages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentItemConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | ContentItemConnectionKeySpecifier)[];
export type ContentItemConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentItemEdgeKeySpecifier = ('cursor' | 'node' | ContentItemEdgeKeySpecifier)[];
export type ContentItemEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentItemPageKeySpecifier = ('nodes' | 'pageInfo' | ContentItemPageKeySpecifier)[];
export type ContentItemPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentOptionKeySpecifier = ('array' | 'configValue' | 'contentItemId' | 'createdAt' | 'dataItem' | 'defaultValue' | 'description' | 'file' | 'fileId' | 'id' | 'kind' | 'label' | 'mediaItem' | 'name' | 'nullable' | 'templateParam' | 'templateParamId' | 'updatedAt' | 'value' | ContentOptionKeySpecifier)[];
export type ContentOptionFieldPolicy = {
	array?: FieldPolicy<any> | FieldReadFunction<any>,
	configValue?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataItem?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultValue?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaItem?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nullable?: FieldPolicy<any> | FieldReadFunction<any>,
	templateParam?: FieldPolicy<any> | FieldReadFunction<any>,
	templateParamId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentPageKeySpecifier = ('nodes' | 'pageInfo' | ContentPageKeySpecifier)[];
export type ContentPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContentTagKeySpecifier = ('name' | 'uses' | ContentTagKeySpecifier)[];
export type ContentTagFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CopyContentItemPayloadKeySpecifier = ('clientMutationId' | 'contentItem' | 'errors' | 'network' | CopyContentItemPayloadKeySpecifier)[];
export type CopyContentItemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CopyDesignPayloadKeySpecifier = ('clientMutationId' | 'design' | 'network' | CopyDesignPayloadKeySpecifier)[];
export type CopyDesignPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	design?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CopyShowPayloadKeySpecifier = ('clientMutationId' | 'show' | CopyShowPayloadKeySpecifier)[];
export type CopyShowPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CopyViewPayloadKeySpecifier = ('clientMutationId' | 'show' | 'view' | CopyViewPayloadKeySpecifier)[];
export type CopyViewPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>,
	view?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateAwsCredentialsPayloadKeySpecifier = ('clientMutationId' | 'credentials' | 'region' | CreateAwsCredentialsPayloadKeySpecifier)[];
export type CreateAwsCredentialsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	credentials?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateChannelGuidePayloadKeySpecifier = ('channelGuide' | 'clientMutationId' | 'network' | CreateChannelGuidePayloadKeySpecifier)[];
export type CreateChannelGuidePayloadFieldPolicy = {
	channelGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateChannelPayloadKeySpecifier = ('channel' | 'clientMutationId' | 'network' | CreateChannelPayloadKeySpecifier)[];
export type CreateChannelPayloadFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateContentFolderPayloadKeySpecifier = ('clientMutationId' | 'contentFolder' | 'network' | 'parent' | CreateContentFolderPayloadKeySpecifier)[];
export type CreateContentFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateContentItemPayloadKeySpecifier = ('clientMutationId' | 'contentItem' | 'network' | CreateContentItemPayloadKeySpecifier)[];
export type CreateContentItemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDesignFolderPayloadKeySpecifier = ('clientMutationId' | 'designFolder' | 'network' | 'parent' | CreateDesignFolderPayloadKeySpecifier)[];
export type CreateDesignFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDesignPayloadKeySpecifier = ('clientMutationId' | 'design' | CreateDesignPayloadKeySpecifier)[];
export type CreateDesignPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	design?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDeviceCollectionPayloadKeySpecifier = ('clientMutationId' | 'deviceCollection' | 'network' | CreateDeviceCollectionPayloadKeySpecifier)[];
export type CreateDeviceCollectionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDeviceGroupPayloadKeySpecifier = ('clientMutationId' | 'deviceGroup' | 'network' | CreateDeviceGroupPayloadKeySpecifier)[];
export type CreateDeviceGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDeviceSignalPayloadKeySpecifier = ('clientMutationId' | 'deviceSignal' | CreateDeviceSignalPayloadKeySpecifier)[];
export type CreateDeviceSignalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceSignal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateEventPayloadKeySpecifier = ('clientMutationId' | 'event' | 'eventType' | 'network' | CreateEventPayloadKeySpecifier)[];
export type CreateEventPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateEventTypePayloadKeySpecifier = ('clientMutationId' | 'eventType' | 'network' | CreateEventTypePayloadKeySpecifier)[];
export type CreateEventTypePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateFontPayloadKeySpecifier = ('clientMutationId' | 'font' | 'network' | CreateFontPayloadKeySpecifier)[];
export type CreateFontPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	font?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateLayoutPayloadKeySpecifier = ('clientMutationId' | 'layout' | CreateLayoutPayloadKeySpecifier)[];
export type CreateLayoutPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateOverlayPayloadKeySpecifier = ('clientMutationId' | 'overlay' | CreateOverlayPayloadKeySpecifier)[];
export type CreateOverlayPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	overlay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreatePlaylistFolderPayloadKeySpecifier = ('clientMutationId' | 'network' | 'parent' | 'playlistFolder' | CreatePlaylistFolderPayloadKeySpecifier)[];
export type CreatePlaylistFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreatePlaylistPayloadKeySpecifier = ('clientMutationId' | 'playlist' | CreatePlaylistPayloadKeySpecifier)[];
export type CreatePlaylistPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateRemoteCredentialsPayloadKeySpecifier = ('clientMutationId' | 'credentials' | CreateRemoteCredentialsPayloadKeySpecifier)[];
export type CreateRemoteCredentialsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	credentials?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateRolePayloadKeySpecifier = ('clientMutationId' | 'role' | CreateRolePayloadKeySpecifier)[];
export type CreateRolePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateSeasonPayloadKeySpecifier = ('clientMutationId' | 'eventType' | 'season' | CreateSeasonPayloadKeySpecifier)[];
export type CreateSeasonPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	season?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateShowFolderPayloadKeySpecifier = ('clientMutationId' | 'network' | 'parent' | 'showFolder' | CreateShowFolderPayloadKeySpecifier)[];
export type CreateShowFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateShowInstancePayloadKeySpecifier = ('clientMutationId' | 'deviceGroup' | 'event' | 'show' | CreateShowInstancePayloadKeySpecifier)[];
export type CreateShowInstancePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateShowPayloadKeySpecifier = ('clientMutationId' | 'show' | CreateShowPayloadKeySpecifier)[];
export type CreateShowPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateTVBrandPayloadKeySpecifier = ('clientMutationId' | 'tvBrand' | CreateTVBrandPayloadKeySpecifier)[];
export type CreateTVBrandPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	tvBrand?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateTemplatePayloadKeySpecifier = ('clientMutationId' | 'template' | CreateTemplatePayloadKeySpecifier)[];
export type CreateTemplatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateTemplateVersionPayloadKeySpecifier = ('clientMutationId' | 'template' | CreateTemplateVersionPayloadKeySpecifier)[];
export type CreateTemplateVersionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateUploadConfigPayloadKeySpecifier = ('bucket' | 'clientMutationId' | 'credentials' | 'metadata' | 'region' | CreateUploadConfigPayloadKeySpecifier)[];
export type CreateUploadConfigPayloadFieldPolicy = {
	bucket?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	credentials?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateUserPayloadKeySpecifier = ('clientMutationId' | 'network' | 'user' | CreateUserPayloadKeySpecifier)[];
export type CreateUserPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateViewPayloadKeySpecifier = ('clientMutationId' | 'show' | 'view' | CreateViewPayloadKeySpecifier)[];
export type CreateViewPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>,
	view?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateViewZonePlaylistPayloadKeySpecifier = ('clientMutationId' | 'viewZone' | CreateViewZonePlaylistPayloadKeySpecifier)[];
export type CreateViewZonePlaylistPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	viewZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateZonePayloadKeySpecifier = ('clientMutationId' | 'layout' | 'zone' | CreateZonePayloadKeySpecifier)[];
export type CreateZonePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>,
	zone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CredentialsKeySpecifier = ('keySecret' | 'verificationToken' | 'verificationUrl' | CredentialsKeySpecifier)[];
export type CredentialsFieldPolicy = {
	keySecret?: FieldPolicy<any> | FieldReadFunction<any>,
	verificationToken?: FieldPolicy<any> | FieldReadFunction<any>,
	verificationUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrentUserUpdatedPayloadKeySpecifier = ('event' | 'user' | CurrentUserUpdatedPayloadKeySpecifier)[];
export type CurrentUserUpdatedPayloadFieldPolicy = {
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataItemKeySpecifier = ('alcohol' | 'canDestroy' | 'data' | 'enabled' | 'id' | 'source' | DataItemKeySpecifier)[];
export type DataItemFieldPolicy = {
	alcohol?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataItemCreatePayloadKeySpecifier = ('clientMutationId' | 'dataItem' | 'dataSource' | DataItemCreatePayloadKeySpecifier)[];
export type DataItemCreatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataItem?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataItemDeletePayloadKeySpecifier = ('clientMutationId' | 'dataSource' | DataItemDeletePayloadKeySpecifier)[];
export type DataItemDeletePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataItemPageKeySpecifier = ('nodes' | 'pageInfo' | DataItemPageKeySpecifier)[];
export type DataItemPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataItemUpdatePayloadKeySpecifier = ('clientMutationId' | 'dataItem' | 'dataSource' | DataItemUpdatePayloadKeySpecifier)[];
export type DataItemUpdatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataItem?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataSourceKeySpecifier = ('alcoholDisabled' | 'canDestroy' | 'canSync' | 'canUpdate' | 'canUpdateItems' | 'createdAt' | 'creator' | 'deviceKey' | 'foreignIdName' | 'id' | 'includesAlcohol' | 'itemCount' | 'items' | 'keys' | 'kind' | 'name' | 'updatedAt' | DataSourceKeySpecifier)[];
export type DataSourceFieldPolicy = {
	alcoholDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canSync?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdateItems?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	creator?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceKey?: FieldPolicy<any> | FieldReadFunction<any>,
	foreignIdName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	includesAlcohol?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	keys?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataSourcePageKeySpecifier = ('nodes' | 'pageInfo' | DataSourcePageKeySpecifier)[];
export type DataSourcePageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DataSourceRuleKeySpecifier = ('dataSource' | 'id' | DataSourceRuleKeySpecifier)[];
export type DataSourceRuleFieldPolicy = {
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteChannelGuidePayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | DeleteChannelGuidePayloadKeySpecifier)[];
export type DeleteChannelGuidePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteChannelPayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | DeleteChannelPayloadKeySpecifier)[];
export type DeleteChannelPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteContentFolderPayloadKeySpecifier = ('clientMutationId' | 'network' | 'parent' | DeleteContentFolderPayloadKeySpecifier)[];
export type DeleteContentFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteContentPayloadKeySpecifier = ('clientMutationId' | 'deletedItems' | DeleteContentPayloadKeySpecifier)[];
export type DeleteContentPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDataSourcePayloadKeySpecifier = ('clientMutationId' | 'dataSource' | DeleteDataSourcePayloadKeySpecifier)[];
export type DeleteDataSourcePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDesignFolderPayloadKeySpecifier = ('clientMutationId' | 'network' | 'parent' | DeleteDesignFolderPayloadKeySpecifier)[];
export type DeleteDesignFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDesignPayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | DeleteDesignPayloadKeySpecifier)[];
export type DeleteDesignPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDeviceCollectionPayloadKeySpecifier = ('clientMutationId' | 'network' | DeleteDeviceCollectionPayloadKeySpecifier)[];
export type DeleteDeviceCollectionPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDeviceGroupPayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | DeleteDeviceGroupPayloadKeySpecifier)[];
export type DeleteDeviceGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDevicePayloadKeySpecifier = ('clientMutationId' | 'device' | DeleteDevicePayloadKeySpecifier)[];
export type DeleteDevicePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteDeviceSignalPayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | DeleteDeviceSignalPayloadKeySpecifier)[];
export type DeleteDeviceSignalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteEventPayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | DeleteEventPayloadKeySpecifier)[];
export type DeleteEventPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteEventTypePayloadKeySpecifier = ('clientMutationId' | 'eventType' | 'network' | DeleteEventTypePayloadKeySpecifier)[];
export type DeleteEventTypePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteFontPayloadKeySpecifier = ('clientMutationId' | 'font' | DeleteFontPayloadKeySpecifier)[];
export type DeleteFontPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	font?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteLayoutPayloadKeySpecifier = ('clientMutationId' | 'layout' | DeleteLayoutPayloadKeySpecifier)[];
export type DeleteLayoutPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteOverlayPayloadKeySpecifier = ('clientMutationId' | 'overlay' | DeleteOverlayPayloadKeySpecifier)[];
export type DeleteOverlayPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	overlay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePlaylistFolderPayloadKeySpecifier = ('clientMutationId' | 'network' | 'parent' | DeletePlaylistFolderPayloadKeySpecifier)[];
export type DeletePlaylistFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePlaylistItemPayloadKeySpecifier = ('clientMutationId' | 'playlist' | 'removedIds' | DeletePlaylistItemPayloadKeySpecifier)[];
export type DeletePlaylistItemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>,
	removedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePlaylistPayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | DeletePlaylistPayloadKeySpecifier)[];
export type DeletePlaylistPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteRolesPayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | 'network' | DeleteRolesPayloadKeySpecifier)[];
export type DeleteRolesPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteSeasonPayloadKeySpecifier = ('clientMutationId' | 'eventType' | 'season' | DeleteSeasonPayloadKeySpecifier)[];
export type DeleteSeasonPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	season?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteShowFolderPayloadKeySpecifier = ('clientMutationId' | 'network' | 'parent' | DeleteShowFolderPayloadKeySpecifier)[];
export type DeleteShowFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteShowPayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | DeleteShowPayloadKeySpecifier)[];
export type DeleteShowPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteTVBrandPayloadKeySpecifier = ('clientMutationId' | 'network' | 'tvBrand' | DeleteTVBrandPayloadKeySpecifier)[];
export type DeleteTVBrandPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	tvBrand?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteTagPayloadKeySpecifier = ('clientMutationId' | 'network' | DeleteTagPayloadKeySpecifier)[];
export type DeleteTagPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteTemplatePayloadKeySpecifier = ('clientMutationId' | 'template' | DeleteTemplatePayloadKeySpecifier)[];
export type DeleteTemplatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteUserPayloadKeySpecifier = ('clientMutationId' | 'user' | DeleteUserPayloadKeySpecifier)[];
export type DeleteUserPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteViewPayloadKeySpecifier = ('clientMutationId' | 'show' | 'view' | DeleteViewPayloadKeySpecifier)[];
export type DeleteViewPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>,
	view?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteViewZonePlaylistPayloadKeySpecifier = ('clientMutationId' | 'viewZone' | 'viewZonePlaylist' | DeleteViewZonePlaylistPayloadKeySpecifier)[];
export type DeleteViewZonePlaylistPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	viewZone?: FieldPolicy<any> | FieldReadFunction<any>,
	viewZonePlaylist?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteZonePayloadKeySpecifier = ('clientMutationId' | 'zone' | DeleteZonePayloadKeySpecifier)[];
export type DeleteZonePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	zone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignKeySpecifier = ('canDestroy' | 'canUpdate' | 'createdAt' | 'data' | 'dataItems' | 'designFolder' | 'designFolderId' | 'fonts' | 'height' | 'id' | 'mediaItems' | 'name' | 'publishedApp' | 'tags' | 'thumbnailUri' | 'updatedAt' | 'width' | DesignKeySpecifier)[];
export type DesignFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	dataItems?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	fonts?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaItems?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedApp?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUri?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignFiltersKeySpecifier = ('published' | 'tags' | DesignFiltersKeySpecifier)[];
export type DesignFiltersFieldPolicy = {
	published?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignFolderKeySpecifier = ('canDestroy' | 'canUpdate' | 'children' | 'childrenCount' | 'createdAt' | 'designs' | 'id' | 'itemCount' | 'name' | 'updatedAt' | DesignFolderKeySpecifier)[];
export type DesignFolderFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	childrenCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	designs?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignFolderRuleKeySpecifier = ('designFolder' | 'id' | DesignFolderRuleKeySpecifier)[];
export type DesignFolderRuleFieldPolicy = {
	designFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignPageKeySpecifier = ('nodes' | 'pageInfo' | DesignPageKeySpecifier)[];
export type DesignPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DesignTagKeySpecifier = ('name' | 'uses' | DesignTagKeySpecifier)[];
export type DesignTagFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceKeySpecifier = ('activationChangedAt' | 'active' | 'activeShow' | 'api' | 'arch' | 'cacheContent' | 'cacheServer' | 'canSchedule' | 'canSendCommand' | 'canUpdate' | 'canUpdateSoftware' | 'closedCaptioning' | 'command' | 'cpuPercentage' | 'cpuTemperature' | 'createdAt' | 'currentChannel' | 'currentScheduledShow' | 'currentView' | 'defaultChannel' | 'demo' | 'deviceCommands' | 'deviceGroup' | 'diskAvailable' | 'diskTotal' | 'displayOn' | 'displayServer' | 'dynamicCollections' | 'edgeServer' | 'encryptionServer' | 'environments' | 'eventStream' | 'gameEventConsoleType' | 'gameEventSerialServerHost' | 'gameEventSport' | 'gameEvents' | 'grabInterval' | 'group' | 'groups' | 'id' | 'inactiveEnvironments' | 'internal' | 'ipAddress' | 'jpegxsEncoder' | 'jpegxsEncoderBpp' | 'jpegxsEncoderTtl' | 'jpegxsEncoderUrl' | 'jpegxsLicense' | 'keyId' | 'keyIdDescription' | 'kind' | 'libraryVersion' | 'location' | 'logUri' | 'macAddress' | 'manifest' | 'memoryAvailable' | 'memoryTotal' | 'messagingBackend' | 'messagingProxy' | 'metadata' | 'model' | 'name' | 'network' | 'networking' | 'nightlyBehavior' | 'notes' | 'ntpServer' | 'osUptime' | 'overscan' | 'playerVersion' | 'preload' | 'processUptime' | 'properties' | 'propertyGroups' | 'ptpService' | 'publisher' | 'realtime' | 'remoteTargets' | 'samsungFirmwares' | 'scheduledShows' | 'scoreServer' | 'screenshotInterval' | 'screenshotUploadUri' | 'screenshotUri' | 'serialDataSource' | 'serialNetworkUrl' | 'serialPortSpeed' | 'serialServer' | 'silence' | 'snmpService' | 'softwareVersion' | 'sshService' | 'status' | 'statusInterval' | 'statusUpdatedAt' | 'streamAnalysis' | 'supportsMute' | 'supportsVolume' | 'tags' | 'timeSinceUpdate' | 'timeZone' | 'transcodeServer' | 'tvBrand' | 'type' | 'updatedAt' | 'usesLatestVersion' | 'wasCommanded' | 'webosFirmwares' | DeviceKeySpecifier)[];
export type DeviceFieldPolicy = {
	activationChangedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	activeShow?: FieldPolicy<any> | FieldReadFunction<any>,
	api?: FieldPolicy<any> | FieldReadFunction<any>,
	arch?: FieldPolicy<any> | FieldReadFunction<any>,
	cacheContent?: FieldPolicy<any> | FieldReadFunction<any>,
	cacheServer?: FieldPolicy<any> | FieldReadFunction<any>,
	canSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	canSendCommand?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdateSoftware?: FieldPolicy<any> | FieldReadFunction<any>,
	closedCaptioning?: FieldPolicy<any> | FieldReadFunction<any>,
	command?: FieldPolicy<any> | FieldReadFunction<any>,
	cpuPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	cpuTemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	currentScheduledShow?: FieldPolicy<any> | FieldReadFunction<any>,
	currentView?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	demo?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCommands?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	diskAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	diskTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	displayOn?: FieldPolicy<any> | FieldReadFunction<any>,
	displayServer?: FieldPolicy<any> | FieldReadFunction<any>,
	dynamicCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	edgeServer?: FieldPolicy<any> | FieldReadFunction<any>,
	encryptionServer?: FieldPolicy<any> | FieldReadFunction<any>,
	environments?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStream?: FieldPolicy<any> | FieldReadFunction<any>,
	gameEventConsoleType?: FieldPolicy<any> | FieldReadFunction<any>,
	gameEventSerialServerHost?: FieldPolicy<any> | FieldReadFunction<any>,
	gameEventSport?: FieldPolicy<any> | FieldReadFunction<any>,
	gameEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	grabInterval?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inactiveEnvironments?: FieldPolicy<any> | FieldReadFunction<any>,
	internal?: FieldPolicy<any> | FieldReadFunction<any>,
	ipAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	jpegxsEncoder?: FieldPolicy<any> | FieldReadFunction<any>,
	jpegxsEncoderBpp?: FieldPolicy<any> | FieldReadFunction<any>,
	jpegxsEncoderTtl?: FieldPolicy<any> | FieldReadFunction<any>,
	jpegxsEncoderUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	jpegxsLicense?: FieldPolicy<any> | FieldReadFunction<any>,
	keyId?: FieldPolicy<any> | FieldReadFunction<any>,
	keyIdDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	libraryVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	logUri?: FieldPolicy<any> | FieldReadFunction<any>,
	macAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	manifest?: FieldPolicy<any> | FieldReadFunction<any>,
	memoryAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	memoryTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	messagingBackend?: FieldPolicy<any> | FieldReadFunction<any>,
	messagingProxy?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	networking?: FieldPolicy<any> | FieldReadFunction<any>,
	nightlyBehavior?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	ntpServer?: FieldPolicy<any> | FieldReadFunction<any>,
	osUptime?: FieldPolicy<any> | FieldReadFunction<any>,
	overscan?: FieldPolicy<any> | FieldReadFunction<any>,
	playerVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	preload?: FieldPolicy<any> | FieldReadFunction<any>,
	processUptime?: FieldPolicy<any> | FieldReadFunction<any>,
	properties?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	ptpService?: FieldPolicy<any> | FieldReadFunction<any>,
	publisher?: FieldPolicy<any> | FieldReadFunction<any>,
	realtime?: FieldPolicy<any> | FieldReadFunction<any>,
	remoteTargets?: FieldPolicy<any> | FieldReadFunction<any>,
	samsungFirmwares?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledShows?: FieldPolicy<any> | FieldReadFunction<any>,
	scoreServer?: FieldPolicy<any> | FieldReadFunction<any>,
	screenshotInterval?: FieldPolicy<any> | FieldReadFunction<any>,
	screenshotUploadUri?: FieldPolicy<any> | FieldReadFunction<any>,
	screenshotUri?: FieldPolicy<any> | FieldReadFunction<any>,
	serialDataSource?: FieldPolicy<any> | FieldReadFunction<any>,
	serialNetworkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	serialPortSpeed?: FieldPolicy<any> | FieldReadFunction<any>,
	serialServer?: FieldPolicy<any> | FieldReadFunction<any>,
	silence?: FieldPolicy<any> | FieldReadFunction<any>,
	snmpService?: FieldPolicy<any> | FieldReadFunction<any>,
	softwareVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	sshService?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusInterval?: FieldPolicy<any> | FieldReadFunction<any>,
	statusUpdatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	streamAnalysis?: FieldPolicy<any> | FieldReadFunction<any>,
	supportsMute?: FieldPolicy<any> | FieldReadFunction<any>,
	supportsVolume?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	timeSinceUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	transcodeServer?: FieldPolicy<any> | FieldReadFunction<any>,
	tvBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	usesLatestVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	wasCommanded?: FieldPolicy<any> | FieldReadFunction<any>,
	webosFirmwares?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceCommandKeySpecifier = ('command' | 'createdAt' | 'device' | 'expiresAt' | 'id' | 'status' | DeviceCommandKeySpecifier)[];
export type DeviceCommandFieldPolicy = {
	command?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceCommandPageKeySpecifier = ('nodes' | 'pageInfo' | DeviceCommandPageKeySpecifier)[];
export type DeviceCommandPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceDynamicCollectionKeySpecifier = ('canDestroy' | 'createdAt' | 'deviceCount' | 'id' | 'name' | 'query' | 'source' | 'updatedAt' | DeviceDynamicCollectionKeySpecifier)[];
export type DeviceDynamicCollectionFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	query?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceFiltersKeySpecifier = ('arch' | 'demo' | 'displayOn' | 'displayServers' | 'groups' | 'internal' | 'kind' | 'models' | 'playerVersions' | 'services' | 'silence' | 'status' | 'storageBelow' | 'tags' | 'temperatureAbove' | 'tvBrands' | 'uptimeBelow' | DeviceFiltersKeySpecifier)[];
export type DeviceFiltersFieldPolicy = {
	arch?: FieldPolicy<any> | FieldReadFunction<any>,
	demo?: FieldPolicy<any> | FieldReadFunction<any>,
	displayOn?: FieldPolicy<any> | FieldReadFunction<any>,
	displayServers?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	internal?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	models?: FieldPolicy<any> | FieldReadFunction<any>,
	playerVersions?: FieldPolicy<any> | FieldReadFunction<any>,
	services?: FieldPolicy<any> | FieldReadFunction<any>,
	silence?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	storageBelow?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	temperatureAbove?: FieldPolicy<any> | FieldReadFunction<any>,
	tvBrands?: FieldPolicy<any> | FieldReadFunction<any>,
	uptimeBelow?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceGroupKeySpecifier = ('id' | 'location' | 'name' | DeviceGroupKeySpecifier)[];
export type DeviceGroupFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceGroupNewKeySpecifier = ('canDestroy' | 'canUpdate' | 'createdAt' | 'defaultShow' | 'description' | 'deviceCount' | 'deviceStats' | 'devices' | 'enableReporting' | 'id' | 'name' | 'thumbnailFile' | 'updatedAt' | DeviceGroupNewKeySpecifier)[];
export type DeviceGroupNewFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultShow?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceStats?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	enableReporting?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailFile?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceGroupNewPageKeySpecifier = ('nodes' | 'pageInfo' | DeviceGroupNewPageKeySpecifier)[];
export type DeviceGroupNewPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceGroupRuleKeySpecifier = ('access' | 'deviceGroup' | 'id' | DeviceGroupRuleKeySpecifier)[];
export type DeviceGroupRuleFieldPolicy = {
	access?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceNetworkingKeySpecifier = ('ipAddress' | 'macAddress' | 'switch' | DeviceNetworkingKeySpecifier)[];
export type DeviceNetworkingFieldPolicy = {
	ipAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	macAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	switch?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceNetworkingPortKeySpecifier = ('id' | 'speed' | DeviceNetworkingPortKeySpecifier)[];
export type DeviceNetworkingPortFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	speed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceNetworkingSwitchKeySpecifier = ('model' | 'name' | 'port' | 'provider' | DeviceNetworkingSwitchKeySpecifier)[];
export type DeviceNetworkingSwitchFieldPolicy = {
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	port?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DevicePageKeySpecifier = ('nodes' | 'pageInfo' | DevicePageKeySpecifier)[];
export type DevicePageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceRegistrationKeySpecifier = ('keyId' | 'keyIdDescription' | 'type' | DeviceRegistrationKeySpecifier)[];
export type DeviceRegistrationFieldPolicy = {
	keyId?: FieldPolicy<any> | FieldReadFunction<any>,
	keyIdDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceRuleKeySpecifier = ('access' | 'device' | 'id' | DeviceRuleKeySpecifier)[];
export type DeviceRuleFieldPolicy = {
	access?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceSignalKeySpecifier = ('action' | 'allDevices' | 'canCancel' | 'canDestroy' | 'canRun' | 'createdAt' | 'deviceCount' | 'deviceDynamicCollection' | 'deviceGroup' | 'enabled' | 'event' | 'eventType' | 'id' | 'kind' | 'name' | 'running' | 'schedule' | 'tags' | 'updatedAt' | DeviceSignalKeySpecifier)[];
export type DeviceSignalFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	allDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	canCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canRun?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceDynamicCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	running?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceSignalFiltersKeySpecifier = ('action' | 'eventType' | 'kind' | 'tags' | DeviceSignalFiltersKeySpecifier)[];
export type DeviceSignalFiltersFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceSignalPageKeySpecifier = ('nodes' | 'pageInfo' | DeviceSignalPageKeySpecifier)[];
export type DeviceSignalPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceSignalScheduleKeySpecifier = ('endsOn' | 'frequency' | 'startTime' | 'startsOn' | 'weekdays' | DeviceSignalScheduleKeySpecifier)[];
export type DeviceSignalScheduleFieldPolicy = {
	endsOn?: FieldPolicy<any> | FieldReadFunction<any>,
	frequency?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startsOn?: FieldPolicy<any> | FieldReadFunction<any>,
	weekdays?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceSignalTagKeySpecifier = ('name' | 'uses' | DeviceSignalTagKeySpecifier)[];
export type DeviceSignalTagFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceStatsKeySpecifier = ('activeCount' | 'displayOffCount' | 'displayOnCount' | 'errorCount' | 'healthyCount' | 'silenceCount' | 'warnCount' | DeviceStatsKeySpecifier)[];
export type DeviceStatsFieldPolicy = {
	activeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	displayOffCount?: FieldPolicy<any> | FieldReadFunction<any>,
	displayOnCount?: FieldPolicy<any> | FieldReadFunction<any>,
	errorCount?: FieldPolicy<any> | FieldReadFunction<any>,
	healthyCount?: FieldPolicy<any> | FieldReadFunction<any>,
	silenceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	warnCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceTagKeySpecifier = ('name' | 'uses' | DeviceTagKeySpecifier)[];
export type DeviceTagFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DuplicateDeviceSignalPayloadKeySpecifier = ('clientMutationId' | 'deviceSignal' | DuplicateDeviceSignalPayloadKeySpecifier)[];
export type DuplicateDeviceSignalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceSignal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DuplicateTVBrandPayloadKeySpecifier = ('clientMutationId' | 'tvBrand' | DuplicateTVBrandPayloadKeySpecifier)[];
export type DuplicateTVBrandPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	tvBrand?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventKeySpecifier = ('actualStop' | 'canDestroy' | 'canOverride' | 'canRerunRollups' | 'canUpdate' | 'contentBuffer' | 'contentStart' | 'contentStop' | 'createdAt' | 'description' | 'eventType' | 'fcEventId' | 'id' | 'includeInPlayoutReporting' | 'name' | 'overrideCount' | 'rollupRequested' | 'season' | 'showDeviceGroups' | 'sponsorStartTime' | 'sponsorStopTime' | 'start' | 'stop' | 'syncingFromAdmin' | 'updatedAt' | EventKeySpecifier)[];
export type EventFieldPolicy = {
	actualStop?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	canRerunRollups?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	contentBuffer?: FieldPolicy<any> | FieldReadFunction<any>,
	contentStart?: FieldPolicy<any> | FieldReadFunction<any>,
	contentStop?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	fcEventId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	includeInPlayoutReporting?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	overrideCount?: FieldPolicy<any> | FieldReadFunction<any>,
	rollupRequested?: FieldPolicy<any> | FieldReadFunction<any>,
	season?: FieldPolicy<any> | FieldReadFunction<any>,
	showDeviceGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorStartTime?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorStopTime?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	stop?: FieldPolicy<any> | FieldReadFunction<any>,
	syncingFromAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTypeKeySpecifier = ('canDestroy' | 'canShow' | 'canSync' | 'canUpdate' | 'color' | 'contentStartTime' | 'contentStopTime' | 'createdAt' | 'description' | 'event' | 'eventCount' | 'eventIdsWithRollups' | 'events' | 'fcLeagueId' | 'fcTeamId' | 'iconFile' | 'id' | 'manageDisplay' | 'name' | 'seasons' | 'showDeviceGroups' | 'signalType' | 'sponsorStartTime' | 'sponsorStopTime' | 'syncFcAdmin' | 'updatedAt' | EventTypeKeySpecifier)[];
export type EventTypeFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canShow?: FieldPolicy<any> | FieldReadFunction<any>,
	canSync?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	contentStartTime?: FieldPolicy<any> | FieldReadFunction<any>,
	contentStopTime?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventCount?: FieldPolicy<any> | FieldReadFunction<any>,
	eventIdsWithRollups?: FieldPolicy<any> | FieldReadFunction<any>,
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	fcLeagueId?: FieldPolicy<any> | FieldReadFunction<any>,
	fcTeamId?: FieldPolicy<any> | FieldReadFunction<any>,
	iconFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	manageDisplay?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	seasons?: FieldPolicy<any> | FieldReadFunction<any>,
	showDeviceGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	signalType?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorStartTime?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorStopTime?: FieldPolicy<any> | FieldReadFunction<any>,
	syncFcAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTypePageKeySpecifier = ('nodes' | 'pageInfo' | EventTypePageKeySpecifier)[];
export type EventTypePageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTypeRuleKeySpecifier = ('eventType' | 'id' | EventTypeRuleKeySpecifier)[];
export type EventTypeRuleFieldPolicy = {
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportAuditLogsPayloadKeySpecifier = ('clientMutationId' | 'url' | ExportAuditLogsPayloadKeySpecifier)[];
export type ExportAuditLogsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportDataSourcePayloadKeySpecifier = ('clientMutationId' | 'url' | ExportDataSourcePayloadKeySpecifier)[];
export type ExportDataSourcePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportDevicesPayloadKeySpecifier = ('clientMutationId' | 'url' | ExportDevicesPayloadKeySpecifier)[];
export type ExportDevicesPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FailureReasonsKeySpecifier = ('details' | 'fullMessages' | FailureReasonsKeySpecifier)[];
export type FailureReasonsFieldPolicy = {
	details?: FieldPolicy<any> | FieldReadFunction<any>,
	fullMessages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FanconnectConfigKeySpecifier = ('apiKey' | 'autoschedule' | 'domain' | 'leagueName' | 'subdomain' | FanconnectConfigKeySpecifier)[];
export type FanconnectConfigFieldPolicy = {
	apiKey?: FieldPolicy<any> | FieldReadFunction<any>,
	autoschedule?: FieldPolicy<any> | FieldReadFunction<any>,
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	leagueName?: FieldPolicy<any> | FieldReadFunction<any>,
	subdomain?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FileKeySpecifier = ('bucket' | 'createdAt' | 'downloadUri' | 'filename' | 'id' | 'ipAddress' | 'kind' | 'md5Sum' | 'mimeType' | 'network' | 'networkId' | 'objectKey' | 'originalFilename' | 'size' | 'source' | 'uncompressedSize' | 'updatedAt' | 'uri' | FileKeySpecifier)[];
export type FileFieldPolicy = {
	bucket?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadUri?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ipAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	md5Sum?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	networkId?: FieldPolicy<any> | FieldReadFunction<any>,
	objectKey?: FieldPolicy<any> | FieldReadFunction<any>,
	originalFilename?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	uncompressedSize?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uri?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FilterCountKeySpecifier = ('count' | 'filter' | FilterCountKeySpecifier)[];
export type FilterCountFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	filter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FontKeySpecifier = ('canDelete' | 'canUpdate' | 'createdAt' | 'file' | 'id' | 'name' | 'updatedAt' | FontKeySpecifier)[];
export type FontFieldPolicy = {
	canDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FontPageKeySpecifier = ('nodes' | 'pageInfo' | FontPageKeySpecifier)[];
export type FontPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ForgotPasswordPayloadKeySpecifier = ('clientMutationId' | ForgotPasswordPayloadKeySpecifier)[];
export type ForgotPasswordPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GeneratePlayoutDetailPdfPayloadKeySpecifier = ('clientMutationId' | 'url' | GeneratePlayoutDetailPdfPayloadKeySpecifier)[];
export type GeneratePlayoutDetailPdfPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GenerateReportPayloadKeySpecifier = ('clientMutationId' | 'url' | GenerateReportPayloadKeySpecifier)[];
export type GenerateReportPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetDeviceCommandPayloadKeySpecifier = ('clientMutationId' | 'command' | GetDeviceCommandPayloadKeySpecifier)[];
export type GetDeviceCommandPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	command?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupedTemplateParamsKeySpecifier = ('paramGroup' | 'params' | GroupedTemplateParamsKeySpecifier)[];
export type GroupedTemplateParamsFieldPolicy = {
	paramGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	params?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImpersonatePayloadKeySpecifier = ('clientMutationId' | 'user' | ImpersonatePayloadKeySpecifier)[];
export type ImpersonatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IntervalKeySpecifier = ('days' | 'hours' | 'minutes' | 'months' | 'seconds' | 'years' | IntervalKeySpecifier)[];
export type IntervalFieldPolicy = {
	days?: FieldPolicy<any> | FieldReadFunction<any>,
	hours?: FieldPolicy<any> | FieldReadFunction<any>,
	minutes?: FieldPolicy<any> | FieldReadFunction<any>,
	months?: FieldPolicy<any> | FieldReadFunction<any>,
	seconds?: FieldPolicy<any> | FieldReadFunction<any>,
	years?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LayoutKeySpecifier = ('canAddZone' | 'canDestroy' | 'canUpdate' | 'createdAt' | 'description' | 'height' | 'id' | 'name' | 'network' | 'networkId' | 'orientation' | 'updatedAt' | 'width' | 'zoneIds' | 'zones' | LayoutKeySpecifier)[];
export type LayoutFieldPolicy = {
	canAddZone?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	networkId?: FieldPolicy<any> | FieldReadFunction<any>,
	orientation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>,
	zoneIds?: FieldPolicy<any> | FieldReadFunction<any>,
	zones?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LayoutPageKeySpecifier = ('nodes' | 'pageInfo' | LayoutPageKeySpecifier)[];
export type LayoutPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LeagueKeySpecifier = ('id' | 'logoUrl' | 'longName' | 'name' | 'shortName' | LeagueKeySpecifier)[];
export type LeagueFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	longName?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	shortName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocationKeySpecifier = ('id' | 'name' | 'network' | LocationKeySpecifier)[];
export type LocationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LoginPayloadKeySpecifier = ('clientMutationId' | 'user' | LoginPayloadKeySpecifier)[];
export type LoginPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogoutPayloadKeySpecifier = ('clientMutationId' | 'success' | LogoutPayloadKeySpecifier)[];
export type LogoutPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManifestKeySpecifier = ('contentItems' | 'device' | 'event' | 'files' | 'layouts' | 'overlays' | 'playlists' | 'shows' | ManifestKeySpecifier)[];
export type ManifestFieldPolicy = {
	contentItems?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	layouts?: FieldPolicy<any> | FieldReadFunction<any>,
	overlays?: FieldPolicy<any> | FieldReadFunction<any>,
	playlists?: FieldPolicy<any> | FieldReadFunction<any>,
	shows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManifestPropertyKeySpecifier = ('kind' | 'name' | 'propertyGroupName' | 'value' | ManifestPropertyKeySpecifier)[];
export type ManifestPropertyFieldPolicy = {
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyGroupName?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarkAnnouncementsReadPayloadKeySpecifier = ('announcements' | 'clientMutationId' | 'user' | MarkAnnouncementsReadPayloadKeySpecifier)[];
export type MarkAnnouncementsReadPayloadFieldPolicy = {
	announcements?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaItemKeySpecifier = ('canDestroy' | 'canShow' | 'canUpdate' | 'contentFolderId' | 'contentItem' | 'contentItemCount' | 'createdAt' | 'defaultDuration' | 'designCount' | 'file' | 'folder' | 'format' | 'id' | 'kind' | 'name' | 'originalFile' | 'originalMetadata' | 'overlay' | 'playlistCount' | 'public' | 'renditions' | 'status' | 'tags' | 'thumbnailUri' | 'thumbnails' | 'updatedAt' | 'usages' | 'useOriginal' | MediaItemKeySpecifier)[];
export type MediaItemFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canShow?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	designCount?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	folder?: FieldPolicy<any> | FieldReadFunction<any>,
	format?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	originalFile?: FieldPolicy<any> | FieldReadFunction<any>,
	originalMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	overlay?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistCount?: FieldPolicy<any> | FieldReadFunction<any>,
	public?: FieldPolicy<any> | FieldReadFunction<any>,
	renditions?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUri?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnails?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	usages?: FieldPolicy<any> | FieldReadFunction<any>,
	useOriginal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveContentPayloadKeySpecifier = ('clientMutationId' | 'contentFolders' | MoveContentPayloadKeySpecifier)[];
export type MoveContentPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveDesignPayloadKeySpecifier = ('clientMutationId' | 'designFolders' | 'designs' | MoveDesignPayloadKeySpecifier)[];
export type MoveDesignPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolders?: FieldPolicy<any> | FieldReadFunction<any>,
	designs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MovePlaylistPayloadKeySpecifier = ('clientMutationId' | 'playlistFolders' | 'playlists' | MovePlaylistPayloadKeySpecifier)[];
export type MovePlaylistPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolders?: FieldPolicy<any> | FieldReadFunction<any>,
	playlists?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoveShowPayloadKeySpecifier = ('clientMutationId' | 'showFolders' | 'shows' | MoveShowPayloadKeySpecifier)[];
export type MoveShowPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolders?: FieldPolicy<any> | FieldReadFunction<any>,
	shows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('activateDevice' | 'addChannelsToChannelGuide' | 'addContentFoldersToPlaylist' | 'addContentToPlaylist' | 'addContentToShow' | 'addDevicesToDeviceGroup' | 'addToRole' | 'aiChatSendMessage' | 'assignPropertyGroup' | 'bulkTag' | 'bulkUpdateDevices' | 'cancelDeviceSignal' | 'changeDataSourceAlcoholVisibility' | 'cleanupTemplateVersions' | 'clearDeviceCache' | 'copyContentItem' | 'copyDesign' | 'copyShow' | 'copyView' | 'createAwsCredentials' | 'createChannel' | 'createChannelGuide' | 'createContentFolder' | 'createContentItem' | 'createDataItem' | 'createDesign' | 'createDesignFolder' | 'createDeviceCollection' | 'createDeviceGroup' | 'createDeviceSignal' | 'createEvent' | 'createEventType' | 'createFont' | 'createLayout' | 'createOverlay' | 'createPlaylist' | 'createPlaylistFolder' | 'createRemoteCredentials' | 'createRole' | 'createScheduledShow' | 'createSeason' | 'createShow' | 'createShowFolder' | 'createShowInstance' | 'createTemplate' | 'createTemplateVersion' | 'createTvBrand' | 'createUploadConfig' | 'createUser' | 'createView' | 'createViewZonePlaylist' | 'createZone' | 'deleteChannel' | 'deleteChannelGuide' | 'deleteContent' | 'deleteContentFolder' | 'deleteDataItem' | 'deleteDataSource' | 'deleteDesign' | 'deleteDesignFolder' | 'deleteDevice' | 'deleteDeviceCollection' | 'deleteDeviceGroup' | 'deleteDeviceSignal' | 'deleteEvent' | 'deleteEventType' | 'deleteFont' | 'deleteLayout' | 'deleteOverlay' | 'deletePlaylist' | 'deletePlaylistFolder' | 'deletePlaylistItem' | 'deleteRoles' | 'deleteScheduledShow' | 'deleteSeason' | 'deleteShow' | 'deleteShowFolder' | 'deleteTag' | 'deleteTemplate' | 'deleteTvBrand' | 'deleteUser' | 'deleteView' | 'deleteViewZonePlaylist' | 'deleteZone' | 'duplicateDeviceSignal' | 'duplicateTvBrand' | 'exportAuditLogs' | 'exportDataSource' | 'exportDevices' | 'forgotPassword' | 'generatePlayoutDetailPdf' | 'generateReport' | 'getDeviceCommand' | 'impersonate' | 'login' | 'logout' | 'markAnnouncementsRead' | 'moveContent' | 'moveDesign' | 'movePlaylist' | 'moveShow' | 'playContentOnDevices' | 'publishDesign' | 'registerDevice' | 'removeDevicesFromDeviceGroup' | 'removeDevicesFromScheduledShow' | 'removeFromRole' | 'removePropertyGroup' | 'renameTag' | 'rerunEventRollups' | 'resendConfirmation' | 'resetPassword' | 'runDeviceSignal' | 'runSignalByEventName' | 'sendDeviceCommand' | 'sendRemoteCommand' | 'setPassword' | 'shufflePlaylist' | 'stopImpersonate' | 'syncDataSource' | 'syncEvents' | 'transferDevice' | 'tuneRemoteChannel' | 'updateChannel' | 'updateChannelGuide' | 'updateContentFolder' | 'updateContentItem' | 'updateDataItem' | 'updateDataSource' | 'updateDesign' | 'updateDesignFolder' | 'updateDevice' | 'updateDeviceGroup' | 'updateDeviceSignal' | 'updateDeviceStatusV2' | 'updateDeviceStatusV3' | 'updateEvent' | 'updateEventType' | 'updateEventTypeShowsDeviceGroups' | 'updateFont' | 'updateLayout' | 'updateMediaItem' | 'updateNetwork' | 'updateOverlay' | 'updatePlaylist' | 'updatePlaylistFolder' | 'updatePlaylistItem' | 'updatePropertyValue' | 'updateRole' | 'updateScheduledShow' | 'updateSeason' | 'updateShow' | 'updateShowFolder' | 'updateTags' | 'updateTemplate' | 'updateTvBrand' | 'updateUser' | 'updateView' | 'updateViewZone' | 'updateZone' | 'upgradeAllContentItems' | 'upgradeContentItem' | 'uploadDataSource' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	activateDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	addChannelsToChannelGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	addContentFoldersToPlaylist?: FieldPolicy<any> | FieldReadFunction<any>,
	addContentToPlaylist?: FieldPolicy<any> | FieldReadFunction<any>,
	addContentToShow?: FieldPolicy<any> | FieldReadFunction<any>,
	addDevicesToDeviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	addToRole?: FieldPolicy<any> | FieldReadFunction<any>,
	aiChatSendMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	assignPropertyGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	bulkTag?: FieldPolicy<any> | FieldReadFunction<any>,
	bulkUpdateDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelDeviceSignal?: FieldPolicy<any> | FieldReadFunction<any>,
	changeDataSourceAlcoholVisibility?: FieldPolicy<any> | FieldReadFunction<any>,
	cleanupTemplateVersions?: FieldPolicy<any> | FieldReadFunction<any>,
	clearDeviceCache?: FieldPolicy<any> | FieldReadFunction<any>,
	copyContentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	copyDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	copyShow?: FieldPolicy<any> | FieldReadFunction<any>,
	copyView?: FieldPolicy<any> | FieldReadFunction<any>,
	createAwsCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	createChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	createChannelGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	createContentFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	createContentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createDataItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	createDesignFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	createDeviceCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	createDeviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createDeviceSignal?: FieldPolicy<any> | FieldReadFunction<any>,
	createEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	createEventType?: FieldPolicy<any> | FieldReadFunction<any>,
	createFont?: FieldPolicy<any> | FieldReadFunction<any>,
	createLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	createOverlay?: FieldPolicy<any> | FieldReadFunction<any>,
	createPlaylist?: FieldPolicy<any> | FieldReadFunction<any>,
	createPlaylistFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	createRemoteCredentials?: FieldPolicy<any> | FieldReadFunction<any>,
	createRole?: FieldPolicy<any> | FieldReadFunction<any>,
	createScheduledShow?: FieldPolicy<any> | FieldReadFunction<any>,
	createSeason?: FieldPolicy<any> | FieldReadFunction<any>,
	createShow?: FieldPolicy<any> | FieldReadFunction<any>,
	createShowFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	createShowInstance?: FieldPolicy<any> | FieldReadFunction<any>,
	createTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	createTemplateVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	createTvBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	createUploadConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createView?: FieldPolicy<any> | FieldReadFunction<any>,
	createViewZonePlaylist?: FieldPolicy<any> | FieldReadFunction<any>,
	createZone?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteChannelGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteContent?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteContentFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDataItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDataSource?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDesignFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDeviceCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDeviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDeviceSignal?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEventType?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFont?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteOverlay?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePlaylist?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePlaylistFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePlaylistItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteScheduledShow?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSeason?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteShow?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteShowFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTag?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTvBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteView?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteViewZonePlaylist?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteZone?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateDeviceSignal?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateTvBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	exportAuditLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	exportDataSource?: FieldPolicy<any> | FieldReadFunction<any>,
	exportDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	forgotPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	generatePlayoutDetailPdf?: FieldPolicy<any> | FieldReadFunction<any>,
	generateReport?: FieldPolicy<any> | FieldReadFunction<any>,
	getDeviceCommand?: FieldPolicy<any> | FieldReadFunction<any>,
	impersonate?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	logout?: FieldPolicy<any> | FieldReadFunction<any>,
	markAnnouncementsRead?: FieldPolicy<any> | FieldReadFunction<any>,
	moveContent?: FieldPolicy<any> | FieldReadFunction<any>,
	moveDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	movePlaylist?: FieldPolicy<any> | FieldReadFunction<any>,
	moveShow?: FieldPolicy<any> | FieldReadFunction<any>,
	playContentOnDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	publishDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	registerDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	removeDevicesFromDeviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	removeDevicesFromScheduledShow?: FieldPolicy<any> | FieldReadFunction<any>,
	removeFromRole?: FieldPolicy<any> | FieldReadFunction<any>,
	removePropertyGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	renameTag?: FieldPolicy<any> | FieldReadFunction<any>,
	rerunEventRollups?: FieldPolicy<any> | FieldReadFunction<any>,
	resendConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	runDeviceSignal?: FieldPolicy<any> | FieldReadFunction<any>,
	runSignalByEventName?: FieldPolicy<any> | FieldReadFunction<any>,
	sendDeviceCommand?: FieldPolicy<any> | FieldReadFunction<any>,
	sendRemoteCommand?: FieldPolicy<any> | FieldReadFunction<any>,
	setPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	shufflePlaylist?: FieldPolicy<any> | FieldReadFunction<any>,
	stopImpersonate?: FieldPolicy<any> | FieldReadFunction<any>,
	syncDataSource?: FieldPolicy<any> | FieldReadFunction<any>,
	syncEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	transferDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	tuneRemoteChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	updateChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	updateChannelGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	updateContentFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	updateContentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDataItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDataSource?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDesign?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDesignFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDeviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDeviceSignal?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDeviceStatusV2?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDeviceStatusV3?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventType?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventTypeShowsDeviceGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFont?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLayout?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMediaItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNetwork?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOverlay?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePlaylist?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePlaylistFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePlaylistItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePropertyValue?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRole?: FieldPolicy<any> | FieldReadFunction<any>,
	updateScheduledShow?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSeason?: FieldPolicy<any> | FieldReadFunction<any>,
	updateShow?: FieldPolicy<any> | FieldReadFunction<any>,
	updateShowFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTags?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTvBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateView?: FieldPolicy<any> | FieldReadFunction<any>,
	updateViewZone?: FieldPolicy<any> | FieldReadFunction<any>,
	updateZone?: FieldPolicy<any> | FieldReadFunction<any>,
	upgradeAllContentItems?: FieldPolicy<any> | FieldReadFunction<any>,
	upgradeContentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadDataSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NetworkKeySpecifier = ('allChannelGuides' | 'allChannels' | 'allDataSources' | 'allDeviceGroups' | 'allDevices' | 'allEventTypes' | 'allFonts' | 'allLayouts' | 'allPlaylists' | 'allShows' | 'allTvBrands' | 'auditLog' | 'auditLogs' | 'auditLogsFilterInfo' | 'authorizable' | 'cacheServers' | 'canAccessContent' | 'canAccessDataSources' | 'canAccessDevices' | 'canAccessFcAdminLeagues' | 'canAccessFonts' | 'canAccessLiveChannelStreams' | 'canAccessPlaylists' | 'canAccessReporting' | 'canAccessScheduler' | 'canAccessShows' | 'canAccessStudio' | 'canAccessTemplates' | 'canActivateDevices' | 'canCreateDataSources' | 'canCreateEvents' | 'canCreatePlaylists' | 'canCreateScheduledShows' | 'canCreateShows' | 'canCreateTemplate' | 'canCreateUser' | 'canDestroy' | 'canManage' | 'canManagePropertyGroups' | 'canManageViews' | 'canShow' | 'canUpdate' | 'channel' | 'channelCount' | 'channelGuide' | 'channelGuides' | 'channelPages' | 'channels' | 'content' | 'contentFilterInfo' | 'contentFolder' | 'contentFolderTree' | 'contentFolders' | 'contentItem' | 'contentItems' | 'contentTags' | 'createdAt' | 'dataSource' | 'dataSources' | 'description' | 'design' | 'designFilterInfo' | 'designFolder' | 'designFolderTree' | 'designFolders' | 'designTags' | 'designs' | 'deviceCount' | 'deviceDynamicCollections' | 'deviceFilterInfo' | 'deviceGroup' | 'deviceGroups' | 'deviceLicenses' | 'deviceLicensesAvailable' | 'deviceLicensesUsed' | 'deviceSignal' | 'deviceSignalFilterInfo' | 'deviceSignalTags' | 'deviceSignals' | 'deviceStats' | 'deviceTags' | 'devices' | 'displayServers' | 'enableApi' | 'enableSnmp' | 'encryptionKey' | 'event' | 'eventType' | 'eventTypes' | 'events' | 'font' | 'fonts' | 'id' | 'layout' | 'layouts' | 'leagues' | 'logoUrl' | 'mediaItem' | 'mediaItems' | 'models' | 'name' | 'networkMembership' | 'networkMemberships' | 'overlays' | 'playerVersions' | 'playlist' | 'playlistFilterInfo' | 'playlistFolder' | 'playlistFolderTree' | 'playlistFolders' | 'playlistTags' | 'playlists' | 'playoutReport' | 'public' | 'role' | 'roles' | 'scheduledShow' | 'scheduledShows' | 'settings' | 'show' | 'showFilterInfo' | 'showFolder' | 'showFolderTree' | 'showFolders' | 'showTags' | 'shows' | 'snmpCommunity' | 'snmpConfigured' | 'softwareUpdateInfo' | 'teams' | 'timeZone' | 'tvBrand' | 'tvBrands' | 'updatedAt' | 'userCount' | 'userIds' | 'views' | NetworkKeySpecifier)[];
export type NetworkFieldPolicy = {
	allChannelGuides?: FieldPolicy<any> | FieldReadFunction<any>,
	allChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	allDataSources?: FieldPolicy<any> | FieldReadFunction<any>,
	allDeviceGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	allDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	allEventTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	allFonts?: FieldPolicy<any> | FieldReadFunction<any>,
	allLayouts?: FieldPolicy<any> | FieldReadFunction<any>,
	allPlaylists?: FieldPolicy<any> | FieldReadFunction<any>,
	allShows?: FieldPolicy<any> | FieldReadFunction<any>,
	allTvBrands?: FieldPolicy<any> | FieldReadFunction<any>,
	auditLog?: FieldPolicy<any> | FieldReadFunction<any>,
	auditLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	auditLogsFilterInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	authorizable?: FieldPolicy<any> | FieldReadFunction<any>,
	cacheServers?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessContent?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessDataSources?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessFcAdminLeagues?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessFonts?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessLiveChannelStreams?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessPlaylists?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessReporting?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessScheduler?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessShows?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessStudio?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	canActivateDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateDataSources?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreatePlaylists?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateScheduledShows?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateShows?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canManage?: FieldPolicy<any> | FieldReadFunction<any>,
	canManagePropertyGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	canManageViews?: FieldPolicy<any> | FieldReadFunction<any>,
	canShow?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channelCount?: FieldPolicy<any> | FieldReadFunction<any>,
	channelGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	channelGuides?: FieldPolicy<any> | FieldReadFunction<any>,
	channelPages?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFilterInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderTree?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolders?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItems?: FieldPolicy<any> | FieldReadFunction<any>,
	contentTags?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSources?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	design?: FieldPolicy<any> | FieldReadFunction<any>,
	designFilterInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolderTree?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolders?: FieldPolicy<any> | FieldReadFunction<any>,
	designTags?: FieldPolicy<any> | FieldReadFunction<any>,
	designs?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceDynamicCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceFilterInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceLicenses?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceLicensesAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceLicensesUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceSignal?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceSignalFilterInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceSignalTags?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceSignals?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceStats?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceTags?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	displayServers?: FieldPolicy<any> | FieldReadFunction<any>,
	enableApi?: FieldPolicy<any> | FieldReadFunction<any>,
	enableSnmp?: FieldPolicy<any> | FieldReadFunction<any>,
	encryptionKey?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	eventTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	font?: FieldPolicy<any> | FieldReadFunction<any>,
	fonts?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>,
	layouts?: FieldPolicy<any> | FieldReadFunction<any>,
	leagues?: FieldPolicy<any> | FieldReadFunction<any>,
	logoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaItem?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaItems?: FieldPolicy<any> | FieldReadFunction<any>,
	models?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	networkMembership?: FieldPolicy<any> | FieldReadFunction<any>,
	networkMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	overlays?: FieldPolicy<any> | FieldReadFunction<any>,
	playerVersions?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFilterInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolderTree?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolders?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistTags?: FieldPolicy<any> | FieldReadFunction<any>,
	playlists?: FieldPolicy<any> | FieldReadFunction<any>,
	playoutReport?: FieldPolicy<any> | FieldReadFunction<any>,
	public?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledShow?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledShows?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>,
	showFilterInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolderTree?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolders?: FieldPolicy<any> | FieldReadFunction<any>,
	showTags?: FieldPolicy<any> | FieldReadFunction<any>,
	shows?: FieldPolicy<any> | FieldReadFunction<any>,
	snmpCommunity?: FieldPolicy<any> | FieldReadFunction<any>,
	snmpConfigured?: FieldPolicy<any> | FieldReadFunction<any>,
	softwareUpdateInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	teams?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZone?: FieldPolicy<any> | FieldReadFunction<any>,
	tvBrand?: FieldPolicy<any> | FieldReadFunction<any>,
	tvBrands?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userCount?: FieldPolicy<any> | FieldReadFunction<any>,
	userIds?: FieldPolicy<any> | FieldReadFunction<any>,
	views?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NetworkConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | NetworkConnectionKeySpecifier)[];
export type NetworkConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NetworkEdgeKeySpecifier = ('cursor' | 'node' | NetworkEdgeKeySpecifier)[];
export type NetworkEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NetworkMembershipKeySpecifier = ('canDestroyUser' | 'canImpersonateUser' | 'id' | 'network' | 'owner' | 'user' | NetworkMembershipKeySpecifier)[];
export type NetworkMembershipFieldPolicy = {
	canDestroyUser?: FieldPolicy<any> | FieldReadFunction<any>,
	canImpersonateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NetworkMembershipPageKeySpecifier = ('nodes' | 'pageInfo' | NetworkMembershipPageKeySpecifier)[];
export type NetworkMembershipPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NetworkSettingsKeySpecifier = ('accessFcAdminLeagues' | 'defaultImageDuration' | 'enableLanguageSelection' | 'enableLiveChannelStreaming' | 'enableWebpRendition' | 'managePropertyGroups' | 'manageViews' | 'pptSlideDuration' | 'pptTransition' | 'showTimestampOnScreenshots' | 'transcodeServerHost' | NetworkSettingsKeySpecifier)[];
export type NetworkSettingsFieldPolicy = {
	accessFcAdminLeagues?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultImageDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	enableLanguageSelection?: FieldPolicy<any> | FieldReadFunction<any>,
	enableLiveChannelStreaming?: FieldPolicy<any> | FieldReadFunction<any>,
	enableWebpRendition?: FieldPolicy<any> | FieldReadFunction<any>,
	managePropertyGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	manageViews?: FieldPolicy<any> | FieldReadFunction<any>,
	pptSlideDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	pptTransition?: FieldPolicy<any> | FieldReadFunction<any>,
	showTimestampOnScreenshots?: FieldPolicy<any> | FieldReadFunction<any>,
	transcodeServerHost?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OverlayKeySpecifier = ('canDestroy' | 'contentItem' | 'duration' | 'id' | 'mediaItem' | 'name' | OverlayKeySpecifier)[];
export type OverlayFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaItem?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginationInfoKeySpecifier = ('currentPage' | 'hasNextPage' | 'hasPreviousPage' | 'nodesCount' | 'pagesCount' | 'perPage' | PaginationInfoKeySpecifier)[];
export type PaginationInfoFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pagesCount?: FieldPolicy<any> | FieldReadFunction<any>,
	perPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayContentOnDevicesPayloadKeySpecifier = ('clientMutationId' | 'devices' | PlayContentOnDevicesPayloadKeySpecifier)[];
export type PlayContentOnDevicesPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaylistKeySpecifier = ('canDestroy' | 'canUpdate' | 'createdAt' | 'defaultImageDuration' | 'description' | 'id' | 'kind' | 'name' | 'playlistFolder' | 'playlistFolderId' | 'playlistItems' | 'playlistItemsCount' | 'reusable' | 'runtime' | 'showCount' | 'shows' | 'tags' | 'updatedAt' | PlaylistKeySpecifier)[];
export type PlaylistFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultImageDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistItems?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistItemsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	reusable?: FieldPolicy<any> | FieldReadFunction<any>,
	runtime?: FieldPolicy<any> | FieldReadFunction<any>,
	showCount?: FieldPolicy<any> | FieldReadFunction<any>,
	shows?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaylistFiltersKeySpecifier = ('tags' | PlaylistFiltersKeySpecifier)[];
export type PlaylistFiltersFieldPolicy = {
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaylistFolderKeySpecifier = ('canDestroy' | 'canUpdate' | 'children' | 'childrenCount' | 'createdAt' | 'id' | 'itemCount' | 'name' | 'playlists' | 'updatedAt' | PlaylistFolderKeySpecifier)[];
export type PlaylistFolderFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	childrenCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	playlists?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaylistFolderRuleKeySpecifier = ('id' | 'playlistFolder' | PlaylistFolderRuleKeySpecifier)[];
export type PlaylistFolderRuleFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaylistItemKeySpecifier = ('contentItem' | 'contentItemId' | 'createdAt' | 'duration' | 'durationDefaulted' | 'durationReadonly' | 'endsAt' | 'id' | 'name' | 'playlistId' | 'schedule' | 'startsAt' | 'updatedAt' | PlaylistItemKeySpecifier)[];
export type PlaylistItemFieldPolicy = {
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	durationDefaulted?: FieldPolicy<any> | FieldReadFunction<any>,
	durationReadonly?: FieldPolicy<any> | FieldReadFunction<any>,
	endsAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistId?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	startsAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaylistPageKeySpecifier = ('nodes' | 'pageInfo' | PlaylistPageKeySpecifier)[];
export type PlaylistPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaylistTagKeySpecifier = ('name' | 'uses' | PlaylistTagKeySpecifier)[];
export type PlaylistTagFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportKeySpecifier = ('assetDetail' | 'byAsset' | 'byAssetSummary' | 'byDeviceGroup' | 'byEvent' | 'bySponsor' | 'bySponsorSummary' | 'byZone' | 'sponsorDetail' | 'stats' | 'topAssets' | PlayoutReportKeySpecifier)[];
export type PlayoutReportFieldPolicy = {
	assetDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	byAsset?: FieldPolicy<any> | FieldReadFunction<any>,
	byAssetSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	byDeviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	byEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	bySponsor?: FieldPolicy<any> | FieldReadFunction<any>,
	bySponsorSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	byZone?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	stats?: FieldPolicy<any> | FieldReadFunction<any>,
	topAssets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportAssetAggregateKeySpecifier = ('asset' | 'assetId' | 'durationMs' | 'kind' | 'plays' | 'sponsor' | PlayoutReportAssetAggregateKeySpecifier)[];
export type PlayoutReportAssetAggregateFieldPolicy = {
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	durationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	plays?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportAssetDetailKeySpecifier = ('assetName' | 'associatedSponsors' | 'byDeviceGroup' | 'byEvent' | 'byZone' | 'contentFolderId' | 'stats' | 'thumbnailUri' | PlayoutReportAssetDetailKeySpecifier)[];
export type PlayoutReportAssetDetailFieldPolicy = {
	assetName?: FieldPolicy<any> | FieldReadFunction<any>,
	associatedSponsors?: FieldPolicy<any> | FieldReadFunction<any>,
	byDeviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	byEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	byZone?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	stats?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUri?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportAssetSummaryKeySpecifier = ('asset' | 'assetId' | 'avgDurationMsPerEvent' | 'avgDurationMsPerEventPerDevice' | 'avgPlaysPerEvent' | 'avgPlaysPerEventPerDevice' | 'contentFolderId' | 'contentItemId' | 'deviceCount' | 'durationMs' | 'eventCount' | 'kind' | 'mediaItemId' | 'plays' | 'zones' | PlayoutReportAssetSummaryKeySpecifier)[];
export type PlayoutReportAssetSummaryFieldPolicy = {
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	avgDurationMsPerEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	avgDurationMsPerEventPerDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	avgPlaysPerEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	avgPlaysPerEventPerDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	durationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	eventCount?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	plays?: FieldPolicy<any> | FieldReadFunction<any>,
	zones?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportDeviceGroupAggregateKeySpecifier = ('deviceGroup' | 'deviceGroupId' | 'durationMs' | 'otherCount' | PlayoutReportDeviceGroupAggregateKeySpecifier)[];
export type PlayoutReportDeviceGroupAggregateFieldPolicy = {
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	durationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	otherCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportEventAggregateKeySpecifier = ('durationMs' | 'event' | 'eventId' | 'eventStartTime' | 'plays' | PlayoutReportEventAggregateKeySpecifier)[];
export type PlayoutReportEventAggregateFieldPolicy = {
	durationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStartTime?: FieldPolicy<any> | FieldReadFunction<any>,
	plays?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportSponsorAggregateKeySpecifier = ('durationMs' | 'plays' | 'sponsor' | 'sponsorId' | PlayoutReportSponsorAggregateKeySpecifier)[];
export type PlayoutReportSponsorAggregateFieldPolicy = {
	durationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	plays?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsor?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportSponsorDetailKeySpecifier = ('byAssetSummary' | 'byDeviceGroup' | 'byEvent' | 'byZone' | 'contentFolderId' | 'sponsorName' | 'stats' | PlayoutReportSponsorDetailKeySpecifier)[];
export type PlayoutReportSponsorDetailFieldPolicy = {
	byAssetSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	byDeviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	byEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	byZone?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorName?: FieldPolicy<any> | FieldReadFunction<any>,
	stats?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportSponsorSummaryKeySpecifier = ('avgDurationMsPerEvent' | 'avgDurationMsPerEventPerDevice' | 'avgPlaysPerEvent' | 'avgPlaysPerEventPerDevice' | 'contentFolderId' | 'deviceCount' | 'durationMs' | 'eventCount' | 'plays' | 'sponsor' | 'sponsorId' | PlayoutReportSponsorSummaryKeySpecifier)[];
export type PlayoutReportSponsorSummaryFieldPolicy = {
	avgDurationMsPerEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	avgDurationMsPerEventPerDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	avgPlaysPerEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	avgPlaysPerEventPerDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	durationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	eventCount?: FieldPolicy<any> | FieldReadFunction<any>,
	plays?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsor?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportStatsKeySpecifier = ('eventCount' | 'totalDurationMs' | 'totalPlays' | 'uniqueAssets' | 'uniqueDeviceGroups' | 'uniqueDevices' | PlayoutReportStatsKeySpecifier)[];
export type PlayoutReportStatsFieldPolicy = {
	eventCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDurationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPlays?: FieldPolicy<any> | FieldReadFunction<any>,
	uniqueAssets?: FieldPolicy<any> | FieldReadFunction<any>,
	uniqueDeviceGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	uniqueDevices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportTopAssetKeySpecifier = ('asset' | 'assetId' | 'avgDurationMsPerEvent' | 'avgDurationMsPerEventPerDevice' | 'avgPlaysPerEvent' | 'avgPlaysPerEventPerDevice' | 'contentFolderId' | 'contentItemId' | 'deviceCount' | 'durationMs' | 'eventCount' | 'kind' | 'mediaItemId' | 'plays' | 'sponsor' | 'sponsorId' | 'zones' | PlayoutReportTopAssetKeySpecifier)[];
export type PlayoutReportTopAssetFieldPolicy = {
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	assetId?: FieldPolicy<any> | FieldReadFunction<any>,
	avgDurationMsPerEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	avgDurationMsPerEventPerDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	avgPlaysPerEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	avgPlaysPerEventPerDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	durationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	eventCount?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	plays?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsor?: FieldPolicy<any> | FieldReadFunction<any>,
	sponsorId?: FieldPolicy<any> | FieldReadFunction<any>,
	zones?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayoutReportZoneAggregateKeySpecifier = ('durationMs' | 'zone' | PlayoutReportZoneAggregateKeySpecifier)[];
export type PlayoutReportZoneAggregateFieldPolicy = {
	durationMs?: FieldPolicy<any> | FieldReadFunction<any>,
	zone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PropertyDefinitionKeySpecifier = ('allowedValues' | 'defaultValue' | 'description' | 'helpText' | 'id' | 'kind' | 'label' | 'name' | PropertyDefinitionKeySpecifier)[];
export type PropertyDefinitionFieldPolicy = {
	allowedValues?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultValue?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	helpText?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PropertyDefinitionAllowedValuesTypeKeySpecifier = ('label' | 'value' | PropertyDefinitionAllowedValuesTypeKeySpecifier)[];
export type PropertyDefinitionAllowedValuesTypeFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PropertyGroupKeySpecifier = ('description' | 'id' | 'name' | PropertyGroupKeySpecifier)[];
export type PropertyGroupFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PropertyGroupAssignPayloadKeySpecifier = ('clientMutationId' | 'owner' | 'propertyGroupOwner' | PropertyGroupAssignPayloadKeySpecifier)[];
export type PropertyGroupAssignPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyGroupOwner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PropertyGroupOwnerKeySpecifier = ('canDestroy' | 'description' | 'id' | 'name' | 'propertyGroupId' | 'propertyValues' | PropertyGroupOwnerKeySpecifier)[];
export type PropertyGroupOwnerFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PropertyGroupRemovePayloadKeySpecifier = ('clientMutationId' | 'owner' | 'propertyGroupOwner' | PropertyGroupRemovePayloadKeySpecifier)[];
export type PropertyGroupRemovePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyGroupOwner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PropertyValueKeySpecifier = ('id' | 'propertyDefinition' | 'value' | PropertyValueKeySpecifier)[];
export type PropertyValueFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PropertyValueUpdatePayloadKeySpecifier = ('clientMutationId' | 'errors' | 'owner' | PropertyValueUpdatePayloadKeySpecifier)[];
export type PropertyValueUpdatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublishDesignPayloadKeySpecifier = ('app' | 'clientMutationId' | 'design' | PublishDesignPayloadKeySpecifier)[];
export type PublishDesignPayloadFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	design?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('announcement' | 'announcementFilterInfo' | 'announcements' | 'contentItem' | 'contentItems' | 'currentUser' | 'device' | 'deviceManifest' | 'deviceRegistration' | 'devices' | 'emailByToken' | 'env' | 'file' | 'network' | 'networks' | 'newApp' | 'propertyGroups' | 'remote' | 'template' | 'templateCategories' | 'templateVersionPreview' | 'templateZipValidation' | 'templates' | 'timeZones' | 'trueUser' | 'user' | 'users' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	announcement?: FieldPolicy<any> | FieldReadFunction<any>,
	announcementFilterInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	announcements?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItems?: FieldPolicy<any> | FieldReadFunction<any>,
	currentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceManifest?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceRegistration?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	emailByToken?: FieldPolicy<any> | FieldReadFunction<any>,
	env?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	networks?: FieldPolicy<any> | FieldReadFunction<any>,
	newApp?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	remote?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>,
	templateCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	templateVersionPreview?: FieldPolicy<any> | FieldReadFunction<any>,
	templateZipValidation?: FieldPolicy<any> | FieldReadFunction<any>,
	templates?: FieldPolicy<any> | FieldReadFunction<any>,
	timeZones?: FieldPolicy<any> | FieldReadFunction<any>,
	trueUser?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegisterDevicePayloadKeySpecifier = ('clientMutationId' | 'credentials' | RegisterDevicePayloadKeySpecifier)[];
export type RegisterDevicePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	credentials?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RemoteKeySpecifier = ('channels' | 'deviceName' | 'realtime' | 'supportsMute' | 'supportsVolume' | RemoteKeySpecifier)[];
export type RemoteFieldPolicy = {
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceName?: FieldPolicy<any> | FieldReadFunction<any>,
	realtime?: FieldPolicy<any> | FieldReadFunction<any>,
	supportsMute?: FieldPolicy<any> | FieldReadFunction<any>,
	supportsVolume?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RemoteChannelKeySpecifier = ('backgroundColor' | 'id' | 'name' | 'number' | 'thumbnailUri' | RemoteChannelKeySpecifier)[];
export type RemoteChannelFieldPolicy = {
	backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUri?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RemoteCredentialsKeySpecifier = ('apiKey' | 'expiresAt' | RemoteCredentialsKeySpecifier)[];
export type RemoteCredentialsFieldPolicy = {
	apiKey?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RemoveDevicesFromDeviceGroupPayloadKeySpecifier = ('clientMutationId' | 'deviceGroup' | 'network' | 'removedIds' | RemoveDevicesFromDeviceGroupPayloadKeySpecifier)[];
export type RemoveDevicesFromDeviceGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	removedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RemoveDevicesFromScheduledShowPayloadKeySpecifier = ('clientMutationId' | 'devices' | 'scheduledShow' | RemoveDevicesFromScheduledShowPayloadKeySpecifier)[];
export type RemoveDevicesFromScheduledShowPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledShow?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RemoveFromRolePayloadKeySpecifier = ('clientMutationId' | 'role' | RemoveFromRolePayloadKeySpecifier)[];
export type RemoveFromRolePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RenameTagPayloadKeySpecifier = ('clientMutationId' | 'network' | RenameTagPayloadKeySpecifier)[];
export type RenameTagPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RenditionKeySpecifier = ('filename' | 'height' | 'id' | 'size' | 'status' | 'uri' | 'variant' | 'width' | RenditionKeySpecifier)[];
export type RenditionFieldPolicy = {
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	uri?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RerunEventRollupsPayloadKeySpecifier = ('clientMutationId' | 'event' | RerunEventRollupsPayloadKeySpecifier)[];
export type RerunEventRollupsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResendConfirmationPayloadKeySpecifier = ('clientMutationId' | 'success' | ResendConfirmationPayloadKeySpecifier)[];
export type ResendConfirmationPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResetPasswordPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'success' | ResetPasswordPayloadKeySpecifier)[];
export type ResetPasswordPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleKeySpecifier = ('accessDevices' | 'accessFonts' | 'accessLiveChannelStreams' | 'accessReporting' | 'accessScheduler' | 'accessStudio' | 'accessTemplates' | 'activateDevices' | 'contentFolderCount' | 'contentFolderRules' | 'createDataSources' | 'createEvents' | 'createPlaylists' | 'createScheduledShows' | 'createShows' | 'createTemplates' | 'createdAt' | 'dataSourceCount' | 'dataSourceRules' | 'description' | 'designFolderCount' | 'designFolderRules' | 'deviceCount' | 'deviceGroupRules' | 'deviceRules' | 'eventTypeCount' | 'eventTypeRules' | 'id' | 'name' | 'playlistFolderCount' | 'playlistFolderRules' | 'showFolderCount' | 'showFolderRules' | 'updatedAt' | 'userCount' | 'users' | RoleKeySpecifier)[];
export type RoleFieldPolicy = {
	accessDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	accessFonts?: FieldPolicy<any> | FieldReadFunction<any>,
	accessLiveChannelStreams?: FieldPolicy<any> | FieldReadFunction<any>,
	accessReporting?: FieldPolicy<any> | FieldReadFunction<any>,
	accessScheduler?: FieldPolicy<any> | FieldReadFunction<any>,
	accessStudio?: FieldPolicy<any> | FieldReadFunction<any>,
	accessTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	activateDevices?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolderRules?: FieldPolicy<any> | FieldReadFunction<any>,
	createDataSources?: FieldPolicy<any> | FieldReadFunction<any>,
	createEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	createPlaylists?: FieldPolicy<any> | FieldReadFunction<any>,
	createScheduledShows?: FieldPolicy<any> | FieldReadFunction<any>,
	createShows?: FieldPolicy<any> | FieldReadFunction<any>,
	createTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSourceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSourceRules?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolderRules?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroupRules?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceRules?: FieldPolicy<any> | FieldReadFunction<any>,
	eventTypeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	eventTypeRules?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolderRules?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolderCount?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolderRules?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userCount?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RolePageKeySpecifier = ('nodes' | 'pageInfo' | RolePageKeySpecifier)[];
export type RolePageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunDeviceSignalPayloadKeySpecifier = ('clientMutationId' | 'deviceSignal' | RunDeviceSignalPayloadKeySpecifier)[];
export type RunDeviceSignalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceSignal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RunSignalByEventNamePayloadKeySpecifier = ('clientMutationId' | 'success' | RunSignalByEventNamePayloadKeySpecifier)[];
export type RunSignalByEventNamePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SamsungFirmwareKeySpecifier = ('id' | 'version' | SamsungFirmwareKeySpecifier)[];
export type SamsungFirmwareFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduleKeySpecifier = ('allDay' | 'count' | 'endTime' | 'rrule' | 'startDate' | 'startTime' | ScheduleKeySpecifier)[];
export type ScheduleFieldPolicy = {
	allDay?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	rrule?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledShowKeySpecifier = ('canUpdate' | 'createdAt' | 'deviceCount' | 'devices' | 'id' | 'name' | 'schedule' | 'show' | 'updatedAt' | ScheduledShowKeySpecifier)[];
export type ScheduledShowFieldPolicy = {
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledShowMutationsCreatePayloadKeySpecifier = ('clientMutationId' | 'devices' | 'scheduledShow' | 'show' | ScheduledShowMutationsCreatePayloadKeySpecifier)[];
export type ScheduledShowMutationsCreatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledShow?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledShowMutationsDeletePayloadKeySpecifier = ('clientMutationId' | 'deletedIds' | ScheduledShowMutationsDeletePayloadKeySpecifier)[];
export type ScheduledShowMutationsDeletePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledShowMutationsUpdatePayloadKeySpecifier = ('clientMutationId' | 'scheduledShow' | ScheduledShowMutationsUpdatePayloadKeySpecifier)[];
export type ScheduledShowMutationsUpdatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledShow?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduledShowPageKeySpecifier = ('nodes' | 'pageInfo' | ScheduledShowPageKeySpecifier)[];
export type ScheduledShowPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SeasonKeySpecifier = ('canDestroy' | 'canUpdate' | 'endsOn' | 'id' | 'name' | 'startsOn' | SeasonKeySpecifier)[];
export type SeasonFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	endsOn?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	startsOn?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendDeviceCommandPayloadKeySpecifier = ('clientMutationId' | 'devices' | 'error' | SendDeviceCommandPayloadKeySpecifier)[];
export type SendDeviceCommandPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendRemoteCommandPayloadKeySpecifier = ('clientMutationId' | 'remote' | SendRemoteCommandPayloadKeySpecifier)[];
export type SendRemoteCommandPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	remote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetPasswordPayloadKeySpecifier = ('clientMutationId' | 'success' | SetPasswordPayloadKeySpecifier)[];
export type SetPasswordPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowKeySpecifier = ('canDestroy' | 'canUpdate' | 'channelGuide' | 'createdAt' | 'defaultForDeviceGroups' | 'defaultImageDuration' | 'defaultView' | 'defaultViewId' | 'eventDeviceGroups' | 'fanconnect' | 'homeView' | 'id' | 'instances' | 'name' | 'origin' | 'originId' | 'properties' | 'propertyGroups' | 'scheduledShows' | 'serviceIds' | 'services' | 'showFolder' | 'showFolderId' | 'tags' | 'updatedAt' | 'viewCount' | 'viewIds' | 'views' | ShowKeySpecifier)[];
export type ShowFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	channelGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultForDeviceGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultImageDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultView?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultViewId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDeviceGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	fanconnect?: FieldPolicy<any> | FieldReadFunction<any>,
	homeView?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	instances?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	origin?: FieldPolicy<any> | FieldReadFunction<any>,
	originId?: FieldPolicy<any> | FieldReadFunction<any>,
	properties?: FieldPolicy<any> | FieldReadFunction<any>,
	propertyGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledShows?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceIds?: FieldPolicy<any> | FieldReadFunction<any>,
	services?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolderId?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	viewCount?: FieldPolicy<any> | FieldReadFunction<any>,
	viewIds?: FieldPolicy<any> | FieldReadFunction<any>,
	views?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowEventDeviceGroupKeySpecifier = ('deviceGroup' | 'event' | 'id' | 'show' | ShowEventDeviceGroupKeySpecifier)[];
export type ShowEventDeviceGroupFieldPolicy = {
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowEventTypeDeviceGroupKeySpecifier = ('deviceGroup' | 'eventType' | 'id' | 'show' | ShowEventTypeDeviceGroupKeySpecifier)[];
export type ShowEventTypeDeviceGroupFieldPolicy = {
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowFiltersKeySpecifier = ('tags' | ShowFiltersKeySpecifier)[];
export type ShowFiltersFieldPolicy = {
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowFolderKeySpecifier = ('canDestroy' | 'canUpdate' | 'children' | 'childrenCount' | 'createdAt' | 'id' | 'itemCount' | 'name' | 'shows' | 'updatedAt' | ShowFolderKeySpecifier)[];
export type ShowFolderFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	childrenCount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	shows?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowFolderRuleKeySpecifier = ('id' | 'showFolder' | ShowFolderRuleKeySpecifier)[];
export type ShowFolderRuleFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowPageKeySpecifier = ('nodes' | 'pageInfo' | ShowPageKeySpecifier)[];
export type ShowPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShowTagKeySpecifier = ('name' | 'uses' | ShowTagKeySpecifier)[];
export type ShowTagFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	uses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShufflePlaylistPayloadKeySpecifier = ('clientMutationId' | 'playlist' | ShufflePlaylistPayloadKeySpecifier)[];
export type ShufflePlaylistPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignalActionArbitraryKeySpecifier = ('arbitrary' | 'command' | SignalActionArbitraryKeySpecifier)[];
export type SignalActionArbitraryFieldPolicy = {
	arbitrary?: FieldPolicy<any> | FieldReadFunction<any>,
	command?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignalActionPlayOverlayKeySpecifier = ('command' | 'overlay' | SignalActionPlayOverlayKeySpecifier)[];
export type SignalActionPlayOverlayFieldPolicy = {
	command?: FieldPolicy<any> | FieldReadFunction<any>,
	overlay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignalActionPlayShowKeySpecifier = ('command' | 'show' | SignalActionPlayShowKeySpecifier)[];
export type SignalActionPlayShowFieldPolicy = {
	command?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignalActionRebootKeySpecifier = ('command' | SignalActionRebootKeySpecifier)[];
export type SignalActionRebootFieldPolicy = {
	command?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignalActionStopOverlayKeySpecifier = ('command' | SignalActionStopOverlayKeySpecifier)[];
export type SignalActionStopOverlayFieldPolicy = {
	command?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignalActionTriggerViewKeySpecifier = ('command' | 'view' | SignalActionTriggerViewKeySpecifier)[];
export type SignalActionTriggerViewFieldPolicy = {
	command?: FieldPolicy<any> | FieldReadFunction<any>,
	view?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SignalActionTuneChannelKeySpecifier = ('channel' | 'command' | SignalActionTuneChannelKeySpecifier)[];
export type SignalActionTuneChannelFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	command?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SoftwareUpdateInfoKeySpecifier = ('currentVersion' | 'reason' | 'versions' | SoftwareUpdateInfoKeySpecifier)[];
export type SoftwareUpdateInfoFieldPolicy = {
	currentVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	versions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SoftwareVersionKeySpecifier = ('approved' | 'current' | 'eoledAt' | 'id' | 'version' | SoftwareVersionKeySpecifier)[];
export type SoftwareVersionFieldPolicy = {
	approved?: FieldPolicy<any> | FieldReadFunction<any>,
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	eoledAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StopImpersonatePayloadKeySpecifier = ('clientMutationId' | 'user' | StopImpersonatePayloadKeySpecifier)[];
export type StopImpersonatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionKeySpecifier = ('currentUserUpdated' | SubscriptionKeySpecifier)[];
export type SubscriptionFieldPolicy = {
	currentUserUpdated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SyncDataSourcePayloadKeySpecifier = ('clientMutationId' | 'dataSource' | SyncDataSourcePayloadKeySpecifier)[];
export type SyncDataSourcePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SyncEventsPayloadKeySpecifier = ('clientMutationId' | 'eventType' | SyncEventsPayloadKeySpecifier)[];
export type SyncEventsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TVBrandKeySpecifier = ('baudRate' | 'canDestroy' | 'canUpdate' | 'createdAt' | 'deviceCount' | 'id' | 'input1' | 'input2' | 'input3' | 'mute' | 'name' | 'network' | 'powerOff' | 'powerOn' | 'status' | 'unmute' | 'updatedAt' | 'volumeDown' | 'volumeUp' | TVBrandKeySpecifier)[];
export type TVBrandFieldPolicy = {
	baudRate?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	input1?: FieldPolicy<any> | FieldReadFunction<any>,
	input2?: FieldPolicy<any> | FieldReadFunction<any>,
	input3?: FieldPolicy<any> | FieldReadFunction<any>,
	mute?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	powerOff?: FieldPolicy<any> | FieldReadFunction<any>,
	powerOn?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	unmute?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	volumeDown?: FieldPolicy<any> | FieldReadFunction<any>,
	volumeUp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TVBrandPageKeySpecifier = ('nodes' | 'pageInfo' | TVBrandPageKeySpecifier)[];
export type TVBrandPageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TeamKeySpecifier = ('abbreviation' | 'id' | 'location' | 'logoUrl' | 'name' | 'primaryColor' | TeamKeySpecifier)[];
export type TeamFieldPolicy = {
	abbreviation?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	logoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryColor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateKeySpecifier = ('adKind' | 'canCleanup' | 'canDestroy' | 'canUpdate' | 'canUpgradeAll' | 'contentItems' | 'createdAt' | 'description' | 'id' | 'latestVersion' | 'mediaKind' | 'name' | 'templateCategory' | 'templateVersions' | 'thumbnailUri' | 'updatedAt' | TemplateKeySpecifier)[];
export type TemplateFieldPolicy = {
	adKind?: FieldPolicy<any> | FieldReadFunction<any>,
	canCleanup?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpgradeAll?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItems?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	latestVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaKind?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	templateCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	templateVersions?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUri?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateCategoryKeySpecifier = ('id' | 'name' | 'templates' | TemplateCategoryKeySpecifier)[];
export type TemplateCategoryFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	templates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TemplateConnectionKeySpecifier)[];
export type TemplateConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateEdgeKeySpecifier = ('cursor' | 'node' | TemplateEdgeKeySpecifier)[];
export type TemplateEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateParamKeySpecifier = ('array' | 'createdAt' | 'defaultValue' | 'description' | 'id' | 'kind' | 'label' | 'name' | 'nullable' | 'options' | 'templateVersionId' | 'updatedAt' | TemplateParamKeySpecifier)[];
export type TemplateParamFieldPolicy = {
	array?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultValue?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nullable?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	templateVersionId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateParamGroupKeySpecifier = ('description' | 'label' | 'name' | TemplateParamGroupKeySpecifier)[];
export type TemplateParamGroupFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateParamOptionKeySpecifier = ('name' | 'value' | TemplateParamOptionKeySpecifier)[];
export type TemplateParamOptionFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateVersionKeySpecifier = ('aspectRatio' | 'canDestroy' | 'checksum' | 'createdAt' | 'defaultDuration' | 'durationReadonly' | 'fileId' | 'groupedParams' | 'id' | 'templateId' | 'templateParams' | 'updatedAt' | 'uri' | 'uses' | 'version' | TemplateVersionKeySpecifier)[];
export type TemplateVersionFieldPolicy = {
	aspectRatio?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	checksum?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	durationReadonly?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	groupedParams?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	templateId?: FieldPolicy<any> | FieldReadFunction<any>,
	templateParams?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uri?: FieldPolicy<any> | FieldReadFunction<any>,
	uses?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateVersionConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | TemplateVersionConnectionKeySpecifier)[];
export type TemplateVersionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateVersionEdgeKeySpecifier = ('cursor' | 'node' | TemplateVersionEdgeKeySpecifier)[];
export type TemplateVersionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateVersionPreviewTypeKeySpecifier = ('aspectRatio' | 'contentItem' | TemplateVersionPreviewTypeKeySpecifier)[];
export type TemplateVersionPreviewTypeFieldPolicy = {
	aspectRatio?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateZipValidationKeySpecifier = ('errors' | TemplateZipValidationKeySpecifier)[];
export type TemplateZipValidationFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateZipValidationErrorKeySpecifier = ('explanation' | 'path' | TemplateZipValidationErrorKeySpecifier)[];
export type TemplateZipValidationErrorFieldPolicy = {
	explanation?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThumbnailKeySpecifier = ('boundsHeight' | 'boundsWidth' | 'uri' | ThumbnailKeySpecifier)[];
export type ThumbnailFieldPolicy = {
	boundsHeight?: FieldPolicy<any> | FieldReadFunction<any>,
	boundsWidth?: FieldPolicy<any> | FieldReadFunction<any>,
	uri?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimeZoneKeySpecifier = ('id' | 'name' | TimeZoneKeySpecifier)[];
export type TimeZoneFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransferDevicePayloadKeySpecifier = ('clientMutationId' | 'device' | TransferDevicePayloadKeySpecifier)[];
export type TransferDevicePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TuneRemoteChannelPayloadKeySpecifier = ('clientMutationId' | 'remote' | TuneRemoteChannelPayloadKeySpecifier)[];
export type TuneRemoteChannelPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	remote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateChannelGuidePayloadKeySpecifier = ('channelGuide' | 'clientMutationId' | UpdateChannelGuidePayloadKeySpecifier)[];
export type UpdateChannelGuidePayloadFieldPolicy = {
	channelGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateChannelPayloadKeySpecifier = ('channel' | 'clientMutationId' | 'network' | UpdateChannelPayloadKeySpecifier)[];
export type UpdateChannelPayloadFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateContentFolderPayloadKeySpecifier = ('clientMutationId' | 'contentFolder' | 'network' | 'oldParent' | 'parent' | UpdateContentFolderPayloadKeySpecifier)[];
export type UpdateContentFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	oldParent?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateContentItemPayloadKeySpecifier = ('clientMutationId' | 'contentItem' | UpdateContentItemPayloadKeySpecifier)[];
export type UpdateContentItemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDataSourcePayloadKeySpecifier = ('clientMutationId' | 'dataSource' | UpdateDataSourcePayloadKeySpecifier)[];
export type UpdateDataSourcePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDesignFolderPayloadKeySpecifier = ('clientMutationId' | 'designFolder' | 'network' | 'oldParent' | 'parent' | UpdateDesignFolderPayloadKeySpecifier)[];
export type UpdateDesignFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	designFolder?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	oldParent?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDesignPayloadKeySpecifier = ('clientMutationId' | 'design' | 'network' | UpdateDesignPayloadKeySpecifier)[];
export type UpdateDesignPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	design?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDeviceGroupPayloadKeySpecifier = ('clientMutationId' | 'deviceGroup' | 'network' | UpdateDeviceGroupPayloadKeySpecifier)[];
export type UpdateDeviceGroupPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDevicePayloadKeySpecifier = ('clientMutationId' | 'device' | UpdateDevicePayloadKeySpecifier)[];
export type UpdateDevicePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDeviceSignalPayloadKeySpecifier = ('clientMutationId' | 'deviceSignal' | 'network' | UpdateDeviceSignalPayloadKeySpecifier)[];
export type UpdateDeviceSignalPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceSignal?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDeviceStatusPayloadKeySpecifier = ('clientMutationId' | 'device' | UpdateDeviceStatusPayloadKeySpecifier)[];
export type UpdateDeviceStatusPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDeviceStatusV3PayloadKeySpecifier = ('clientMutationId' | 'device' | UpdateDeviceStatusV3PayloadKeySpecifier)[];
export type UpdateDeviceStatusV3PayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	device?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEventPayloadKeySpecifier = ('clientMutationId' | 'event' | UpdateEventPayloadKeySpecifier)[];
export type UpdateEventPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEventTypePayloadKeySpecifier = ('clientMutationId' | 'eventType' | 'network' | UpdateEventTypePayloadKeySpecifier)[];
export type UpdateEventTypePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEventTypeShowsDeviceGroupsPayloadKeySpecifier = ('clientMutationId' | 'eventType' | UpdateEventTypeShowsDeviceGroupsPayloadKeySpecifier)[];
export type UpdateEventTypeShowsDeviceGroupsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateFontPayloadKeySpecifier = ('clientMutationId' | 'font' | UpdateFontPayloadKeySpecifier)[];
export type UpdateFontPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	font?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateLayoutPayloadKeySpecifier = ('clientMutationId' | 'layout' | UpdateLayoutPayloadKeySpecifier)[];
export type UpdateLayoutPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateMediaItemPayloadKeySpecifier = ('clientMutationId' | 'mediaItem' | UpdateMediaItemPayloadKeySpecifier)[];
export type UpdateMediaItemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateNetworkPayloadKeySpecifier = ('clientMutationId' | 'network' | UpdateNetworkPayloadKeySpecifier)[];
export type UpdateNetworkPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateOverlayPayloadKeySpecifier = ('clientMutationId' | 'overlay' | UpdateOverlayPayloadKeySpecifier)[];
export type UpdateOverlayPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	overlay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePlaylistFolderPayloadKeySpecifier = ('clientMutationId' | 'network' | 'oldParent' | 'parent' | 'playlistFolder' | UpdatePlaylistFolderPayloadKeySpecifier)[];
export type UpdatePlaylistFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	oldParent?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistFolder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePlaylistItemPayloadKeySpecifier = ('clientMutationId' | 'playlist' | 'playlistItem' | UpdatePlaylistItemPayloadKeySpecifier)[];
export type UpdatePlaylistItemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePlaylistPayloadKeySpecifier = ('clientMutationId' | 'errors' | 'playlist' | UpdatePlaylistPayloadKeySpecifier)[];
export type UpdatePlaylistPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateRolePayloadKeySpecifier = ('clientMutationId' | 'role' | UpdateRolePayloadKeySpecifier)[];
export type UpdateRolePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateSeasonPayloadKeySpecifier = ('clientMutationId' | 'eventType' | 'season' | UpdateSeasonPayloadKeySpecifier)[];
export type UpdateSeasonPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	season?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateShowFolderPayloadKeySpecifier = ('clientMutationId' | 'network' | 'oldParent' | 'parent' | 'showFolder' | UpdateShowFolderPayloadKeySpecifier)[];
export type UpdateShowFolderPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	oldParent?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	showFolder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateShowPayloadKeySpecifier = ('clientMutationId' | 'show' | UpdateShowPayloadKeySpecifier)[];
export type UpdateShowPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateTVBrandPayloadKeySpecifier = ('clientMutationId' | 'tvBrand' | UpdateTVBrandPayloadKeySpecifier)[];
export type UpdateTVBrandPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	tvBrand?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateTagsPayloadKeySpecifier = ('clientMutationId' | 'network' | 'taggable' | UpdateTagsPayloadKeySpecifier)[];
export type UpdateTagsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	network?: FieldPolicy<any> | FieldReadFunction<any>,
	taggable?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateTemplatePayloadKeySpecifier = ('clientMutationId' | 'template' | UpdateTemplatePayloadKeySpecifier)[];
export type UpdateTemplatePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateUserPayloadKeySpecifier = ('clientMutationId' | 'user' | UpdateUserPayloadKeySpecifier)[];
export type UpdateUserPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateViewPayloadKeySpecifier = ('clientMutationId' | 'view' | UpdateViewPayloadKeySpecifier)[];
export type UpdateViewPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	view?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateViewZonePayloadKeySpecifier = ('clientMutationId' | 'viewZone' | UpdateViewZonePayloadKeySpecifier)[];
export type UpdateViewZonePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	viewZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateZonePayloadKeySpecifier = ('clientMutationId' | 'layout' | 'zone' | UpdateZonePayloadKeySpecifier)[];
export type UpdateZonePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>,
	zone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpgradeAllContentItemsPayloadKeySpecifier = ('clientMutationId' | 'template' | UpgradeAllContentItemsPayloadKeySpecifier)[];
export type UpgradeAllContentItemsPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	template?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpgradeContentItemPayloadKeySpecifier = ('clientMutationId' | 'contentItem' | UpgradeContentItemPayloadKeySpecifier)[];
export type UpgradeContentItemPayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	contentItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadCredentialsKeySpecifier = ('accessKeyId' | 'expiration' | 'secretAccessKey' | 'sessionToken' | UploadCredentialsKeySpecifier)[];
export type UploadCredentialsFieldPolicy = {
	accessKeyId?: FieldPolicy<any> | FieldReadFunction<any>,
	expiration?: FieldPolicy<any> | FieldReadFunction<any>,
	secretAccessKey?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadDataSourcePayloadKeySpecifier = ('clientMutationId' | 'dataSource' | UploadDataSourcePayloadKeySpecifier)[];
export type UploadDataSourcePayloadFieldPolicy = {
	clientMutationId?: FieldPolicy<any> | FieldReadFunction<any>,
	dataSource?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadMetadataKeySpecifier = ('networkId' | 'userId' | UploadMetadataKeySpecifier)[];
export type UploadMetadataFieldPolicy = {
	networkId?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsagePageKeySpecifier = ('nodes' | 'pageInfo' | UsagePageKeySpecifier)[];
export type UsagePageFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('admin' | 'authStrategy' | 'autoRefresh' | 'canCreateNetwork' | 'canDestroy' | 'canManageNetwork' | 'canShow' | 'canUpdate' | 'createdAt' | 'currentSignInAt' | 'currentSignInIp' | 'defaultNetworkId' | 'devicePreviewAutoplay' | 'email' | 'hideDashboard' | 'id' | 'lastSignInAt' | 'lastSignInIp' | 'locale' | 'name' | 'networkMembership' | 'networkMemberships' | 'networks' | 'roles' | 'signInCount' | 'status' | 'unreadAnnouncementCount' | 'unreadAnnouncementsBySeverity' | 'updatedAt' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	admin?: FieldPolicy<any> | FieldReadFunction<any>,
	authStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	autoRefresh?: FieldPolicy<any> | FieldReadFunction<any>,
	canCreateNetwork?: FieldPolicy<any> | FieldReadFunction<any>,
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canManageNetwork?: FieldPolicy<any> | FieldReadFunction<any>,
	canShow?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentSignInAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentSignInIp?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultNetworkId?: FieldPolicy<any> | FieldReadFunction<any>,
	devicePreviewAutoplay?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	hideDashboard?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSignInAt?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSignInIp?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	networkMembership?: FieldPolicy<any> | FieldReadFunction<any>,
	networkMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	networks?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	signInCount?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadAnnouncementCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadAnnouncementsBySeverity?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserConnectionKeySpecifier = ('edges' | 'nodes' | 'pageInfo' | 'totalCount' | UserConnectionKeySpecifier)[];
export type UserConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserEdgeKeySpecifier = ('cursor' | 'node' | UserEdgeKeySpecifier)[];
export type UserEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ViewKeySpecifier = ('canDestroy' | 'createdAt' | 'id' | 'layout' | 'layoutId' | 'name' | 'show' | 'showId' | 'thumbnailFileId' | 'thumbnailUri' | 'updatedAt' | 'viewZones' | ViewKeySpecifier)[];
export type ViewFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	layout?: FieldPolicy<any> | FieldReadFunction<any>,
	layoutId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	show?: FieldPolicy<any> | FieldReadFunction<any>,
	showId?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailFileId?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUri?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	viewZones?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ViewZoneKeySpecifier = ('createdAt' | 'id' | 'layoutId' | 'name' | 'reportPlayback' | 'sync' | 'updatedAt' | 'viewZonePlaylistIds' | 'viewZonePlaylists' | 'zoneId' | ViewZoneKeySpecifier)[];
export type ViewZoneFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	layoutId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reportPlayback?: FieldPolicy<any> | FieldReadFunction<any>,
	sync?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	viewZonePlaylistIds?: FieldPolicy<any> | FieldReadFunction<any>,
	viewZonePlaylists?: FieldPolicy<any> | FieldReadFunction<any>,
	zoneId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ViewZonePlaylistKeySpecifier = ('createdAt' | 'id' | 'playlist' | 'playlistId' | 'updatedAt' | 'viewZone' | ViewZonePlaylistKeySpecifier)[];
export type ViewZonePlaylistFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	playlist?: FieldPolicy<any> | FieldReadFunction<any>,
	playlistId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	viewZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebosFirmwareKeySpecifier = ('id' | 'version' | WebosFirmwareKeySpecifier)[];
export type WebosFirmwareFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ZoneKeySpecifier = ('canDestroy' | 'canUpdate' | 'createdAt' | 'height' | 'id' | 'layoutId' | 'left' | 'name' | 'top' | 'updatedAt' | 'width' | ZoneKeySpecifier)[];
export type ZoneFieldPolicy = {
	canDestroy?: FieldPolicy<any> | FieldReadFunction<any>,
	canUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	layoutId?: FieldPolicy<any> | FieldReadFunction<any>,
	left?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	top?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	ActivateDevicePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivateDevicePayloadKeySpecifier | (() => undefined | ActivateDevicePayloadKeySpecifier),
		fields?: ActivateDevicePayloadFieldPolicy,
	},
	ActiveShow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActiveShowKeySpecifier | (() => undefined | ActiveShowKeySpecifier),
		fields?: ActiveShowFieldPolicy,
	},
	AddChannelsToChannelGuidePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddChannelsToChannelGuidePayloadKeySpecifier | (() => undefined | AddChannelsToChannelGuidePayloadKeySpecifier),
		fields?: AddChannelsToChannelGuidePayloadFieldPolicy,
	},
	AddContentFoldersToPlaylistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddContentFoldersToPlaylistPayloadKeySpecifier | (() => undefined | AddContentFoldersToPlaylistPayloadKeySpecifier),
		fields?: AddContentFoldersToPlaylistPayloadFieldPolicy,
	},
	AddContentToPlaylistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddContentToPlaylistPayloadKeySpecifier | (() => undefined | AddContentToPlaylistPayloadKeySpecifier),
		fields?: AddContentToPlaylistPayloadFieldPolicy,
	},
	AddContentToShowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddContentToShowPayloadKeySpecifier | (() => undefined | AddContentToShowPayloadKeySpecifier),
		fields?: AddContentToShowPayloadFieldPolicy,
	},
	AddDevicesToDeviceGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddDevicesToDeviceGroupPayloadKeySpecifier | (() => undefined | AddDevicesToDeviceGroupPayloadKeySpecifier),
		fields?: AddDevicesToDeviceGroupPayloadFieldPolicy,
	},
	AddToRolePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddToRolePayloadKeySpecifier | (() => undefined | AddToRolePayloadKeySpecifier),
		fields?: AddToRolePayloadFieldPolicy,
	},
	AiChatSendMessagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AiChatSendMessagePayloadKeySpecifier | (() => undefined | AiChatSendMessagePayloadKeySpecifier),
		fields?: AiChatSendMessagePayloadFieldPolicy,
	},
	Announcement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnnouncementKeySpecifier | (() => undefined | AnnouncementKeySpecifier),
		fields?: AnnouncementFieldPolicy,
	},
	AnnouncementFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnnouncementFiltersKeySpecifier | (() => undefined | AnnouncementFiltersKeySpecifier),
		fields?: AnnouncementFiltersFieldPolicy,
	},
	AnnouncementPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnnouncementPageKeySpecifier | (() => undefined | AnnouncementPageKeySpecifier),
		fields?: AnnouncementPageFieldPolicy,
	},
	AnnouncementUnreadCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AnnouncementUnreadCountKeySpecifier | (() => undefined | AnnouncementUnreadCountKeySpecifier),
		fields?: AnnouncementUnreadCountFieldPolicy,
	},
	AuditLog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditLogKeySpecifier | (() => undefined | AuditLogKeySpecifier),
		fields?: AuditLogFieldPolicy,
	},
	AuditLogPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditLogPageKeySpecifier | (() => undefined | AuditLogPageKeySpecifier),
		fields?: AuditLogPageFieldPolicy,
	},
	AuditLogRecord?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditLogRecordKeySpecifier | (() => undefined | AuditLogRecordKeySpecifier),
		fields?: AuditLogRecordFieldPolicy,
	},
	AuditLogRecordPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditLogRecordPageKeySpecifier | (() => undefined | AuditLogRecordPageKeySpecifier),
		fields?: AuditLogRecordPageFieldPolicy,
	},
	AuditLogsFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuditLogsFiltersKeySpecifier | (() => undefined | AuditLogsFiltersKeySpecifier),
		fields?: AuditLogsFiltersFieldPolicy,
	},
	Authorizable?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuthorizableKeySpecifier | (() => undefined | AuthorizableKeySpecifier),
		fields?: AuthorizableFieldPolicy,
	},
	AuthorizationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AuthorizationResultKeySpecifier | (() => undefined | AuthorizationResultKeySpecifier),
		fields?: AuthorizationResultFieldPolicy,
	},
	BulkTagPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkTagPayloadKeySpecifier | (() => undefined | BulkTagPayloadKeySpecifier),
		fields?: BulkTagPayloadFieldPolicy,
	},
	BulkUpdateDevicesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkUpdateDevicesPayloadKeySpecifier | (() => undefined | BulkUpdateDevicesPayloadKeySpecifier),
		fields?: BulkUpdateDevicesPayloadFieldPolicy,
	},
	BulkUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkUpdateResultKeySpecifier | (() => undefined | BulkUpdateResultKeySpecifier),
		fields?: BulkUpdateResultFieldPolicy,
	},
	CancelDeviceSignalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CancelDeviceSignalPayloadKeySpecifier | (() => undefined | CancelDeviceSignalPayloadKeySpecifier),
		fields?: CancelDeviceSignalPayloadFieldPolicy,
	},
	ChangeDataSourceAlcoholVisibilityPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChangeDataSourceAlcoholVisibilityPayloadKeySpecifier | (() => undefined | ChangeDataSourceAlcoholVisibilityPayloadKeySpecifier),
		fields?: ChangeDataSourceAlcoholVisibilityPayloadFieldPolicy,
	},
	Channel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelKeySpecifier | (() => undefined | ChannelKeySpecifier),
		fields?: ChannelFieldPolicy,
	},
	ChannelAudioStream?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelAudioStreamKeySpecifier | (() => undefined | ChannelAudioStreamKeySpecifier),
		fields?: ChannelAudioStreamFieldPolicy,
	},
	ChannelGuide?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelGuideKeySpecifier | (() => undefined | ChannelGuideKeySpecifier),
		fields?: ChannelGuideFieldPolicy,
	},
	ChannelGuidePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelGuidePageKeySpecifier | (() => undefined | ChannelGuidePageKeySpecifier),
		fields?: ChannelGuidePageFieldPolicy,
	},
	ChannelMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelMetadataKeySpecifier | (() => undefined | ChannelMetadataKeySpecifier),
		fields?: ChannelMetadataFieldPolicy,
	},
	ChannelPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelPageKeySpecifier | (() => undefined | ChannelPageKeySpecifier),
		fields?: ChannelPageFieldPolicy,
	},
	ChannelVideoStream?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelVideoStreamKeySpecifier | (() => undefined | ChannelVideoStreamKeySpecifier),
		fields?: ChannelVideoStreamFieldPolicy,
	},
	CleanupTemplateVersionsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CleanupTemplateVersionsPayloadKeySpecifier | (() => undefined | CleanupTemplateVersionsPayloadKeySpecifier),
		fields?: CleanupTemplateVersionsPayloadFieldPolicy,
	},
	ClearDeviceCachePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClearDeviceCachePayloadKeySpecifier | (() => undefined | ClearDeviceCachePayloadKeySpecifier),
		fields?: ClearDeviceCachePayloadFieldPolicy,
	},
	ContentFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentFiltersKeySpecifier | (() => undefined | ContentFiltersKeySpecifier),
		fields?: ContentFiltersFieldPolicy,
	},
	ContentFolder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentFolderKeySpecifier | (() => undefined | ContentFolderKeySpecifier),
		fields?: ContentFolderFieldPolicy,
	},
	ContentFolderRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentFolderRuleKeySpecifier | (() => undefined | ContentFolderRuleKeySpecifier),
		fields?: ContentFolderRuleFieldPolicy,
	},
	ContentItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentItemKeySpecifier | (() => undefined | ContentItemKeySpecifier),
		fields?: ContentItemFieldPolicy,
	},
	ContentItemConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentItemConnectionKeySpecifier | (() => undefined | ContentItemConnectionKeySpecifier),
		fields?: ContentItemConnectionFieldPolicy,
	},
	ContentItemEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentItemEdgeKeySpecifier | (() => undefined | ContentItemEdgeKeySpecifier),
		fields?: ContentItemEdgeFieldPolicy,
	},
	ContentItemPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentItemPageKeySpecifier | (() => undefined | ContentItemPageKeySpecifier),
		fields?: ContentItemPageFieldPolicy,
	},
	ContentOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentOptionKeySpecifier | (() => undefined | ContentOptionKeySpecifier),
		fields?: ContentOptionFieldPolicy,
	},
	ContentPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentPageKeySpecifier | (() => undefined | ContentPageKeySpecifier),
		fields?: ContentPageFieldPolicy,
	},
	ContentTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContentTagKeySpecifier | (() => undefined | ContentTagKeySpecifier),
		fields?: ContentTagFieldPolicy,
	},
	CopyContentItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CopyContentItemPayloadKeySpecifier | (() => undefined | CopyContentItemPayloadKeySpecifier),
		fields?: CopyContentItemPayloadFieldPolicy,
	},
	CopyDesignPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CopyDesignPayloadKeySpecifier | (() => undefined | CopyDesignPayloadKeySpecifier),
		fields?: CopyDesignPayloadFieldPolicy,
	},
	CopyShowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CopyShowPayloadKeySpecifier | (() => undefined | CopyShowPayloadKeySpecifier),
		fields?: CopyShowPayloadFieldPolicy,
	},
	CopyViewPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CopyViewPayloadKeySpecifier | (() => undefined | CopyViewPayloadKeySpecifier),
		fields?: CopyViewPayloadFieldPolicy,
	},
	CreateAwsCredentialsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateAwsCredentialsPayloadKeySpecifier | (() => undefined | CreateAwsCredentialsPayloadKeySpecifier),
		fields?: CreateAwsCredentialsPayloadFieldPolicy,
	},
	CreateChannelGuidePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateChannelGuidePayloadKeySpecifier | (() => undefined | CreateChannelGuidePayloadKeySpecifier),
		fields?: CreateChannelGuidePayloadFieldPolicy,
	},
	CreateChannelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateChannelPayloadKeySpecifier | (() => undefined | CreateChannelPayloadKeySpecifier),
		fields?: CreateChannelPayloadFieldPolicy,
	},
	CreateContentFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateContentFolderPayloadKeySpecifier | (() => undefined | CreateContentFolderPayloadKeySpecifier),
		fields?: CreateContentFolderPayloadFieldPolicy,
	},
	CreateContentItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateContentItemPayloadKeySpecifier | (() => undefined | CreateContentItemPayloadKeySpecifier),
		fields?: CreateContentItemPayloadFieldPolicy,
	},
	CreateDesignFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDesignFolderPayloadKeySpecifier | (() => undefined | CreateDesignFolderPayloadKeySpecifier),
		fields?: CreateDesignFolderPayloadFieldPolicy,
	},
	CreateDesignPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDesignPayloadKeySpecifier | (() => undefined | CreateDesignPayloadKeySpecifier),
		fields?: CreateDesignPayloadFieldPolicy,
	},
	CreateDeviceCollectionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDeviceCollectionPayloadKeySpecifier | (() => undefined | CreateDeviceCollectionPayloadKeySpecifier),
		fields?: CreateDeviceCollectionPayloadFieldPolicy,
	},
	CreateDeviceGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDeviceGroupPayloadKeySpecifier | (() => undefined | CreateDeviceGroupPayloadKeySpecifier),
		fields?: CreateDeviceGroupPayloadFieldPolicy,
	},
	CreateDeviceSignalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDeviceSignalPayloadKeySpecifier | (() => undefined | CreateDeviceSignalPayloadKeySpecifier),
		fields?: CreateDeviceSignalPayloadFieldPolicy,
	},
	CreateEventPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateEventPayloadKeySpecifier | (() => undefined | CreateEventPayloadKeySpecifier),
		fields?: CreateEventPayloadFieldPolicy,
	},
	CreateEventTypePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateEventTypePayloadKeySpecifier | (() => undefined | CreateEventTypePayloadKeySpecifier),
		fields?: CreateEventTypePayloadFieldPolicy,
	},
	CreateFontPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateFontPayloadKeySpecifier | (() => undefined | CreateFontPayloadKeySpecifier),
		fields?: CreateFontPayloadFieldPolicy,
	},
	CreateLayoutPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateLayoutPayloadKeySpecifier | (() => undefined | CreateLayoutPayloadKeySpecifier),
		fields?: CreateLayoutPayloadFieldPolicy,
	},
	CreateOverlayPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateOverlayPayloadKeySpecifier | (() => undefined | CreateOverlayPayloadKeySpecifier),
		fields?: CreateOverlayPayloadFieldPolicy,
	},
	CreatePlaylistFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreatePlaylistFolderPayloadKeySpecifier | (() => undefined | CreatePlaylistFolderPayloadKeySpecifier),
		fields?: CreatePlaylistFolderPayloadFieldPolicy,
	},
	CreatePlaylistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreatePlaylistPayloadKeySpecifier | (() => undefined | CreatePlaylistPayloadKeySpecifier),
		fields?: CreatePlaylistPayloadFieldPolicy,
	},
	CreateRemoteCredentialsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateRemoteCredentialsPayloadKeySpecifier | (() => undefined | CreateRemoteCredentialsPayloadKeySpecifier),
		fields?: CreateRemoteCredentialsPayloadFieldPolicy,
	},
	CreateRolePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateRolePayloadKeySpecifier | (() => undefined | CreateRolePayloadKeySpecifier),
		fields?: CreateRolePayloadFieldPolicy,
	},
	CreateSeasonPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateSeasonPayloadKeySpecifier | (() => undefined | CreateSeasonPayloadKeySpecifier),
		fields?: CreateSeasonPayloadFieldPolicy,
	},
	CreateShowFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateShowFolderPayloadKeySpecifier | (() => undefined | CreateShowFolderPayloadKeySpecifier),
		fields?: CreateShowFolderPayloadFieldPolicy,
	},
	CreateShowInstancePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateShowInstancePayloadKeySpecifier | (() => undefined | CreateShowInstancePayloadKeySpecifier),
		fields?: CreateShowInstancePayloadFieldPolicy,
	},
	CreateShowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateShowPayloadKeySpecifier | (() => undefined | CreateShowPayloadKeySpecifier),
		fields?: CreateShowPayloadFieldPolicy,
	},
	CreateTVBrandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateTVBrandPayloadKeySpecifier | (() => undefined | CreateTVBrandPayloadKeySpecifier),
		fields?: CreateTVBrandPayloadFieldPolicy,
	},
	CreateTemplatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateTemplatePayloadKeySpecifier | (() => undefined | CreateTemplatePayloadKeySpecifier),
		fields?: CreateTemplatePayloadFieldPolicy,
	},
	CreateTemplateVersionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateTemplateVersionPayloadKeySpecifier | (() => undefined | CreateTemplateVersionPayloadKeySpecifier),
		fields?: CreateTemplateVersionPayloadFieldPolicy,
	},
	CreateUploadConfigPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateUploadConfigPayloadKeySpecifier | (() => undefined | CreateUploadConfigPayloadKeySpecifier),
		fields?: CreateUploadConfigPayloadFieldPolicy,
	},
	CreateUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateUserPayloadKeySpecifier | (() => undefined | CreateUserPayloadKeySpecifier),
		fields?: CreateUserPayloadFieldPolicy,
	},
	CreateViewPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateViewPayloadKeySpecifier | (() => undefined | CreateViewPayloadKeySpecifier),
		fields?: CreateViewPayloadFieldPolicy,
	},
	CreateViewZonePlaylistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateViewZonePlaylistPayloadKeySpecifier | (() => undefined | CreateViewZonePlaylistPayloadKeySpecifier),
		fields?: CreateViewZonePlaylistPayloadFieldPolicy,
	},
	CreateZonePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateZonePayloadKeySpecifier | (() => undefined | CreateZonePayloadKeySpecifier),
		fields?: CreateZonePayloadFieldPolicy,
	},
	Credentials?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CredentialsKeySpecifier | (() => undefined | CredentialsKeySpecifier),
		fields?: CredentialsFieldPolicy,
	},
	CurrentUserUpdatedPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrentUserUpdatedPayloadKeySpecifier | (() => undefined | CurrentUserUpdatedPayloadKeySpecifier),
		fields?: CurrentUserUpdatedPayloadFieldPolicy,
	},
	DataItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataItemKeySpecifier | (() => undefined | DataItemKeySpecifier),
		fields?: DataItemFieldPolicy,
	},
	DataItemCreatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataItemCreatePayloadKeySpecifier | (() => undefined | DataItemCreatePayloadKeySpecifier),
		fields?: DataItemCreatePayloadFieldPolicy,
	},
	DataItemDeletePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataItemDeletePayloadKeySpecifier | (() => undefined | DataItemDeletePayloadKeySpecifier),
		fields?: DataItemDeletePayloadFieldPolicy,
	},
	DataItemPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataItemPageKeySpecifier | (() => undefined | DataItemPageKeySpecifier),
		fields?: DataItemPageFieldPolicy,
	},
	DataItemUpdatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataItemUpdatePayloadKeySpecifier | (() => undefined | DataItemUpdatePayloadKeySpecifier),
		fields?: DataItemUpdatePayloadFieldPolicy,
	},
	DataSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataSourceKeySpecifier | (() => undefined | DataSourceKeySpecifier),
		fields?: DataSourceFieldPolicy,
	},
	DataSourcePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataSourcePageKeySpecifier | (() => undefined | DataSourcePageKeySpecifier),
		fields?: DataSourcePageFieldPolicy,
	},
	DataSourceRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DataSourceRuleKeySpecifier | (() => undefined | DataSourceRuleKeySpecifier),
		fields?: DataSourceRuleFieldPolicy,
	},
	DeleteChannelGuidePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteChannelGuidePayloadKeySpecifier | (() => undefined | DeleteChannelGuidePayloadKeySpecifier),
		fields?: DeleteChannelGuidePayloadFieldPolicy,
	},
	DeleteChannelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteChannelPayloadKeySpecifier | (() => undefined | DeleteChannelPayloadKeySpecifier),
		fields?: DeleteChannelPayloadFieldPolicy,
	},
	DeleteContentFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteContentFolderPayloadKeySpecifier | (() => undefined | DeleteContentFolderPayloadKeySpecifier),
		fields?: DeleteContentFolderPayloadFieldPolicy,
	},
	DeleteContentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteContentPayloadKeySpecifier | (() => undefined | DeleteContentPayloadKeySpecifier),
		fields?: DeleteContentPayloadFieldPolicy,
	},
	DeleteDataSourcePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDataSourcePayloadKeySpecifier | (() => undefined | DeleteDataSourcePayloadKeySpecifier),
		fields?: DeleteDataSourcePayloadFieldPolicy,
	},
	DeleteDesignFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDesignFolderPayloadKeySpecifier | (() => undefined | DeleteDesignFolderPayloadKeySpecifier),
		fields?: DeleteDesignFolderPayloadFieldPolicy,
	},
	DeleteDesignPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDesignPayloadKeySpecifier | (() => undefined | DeleteDesignPayloadKeySpecifier),
		fields?: DeleteDesignPayloadFieldPolicy,
	},
	DeleteDeviceCollectionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDeviceCollectionPayloadKeySpecifier | (() => undefined | DeleteDeviceCollectionPayloadKeySpecifier),
		fields?: DeleteDeviceCollectionPayloadFieldPolicy,
	},
	DeleteDeviceGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDeviceGroupPayloadKeySpecifier | (() => undefined | DeleteDeviceGroupPayloadKeySpecifier),
		fields?: DeleteDeviceGroupPayloadFieldPolicy,
	},
	DeleteDevicePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDevicePayloadKeySpecifier | (() => undefined | DeleteDevicePayloadKeySpecifier),
		fields?: DeleteDevicePayloadFieldPolicy,
	},
	DeleteDeviceSignalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteDeviceSignalPayloadKeySpecifier | (() => undefined | DeleteDeviceSignalPayloadKeySpecifier),
		fields?: DeleteDeviceSignalPayloadFieldPolicy,
	},
	DeleteEventPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteEventPayloadKeySpecifier | (() => undefined | DeleteEventPayloadKeySpecifier),
		fields?: DeleteEventPayloadFieldPolicy,
	},
	DeleteEventTypePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteEventTypePayloadKeySpecifier | (() => undefined | DeleteEventTypePayloadKeySpecifier),
		fields?: DeleteEventTypePayloadFieldPolicy,
	},
	DeleteFontPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteFontPayloadKeySpecifier | (() => undefined | DeleteFontPayloadKeySpecifier),
		fields?: DeleteFontPayloadFieldPolicy,
	},
	DeleteLayoutPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteLayoutPayloadKeySpecifier | (() => undefined | DeleteLayoutPayloadKeySpecifier),
		fields?: DeleteLayoutPayloadFieldPolicy,
	},
	DeleteOverlayPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteOverlayPayloadKeySpecifier | (() => undefined | DeleteOverlayPayloadKeySpecifier),
		fields?: DeleteOverlayPayloadFieldPolicy,
	},
	DeletePlaylistFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePlaylistFolderPayloadKeySpecifier | (() => undefined | DeletePlaylistFolderPayloadKeySpecifier),
		fields?: DeletePlaylistFolderPayloadFieldPolicy,
	},
	DeletePlaylistItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePlaylistItemPayloadKeySpecifier | (() => undefined | DeletePlaylistItemPayloadKeySpecifier),
		fields?: DeletePlaylistItemPayloadFieldPolicy,
	},
	DeletePlaylistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePlaylistPayloadKeySpecifier | (() => undefined | DeletePlaylistPayloadKeySpecifier),
		fields?: DeletePlaylistPayloadFieldPolicy,
	},
	DeleteRolesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteRolesPayloadKeySpecifier | (() => undefined | DeleteRolesPayloadKeySpecifier),
		fields?: DeleteRolesPayloadFieldPolicy,
	},
	DeleteSeasonPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteSeasonPayloadKeySpecifier | (() => undefined | DeleteSeasonPayloadKeySpecifier),
		fields?: DeleteSeasonPayloadFieldPolicy,
	},
	DeleteShowFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteShowFolderPayloadKeySpecifier | (() => undefined | DeleteShowFolderPayloadKeySpecifier),
		fields?: DeleteShowFolderPayloadFieldPolicy,
	},
	DeleteShowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteShowPayloadKeySpecifier | (() => undefined | DeleteShowPayloadKeySpecifier),
		fields?: DeleteShowPayloadFieldPolicy,
	},
	DeleteTVBrandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteTVBrandPayloadKeySpecifier | (() => undefined | DeleteTVBrandPayloadKeySpecifier),
		fields?: DeleteTVBrandPayloadFieldPolicy,
	},
	DeleteTagPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteTagPayloadKeySpecifier | (() => undefined | DeleteTagPayloadKeySpecifier),
		fields?: DeleteTagPayloadFieldPolicy,
	},
	DeleteTemplatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteTemplatePayloadKeySpecifier | (() => undefined | DeleteTemplatePayloadKeySpecifier),
		fields?: DeleteTemplatePayloadFieldPolicy,
	},
	DeleteUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteUserPayloadKeySpecifier | (() => undefined | DeleteUserPayloadKeySpecifier),
		fields?: DeleteUserPayloadFieldPolicy,
	},
	DeleteViewPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteViewPayloadKeySpecifier | (() => undefined | DeleteViewPayloadKeySpecifier),
		fields?: DeleteViewPayloadFieldPolicy,
	},
	DeleteViewZonePlaylistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteViewZonePlaylistPayloadKeySpecifier | (() => undefined | DeleteViewZonePlaylistPayloadKeySpecifier),
		fields?: DeleteViewZonePlaylistPayloadFieldPolicy,
	},
	DeleteZonePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteZonePayloadKeySpecifier | (() => undefined | DeleteZonePayloadKeySpecifier),
		fields?: DeleteZonePayloadFieldPolicy,
	},
	Design?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignKeySpecifier | (() => undefined | DesignKeySpecifier),
		fields?: DesignFieldPolicy,
	},
	DesignFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignFiltersKeySpecifier | (() => undefined | DesignFiltersKeySpecifier),
		fields?: DesignFiltersFieldPolicy,
	},
	DesignFolder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignFolderKeySpecifier | (() => undefined | DesignFolderKeySpecifier),
		fields?: DesignFolderFieldPolicy,
	},
	DesignFolderRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignFolderRuleKeySpecifier | (() => undefined | DesignFolderRuleKeySpecifier),
		fields?: DesignFolderRuleFieldPolicy,
	},
	DesignPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignPageKeySpecifier | (() => undefined | DesignPageKeySpecifier),
		fields?: DesignPageFieldPolicy,
	},
	DesignTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DesignTagKeySpecifier | (() => undefined | DesignTagKeySpecifier),
		fields?: DesignTagFieldPolicy,
	},
	Device?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceKeySpecifier | (() => undefined | DeviceKeySpecifier),
		fields?: DeviceFieldPolicy,
	},
	DeviceCommand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceCommandKeySpecifier | (() => undefined | DeviceCommandKeySpecifier),
		fields?: DeviceCommandFieldPolicy,
	},
	DeviceCommandPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceCommandPageKeySpecifier | (() => undefined | DeviceCommandPageKeySpecifier),
		fields?: DeviceCommandPageFieldPolicy,
	},
	DeviceDynamicCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceDynamicCollectionKeySpecifier | (() => undefined | DeviceDynamicCollectionKeySpecifier),
		fields?: DeviceDynamicCollectionFieldPolicy,
	},
	DeviceFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceFiltersKeySpecifier | (() => undefined | DeviceFiltersKeySpecifier),
		fields?: DeviceFiltersFieldPolicy,
	},
	DeviceGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceGroupKeySpecifier | (() => undefined | DeviceGroupKeySpecifier),
		fields?: DeviceGroupFieldPolicy,
	},
	DeviceGroupNew?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceGroupNewKeySpecifier | (() => undefined | DeviceGroupNewKeySpecifier),
		fields?: DeviceGroupNewFieldPolicy,
	},
	DeviceGroupNewPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceGroupNewPageKeySpecifier | (() => undefined | DeviceGroupNewPageKeySpecifier),
		fields?: DeviceGroupNewPageFieldPolicy,
	},
	DeviceGroupRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceGroupRuleKeySpecifier | (() => undefined | DeviceGroupRuleKeySpecifier),
		fields?: DeviceGroupRuleFieldPolicy,
	},
	DeviceNetworking?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceNetworkingKeySpecifier | (() => undefined | DeviceNetworkingKeySpecifier),
		fields?: DeviceNetworkingFieldPolicy,
	},
	DeviceNetworkingPort?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceNetworkingPortKeySpecifier | (() => undefined | DeviceNetworkingPortKeySpecifier),
		fields?: DeviceNetworkingPortFieldPolicy,
	},
	DeviceNetworkingSwitch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceNetworkingSwitchKeySpecifier | (() => undefined | DeviceNetworkingSwitchKeySpecifier),
		fields?: DeviceNetworkingSwitchFieldPolicy,
	},
	DevicePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DevicePageKeySpecifier | (() => undefined | DevicePageKeySpecifier),
		fields?: DevicePageFieldPolicy,
	},
	DeviceRegistration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceRegistrationKeySpecifier | (() => undefined | DeviceRegistrationKeySpecifier),
		fields?: DeviceRegistrationFieldPolicy,
	},
	DeviceRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceRuleKeySpecifier | (() => undefined | DeviceRuleKeySpecifier),
		fields?: DeviceRuleFieldPolicy,
	},
	DeviceSignal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceSignalKeySpecifier | (() => undefined | DeviceSignalKeySpecifier),
		fields?: DeviceSignalFieldPolicy,
	},
	DeviceSignalFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceSignalFiltersKeySpecifier | (() => undefined | DeviceSignalFiltersKeySpecifier),
		fields?: DeviceSignalFiltersFieldPolicy,
	},
	DeviceSignalPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceSignalPageKeySpecifier | (() => undefined | DeviceSignalPageKeySpecifier),
		fields?: DeviceSignalPageFieldPolicy,
	},
	DeviceSignalSchedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceSignalScheduleKeySpecifier | (() => undefined | DeviceSignalScheduleKeySpecifier),
		fields?: DeviceSignalScheduleFieldPolicy,
	},
	DeviceSignalTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceSignalTagKeySpecifier | (() => undefined | DeviceSignalTagKeySpecifier),
		fields?: DeviceSignalTagFieldPolicy,
	},
	DeviceStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceStatsKeySpecifier | (() => undefined | DeviceStatsKeySpecifier),
		fields?: DeviceStatsFieldPolicy,
	},
	DeviceTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceTagKeySpecifier | (() => undefined | DeviceTagKeySpecifier),
		fields?: DeviceTagFieldPolicy,
	},
	DuplicateDeviceSignalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DuplicateDeviceSignalPayloadKeySpecifier | (() => undefined | DuplicateDeviceSignalPayloadKeySpecifier),
		fields?: DuplicateDeviceSignalPayloadFieldPolicy,
	},
	DuplicateTVBrandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DuplicateTVBrandPayloadKeySpecifier | (() => undefined | DuplicateTVBrandPayloadKeySpecifier),
		fields?: DuplicateTVBrandPayloadFieldPolicy,
	},
	Event?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventKeySpecifier | (() => undefined | EventKeySpecifier),
		fields?: EventFieldPolicy,
	},
	EventType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTypeKeySpecifier | (() => undefined | EventTypeKeySpecifier),
		fields?: EventTypeFieldPolicy,
	},
	EventTypePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTypePageKeySpecifier | (() => undefined | EventTypePageKeySpecifier),
		fields?: EventTypePageFieldPolicy,
	},
	EventTypeRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTypeRuleKeySpecifier | (() => undefined | EventTypeRuleKeySpecifier),
		fields?: EventTypeRuleFieldPolicy,
	},
	ExportAuditLogsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportAuditLogsPayloadKeySpecifier | (() => undefined | ExportAuditLogsPayloadKeySpecifier),
		fields?: ExportAuditLogsPayloadFieldPolicy,
	},
	ExportDataSourcePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportDataSourcePayloadKeySpecifier | (() => undefined | ExportDataSourcePayloadKeySpecifier),
		fields?: ExportDataSourcePayloadFieldPolicy,
	},
	ExportDevicesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportDevicesPayloadKeySpecifier | (() => undefined | ExportDevicesPayloadKeySpecifier),
		fields?: ExportDevicesPayloadFieldPolicy,
	},
	FailureReasons?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FailureReasonsKeySpecifier | (() => undefined | FailureReasonsKeySpecifier),
		fields?: FailureReasonsFieldPolicy,
	},
	FanconnectConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FanconnectConfigKeySpecifier | (() => undefined | FanconnectConfigKeySpecifier),
		fields?: FanconnectConfigFieldPolicy,
	},
	File?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FileKeySpecifier | (() => undefined | FileKeySpecifier),
		fields?: FileFieldPolicy,
	},
	FilterCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FilterCountKeySpecifier | (() => undefined | FilterCountKeySpecifier),
		fields?: FilterCountFieldPolicy,
	},
	Font?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FontKeySpecifier | (() => undefined | FontKeySpecifier),
		fields?: FontFieldPolicy,
	},
	FontPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FontPageKeySpecifier | (() => undefined | FontPageKeySpecifier),
		fields?: FontPageFieldPolicy,
	},
	ForgotPasswordPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ForgotPasswordPayloadKeySpecifier | (() => undefined | ForgotPasswordPayloadKeySpecifier),
		fields?: ForgotPasswordPayloadFieldPolicy,
	},
	GeneratePlayoutDetailPdfPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GeneratePlayoutDetailPdfPayloadKeySpecifier | (() => undefined | GeneratePlayoutDetailPdfPayloadKeySpecifier),
		fields?: GeneratePlayoutDetailPdfPayloadFieldPolicy,
	},
	GenerateReportPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GenerateReportPayloadKeySpecifier | (() => undefined | GenerateReportPayloadKeySpecifier),
		fields?: GenerateReportPayloadFieldPolicy,
	},
	GetDeviceCommandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetDeviceCommandPayloadKeySpecifier | (() => undefined | GetDeviceCommandPayloadKeySpecifier),
		fields?: GetDeviceCommandPayloadFieldPolicy,
	},
	GroupedTemplateParams?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupedTemplateParamsKeySpecifier | (() => undefined | GroupedTemplateParamsKeySpecifier),
		fields?: GroupedTemplateParamsFieldPolicy,
	},
	ImpersonatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImpersonatePayloadKeySpecifier | (() => undefined | ImpersonatePayloadKeySpecifier),
		fields?: ImpersonatePayloadFieldPolicy,
	},
	Interval?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IntervalKeySpecifier | (() => undefined | IntervalKeySpecifier),
		fields?: IntervalFieldPolicy,
	},
	Layout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LayoutKeySpecifier | (() => undefined | LayoutKeySpecifier),
		fields?: LayoutFieldPolicy,
	},
	LayoutPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LayoutPageKeySpecifier | (() => undefined | LayoutPageKeySpecifier),
		fields?: LayoutPageFieldPolicy,
	},
	League?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LeagueKeySpecifier | (() => undefined | LeagueKeySpecifier),
		fields?: LeagueFieldPolicy,
	},
	Location?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocationKeySpecifier | (() => undefined | LocationKeySpecifier),
		fields?: LocationFieldPolicy,
	},
	LoginPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LoginPayloadKeySpecifier | (() => undefined | LoginPayloadKeySpecifier),
		fields?: LoginPayloadFieldPolicy,
	},
	LogoutPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogoutPayloadKeySpecifier | (() => undefined | LogoutPayloadKeySpecifier),
		fields?: LogoutPayloadFieldPolicy,
	},
	Manifest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManifestKeySpecifier | (() => undefined | ManifestKeySpecifier),
		fields?: ManifestFieldPolicy,
	},
	ManifestProperty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManifestPropertyKeySpecifier | (() => undefined | ManifestPropertyKeySpecifier),
		fields?: ManifestPropertyFieldPolicy,
	},
	MarkAnnouncementsReadPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarkAnnouncementsReadPayloadKeySpecifier | (() => undefined | MarkAnnouncementsReadPayloadKeySpecifier),
		fields?: MarkAnnouncementsReadPayloadFieldPolicy,
	},
	MediaItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaItemKeySpecifier | (() => undefined | MediaItemKeySpecifier),
		fields?: MediaItemFieldPolicy,
	},
	MoveContentPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveContentPayloadKeySpecifier | (() => undefined | MoveContentPayloadKeySpecifier),
		fields?: MoveContentPayloadFieldPolicy,
	},
	MoveDesignPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveDesignPayloadKeySpecifier | (() => undefined | MoveDesignPayloadKeySpecifier),
		fields?: MoveDesignPayloadFieldPolicy,
	},
	MovePlaylistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MovePlaylistPayloadKeySpecifier | (() => undefined | MovePlaylistPayloadKeySpecifier),
		fields?: MovePlaylistPayloadFieldPolicy,
	},
	MoveShowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoveShowPayloadKeySpecifier | (() => undefined | MoveShowPayloadKeySpecifier),
		fields?: MoveShowPayloadFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	Network?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NetworkKeySpecifier | (() => undefined | NetworkKeySpecifier),
		fields?: NetworkFieldPolicy,
	},
	NetworkConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NetworkConnectionKeySpecifier | (() => undefined | NetworkConnectionKeySpecifier),
		fields?: NetworkConnectionFieldPolicy,
	},
	NetworkEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NetworkEdgeKeySpecifier | (() => undefined | NetworkEdgeKeySpecifier),
		fields?: NetworkEdgeFieldPolicy,
	},
	NetworkMembership?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NetworkMembershipKeySpecifier | (() => undefined | NetworkMembershipKeySpecifier),
		fields?: NetworkMembershipFieldPolicy,
	},
	NetworkMembershipPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NetworkMembershipPageKeySpecifier | (() => undefined | NetworkMembershipPageKeySpecifier),
		fields?: NetworkMembershipPageFieldPolicy,
	},
	NetworkSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NetworkSettingsKeySpecifier | (() => undefined | NetworkSettingsKeySpecifier),
		fields?: NetworkSettingsFieldPolicy,
	},
	Overlay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OverlayKeySpecifier | (() => undefined | OverlayKeySpecifier),
		fields?: OverlayFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	PaginationInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginationInfoKeySpecifier | (() => undefined | PaginationInfoKeySpecifier),
		fields?: PaginationInfoFieldPolicy,
	},
	PlayContentOnDevicesPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayContentOnDevicesPayloadKeySpecifier | (() => undefined | PlayContentOnDevicesPayloadKeySpecifier),
		fields?: PlayContentOnDevicesPayloadFieldPolicy,
	},
	Playlist?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaylistKeySpecifier | (() => undefined | PlaylistKeySpecifier),
		fields?: PlaylistFieldPolicy,
	},
	PlaylistFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaylistFiltersKeySpecifier | (() => undefined | PlaylistFiltersKeySpecifier),
		fields?: PlaylistFiltersFieldPolicy,
	},
	PlaylistFolder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaylistFolderKeySpecifier | (() => undefined | PlaylistFolderKeySpecifier),
		fields?: PlaylistFolderFieldPolicy,
	},
	PlaylistFolderRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaylistFolderRuleKeySpecifier | (() => undefined | PlaylistFolderRuleKeySpecifier),
		fields?: PlaylistFolderRuleFieldPolicy,
	},
	PlaylistItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaylistItemKeySpecifier | (() => undefined | PlaylistItemKeySpecifier),
		fields?: PlaylistItemFieldPolicy,
	},
	PlaylistPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaylistPageKeySpecifier | (() => undefined | PlaylistPageKeySpecifier),
		fields?: PlaylistPageFieldPolicy,
	},
	PlaylistTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaylistTagKeySpecifier | (() => undefined | PlaylistTagKeySpecifier),
		fields?: PlaylistTagFieldPolicy,
	},
	PlayoutReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportKeySpecifier | (() => undefined | PlayoutReportKeySpecifier),
		fields?: PlayoutReportFieldPolicy,
	},
	PlayoutReportAssetAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportAssetAggregateKeySpecifier | (() => undefined | PlayoutReportAssetAggregateKeySpecifier),
		fields?: PlayoutReportAssetAggregateFieldPolicy,
	},
	PlayoutReportAssetDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportAssetDetailKeySpecifier | (() => undefined | PlayoutReportAssetDetailKeySpecifier),
		fields?: PlayoutReportAssetDetailFieldPolicy,
	},
	PlayoutReportAssetSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportAssetSummaryKeySpecifier | (() => undefined | PlayoutReportAssetSummaryKeySpecifier),
		fields?: PlayoutReportAssetSummaryFieldPolicy,
	},
	PlayoutReportDeviceGroupAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportDeviceGroupAggregateKeySpecifier | (() => undefined | PlayoutReportDeviceGroupAggregateKeySpecifier),
		fields?: PlayoutReportDeviceGroupAggregateFieldPolicy,
	},
	PlayoutReportEventAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportEventAggregateKeySpecifier | (() => undefined | PlayoutReportEventAggregateKeySpecifier),
		fields?: PlayoutReportEventAggregateFieldPolicy,
	},
	PlayoutReportSponsorAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportSponsorAggregateKeySpecifier | (() => undefined | PlayoutReportSponsorAggregateKeySpecifier),
		fields?: PlayoutReportSponsorAggregateFieldPolicy,
	},
	PlayoutReportSponsorDetail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportSponsorDetailKeySpecifier | (() => undefined | PlayoutReportSponsorDetailKeySpecifier),
		fields?: PlayoutReportSponsorDetailFieldPolicy,
	},
	PlayoutReportSponsorSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportSponsorSummaryKeySpecifier | (() => undefined | PlayoutReportSponsorSummaryKeySpecifier),
		fields?: PlayoutReportSponsorSummaryFieldPolicy,
	},
	PlayoutReportStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportStatsKeySpecifier | (() => undefined | PlayoutReportStatsKeySpecifier),
		fields?: PlayoutReportStatsFieldPolicy,
	},
	PlayoutReportTopAsset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportTopAssetKeySpecifier | (() => undefined | PlayoutReportTopAssetKeySpecifier),
		fields?: PlayoutReportTopAssetFieldPolicy,
	},
	PlayoutReportZoneAggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayoutReportZoneAggregateKeySpecifier | (() => undefined | PlayoutReportZoneAggregateKeySpecifier),
		fields?: PlayoutReportZoneAggregateFieldPolicy,
	},
	PropertyDefinition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PropertyDefinitionKeySpecifier | (() => undefined | PropertyDefinitionKeySpecifier),
		fields?: PropertyDefinitionFieldPolicy,
	},
	PropertyDefinitionAllowedValuesType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PropertyDefinitionAllowedValuesTypeKeySpecifier | (() => undefined | PropertyDefinitionAllowedValuesTypeKeySpecifier),
		fields?: PropertyDefinitionAllowedValuesTypeFieldPolicy,
	},
	PropertyGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PropertyGroupKeySpecifier | (() => undefined | PropertyGroupKeySpecifier),
		fields?: PropertyGroupFieldPolicy,
	},
	PropertyGroupAssignPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PropertyGroupAssignPayloadKeySpecifier | (() => undefined | PropertyGroupAssignPayloadKeySpecifier),
		fields?: PropertyGroupAssignPayloadFieldPolicy,
	},
	PropertyGroupOwner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PropertyGroupOwnerKeySpecifier | (() => undefined | PropertyGroupOwnerKeySpecifier),
		fields?: PropertyGroupOwnerFieldPolicy,
	},
	PropertyGroupRemovePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PropertyGroupRemovePayloadKeySpecifier | (() => undefined | PropertyGroupRemovePayloadKeySpecifier),
		fields?: PropertyGroupRemovePayloadFieldPolicy,
	},
	PropertyValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PropertyValueKeySpecifier | (() => undefined | PropertyValueKeySpecifier),
		fields?: PropertyValueFieldPolicy,
	},
	PropertyValueUpdatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PropertyValueUpdatePayloadKeySpecifier | (() => undefined | PropertyValueUpdatePayloadKeySpecifier),
		fields?: PropertyValueUpdatePayloadFieldPolicy,
	},
	PublishDesignPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublishDesignPayloadKeySpecifier | (() => undefined | PublishDesignPayloadKeySpecifier),
		fields?: PublishDesignPayloadFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	RegisterDevicePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegisterDevicePayloadKeySpecifier | (() => undefined | RegisterDevicePayloadKeySpecifier),
		fields?: RegisterDevicePayloadFieldPolicy,
	},
	Remote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RemoteKeySpecifier | (() => undefined | RemoteKeySpecifier),
		fields?: RemoteFieldPolicy,
	},
	RemoteChannel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RemoteChannelKeySpecifier | (() => undefined | RemoteChannelKeySpecifier),
		fields?: RemoteChannelFieldPolicy,
	},
	RemoteCredentials?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RemoteCredentialsKeySpecifier | (() => undefined | RemoteCredentialsKeySpecifier),
		fields?: RemoteCredentialsFieldPolicy,
	},
	RemoveDevicesFromDeviceGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RemoveDevicesFromDeviceGroupPayloadKeySpecifier | (() => undefined | RemoveDevicesFromDeviceGroupPayloadKeySpecifier),
		fields?: RemoveDevicesFromDeviceGroupPayloadFieldPolicy,
	},
	RemoveDevicesFromScheduledShowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RemoveDevicesFromScheduledShowPayloadKeySpecifier | (() => undefined | RemoveDevicesFromScheduledShowPayloadKeySpecifier),
		fields?: RemoveDevicesFromScheduledShowPayloadFieldPolicy,
	},
	RemoveFromRolePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RemoveFromRolePayloadKeySpecifier | (() => undefined | RemoveFromRolePayloadKeySpecifier),
		fields?: RemoveFromRolePayloadFieldPolicy,
	},
	RenameTagPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RenameTagPayloadKeySpecifier | (() => undefined | RenameTagPayloadKeySpecifier),
		fields?: RenameTagPayloadFieldPolicy,
	},
	Rendition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RenditionKeySpecifier | (() => undefined | RenditionKeySpecifier),
		fields?: RenditionFieldPolicy,
	},
	RerunEventRollupsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RerunEventRollupsPayloadKeySpecifier | (() => undefined | RerunEventRollupsPayloadKeySpecifier),
		fields?: RerunEventRollupsPayloadFieldPolicy,
	},
	ResendConfirmationPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResendConfirmationPayloadKeySpecifier | (() => undefined | ResendConfirmationPayloadKeySpecifier),
		fields?: ResendConfirmationPayloadFieldPolicy,
	},
	ResetPasswordPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResetPasswordPayloadKeySpecifier | (() => undefined | ResetPasswordPayloadKeySpecifier),
		fields?: ResetPasswordPayloadFieldPolicy,
	},
	Role?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleKeySpecifier | (() => undefined | RoleKeySpecifier),
		fields?: RoleFieldPolicy,
	},
	RolePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RolePageKeySpecifier | (() => undefined | RolePageKeySpecifier),
		fields?: RolePageFieldPolicy,
	},
	RunDeviceSignalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunDeviceSignalPayloadKeySpecifier | (() => undefined | RunDeviceSignalPayloadKeySpecifier),
		fields?: RunDeviceSignalPayloadFieldPolicy,
	},
	RunSignalByEventNamePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RunSignalByEventNamePayloadKeySpecifier | (() => undefined | RunSignalByEventNamePayloadKeySpecifier),
		fields?: RunSignalByEventNamePayloadFieldPolicy,
	},
	SamsungFirmware?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SamsungFirmwareKeySpecifier | (() => undefined | SamsungFirmwareKeySpecifier),
		fields?: SamsungFirmwareFieldPolicy,
	},
	Schedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduleKeySpecifier | (() => undefined | ScheduleKeySpecifier),
		fields?: ScheduleFieldPolicy,
	},
	ScheduledShow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledShowKeySpecifier | (() => undefined | ScheduledShowKeySpecifier),
		fields?: ScheduledShowFieldPolicy,
	},
	ScheduledShowMutationsCreatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledShowMutationsCreatePayloadKeySpecifier | (() => undefined | ScheduledShowMutationsCreatePayloadKeySpecifier),
		fields?: ScheduledShowMutationsCreatePayloadFieldPolicy,
	},
	ScheduledShowMutationsDeletePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledShowMutationsDeletePayloadKeySpecifier | (() => undefined | ScheduledShowMutationsDeletePayloadKeySpecifier),
		fields?: ScheduledShowMutationsDeletePayloadFieldPolicy,
	},
	ScheduledShowMutationsUpdatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledShowMutationsUpdatePayloadKeySpecifier | (() => undefined | ScheduledShowMutationsUpdatePayloadKeySpecifier),
		fields?: ScheduledShowMutationsUpdatePayloadFieldPolicy,
	},
	ScheduledShowPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduledShowPageKeySpecifier | (() => undefined | ScheduledShowPageKeySpecifier),
		fields?: ScheduledShowPageFieldPolicy,
	},
	Season?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SeasonKeySpecifier | (() => undefined | SeasonKeySpecifier),
		fields?: SeasonFieldPolicy,
	},
	SendDeviceCommandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendDeviceCommandPayloadKeySpecifier | (() => undefined | SendDeviceCommandPayloadKeySpecifier),
		fields?: SendDeviceCommandPayloadFieldPolicy,
	},
	SendRemoteCommandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendRemoteCommandPayloadKeySpecifier | (() => undefined | SendRemoteCommandPayloadKeySpecifier),
		fields?: SendRemoteCommandPayloadFieldPolicy,
	},
	SetPasswordPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetPasswordPayloadKeySpecifier | (() => undefined | SetPasswordPayloadKeySpecifier),
		fields?: SetPasswordPayloadFieldPolicy,
	},
	Show?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowKeySpecifier | (() => undefined | ShowKeySpecifier),
		fields?: ShowFieldPolicy,
	},
	ShowEventDeviceGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowEventDeviceGroupKeySpecifier | (() => undefined | ShowEventDeviceGroupKeySpecifier),
		fields?: ShowEventDeviceGroupFieldPolicy,
	},
	ShowEventTypeDeviceGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowEventTypeDeviceGroupKeySpecifier | (() => undefined | ShowEventTypeDeviceGroupKeySpecifier),
		fields?: ShowEventTypeDeviceGroupFieldPolicy,
	},
	ShowFilters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowFiltersKeySpecifier | (() => undefined | ShowFiltersKeySpecifier),
		fields?: ShowFiltersFieldPolicy,
	},
	ShowFolder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowFolderKeySpecifier | (() => undefined | ShowFolderKeySpecifier),
		fields?: ShowFolderFieldPolicy,
	},
	ShowFolderRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowFolderRuleKeySpecifier | (() => undefined | ShowFolderRuleKeySpecifier),
		fields?: ShowFolderRuleFieldPolicy,
	},
	ShowPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowPageKeySpecifier | (() => undefined | ShowPageKeySpecifier),
		fields?: ShowPageFieldPolicy,
	},
	ShowTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShowTagKeySpecifier | (() => undefined | ShowTagKeySpecifier),
		fields?: ShowTagFieldPolicy,
	},
	ShufflePlaylistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShufflePlaylistPayloadKeySpecifier | (() => undefined | ShufflePlaylistPayloadKeySpecifier),
		fields?: ShufflePlaylistPayloadFieldPolicy,
	},
	SignalActionArbitrary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignalActionArbitraryKeySpecifier | (() => undefined | SignalActionArbitraryKeySpecifier),
		fields?: SignalActionArbitraryFieldPolicy,
	},
	SignalActionPlayOverlay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignalActionPlayOverlayKeySpecifier | (() => undefined | SignalActionPlayOverlayKeySpecifier),
		fields?: SignalActionPlayOverlayFieldPolicy,
	},
	SignalActionPlayShow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignalActionPlayShowKeySpecifier | (() => undefined | SignalActionPlayShowKeySpecifier),
		fields?: SignalActionPlayShowFieldPolicy,
	},
	SignalActionReboot?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignalActionRebootKeySpecifier | (() => undefined | SignalActionRebootKeySpecifier),
		fields?: SignalActionRebootFieldPolicy,
	},
	SignalActionStopOverlay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignalActionStopOverlayKeySpecifier | (() => undefined | SignalActionStopOverlayKeySpecifier),
		fields?: SignalActionStopOverlayFieldPolicy,
	},
	SignalActionTriggerView?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignalActionTriggerViewKeySpecifier | (() => undefined | SignalActionTriggerViewKeySpecifier),
		fields?: SignalActionTriggerViewFieldPolicy,
	},
	SignalActionTuneChannel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SignalActionTuneChannelKeySpecifier | (() => undefined | SignalActionTuneChannelKeySpecifier),
		fields?: SignalActionTuneChannelFieldPolicy,
	},
	SoftwareUpdateInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SoftwareUpdateInfoKeySpecifier | (() => undefined | SoftwareUpdateInfoKeySpecifier),
		fields?: SoftwareUpdateInfoFieldPolicy,
	},
	SoftwareVersion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SoftwareVersionKeySpecifier | (() => undefined | SoftwareVersionKeySpecifier),
		fields?: SoftwareVersionFieldPolicy,
	},
	StopImpersonatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StopImpersonatePayloadKeySpecifier | (() => undefined | StopImpersonatePayloadKeySpecifier),
		fields?: StopImpersonatePayloadFieldPolicy,
	},
	Subscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionKeySpecifier | (() => undefined | SubscriptionKeySpecifier),
		fields?: SubscriptionFieldPolicy,
	},
	SyncDataSourcePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SyncDataSourcePayloadKeySpecifier | (() => undefined | SyncDataSourcePayloadKeySpecifier),
		fields?: SyncDataSourcePayloadFieldPolicy,
	},
	SyncEventsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SyncEventsPayloadKeySpecifier | (() => undefined | SyncEventsPayloadKeySpecifier),
		fields?: SyncEventsPayloadFieldPolicy,
	},
	TVBrand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TVBrandKeySpecifier | (() => undefined | TVBrandKeySpecifier),
		fields?: TVBrandFieldPolicy,
	},
	TVBrandPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TVBrandPageKeySpecifier | (() => undefined | TVBrandPageKeySpecifier),
		fields?: TVBrandPageFieldPolicy,
	},
	Team?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TeamKeySpecifier | (() => undefined | TeamKeySpecifier),
		fields?: TeamFieldPolicy,
	},
	Template?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateKeySpecifier | (() => undefined | TemplateKeySpecifier),
		fields?: TemplateFieldPolicy,
	},
	TemplateCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateCategoryKeySpecifier | (() => undefined | TemplateCategoryKeySpecifier),
		fields?: TemplateCategoryFieldPolicy,
	},
	TemplateConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateConnectionKeySpecifier | (() => undefined | TemplateConnectionKeySpecifier),
		fields?: TemplateConnectionFieldPolicy,
	},
	TemplateEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateEdgeKeySpecifier | (() => undefined | TemplateEdgeKeySpecifier),
		fields?: TemplateEdgeFieldPolicy,
	},
	TemplateParam?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateParamKeySpecifier | (() => undefined | TemplateParamKeySpecifier),
		fields?: TemplateParamFieldPolicy,
	},
	TemplateParamGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateParamGroupKeySpecifier | (() => undefined | TemplateParamGroupKeySpecifier),
		fields?: TemplateParamGroupFieldPolicy,
	},
	TemplateParamOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateParamOptionKeySpecifier | (() => undefined | TemplateParamOptionKeySpecifier),
		fields?: TemplateParamOptionFieldPolicy,
	},
	TemplateVersion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateVersionKeySpecifier | (() => undefined | TemplateVersionKeySpecifier),
		fields?: TemplateVersionFieldPolicy,
	},
	TemplateVersionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateVersionConnectionKeySpecifier | (() => undefined | TemplateVersionConnectionKeySpecifier),
		fields?: TemplateVersionConnectionFieldPolicy,
	},
	TemplateVersionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateVersionEdgeKeySpecifier | (() => undefined | TemplateVersionEdgeKeySpecifier),
		fields?: TemplateVersionEdgeFieldPolicy,
	},
	TemplateVersionPreviewType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateVersionPreviewTypeKeySpecifier | (() => undefined | TemplateVersionPreviewTypeKeySpecifier),
		fields?: TemplateVersionPreviewTypeFieldPolicy,
	},
	TemplateZipValidation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateZipValidationKeySpecifier | (() => undefined | TemplateZipValidationKeySpecifier),
		fields?: TemplateZipValidationFieldPolicy,
	},
	TemplateZipValidationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateZipValidationErrorKeySpecifier | (() => undefined | TemplateZipValidationErrorKeySpecifier),
		fields?: TemplateZipValidationErrorFieldPolicy,
	},
	Thumbnail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThumbnailKeySpecifier | (() => undefined | ThumbnailKeySpecifier),
		fields?: ThumbnailFieldPolicy,
	},
	TimeZone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimeZoneKeySpecifier | (() => undefined | TimeZoneKeySpecifier),
		fields?: TimeZoneFieldPolicy,
	},
	TransferDevicePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransferDevicePayloadKeySpecifier | (() => undefined | TransferDevicePayloadKeySpecifier),
		fields?: TransferDevicePayloadFieldPolicy,
	},
	TuneRemoteChannelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TuneRemoteChannelPayloadKeySpecifier | (() => undefined | TuneRemoteChannelPayloadKeySpecifier),
		fields?: TuneRemoteChannelPayloadFieldPolicy,
	},
	UpdateChannelGuidePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateChannelGuidePayloadKeySpecifier | (() => undefined | UpdateChannelGuidePayloadKeySpecifier),
		fields?: UpdateChannelGuidePayloadFieldPolicy,
	},
	UpdateChannelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateChannelPayloadKeySpecifier | (() => undefined | UpdateChannelPayloadKeySpecifier),
		fields?: UpdateChannelPayloadFieldPolicy,
	},
	UpdateContentFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateContentFolderPayloadKeySpecifier | (() => undefined | UpdateContentFolderPayloadKeySpecifier),
		fields?: UpdateContentFolderPayloadFieldPolicy,
	},
	UpdateContentItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateContentItemPayloadKeySpecifier | (() => undefined | UpdateContentItemPayloadKeySpecifier),
		fields?: UpdateContentItemPayloadFieldPolicy,
	},
	UpdateDataSourcePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDataSourcePayloadKeySpecifier | (() => undefined | UpdateDataSourcePayloadKeySpecifier),
		fields?: UpdateDataSourcePayloadFieldPolicy,
	},
	UpdateDesignFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDesignFolderPayloadKeySpecifier | (() => undefined | UpdateDesignFolderPayloadKeySpecifier),
		fields?: UpdateDesignFolderPayloadFieldPolicy,
	},
	UpdateDesignPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDesignPayloadKeySpecifier | (() => undefined | UpdateDesignPayloadKeySpecifier),
		fields?: UpdateDesignPayloadFieldPolicy,
	},
	UpdateDeviceGroupPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDeviceGroupPayloadKeySpecifier | (() => undefined | UpdateDeviceGroupPayloadKeySpecifier),
		fields?: UpdateDeviceGroupPayloadFieldPolicy,
	},
	UpdateDevicePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDevicePayloadKeySpecifier | (() => undefined | UpdateDevicePayloadKeySpecifier),
		fields?: UpdateDevicePayloadFieldPolicy,
	},
	UpdateDeviceSignalPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDeviceSignalPayloadKeySpecifier | (() => undefined | UpdateDeviceSignalPayloadKeySpecifier),
		fields?: UpdateDeviceSignalPayloadFieldPolicy,
	},
	UpdateDeviceStatusPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDeviceStatusPayloadKeySpecifier | (() => undefined | UpdateDeviceStatusPayloadKeySpecifier),
		fields?: UpdateDeviceStatusPayloadFieldPolicy,
	},
	UpdateDeviceStatusV3Payload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDeviceStatusV3PayloadKeySpecifier | (() => undefined | UpdateDeviceStatusV3PayloadKeySpecifier),
		fields?: UpdateDeviceStatusV3PayloadFieldPolicy,
	},
	UpdateEventPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEventPayloadKeySpecifier | (() => undefined | UpdateEventPayloadKeySpecifier),
		fields?: UpdateEventPayloadFieldPolicy,
	},
	UpdateEventTypePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEventTypePayloadKeySpecifier | (() => undefined | UpdateEventTypePayloadKeySpecifier),
		fields?: UpdateEventTypePayloadFieldPolicy,
	},
	UpdateEventTypeShowsDeviceGroupsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEventTypeShowsDeviceGroupsPayloadKeySpecifier | (() => undefined | UpdateEventTypeShowsDeviceGroupsPayloadKeySpecifier),
		fields?: UpdateEventTypeShowsDeviceGroupsPayloadFieldPolicy,
	},
	UpdateFontPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateFontPayloadKeySpecifier | (() => undefined | UpdateFontPayloadKeySpecifier),
		fields?: UpdateFontPayloadFieldPolicy,
	},
	UpdateLayoutPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateLayoutPayloadKeySpecifier | (() => undefined | UpdateLayoutPayloadKeySpecifier),
		fields?: UpdateLayoutPayloadFieldPolicy,
	},
	UpdateMediaItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateMediaItemPayloadKeySpecifier | (() => undefined | UpdateMediaItemPayloadKeySpecifier),
		fields?: UpdateMediaItemPayloadFieldPolicy,
	},
	UpdateNetworkPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateNetworkPayloadKeySpecifier | (() => undefined | UpdateNetworkPayloadKeySpecifier),
		fields?: UpdateNetworkPayloadFieldPolicy,
	},
	UpdateOverlayPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateOverlayPayloadKeySpecifier | (() => undefined | UpdateOverlayPayloadKeySpecifier),
		fields?: UpdateOverlayPayloadFieldPolicy,
	},
	UpdatePlaylistFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePlaylistFolderPayloadKeySpecifier | (() => undefined | UpdatePlaylistFolderPayloadKeySpecifier),
		fields?: UpdatePlaylistFolderPayloadFieldPolicy,
	},
	UpdatePlaylistItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePlaylistItemPayloadKeySpecifier | (() => undefined | UpdatePlaylistItemPayloadKeySpecifier),
		fields?: UpdatePlaylistItemPayloadFieldPolicy,
	},
	UpdatePlaylistPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePlaylistPayloadKeySpecifier | (() => undefined | UpdatePlaylistPayloadKeySpecifier),
		fields?: UpdatePlaylistPayloadFieldPolicy,
	},
	UpdateRolePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateRolePayloadKeySpecifier | (() => undefined | UpdateRolePayloadKeySpecifier),
		fields?: UpdateRolePayloadFieldPolicy,
	},
	UpdateSeasonPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateSeasonPayloadKeySpecifier | (() => undefined | UpdateSeasonPayloadKeySpecifier),
		fields?: UpdateSeasonPayloadFieldPolicy,
	},
	UpdateShowFolderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateShowFolderPayloadKeySpecifier | (() => undefined | UpdateShowFolderPayloadKeySpecifier),
		fields?: UpdateShowFolderPayloadFieldPolicy,
	},
	UpdateShowPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateShowPayloadKeySpecifier | (() => undefined | UpdateShowPayloadKeySpecifier),
		fields?: UpdateShowPayloadFieldPolicy,
	},
	UpdateTVBrandPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateTVBrandPayloadKeySpecifier | (() => undefined | UpdateTVBrandPayloadKeySpecifier),
		fields?: UpdateTVBrandPayloadFieldPolicy,
	},
	UpdateTagsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateTagsPayloadKeySpecifier | (() => undefined | UpdateTagsPayloadKeySpecifier),
		fields?: UpdateTagsPayloadFieldPolicy,
	},
	UpdateTemplatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateTemplatePayloadKeySpecifier | (() => undefined | UpdateTemplatePayloadKeySpecifier),
		fields?: UpdateTemplatePayloadFieldPolicy,
	},
	UpdateUserPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateUserPayloadKeySpecifier | (() => undefined | UpdateUserPayloadKeySpecifier),
		fields?: UpdateUserPayloadFieldPolicy,
	},
	UpdateViewPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateViewPayloadKeySpecifier | (() => undefined | UpdateViewPayloadKeySpecifier),
		fields?: UpdateViewPayloadFieldPolicy,
	},
	UpdateViewZonePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateViewZonePayloadKeySpecifier | (() => undefined | UpdateViewZonePayloadKeySpecifier),
		fields?: UpdateViewZonePayloadFieldPolicy,
	},
	UpdateZonePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateZonePayloadKeySpecifier | (() => undefined | UpdateZonePayloadKeySpecifier),
		fields?: UpdateZonePayloadFieldPolicy,
	},
	UpgradeAllContentItemsPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpgradeAllContentItemsPayloadKeySpecifier | (() => undefined | UpgradeAllContentItemsPayloadKeySpecifier),
		fields?: UpgradeAllContentItemsPayloadFieldPolicy,
	},
	UpgradeContentItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpgradeContentItemPayloadKeySpecifier | (() => undefined | UpgradeContentItemPayloadKeySpecifier),
		fields?: UpgradeContentItemPayloadFieldPolicy,
	},
	UploadCredentials?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadCredentialsKeySpecifier | (() => undefined | UploadCredentialsKeySpecifier),
		fields?: UploadCredentialsFieldPolicy,
	},
	UploadDataSourcePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadDataSourcePayloadKeySpecifier | (() => undefined | UploadDataSourcePayloadKeySpecifier),
		fields?: UploadDataSourcePayloadFieldPolicy,
	},
	UploadMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadMetadataKeySpecifier | (() => undefined | UploadMetadataKeySpecifier),
		fields?: UploadMetadataFieldPolicy,
	},
	UsagePage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsagePageKeySpecifier | (() => undefined | UsagePageKeySpecifier),
		fields?: UsagePageFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserConnectionKeySpecifier | (() => undefined | UserConnectionKeySpecifier),
		fields?: UserConnectionFieldPolicy,
	},
	UserEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserEdgeKeySpecifier | (() => undefined | UserEdgeKeySpecifier),
		fields?: UserEdgeFieldPolicy,
	},
	View?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ViewKeySpecifier | (() => undefined | ViewKeySpecifier),
		fields?: ViewFieldPolicy,
	},
	ViewZone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ViewZoneKeySpecifier | (() => undefined | ViewZoneKeySpecifier),
		fields?: ViewZoneFieldPolicy,
	},
	ViewZonePlaylist?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ViewZonePlaylistKeySpecifier | (() => undefined | ViewZonePlaylistKeySpecifier),
		fields?: ViewZonePlaylistFieldPolicy,
	},
	WebosFirmware?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebosFirmwareKeySpecifier | (() => undefined | WebosFirmwareKeySpecifier),
		fields?: WebosFirmwareFieldPolicy,
	},
	Zone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ZoneKeySpecifier | (() => undefined | ZoneKeySpecifier),
		fields?: ZoneFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
export type UpdatePropertyValueMutationVariables = Exact<{
  ownerType: PropertyOwnerType;
  ownerId: Scalars['Int']['input'];
  patch: ReadonlyArray<PropertyValuePatch> | PropertyValuePatch;
}>;


export type UpdatePropertyValueMutation = { readonly __typename: 'Mutation', readonly updatePropertyValue?: { readonly __typename: 'PropertyValueUpdatePayload', readonly errors: ReadonlyArray<string>, readonly owner: { readonly __typename: 'Device' } | { readonly __typename: 'Show', readonly id: number, readonly name: string, readonly propertyGroups: ReadonlyArray<{ readonly __typename: 'PropertyGroupOwner', readonly id: number, readonly propertyValues: ReadonlyArray<{ readonly __typename: 'PropertyValue', readonly id: number, readonly value?: string | null }> }> } } | null };

export type CreateUploadConfigMutationVariables = Exact<{
  networkId: Scalars['Int']['input'];
}>;


export type CreateUploadConfigMutation = { readonly __typename: 'Mutation', readonly createUploadConfig?: { readonly __typename: 'CreateUploadConfigPayload', readonly bucket: string, readonly region: string, readonly credentials: { readonly __typename: 'UploadCredentials', readonly accessKeyId: string, readonly expiration: string, readonly secretAccessKey: string, readonly sessionToken: string }, readonly metadata: { readonly __typename: 'UploadMetadata', readonly networkId: string, readonly userId: string } } | null };

export type UserListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  currentNetworkId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrdering> | UserOrdering>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserListQuery = { readonly __typename: 'Query', readonly users: { readonly __typename: 'UserConnection', readonly totalCount: number, readonly nodes: ReadonlyArray<{ readonly __typename: 'User', readonly admin: boolean, readonly currentSignInAt?: string | null, readonly email: string, readonly id: number, readonly name: string, readonly status: string, readonly canDestroy: { readonly __typename: 'AuthorizationResult', readonly value: boolean }, readonly networks: ReadonlyArray<{ readonly __typename: 'Network', readonly id: number, readonly name: string, readonly public: boolean }> }>, readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean } } };

export type UserList__UsersFragment = { readonly __typename: 'UserConnection', readonly totalCount: number, readonly nodes: ReadonlyArray<{ readonly __typename: 'User', readonly admin: boolean, readonly currentSignInAt?: string | null, readonly email: string, readonly id: number, readonly name: string, readonly status: string, readonly canDestroy: { readonly __typename: 'AuthorizationResult', readonly value: boolean }, readonly networks: ReadonlyArray<{ readonly __typename: 'Network', readonly id: number, readonly name: string, readonly public: boolean }> }>, readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean } };

export type UserList__UserFragment = { readonly __typename: 'User', readonly admin: boolean, readonly currentSignInAt?: string | null, readonly email: string, readonly id: number, readonly name: string, readonly status: string, readonly canDestroy: { readonly __typename: 'AuthorizationResult', readonly value: boolean }, readonly networks: ReadonlyArray<{ readonly __typename: 'Network', readonly id: number, readonly name: string, readonly public: boolean }> };

export type UserSettingsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type UserSettingsQuery = { readonly __typename: 'Query', readonly user?: { readonly __typename: 'User', readonly admin: boolean, readonly email: string, readonly id: number, readonly name: string, readonly canDestroy: { readonly __typename: 'AuthorizationResult', readonly value: boolean }, readonly networks: ReadonlyArray<{ readonly __typename: 'Network', readonly id: number, readonly name: string, readonly public: boolean }> } | null };

export type UserSettings__UserFragment = { readonly __typename: 'User', readonly admin: boolean, readonly email: string, readonly id: number, readonly name: string, readonly canDestroy: { readonly __typename: 'AuthorizationResult', readonly value: boolean }, readonly networks: ReadonlyArray<{ readonly __typename: 'Network', readonly id: number, readonly name: string, readonly public: boolean }> };

export type CreatePasswordQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type CreatePasswordQuery = { readonly __typename: 'Query', readonly emailByToken?: string | null, readonly currentUser?: { readonly __typename: 'User', readonly id: number } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { readonly __typename: 'Mutation', readonly logout?: { readonly __typename: 'LogoutPayload', readonly success: boolean } | null };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SetPasswordMutation = { readonly __typename: 'Mutation', readonly setPassword?: { readonly __typename: 'SetPasswordPayload', readonly success: boolean } | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { readonly __typename: 'Mutation', readonly forgotPassword?: { readonly __typename: 'ForgotPasswordPayload', readonly clientMutationId?: string | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { readonly __typename: 'Mutation', readonly resetPassword?: { readonly __typename: 'ResetPasswordPayload', readonly errors: ReadonlyArray<string>, readonly success: boolean } | null };

export const UserList__UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserList__User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"canDestroy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSignInAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"networks"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"User__Network","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<UserList__UserFragment, unknown>;
export const UserList__UsersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserList__Users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserList__User"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserList__User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"canDestroy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSignInAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"networks"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"User__Network","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<UserList__UsersFragment, unknown>;
export const UserSettings__UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettings__User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"canDestroy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"networks"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"User__Network","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}}]}}]} as unknown as DocumentNode<UserSettings__UserFragment, unknown>;
export const UpdatePropertyValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyValue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyOwnerType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patch"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyValuePatch"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePropertyValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ownerType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patch"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Show"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"propertyGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"propertyValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyValueMutation, UpdatePropertyValueMutationVariables>;
export const CreateUploadConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUploadConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"networkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUploadConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"networkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"networkId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucket"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessKeyId"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}},{"kind":"Field","name":{"kind":"Name","value":"secretAccessKey"}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"networkId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}}]} as unknown as DocumentNode<CreateUploadConfigMutation, CreateUploadConfigMutationVariables>;
export const UserListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentNetworkId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrdering"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentNetworkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentNetworkId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserList__Users"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserList__Users"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserList__User"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserList__User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"canDestroy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSignInAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"networks"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"User__Network","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<UserListQuery, UserListQueryVariables>;
export const UserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSettings__User"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettings__User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"canDestroy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"networks"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"User__Network","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}}]}}]} as unknown as DocumentNode<UserSettingsQuery, UserSettingsQueryVariables>;
export const CreatePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreatePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailByToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<CreatePasswordQuery, CreatePasswordQueryVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const SetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SetPasswordMutation, SetPasswordMutationVariables>;
export const ForgotPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ForgotPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgotPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;